import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useId, forwardRef, useRef, useMemo, createElement, useState, useEffect, useCallback, createContext, useContext, useImperativeHandle } from 'react';
import { useDisclosureState, useDisclosureGroupState } from '@react-stately/disclosure';
import { useHoverable, useFocusable, mergeProps, useTokens, Box, useObjectRef as useObjectRef$1, useRenderLink, useBreakpointValue, FocusableProvider, Overlay, getRootFontSizeValue, usePopover, useTranslation, unsafe_keyframes, useLocale, useResizeObserver, useLayoutEffect, usePressable, useHorizontalScroll, useNotificationGroup, useNotification } from '@gemini/core';
import { ChevronDownIcon, ExternalLinkIcon, LoaderIcon, CloseIcon, ChevronLeftIcon, ChevronRightIcon, MinusIcon, PlusIcon, CaretDownFilledIcon, CalendarIcon, InfoFilledCircleIcon, ExclamationFilledCircleIcon, CheckFilledCircleIcon, CloseFilledCircleIcon, ExclamationTriangleIcon, TrashCanIcon, ImageIcon, PenLineIcon, ArrowDownRightIcon, ArrowUpLeftIcon, StarIcon, EllipsisVerticalIcon, ClapperboardPlayIcon, FileLinesIcon, FolderOpenIcon, RotateLeftIcon, RotateRightImageIcon, StarFilledIcon, StarHalfFilledIcon, ExclamationFilledTriangleIcon, CheckIcon } from '@gemini/icons';
import { chain, useObjectRef, useId as useId$1, mergeProps as mergeProps$1, mergeRefs } from '@react-aria/utils';
import { u as useExitAnimation, M as Modal, i as isAllowedTitleTag, B as Button, D as DEFAULT_LABEL_AS, a as useField, F as FieldBase, b as useButton$1, c as Badge, d as createCalendar, e as Backdrop, f as FieldLabel, S as StateMessage, C as CheckboxTick, g as useCheckboxGroup$1, h as CheckboxGroupContext$1, j as useCheckboxInGroup, k as useEnterAnimation, l as useCheckbox, m as FieldNecessityIndicator, T as Tooltip, n as FieldTooltipTrigger } from './unsafe-Br2TKd7D.mjs';
export { o as ButtonBar, p as Checkbox, q as CheckboxGroup, s as TopBar, r as useTooltipTrigger } from './unsafe-Br2TKd7D.mjs';
import { useDisclosure } from '@react-aria/disclosure';
import { useButton, useToggleButton as useToggleButton$1 } from '@react-aria/button';
import { useMenuTrigger, useMenuItem, useMenu as useMenu$1 } from '@react-aria/menu';
import { useTreeState } from '@react-stately/tree';
import { Item } from '@react-stately/collections';
import { useMenuTriggerState } from '@react-stately/menu';
import { DismissButton, useOverlay, useOverlayPosition } from '@react-aria/overlays';
import { useOption, useListBox } from '@react-aria/listbox';
import '@react-stately/list';
import { useTextField as useTextField$1 } from '@react-aria/textfield';
import { useComboBox } from '@react-aria/combobox';
import { useSearchField } from '@react-aria/searchfield';
import { useSearchFieldState } from '@react-stately/searchfield';
import { useComboBoxState } from '@react-stately/combobox';
import isEqual from 'react-fast-compare';
import { focusSafely } from '@react-aria/focus';
import '@react-aria/tooltip';
import '@react-stately/tooltip';
import { flushSync } from 'react-dom';
import { useCheckboxGroup, useCheckboxGroupItem } from '@react-aria/checkbox';
import { useCheckboxGroupState } from '@react-stately/checkbox';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useRadioGroup as useRadioGroup$1, useRadio as useRadio$1 } from '@react-aria/radio';
import { useRadioGroupState } from '@react-stately/radio';
import { useControlledState } from '@react-stately/utils';
import { useMove, PressResponder } from '@react-aria/interactions';
import { useToggleState } from '@react-stately/toggle';
import { useNumberFieldState } from '@react-stately/numberfield';
import { useNumberField } from '@react-aria/numberfield';
import { today, getLocalTimeZone, getWeeksInMonth, parseDate, CalendarDate, endOfMonth } from '@internationalized/date';
import { useCalendarState } from '@react-stately/calendar';
import { useCalendar, useCalendarCell, useCalendarGrid } from '@react-aria/calendar';
import { useDateFormatter, useNumberFormatter } from '@react-aria/i18n';
import { useDatePicker as useDatePicker$1, useDateSegment, useDateField as useDateField$1 } from '@react-aria/datepicker';
import { useDatePickerState, useDateFieldState } from '@react-stately/datepicker';
import { useSelect, HiddenSelect } from '@react-aria/select';
import { useSelectState } from '@react-stately/select';
import { v4 } from 'uuid';
import { useDrop, useDrag } from '@react-aria/dnd';
import Cropper from 'react-easy-crop';
import { InfoQuitSaveHero } from '@gemini/illustrations';
import { useSlider, useSliderThumb } from '@react-aria/slider';
import { useSliderState } from '@react-stately/slider';
import { useNumberFormat, unformat, format } from '@react-input/number-format';
import { useMask, unformat as unformat$1, format as format$1 } from '@react-input/mask';
import { useProgressBar } from '@react-aria/progress';
import { useTabListState } from '@react-stately/tabs';
import { useTabPanel as useTabPanel$1, useTab as useTab$1, useTabList as useTabList$1 } from '@react-aria/tabs';
import { parsePhoneNumber, ParseError } from 'libphonenumber-js/core';
import '@react-aria/label';
import 'recharts';
import '@react-stately/overlays';
import '@react-aria/dialog';

function useAccordionItem({ id: idProp, isExpanded: isExpandedProp, isDisabled: isDisabledProp, defaultExpanded, onExpandedChange, onPress, groupState }, refs) {
    const defaultId = useId();
    const id = idProp ?? defaultId;
    const isExpanded = groupState ? groupState.expandedKeys.has(id) : isExpandedProp;
    const isDisabled = isDisabledProp || groupState?.isDisabled || false;
    const props = {
        ...isExpanded !== undefined ? {
            isExpanded
        } : {},
        ...defaultExpanded !== undefined ? {
            defaultExpanded
        } : {},
        isDisabled,
        onExpandedChange (isExpanded) {
            if (groupState) {
                groupState.toggleKey(id);
            }
            onExpandedChange?.(isExpanded);
        }
    };
    const state = useDisclosureState(props);
    const { buttonProps: triggerProps, panelProps } = useDisclosure({
        ...props
    }, state, refs.panel);
    const { buttonProps, isPressed } = useButton({
        ...triggerProps,
        onPress: chain(triggerProps.onPress, onPress)
    }, refs.trigger);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled
    });
    const { boxProps: focusProps, isFocusVisible: isFocused } = useFocusable(refs.trigger, {
        isDisabled
    });
    return {
        boxProps: {
            button: mergeProps(buttonProps, focusProps, hoverProps),
            panel: panelProps
        },
        isDisabled,
        isExpanded: state.isExpanded,
        isPressed,
        isHovered,
        isFocused
    };
}

const AccordionItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { id, title, titleAs = 'span', titleSize = '22', subTitle, description, content, isDisabled: isDisabledProp, variant = 'bordered', icon: Icon, isExpanded: isExpandedProp, defaultExpanded, onExpandedChange, onPress, groupState, ...containerProps } = props;
    const tokens = useTokens();
    const triggerRef = useObjectRef(ref);
    const panelRef = useRef(null);
    const { boxProps: { button: buttonProps, panel: { hidden, ...panelProps } }, isDisabled, isExpanded, isPressed, isHovered, isFocused } = useAccordionItem({
        ...props
    }, {
        trigger: triggerRef,
        panel: panelRef
    });
    const isExiting = useExitAnimation(panelRef, isExpanded);
    const computedPadding = useMemo(()=>`calc(${tokens['unsafe_component.accordion.spacing.padding']} - ${tokens['unsafe_component.accordion.borderWidth']})`, [
        tokens
    ]);
    const getBackgroundColor = useMemo(()=>{
        switch(true){
            case isPressed && !isDisabled:
                return `unsafe_component.accordion.color.bgPressed`;
            case isHovered || isFocused:
                return `unsafe_component.accordion.color.bgHovered`;
            case isDisabled:
                return `unsafe_component.accordion.color.bgDisabled`;
            default:
                return `unsafe_component.accordion.color.bg`;
        }
    }, [
        isDisabled,
        isFocused,
        isHovered,
        isPressed
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        width: "100%",
        overflow: [
            'hidden',
            'clip'
        ],
        ...containerProps,
        ...variant === 'bordered' ? {
            borderStyle: 'solid',
            borderWidth: 'unsafe_component.accordion.borderWidth',
            borderColor: 'unsafe_component.accordion.color.border',
            borderRadius: 'unsafe_component.accordion.radius'
        } : {
            borderBottomStyle: 'solid',
            borderBottomWidth: 'borderWidth.1',
            borderColor: 'unsafe_component.accordion.color.divider'
        },
        children: [
            /*#__PURE__*/ jsxs(Box, {
                as: "button",
                type: "button",
                ref: triggerRef,
                ...buttonProps,
                display: "flex",
                alignItems: "center",
                borderStyle: "none",
                textAlign: "left",
                width: "100%",
                padding: computedPadding,
                paddingBottom: isExpanded ? 'unsafe_component.accordion.spacing.padding' : undefined,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                outlineStyle: isFocused ? 'auto' : 'none',
                outlineOffset: "-unsafe_component.accordion.spacing.gap",
                color: isDisabled ? 'unsafe_component.accordion.color.textDisabled' : 'unsafe_component.accordion.color.text',
                backgroundColor: getBackgroundColor,
                children: [
                    Icon && /*#__PURE__*/ jsx(Icon, {
                        marginRight: "unsafe_component.accordion.spacing.padding",
                        size: "sizing.24"
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        width: "100%",
                        paddingRight: "unsafe_component.accordion.spacing.gap",
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                typography: `unsafe_component.accordion.typography.titleNew.${titleSize}`,
                                as: titleAs,
                                margin: "spacing.none",
                                children: title
                            }),
                            subTitle !== undefined && /*#__PURE__*/ jsx(Box, {
                                typography: "unsafe_component.accordion.typography.subTitle",
                                children: subTitle
                            }),
                            description !== undefined && /*#__PURE__*/ jsx(Box, {
                                typography: "unsafe_component.accordion.typography.description",
                                color: isDisabled ? 'unsafe_component.accordion.color.textDisabled' : 'unsafe_component.accordion.color.description',
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(IconElement$7, {
                        isExpanded: isExpanded
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                ...panelProps,
                ref: panelRef,
                display: "grid",
                overflow: [
                    'hidden',
                    'clip'
                ],
                gridTemplateRows: '0fr',
                typography: "unsafe_component.accordion.typography.content",
                transitionProperty: "all",
                transitionDuration: "unsafe_component.accordion.motionDuration",
                transitionTimingFunction: "unsafe_component.accordion.motionEasing",
                paddingHorizontal: computedPadding,
                paddingTop: isExpanded ? 'unsafe_component.accordion.spacing.padding' : 0,
                paddingBottom: isExpanded ? computedPadding : 0,
                unsafe_style: {
                    contentVisibility: (isExpanded || isExiting) && // Due to a bug in Chromatic, we need to remove contentVisibility to have a correct snapshot
                    process.env.NODE_ENV !== 'test' ? 'auto' : undefined,
                    gridTemplateRows: isExpanded ? '1fr' : undefined
                },
                hidden: isExpanded ? undefined : hidden,
                children: /*#__PURE__*/ jsx(Box, {
                    minHeight: 0,
                    children: content
                })
            })
        ]
    });
});
const IconElement$7 = ({ isExpanded })=>{
    const Icon = ChevronDownIcon;
    return /*#__PURE__*/ jsx(Icon, {
        transform: isExpanded ? 'rotate(180deg)' : '',
        transitionDuration: "unsafe_component.accordion.motionDuration",
        transitionTimingFunction: "unsafe_component.accordion.motionEasing",
        size: "sizing.20"
    });
};

const _Accordion = ({ titleAs = 'span', titleSize = '22', variant = 'bordered', ...props }, ref)=>{
    if (props.v2) {
        const { v2, items, isDisabled, onExpandedChange, expandedKeys, defaultExpandedKeys, ...restProps } = props;
        // User should decide between v2 or not and should not switch from v1 to v2 dynamically. So we assumre that it won't change overtime.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const state = useDisclosureGroupState({
            allowsMultipleExpanded: true,
            isDisabled: Boolean(isDisabled),
            onExpandedChange: onExpandedChange,
            ...expandedKeys ? {
                expandedKeys
            } : {},
            ...defaultExpandedKeys ? {
                defaultExpandedKeys
            } : {}
        });
        return /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: variant !== 'divided' ? 'unsafe_component.accordion.spacing.padding' : undefined,
            width: "100%",
            ...restProps,
            children: items.map((item)=>/*#__PURE__*/ createElement(AccordionItem, {
                    ...item,
                    key: item.id,
                    groupState: state,
                    titleAs: titleAs,
                    titleSize: titleSize,
                    variant: variant
                }))
        });
    } else {
        // @TODO: Old Accordion implementation, return to be removed in the next major version
        return /*#__PURE__*/ jsx(AccordionItem, {
            ref: ref,
            titleAs: titleAs,
            titleSize: titleSize,
            variant: variant,
            ...props,
            // Previous implementation used `isExpanded` prop, but now we use `defaultExpanded` for uncontrolled behavior.
            isExpanded: undefined,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            defaultExpanded: props.isExpanded,
            marginBottom: "unsafe_component.accordion.spacing.padding"
        });
    }
};
// To keep generic working, won't be needed anymore in react 19
const Accordion = /*#__PURE__*/ forwardRef(_Accordion);

// @TODO: Create a global mapping helper for this kind of stuff
// https://avivgroup.atlassian.net/browse/GEMINI-1186
const assignToReactAriaPress$2 = (pressHandler)=>(e)=>pressHandler ? pressHandler({
            ...e,
            target: e.element,
            type: e.eventType
        }) : undefined;
const ActionMenuToggle = ({ state, boxProps, children })=>{
    const { menuTriggerProps } = useMenuTrigger({
        type: 'menu',
        trigger: 'press'
    }, state, boxProps.toggle.ref);
    return children({
        ref: boxProps.toggle.ref,
        id: boxProps.toggle.id,
        'aria-haspopup': boxProps.toggle['aria-haspopup'] ?? 'menu',
        'aria-expanded': menuTriggerProps['aria-expanded'] ?? false,
        'aria-controls': state.isOpen ? boxProps.toggle['aria-controls'] ?? boxProps.menu.id : null,
        onPressStart: assignToReactAriaPress$2(menuTriggerProps.onPressStart),
        onPress: assignToReactAriaPress$2(menuTriggerProps.onPress),
        onKeyDown: menuTriggerProps.onKeyDown,
        preventFocusOnPress: menuTriggerProps.preventFocusOnPress
    });
};

const DESKTOP_BREAKPOINT$1 = 'sm';

const useActionMenuItemAnchor = (ref, { id, state, isDisabled, isActive, isExternal, href })=>{
    const refObject = useObjectRef$1(ref);
    const { boxProps, ...states } = useActionMenuItem(refObject, {
        id,
        state,
        isActive,
        isDisabled
    });
    return {
        boxProps: mergeProps(boxProps, {
            ref: refObject,
            href: isDisabled ? undefined : href,
            target: isExternal ? '_blank' : undefined,
            'aria-disabled': isDisabled,
            'aria-current': isActive ? 'page' : undefined,
            rel: isExternal ? 'noopener' : undefined
        }),
        ...states
    };
};
const useActionMenuItemButton = (ref, { id, state, isActive, isDisabled })=>{
    const refObject = useObjectRef$1(ref);
    const { boxProps, ...states } = useActionMenuItem(refObject, {
        id,
        state,
        isActive,
        isDisabled
    });
    return {
        boxProps: mergeProps(boxProps, {
            ref: refObject,
            type: 'button',
            disabled: isDisabled,
            'aria-current': isActive || undefined
        }),
        ...states
    };
};
const useActionMenuItem = (ref, { id, state, isActive, isDisabled })=>{
    const { menuItemProps, isFocusVisible: isKeyboardFocused, isPressed } = useMenuItem({
        key: id
    }, state, ref);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    // Remove unused or self-assigned properties
    const { 'aria-disabled': ariaDisabled, 'aria-describedby': ariaDescribedBy, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, ...ariaMenuItemProps } = menuItemProps;
    return {
        boxProps: mergeProps(hoverProps, ariaMenuItemProps),
        isPressed,
        isFocused: isKeyboardFocused,
        isHovered,
        isActive: Boolean(isActive),
        isDisabled: Boolean(isDisabled)
    };
};

/**
 * Only allowed to be rendered within a component that calls `useMenu`
 */ const ActionMenuItem = ({ id, state, elementType, children, icon, iconProps, href, isActive, isDisabled, isExternal = false })=>{
    return /*#__PURE__*/ jsx(Box, {
        as: "li",
        role: "none",
        children: elementType === 'button' ? /*#__PURE__*/ jsx(ActionMenuItemButton, {
            id: id,
            state: state,
            isActive: isActive,
            isDisabled: isDisabled,
            icon: icon,
            iconProps: iconProps,
            children: children
        }) : /*#__PURE__*/ jsx(ActionMenuItemAnchor, {
            id: id,
            state: state,
            href: href,
            isActive: isActive,
            isDisabled: isDisabled,
            isExternal: isExternal,
            icon: icon,
            iconProps: iconProps,
            children: children
        })
    });
};
const ActionMenuItemButton = ({ id, state, isActive, isDisabled, icon, iconProps, children })=>{
    const ref = useRef(null);
    const { boxProps, ...states } = useActionMenuItemButton(ref, {
        id,
        state,
        isActive,
        isDisabled
    });
    const stateStyleBoxProps = useMemo(()=>mapStatesToBoxProps(states), [
        states
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...STYLE_BOX_PROPS,
        ...stateStyleBoxProps,
        ...boxProps,
        as: "button",
        type: "button",
        borderStyle: "initial",
        textAlign: "initial",
        children: [
            icon ? /*#__PURE__*/ jsx(IconElement$6, {
                icon: icon,
                iconProps: iconProps
            }) : null,
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                children: children
            })
        ]
    });
};
const ActionMenuItemAnchor = ({ id, state, isActive, isDisabled, isExternal, href, icon, iconProps, children })=>{
    const ref = useRef(null);
    const { boxProps, ...states } = useActionMenuItemAnchor(ref, {
        id,
        state,
        isActive,
        isDisabled,
        isExternal,
        href
    });
    const stateStyleBoxProps = useMemo(()=>mapStatesToBoxProps(states), [
        states
    ]);
    const LinkComponent = useRenderLink({
        isExternal
    });
    return /*#__PURE__*/ jsxs(LinkComponent, {
        ...STYLE_BOX_PROPS,
        ...stateStyleBoxProps,
        ...boxProps,
        as: "a",
        children: [
            icon ? /*#__PURE__*/ jsx(IconElement$6, {
                icon: icon,
                iconProps: iconProps
            }) : null,
            /*#__PURE__*/ jsxs(Box, {
                as: "span",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                width: "100%",
                children: [
                    children,
                    isExternal && /*#__PURE__*/ jsx(ExternalLinkIcon, {
                        size: "sizing.24",
                        marginLeft: "unsafe_component.actionMenu.spacing.menuItem.gapExternalIcon"
                    })
                ]
            })
        ]
    });
};
const IconElement$6 = ({ icon: Icon, iconProps = {} })=>/*#__PURE__*/ jsx(Icon, {
        ...iconProps,
        size: "sizing.24",
        marginRight: "unsafe_component.actionMenu.spacing.menuItem.gapIcon"
    });
const STYLE_BOX_PROPS = {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    padding: 'unsafe_component.actionMenu.spacing.menuItem.padding',
    typography: 'unsafe_component.actionMenu.typography.menuItem',
    outlineWidth: 'borderWidth.2',
    outlineOffset: '-borderWidth.2'
};
const mapStatesToBoxProps = ({ isDisabled, isActive, isPressed, isHovered, isFocused })=>{
    const bgTokenPrefix = isActive ? 'bgActive' : 'bg';
    const contentTokenPrefix = isActive ? 'contentActive' : 'content';
    const baseBoxProps = {
        color: `unsafe_component.actionMenu.color.menuItem.${contentTokenPrefix}`,
        backgroundColor: `unsafe_component.actionMenu.color.menuItem.${bgTokenPrefix}`,
        cursor: 'pointer',
        outlineStyle: 'none',
        borderRadius: {
            [`breakpoint.base`]: 'radius.8',
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'radius.none'
        }
    };
    if (isDisabled) {
        return {
            ...baseBoxProps,
            color: 'unsafe_component.actionMenu.color.menuItem.contentDisabled',
            backgroundColor: 'unsafe_component.actionMenu.color.menuItem.bgDisabled',
            cursor: 'not-allowed'
        };
    }
    if (isPressed) {
        return {
            ...baseBoxProps,
            color: `unsafe_component.actionMenu.color.menuItem.${contentTokenPrefix}Pressed`,
            backgroundColor: `unsafe_component.actionMenu.color.menuItem.${bgTokenPrefix}Pressed`
        };
    }
    if (isFocused) {
        return {
            ...baseBoxProps,
            color: `unsafe_component.actionMenu.color.menuItem.${contentTokenPrefix}Focused`,
            backgroundColor: `unsafe_component.actionMenu.color.menuItem.${bgTokenPrefix}Focused`,
            outlineStyle: 'auto'
        };
    }
    if (isHovered) {
        return {
            ...baseBoxProps,
            color: `unsafe_component.actionMenu.color.menuItem.${contentTokenPrefix}Hovered`,
            backgroundColor: `unsafe_component.actionMenu.color.menuItem.${bgTokenPrefix}Hovered`
        };
    }
    return baseBoxProps;
};

const useActionMenuItemGroup = (ref, { boxProps, state, toggleState, ...popoverProps })=>{
    const collectionItems = useMemo(()=>getCollectionItems(state), [
        state
    ]);
    // @TODO: GEMINI-1180 - Fix menu not closing by tabbing outside
    // See example https://react-spectrum.adobe.com/react-aria/useMenu.html#menuitem
    const { menuProps } = useMenu$1({
        id: boxProps.menu.id,
        'aria-labelledby': boxProps.toggle.id,
        autoFocus: toggleState.focusStrategy || false,
        onClose: toggleState.close,
        onAction: (key)=>{
            const keyAsId = key.toString();
            const item = collectionItems.find(({ value })=>value.id === keyAsId);
            if (!item || !item.value?.onAction) {
                return;
            }
            item.value.onAction(keyAsId);
        }
    }, state, ref);
    return {
        collectionItems,
        boxProps: mergeProps(menuProps, popoverProps)
    };
};
const getCollectionItems = (state)=>{
    return [
        ...state.collection
    ].filter((item)=>item.value !== null);
};

const ActionMenuItemGroup = ({ popoverWidth, boxProps, state, toggleState, ...popoverProps })=>{
    const { collectionItems, boxProps: menuBoxProps } = useActionMenuItemGroup(boxProps.menu.ref, {
        boxProps,
        state,
        toggleState,
        ...popoverProps
    });
    const { unsafe_style, ...listBoxProps } = menuBoxProps;
    return /*#__PURE__*/ jsx(Box, {
        as: "div",
        ref: boxProps.menu.ref,
        unsafe_style: unsafe_style,
        display: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'flex'
        },
        flexDirection: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'column'
        },
        paddingVertical: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'unsafe_component.actionMenu.spacing.menuItemGroup.paddingVertical'
        },
        width: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: popoverWidth ?? 'unsafe_component.actionMenu.sizing.menuItemGroup.width'
        },
        maxWidth: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: popoverWidth !== undefined ? 'unsafe_component.actionMenu.sizing.menuItemGroup.width' : undefined
        },
        backgroundColor: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'unsafe_component.actionMenu.color.menuItemGroup.bg'
        },
        boxShadow: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'unsafe_component.actionMenu.shadow.menuItemGroup'
        },
        borderRadius: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'unsafe_component.actionMenu.radius.menuItemGroup'
        },
        overflowY: {
            [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: [
                'hidden',
                'clip'
            ]
        },
        children: /*#__PURE__*/ jsx(Box, {
            as: "ul",
            ...listBoxProps,
            listStyleType: "none",
            padding: 0,
            margin: 0,
            maxHeight: {
                [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: '50vh'
            },
            overflowY: {
                [`breakpoint.${DESKTOP_BREAKPOINT$1}`]: 'auto'
            },
            children: collectionItems.map((collectionItem)=>{
                const { children, ...menuItemProps } = {
                    ...collectionItem.value,
                    state
                };
                return /*#__PURE__*/ createElement(ActionMenuItem, {
                    ...menuItemProps,
                    key: menuItemProps.id
                }, children);
            })
        })
    });
};

const useActionMenu = ({ menuItems, activeMenuItem, isOpen, defaultOpen, onOpenChange })=>{
    const toggleRef = useRef(null);
    const menuRef = useRef(null);
    const disabledKeys = useMemo(()=>getDisabledKeys(menuItems), [
        menuItems
    ]);
    const menuItemsWithActive = useMemo(()=>getMenuItemsWithActive(menuItems, activeMenuItem), [
        menuItems,
        activeMenuItem
    ]);
    const treeState = useTreeState({
        selectionMode: 'none',
        disallowEmptySelection: false,
        disabledKeys,
        items: menuItemsWithActive,
        children: (item)=>/*#__PURE__*/ jsx(Item, {
                children: item.children
            })
    });
    const toggleState = useMenuTriggerState({
        trigger: 'press',
        ...isOpen !== undefined ? {
            isOpen
        } : {},
        ...defaultOpen !== undefined ? {
            defaultOpen
        } : {},
        ...onOpenChange !== undefined ? {
            onOpenChange
        } : {}
    });
    return {
        boxProps: {
            toggle: {
                id: useId$1(),
                ref: toggleRef
            },
            menu: {
                id: useId$1(),
                ref: menuRef
            }
        },
        ...treeState,
        ...toggleState
    };
};
const getDisabledKeys = (menuItems)=>{
    const disabledItems = menuItems.filter((item)=>item.isDisabled);
    return disabledItems.reduce((previous, current)=>[
            ...previous,
            current.id
        ], []);
};
const getMenuItemsWithActive = (menuItems, activeMenuItem)=>menuItems.map((menuItem)=>({
            ...menuItem,
            isActive: menuItem.id === activeMenuItem
        }));

const ActionMenu = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { menuItems, children, activeMenuItem, shouldFlip, alignment, placement, 'aria-label': ariaLabel, isOpen: isOpenProp, defaultOpen, onOpenChange, // eslint-disable-next-line @typescript-eslint/no-deprecated
    hasAutoWidth = false, popoverWidth } = props;
    const isMobile = useBreakpointValue({
        base: true,
        [DESKTOP_BREAKPOINT$1]: false
    });
    const { boxProps, ...stateProps } = useActionMenu({
        menuItems,
        activeMenuItem,
        isOpen: isOpenProp,
        defaultOpen,
        onOpenChange
    });
    const { focusStrategy, isOpen, setOpen, open, close, toggle, ...treeState } = stateProps;
    const toggleState = {
        focusStrategy,
        isOpen,
        setOpen,
        open,
        close,
        toggle
    };
    return /*#__PURE__*/ jsx(FocusableProvider, {
        ref: ref,
        position: "relative",
        children: isMobile ? /*#__PURE__*/ jsx(Modal, {
            title: ariaLabel,
            isDismissable: true,
            isOpen: isOpen,
            onOpenChange: setOpen,
            trigger: (modalTriggerProps)=>/*#__PURE__*/ jsx(ActionMenuToggle, {
                    boxProps: {
                        ...boxProps,
                        toggle: {
                            ...boxProps.toggle,
                            'aria-controls': modalTriggerProps['aria-controls'],
                            'aria-haspopup': modalTriggerProps['aria-haspopup']
                        }
                    },
                    state: toggleState,
                    children: (props)=>children(props)
                }),
            children: /*#__PURE__*/ jsx(ActionMenuItemGroup, {
                boxProps: boxProps,
                state: treeState,
                toggleState: toggleState
            })
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(ActionMenuToggle, {
                    boxProps: boxProps,
                    state: toggleState,
                    children: (props)=>children(props)
                }),
                /*#__PURE__*/ jsx(Overlay, {
                    isOpen: isOpen,
                    children: /*#__PURE__*/ jsx(ActionMenuPopover, {
                        boxProps: boxProps,
                        state: toggleState,
                        shouldFlip: shouldFlip,
                        placement: placement,
                        alignment: alignment,
                        children: (popoverProps, underlayProps)=>/*#__PURE__*/ jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ jsx(Box, {
                                        ...underlayProps,
                                        position: "fixed",
                                        top: 0,
                                        bottom: 0,
                                        left: 0,
                                        right: 0
                                    }),
                                    /*#__PURE__*/ jsx(ActionMenuItemGroup, {
                                        ...popoverProps,
                                        boxProps: boxProps,
                                        state: treeState,
                                        toggleState: toggleState,
                                        popoverWidth: popoverWidth ?? (hasAutoWidth ? 'auto' : undefined)
                                    })
                                ]
                            })
                    })
                })
            ]
        })
    });
});
const ActionMenuPopover = ({ boxProps, state, children, shouldFlip = true, placement = 'bottom', alignment })=>{
    const tokens = useTokens();
    const rootFontSizeValue = getRootFontSizeValue();
    const { boxProps: popoverBoxProps } = usePopover({
        popover: boxProps.menu.ref,
        trigger: boxProps.toggle.ref
    }, {
        isOpen: state.isOpen,
        close: state.close,
        shouldFlip,
        offset: parseFloat(tokens['unsafe_component.actionMenu.spacing.menuItemGroup.paddingVertical'].toString()) * rootFontSizeValue,
        placement,
        alignment: alignment ?? (placement === 'left' || placement === 'right' ? 'start' : 'end')
    });
    return children(popoverBoxProps.popover, popoverBoxProps.underlay);
};

const InfoState = ({ description, endButtonProps, image, title, titleAs, startButtonProps, ...restProps })=>{
    const imageComp = useMemo(()=>{
        if (!image) return null;
        if (typeof image === 'string') {
            return /*#__PURE__*/ jsx(Box, {
                as: "img",
                src: image,
                alt: title,
                maxHeight: "unsafe_component.infoState.sizing.image",
                borderRadius: "unsafe_component.infoState.radius.image"
            });
        }
        const Icon = image;
        return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            "aria-label": title
        });
    }, [
        image,
        title
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: {
            'breakpoint.sm': '50vw',
            'breakpoint.base': '100%'
        },
        padding: "unsafe_component.infoState.spacing.gap.title",
        children: [
            imageComp,
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "unsafe_component.infoState.spacing.margin.contentHeader",
                marginBottom: startButtonProps || endButtonProps ? 'unsafe_component.infoState.spacing.margin.content' : undefined,
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: titleAs !== undefined && isAllowedTitleTag(titleAs) ? titleAs : 'span',
                        typography: "unsafe_component.infoState.typography.contentHeader",
                        // Reset margin to avoid spacing from heading level tag
                        margin: "spacing.none",
                        marginBottom: "unsafe_component.infoState.spacing.gap.title",
                        textAlign: "center",
                        children: title
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        textAlign: "center",
                        typography: "unsafe_component.infoState.typography.content",
                        children: description
                    })
                ]
            }),
            startButtonProps && /*#__PURE__*/ jsx(Button, {
                ...startButtonProps,
                variant: "primary",
                isFullWidth: {
                    'breakpoint.sm': false,
                    'breakpoint.base': true
                }
            }),
            endButtonProps && /*#__PURE__*/ jsx(Button, {
                ...endButtonProps,
                variant: "tertiary",
                isFullWidth: {
                    'breakpoint.sm': false,
                    'breakpoint.base': true
                },
                marginTop: startButtonProps ? 'unsafe_component.infoState.spacing.margin.button' : undefined
            })
        ]
    });
};

const useLoadingStateTranslation = ()=>useTranslation({
        'en-GB': {
            'loadingState::label::loading': 'Loading…'
        },
        'fr-FR': {
            'loadingState::label::loading': 'Chargement…'
        },
        'de-DE': {
            'loadingState::label::loading': 'Laden…'
        },
        'nl-NL': {
            'loadingState::label::loading': 'Laden…'
        }
    });

const spin$1 = unsafe_keyframes({
    from: {
        transform: 'rotate(0deg)'
    },
    to: {
        transform: 'rotate(360deg)'
    }
});
const LoadingState = ({ title, description, size = '32', variant = 'dark', ariaLabel, ariaLive = 'assertive', ...restProps })=>{
    const tokens = useTokens();
    const t = useLoadingStateTranslation();
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ...restProps,
        children: [
            /*#__PURE__*/ jsx(Box, {
                role: "status",
                display: "flex",
                unsafe_style: {
                    fontSize: tokens[`unsafe_component.loadingState.sizing.${size}`]
                },
                "aria-label": ariaLabel ?? t('loadingState::label::loading'),
                "aria-live": ariaLive,
                children: /*#__PURE__*/ jsx(LoaderIcon, {
                    color: `unsafe_component.loadingState.color.${variant}`,
                    size: "inherit",
                    animationDuration: "unsafe_component.loadingState.motionDuration",
                    animationTimingFunction: "unsafe_component.loadingState.motionEasing",
                    animationName: spin$1,
                    animationIterationCount: "infinite"
                })
            }),
            title !== undefined && /*#__PURE__*/ jsx(Box, {
                textAlign: "center",
                typography: "unsafe_component.loadingState.typography.title",
                marginTop: "unsafe_component.loadingState.spacing.gap.title",
                color: `unsafe_component.loadingState.color.${variant}`,
                children: title
            }),
            description !== undefined && /*#__PURE__*/ jsx(Box, {
                textAlign: "center",
                typography: "unsafe_component.loadingState.typography.description",
                marginTop: "unsafe_component.loadingState.spacing.gap.description",
                color: `unsafe_component.loadingState.color.${variant}`,
                children: description
            })
        ]
    });
};

const useSelectableListItem = (ref, { id, state })=>{
    const { optionProps, labelProps, descriptionProps, isSelected, isPressed, isFocused, isDisabled } = useOption({
        key: id
    }, state, ref);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled
    });
    return {
        boxProps: {
            option: mergeProps(hoverProps, optionProps, {
                ref
            }),
            label: labelProps,
            suffix: descriptionProps
        },
        isSelected,
        isPressed,
        isFocused,
        isHovered
    };
};

const SelectableListItem = ({ id, label, suffix, state, variant, icon, iconPosition = 'end', isCustomItem, ...restProps })=>{
    const ref = useRef(null);
    const { boxProps, isSelected, isPressed, isFocused, isHovered } = useSelectableListItem(ref, {
        id,
        state
    });
    const backgroundColor = useMemo(()=>mapStateToBackgroundColor$1({
            isSelected,
            isFocused,
            isPressed,
            isHovered
        }), [
        isSelected,
        isFocused,
        isPressed,
        isHovered
    ]);
    const mapIconMarginProps = ({ iconPosition })=>{
        const key = `margin${iconPosition === 'start' ? 'Right' : 'Left'}`;
        return {
            [key]: 'unsafe_component.selectableList.option.spacing.margin'
        };
    };
    const iconProps = {
        icon,
        iconPosition,
        margin: useMemo(()=>mapIconMarginProps({
                iconPosition
            }), [
            iconPosition
        ])
    };
    const IconElement = ({ icon: Icon, margin })=>{
        if (!Icon) return null;
        return /*#__PURE__*/ jsx(Box, {
            as: "span",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: iconPosition === 'end' ? 'auto' : undefined,
            children: /*#__PURE__*/ jsx(Icon, {
                size: "sizing.24",
                ...margin
            })
        });
    };
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps$1(boxProps.option, restProps),
        as: "li",
        padding: "unsafe_component.selectableList.option.spacing.padding",
        borderRadius: `unsafe_component.selectableList.option.radius.${variant}`,
        color: `unsafe_component.selectableList.option.color.content${isSelected ? 'Selected' : ''}`,
        backgroundColor: backgroundColor,
        cursor: isFocused || isHovered ? 'pointer' : undefined,
        outlineWidth: "borderWidth.none",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        typography: isCustomItem ? 'unsafe_component.selectableList.option.typography.custom' : 'unsafe_component.selectableList.option.typography.default',
        children: [
            /*#__PURE__*/ jsxs(Box, {
                ...boxProps.label,
                display: "flex",
                width: isCustomItem ? '100%' : undefined,
                children: [
                    iconPosition === 'start' ? /*#__PURE__*/ jsx(IconElement, {
                        ...iconProps
                    }) : null,
                    label
                ]
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                children: [
                    suffix && /*#__PURE__*/ jsx(Box, {
                        ...boxProps.suffix,
                        marginLeft: "unsafe_component.selectableList.option.spacing.gap",
                        textAlign: "right",
                        children: suffix
                    }),
                    iconPosition === 'end' ? /*#__PURE__*/ jsx(IconElement, {
                        ...iconProps
                    }) : null
                ]
            })
        ]
    });
};
const mapStateToBackgroundColor$1 = ({ isSelected, isFocused, isPressed, isHovered })=>{
    if (!isSelected) {
        if (isPressed) return 'unsafe_component.selectableList.option.color.bgPressed';
        if (isFocused || isHovered) return 'unsafe_component.selectableList.option.color.bgFocused';
        return 'unsafe_component.selectableList.option.color.bg';
    }
    if (isPressed) return 'unsafe_component.selectableList.option.color.bgSelectedPressed';
    if (isFocused || isHovered) return 'unsafe_component.selectableList.option.color.bgSelectedFocused';
    return 'unsafe_component.selectableList.option.color.bgSelected';
};

const useSelectableList = (ref, { state, label, autoFocus, shouldUseVirtualFocus, shouldSelectOnPressUp, shouldFocusOnHover, ...restProps })=>{
    const refObject = useObjectRef$1(ref);
    const tokens = useTokens();
    const [minHeight, setMinHeight] = useState(0);
    const ariaListBoxProps = useListBox({
        ...restProps,
        'aria-label': label,
        ...autoFocus ? {
            autoFocus
        } : {},
        shouldUseVirtualFocus: Boolean(shouldUseVirtualFocus),
        shouldSelectOnPressUp: Boolean(shouldSelectOnPressUp),
        shouldFocusOnHover: Boolean(shouldFocusOnHover)
    }, state, refObject);
    useEffect(()=>{
        if (refObject.current) {
            let height = 0;
            const itemsLength = Math.min(refObject.current.childElementCount, 4);
            for(let i = 0; i < itemsLength; i++){
                height += refObject.current.children[i]?.clientHeight || 0;
            }
            setMinHeight(height);
        }
    // Trigger when list size change
    }, [
        refObject,
        state.collection.size
    ]);
    return {
        boxProps: {
            list: {
                ...ariaListBoxProps.listBoxProps,
                ref: refObject
            },
            container: {
                minHeight: `calc((${tokens['unsafe_component.selectableList.spacing.padding.vertical']} * 2) + ${minHeight}px)`
            }
        }
    };
};

const SelectableListBase = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { state, variant, label, width, containerRef, containerProps, autoFocus, shouldUseVirtualFocus, shouldSelectOnPressUp, shouldFocusOnHover, emptyState, isLoading, loadingState, isNonModal, ...listProps } = props;
    const { boxProps } = useSelectableList(ref, {
        ...props,
        state
    });
    const showEmptyState = state.collection.size <= 0 && emptyState;
    const list = /*#__PURE__*/ jsx(Box, {
        // Margin should be before because listProps might contain some margins
        margin: "spacing.none",
        ...mergeProps(boxProps.list, listProps),
        as: showEmptyState ? 'div' : 'ul',
        display: "flex",
        flexDirection: "column",
        alignItems: showEmptyState && variant === 'borderless' ? 'center' : undefined,
        // Reset horizontal padding for UL
        paddingHorizontal: "spacing.none",
        width: "100%",
        height: "100%",
        overflow: variant === 'borderless' ? 'hidden auto' : undefined,
        outlineStyle: "none",
        children: /*#__PURE__*/ jsx(SelectableListContent, {
            variant: variant,
            state: state,
            emptyState: emptyState,
            isLoading: isLoading,
            loadingState: loadingState
        })
    });
    if (variant === 'borderless') return list;
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(containerProps, boxProps.container),
        display: "flex",
        backgroundColor: "unsafe_component.selectableList.color.bg",
        borderRadius: "unsafe_component.selectableList.radius",
        boxShadow: `unsafe_component.selectableList.shadow.${variant}`,
        paddingVertical: state.collection.size > 0 ? 'unsafe_component.selectableList.spacing.padding.vertical' : undefined,
        padding: state.collection.size <= 0 ? 'unsafe_component.selectableList.spacing.emptyList.padding' : undefined,
        overflow: [
            'hidden',
            'clip'
        ],
        ref: containerRef,
        width: width || '100%',
        children: [
            !isNonModal && 'close' in state && /*#__PURE__*/ jsx(DismissButton, {
                onDismiss: state.close
            }),
            /*#__PURE__*/ jsx(Box, {
                display: "flex",
                overflowX: [
                    'hidden',
                    'clip'
                ],
                overflowY: "auto",
                width: "100%",
                children: list
            }),
            'close' in state && /*#__PURE__*/ jsx(DismissButton, {
                onDismiss: state.close
            })
        ]
    });
});
const SelectableListContent = ({ variant, emptyState, state, isLoading, loadingState })=>{
    return isLoading ? /*#__PURE__*/ jsx(ContentLoadingState, {
        loadingState: loadingState,
        variant: variant
    }) : state.collection.size <= 0 && emptyState ? variant === 'borderless' ? /*#__PURE__*/ jsx(Box, {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        role: "option",
        children: /*#__PURE__*/ jsx(InfoState, {
            title: emptyState.title,
            description: emptyState.description,
            image: emptyState.image
        })
    }) : /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        role: "option",
        children: [
            /*#__PURE__*/ jsx(Box, {
                typography: "unsafe_component.selectableList.typography.emptyListTitle",
                marginBottom: "unsafe_component.selectableList.spacing.emptyList.gap",
                children: emptyState?.title
            }),
            /*#__PURE__*/ jsx(Box, {
                typography: "unsafe_component.selectableList.typography.emptyListDescription",
                children: emptyState?.description
            })
        ]
    }) : [
        ...state.collection
    ].map(({ value }, index, array)=>{
        if (!value) return null;
        return /*#__PURE__*/ jsx(SelectableListItem, {
            id: value.id,
            label: value.label,
            suffix: value.suffix,
            state: state,
            variant: variant,
            icon: value.icon,
            isCustomItem: value.isCustomItem,
            iconPosition: value.iconPosition,
            marginTop: index === 0 && variant === 'borderless' ? 'unsafe_component.selectableList.spacing.padding.vertical' : undefined,
            marginBottom: index === array.length - 1 && variant === 'borderless' ? 'unsafe_component.selectableList.spacing.padding.vertical' : undefined
        }, value.id);
    });
};
const ContentLoadingState = ({ loadingState, variant })=>{
    const t = useLoadingStateTranslation();
    const isBorderless = variant === 'borderless';
    return /*#__PURE__*/ jsxs(Box, {
        as: "li",
        display: "flex",
        flexDirection: isBorderless ? 'column' : undefined,
        height: isBorderless ? '100%' : undefined,
        justifyContent: isBorderless ? 'center' : undefined,
        paddingVertical: "unsafe_component.selectableList.spacing.loading.padding.vertical",
        paddingHorizontal: "unsafe_component.selectableList.spacing.loading.padding.horizontal",
        borderRadius: `unsafe_component.selectableList.option.radius.${variant}`,
        outlineWidth: "borderWidth.none",
        children: [
            /*#__PURE__*/ jsx(LoadingState, {
                size: isBorderless ? '32' : '24',
                ariaLabel: loadingState?.title ?? t('loadingState::label::loading')
            }),
            /*#__PURE__*/ jsx(Box, {
                "aria-hidden": "true",
                display: "flex",
                justifyContent: isBorderless ? 'center' : undefined,
                alignItems: isBorderless ? 'center' : undefined,
                marginTop: isBorderless ? 'unsafe_component.selectableList.spacing.loading.title.margin.top' : undefined,
                marginLeft: !isBorderless ? 'unsafe_component.selectableList.spacing.loading.title.margin.left' : undefined,
                typography: `unsafe_component.selectableList.typography.loading.title.${variant}`,
                children: loadingState?.title ?? t('loadingState::label::loading')
            })
        ]
    });
};

const useTextField = (ref, { label, isDisabled, isOptional, min, max, placeholder, name, error, inputMode, autoComplete, containerRef, ...rest })=>{
    const defaultInputMode = rest.type === 'number' ? 'decimal' : 'text';
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const { inputProps, labelProps, descriptionProps, errorMessageProps } = useTextField$1({
        [labelProp]: typeof label === 'string' ? label : label.content,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        placeholder: placeholder,
        autoComplete: autoComplete,
        name: name,
        isInvalid: Boolean(error),
        inputMode: inputMode ?? defaultInputMode,
        ...rest.type !== 'number' ? {
            minLength: min,
            maxLength: max
        } : {},
        // useTextFieldReactAria will pass type and placeholder props
        ...rest
    }, ref);
    return {
        boxProps: {
            input: mergeProps({
                ...inputProps,
                ...rest.type === 'number' ? {
                    min,
                    max
                } : {}
            }),
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        }
    };
};
const useTextFieldBase = (refs, { isDisabled })=>{
    const { inputRef, endButtonRef } = refs;
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusProps, isFocused } = useFocusable(inputRef, {
        unsafe_ignoreProviderProps: true
    });
    return {
        boxProps: {
            wrapper: {
                ...hoverProps,
                onClick: (event)=>{
                    if (inputRef.current && event.target !== inputRef.current && event.target !== endButtonRef?.current) {
                        inputRef.current?.focus();
                    }
                }
            },
            input: focusProps
        },
        isFocused,
        isHovered
    };
};

const TextFieldIcon = ({ icon: Icon, borderWidth })=>{
    const tokens = useTokens();
    if (!Icon) return null;
    return /*#__PURE__*/ jsx(Icon, {
        size: "sizing.24",
        marginVertical: `calc(${tokens['unsafe_component.textField.spacing.padding.vertical']} - ${borderWidth})`,
        color: "unsafe_component.textField.color.icon"
    });
};

const TextFieldInput = /*#__PURE__*/ forwardRef(({ borderWidth, hasStartIcon, hasEndIcon, hasSuffix, type, ...restProps }, ref)=>{
    const tokens = useTokens();
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        ref: ref,
        as: "input",
        type: type,
        borderWidth: "borderWidth.none",
        padding: "spacing.none",
        outlineStyle: "none",
        placeholderColor: "unsafe_component.textField.color.placeholder",
        paddingVertical: `calc(${tokens['unsafe_component.textField.spacing.padding.vertical']} - ${borderWidth})`,
        flexGrow: 1,
        marginLeft: hasStartIcon ? 'unsafe_component.textField.spacing.gap' : undefined,
        marginRight: hasSuffix || hasEndIcon ? 'unsafe_component.textField.spacing.endContentGap' : undefined,
        minWidth: 0,
        onWheel: type === 'number' ? (e)=>e.currentTarget.blur() : undefined,
        size: 1,
        width: "100%"
    });
});

const TextFieldSuffix = ({ suffix, borderWidth, hasEndIcon })=>{
    const tokens = useTokens();
    if (!suffix) return null;
    return /*#__PURE__*/ jsx(Box, {
        as: "span",
        paddingVertical: `calc(${tokens['unsafe_component.textField.spacing.padding.vertical']} - ${borderWidth})`,
        color: "unsafe_component.textField.color.suffix",
        userSelect: "none",
        marginRight: hasEndIcon ? 'unsafe_component.textField.spacing.gap' : undefined,
        children: suffix
    });
};

const TextFieldBase = ({ inputRef, inputProps, containerRef, ...props })=>{
    const { isDisabled, error, suffix, iconEnd: IconEnd, iconStart: IconStart, isFullWidth } = props;
    const hasEndButton = IconEnd && typeof IconEnd === 'object';
    const tokens = useTokens();
    const endButtonRef = useRef(null);
    const { boxProps: { input: inputBaseBoxProps, wrapper: wrapperBoxProps }, isFocused, isHovered } = useTextFieldBase({
        inputRef,
        endButtonRef
    }, props);
    const borderWidth = isFocused ? tokens['unsafe_component.textField.borderWidth.active'] : tokens['unsafe_component.textField.borderWidth.default'];
    const borderColor = useMemo(()=>{
        const hasError = Boolean(error);
        switch(true){
            case isDisabled:
                return `unsafe_component.textField.color.borderDisabled`;
            case hasError && isHovered && !isFocused:
                return `unsafe_component.textField.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.textField.color.borderError`;
            case isFocused:
                return `unsafe_component.textField.color.borderFocus`;
            case isHovered:
                return `unsafe_component.textField.color.borderHover`;
            default:
                return `unsafe_component.textField.color.border`;
        }
    }, [
        error,
        isDisabled,
        isFocused,
        isHovered
    ]);
    const textFieldMinWidth = useMemo(()=>mapTextFieldWidthProps(isFullWidth), [
        isFullWidth
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...wrapperBoxProps,
        display: "flex",
        alignItems: "center",
        borderWidth: isFocused ? 'unsafe_component.textField.borderWidth.active' : 'unsafe_component.textField.borderWidth.default',
        borderStyle: "solid",
        borderColor: borderColor,
        borderRadius: "unsafe_component.textField.radius",
        backgroundColor: isDisabled ? `unsafe_component.textField.color.bgDisabled` : `unsafe_component.textField.color.bg`,
        paddingLeft: `calc(${tokens['unsafe_component.textField.spacing.padding.horizontal']} - ${borderWidth})`,
        paddingRight: hasEndButton ? `calc(${tokens['unsafe_component.textField.spacing.padding.endButton']} - ${borderWidth})` : `calc(${tokens['unsafe_component.textField.spacing.padding.horizontal']} - ${borderWidth})`,
        height: "unsafe_component.textField.sizing.height",
        color: isDisabled ? `unsafe_component.textField.color.textDisabled` : `unsafe_component.textField.color.text`,
        typography: "unsafe_component.textField.typography",
        cursor: isDisabled ? 'not-allowed' : 'text',
        minWidth: textFieldMinWidth,
        ref: containerRef,
        children: [
            /*#__PURE__*/ jsx(TextFieldIcon, {
                icon: IconStart,
                borderWidth: borderWidth
            }),
            /*#__PURE__*/ jsx(TextFieldInput, {
                ...mergeProps(inputProps, inputBaseBoxProps),
                ref: inputRef,
                hasEndIcon: Boolean(IconEnd),
                hasStartIcon: Boolean(IconStart),
                hasSuffix: Boolean(suffix),
                borderWidth: borderWidth
            }),
            /*#__PURE__*/ jsx(TextFieldSuffix, {
                suffix: suffix,
                borderWidth: borderWidth,
                hasEndIcon: Boolean(IconEnd)
            }),
            hasEndButton ? /*#__PURE__*/ jsx(Button, {
                ...IconEnd,
                iconOnly: true,
                size: "40",
                variant: "tertiary",
                ref: endButtonRef
            }) : /*#__PURE__*/ jsx(TextFieldIcon, {
                icon: IconEnd,
                borderWidth: borderWidth
            })
        ]
    });
};
const mapTextFieldWidthProps = (isFullWidthWithResponsive)=>{
    // if we don't have full width i.E. undefined / false return min width of the field
    if (!isFullWidthWithResponsive) {
        return 'unsafe_component.textField.sizing.minWidth';
    }
    // if the prop is not an responsive object return 100% directly
    if (typeof isFullWidthWithResponsive === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidthWithResponsive).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            // apply 100% for full width or default min width of the field
            [breakpoint]: isFullWidth ? '100%' : 'unsafe_component.textField.sizing.minWidth'
        };
    }, {});
};

const cache = new Map();
/**
 * Provides localized string collation for the current locale. Automatically updates when the locale changes,
 * and handles caching of the collator for performance.
 * @param options - Collator options.
 */ function useCollator(options) {
    const locale = useLocale();
    const cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
    }
    const formatter = new Intl.Collator(locale, options);
    cache.set(cacheKey, formatter);
    return formatter;
}

/**
 * Provides localized string search functionality that is useful for filtering or matching items
 * in a list. Options can be provided to adjust the sensitivity to case, diacritics, and other parameters.
 */ function useFilter(options) {
    const collator = useCollator({
        usage: 'search',
        ...options
    });
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    const startsWith = useCallback((string, substring)=>{
        if (substring.length === 0) {
            return true;
        }
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    const endsWith = useCallback((string, substring)=>{
        if (substring.length === 0) {
            return true;
        }
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    const contains = useCallback((string, substring)=>{
        if (substring.length === 0) {
            return true;
        }
        string = string.normalize('NFC');
        substring = substring.normalize('NFC');
        let scan = 0;
        const sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            const slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) {
                return true;
            }
        }
        return false;
    }, [
        collator
    ]);
    return useMemo(()=>({
            startsWith,
            endsWith,
            contains
        }), [
        startsWith,
        endsWith,
        contains
    ]);
}

const AutocompleteContext = /*#__PURE__*/ createContext(null);
const AutocompleteProvider = (props)=>{
    const { value, defaultValue, items, defaultItems = [], isMobile, emptyState, onSubmit, onChange, onOpenChange, error, children, shouldFocusFirstItem = false, menuTrigger = 'input', customItems } = props;
    const { contains } = useFilter({
        sensitivity: 'base'
    });
    const allowsEmptyCollection = Boolean(isMobile || emptyState);
    const additionalCustomItems = customItems ? customItems.map((item, id)=>({
            id: `custom-action-${id}`,
            label: item.label,
            icon: item.icon,
            iconPosition: item.iconPosition,
            isCustomItem: true,
            onAction: item.onAction
        })) : [];
    const contextValue = useComboBoxState({
        menuTrigger,
        inputValue: value,
        defaultInputValue: defaultValue,
        defaultFilter: (textValue, inputValue)=>{
            const isCustomItemMatch = customItems?.find((customItem)=>textValue === customItem.label);
            const isDefaultItemMatch = defaultItems.some(({ label })=>contains(label, inputValue));
            if (isCustomItemMatch && (!emptyState || isDefaultItemMatch)) {
                return true;
            }
            return contains(textValue, inputValue);
        },
        ...items ? {
            items: [
                ...items,
                ...additionalCustomItems
            ]
        } : {
            defaultItems: [
                ...defaultItems,
                ...additionalCustomItems
            ]
        },
        allowsEmptyCollection,
        allowsCustomValue: true,
        shouldCloseOnBlur: !isMobile,
        children: (item)=>/*#__PURE__*/ jsx(Item, {
                children: item.label
            }),
        onSelectionChange: (key)=>{
            const getCustomItem = additionalCustomItems?.find((item)=>key === item.id);
            if (getCustomItem) {
                getCustomItem.onAction();
                // Revert selection as we do not want it selected (it's not a real option)
                contextValue.revert();
                return;
            }
            return key !== null && onSubmit && onSubmit(null, key);
        },
        onInputChange: (value)=>{
            const customId = additionalCustomItems?.find((items)=>items.id === contextValue.selectedKey);
            if (!customId && onChange) {
                onChange(value);
            }
        },
        ...onOpenChange && {
            onOpenChange
        },
        // Not sure that the combobox state use it anyway
        isInvalid: Boolean(error)
    });
    const lastValue = useRef(contextValue.inputValue);
    const lastItems = useRef(items || []);
    /**
	 * Add use case to the existing one in the combobox state
	 * This will help to manage empty list without having to use `allowsEmptyCollection`
	 * This useEffect rely only on `items` list that is the controlled way of working with Autocomplete and APIs
	 * We check that the items list is not equal while the input value is still the same and that selectedItem is not the same as input value to avoid reopening
	 * https://github.com/adobe/react-spectrum/blob/020a0a53d53140f5561e5a5b68ad73a9660eca0d/packages/%40react-stately/combobox/src/useComboBoxState.ts#L157-L165
	 */ useEffect(()=>{
        if (contextValue.isFocused && !allowsEmptyCollection && !contextValue.isOpen && contextValue.inputValue === lastValue.current && items && !isEqual(items, lastItems.current) && (!contextValue.selectedItem || contextValue.inputValue !== contextValue.selectedItem.value?.label)) {
            contextValue.open(null, 'input');
        }
    }, [
        allowsEmptyCollection,
        contextValue,
        items
    ]);
    useEffect(()=>{
        if (shouldFocusFirstItem && contextValue.isFocused && contextValue.isOpen && contextValue.collection.size > 0 && !contextValue.selectionManager.focusedKey) {
            contextValue.selectionManager.setFocusedKey(contextValue.collection.getFirstKey(), 'first');
        }
    }, [
        shouldFocusFirstItem,
        contextValue
    ]);
    useEffect(()=>{
        lastValue.current = contextValue.inputValue;
        lastItems.current = items || [];
    });
    return /*#__PURE__*/ jsx(AutocompleteContext.Provider, {
        value: contextValue,
        children: children
    });
};
const useAutocompleteContext = ()=>{
    const contextValue = useContext(AutocompleteContext);
    if (!contextValue) {
        throw new Error('The `AutocompleteProvider` has not been instantiated correctly with its corresponding context. Please make sure that it is rendered higher in your app. If the issue persists, report it to Team GEMINI.');
    }
    return contextValue;
};

const useAutocomplete = (ref, props)=>{
    const { onChange, items, label, isDisabled, isOptional, onSubmit, onOpenChange, onClear, placeholder, name, emptyState, value, defaultValue, error, isMobile, autoComplete = 'off', placement, ...rest } = props;
    const { textfield: textfieldRef, selectableList: selectableListRef, popover: popoverRef } = ref;
    const context = useAutocompleteContext();
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const searchProp = {
        ...rest,
        [labelProp]: typeof label === 'string' ? label : label.content,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        value: context.inputValue,
        autoComplete,
        placeholder: placeholder || '',
        name: name || '',
        onSubmit: (value)=>{
            // Prevent submission from search field if menu item was selected
            if (onSubmit && context.selectionManager.focusedKey === null) {
                onSubmit(value, null);
            }
        },
        onClear: ()=>{
            context.setInputValue('');
            if (onClear) onClear();
        },
        isInvalid: Boolean(error)
    };
    const searchState = useSearchFieldState(searchProp);
    const { inputProps: inputBoxProps } = useSearchField(searchProp, searchState, textfieldRef);
    const { inputProps: comboBoxInputProps, // Remove linkBehavior, not used on our side as we have our own solution regarding links
    listBoxProps: { linkBehavior, ...listBoxProps }, labelProps, descriptionProps, errorMessageProps } = useComboBox({
        [labelProp]: typeof label === 'string' ? label : label.content,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        popoverRef,
        listBoxRef: selectableListRef,
        inputRef: textfieldRef,
        isInvalid: Boolean(error)
    }, context);
    const textfieldProps = mergeProps(inputBoxProps, comboBoxInputProps);
    return {
        boxProps: {
            // `useCombobox` enforce `autoComplete="off"`, in most cases it's fine, but if we don't want autofill, we need to be able to pass something like `new-password`
            // So we return the `autoComplete` given from the props and fallback to `off` when no value is passed
            input: {
                ...textfieldProps,
                autoComplete
            },
            list: listBoxProps,
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        }
    };
};
const useAutocompleteMobile = (ref, props)=>{
    const { textfield: textfieldRef, popover: popoverRef } = ref;
    const { textfieldProps, onSubmit } = props;
    const context = useAutocompleteContext();
    // Close the software keyboard on scroll to give the user a bigger area to scroll.
    // But only do this if scrolling with touch, otherwise it can cause issues with touch
    // screen readers.
    const isTouchDown = useRef(false);
    const onTouchStart = ()=>{
        isTouchDown.current = true;
    };
    const onTouchEnd = ()=>{
        isTouchDown.current = false;
    };
    const onScroll = useCallback(()=>{
        if (!textfieldRef.current || document.activeElement !== textfieldRef.current || !isTouchDown.current) {
            return;
        }
        if (popoverRef.current) {
            popoverRef.current.focus();
        }
    }, [
        textfieldRef,
        popoverRef,
        isTouchDown
    ]);
    const onKeyDown = (e)=>{
        // Close virtual keyboard, close modal, and fire onSubmit if user hits Enter w/o any focused options
        if (e.key === 'Enter' && context.selectionManager.focusedKey == null) {
            popoverRef.current?.focus();
            if (onSubmit) {
                onSubmit(context.inputValue == null ? null : context.inputValue.toString(), null);
            }
        }
    };
    // Taken from react-aria MobileComboBox implementation:
    // https://github.com/adobe/react-spectrum/blob/19bc0b84597cb3e88b04829626eda48302fe911f/packages/%40react-spectrum/combobox/src/MobileComboBox.tsx#L376-L385
    // Override the role of the input to "searchbox" instead of "combobox".
    // Since the listbox is always visible, the combobox role doesn't really give us anything.
    // VoiceOver on iOS reads "double tap to collapse" when focused on the input rather than
    // "double tap to edit text", as with a textbox or searchbox. We'd like double tapping to
    // open the virtual keyboard rather than closing the tray.
    // Unlike "combobox", "aria-expanded" is not a valid attribute on "searchbox".
    textfieldProps.role = 'searchbox';
    textfieldProps['aria-haspopup'] = 'listbox';
    delete textfieldProps['aria-expanded'];
    delete textfieldProps.onTouchEnd;
    return {
        boxProps: {
            textfield: mergeProps(textfieldProps, {
                onKeyDown
            }),
            list: {
                onScroll,
                onTouchStart,
                onTouchEnd
            }
        }
    };
};
const useAutocompleteClearButton = (ref, { isDisabled, onClear })=>{
    const context = useAutocompleteContext();
    return {
        boxProps: {
            // Same properties as used in the react-aria useSearchField implementation but simplified
            excludeFromTabOrder: true,
            preventFocusOnPress: true,
            isDisabled,
            onPress: ()=>{
                context.setInputValue('');
                if (onClear) {
                    onClear();
                }
            },
            onPressStart: ()=>ref.current?.focus()
        },
        showClearButton: context.inputValue !== ''
    };
};
const useAutocompleteList = (ref, props)=>{
    const { trigger: triggerRef, popover: popoverRef } = ref;
    const { boxProps: popoverBoxProps } = usePopover({
        popover: popoverRef,
        trigger: triggerRef
    }, {
        ...props,
        unsafe_isNonModal: true
    });
    return {
        boxProps: popoverBoxProps?.popover
    };
};

const useAutocompleteTranslation = ()=>useTranslation({
        'en-GB': {
            'autocomplete::clearLabel': 'Clear search'
        },
        'fr-FR': {
            'autocomplete::clearLabel': 'Effacer la recherche'
        },
        'de-DE': {
            'autocomplete::clearLabel': 'Suche zurücksetzen'
        },
        'nl-NL': {
            'autocomplete::clearLabel': 'Zoekactie wissen'
        }
    });

const Field = /*#__PURE__*/ forwardRef((props, forwardedRef)=>{
    const { as = DEFAULT_LABEL_AS, children, ...restProps } = props;
    const { boxProps } = useField({
        as,
        ...restProps
    });
    return /*#__PURE__*/ jsx(FieldBase, {
        as: as,
        ref: forwardedRef,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        labelProps: boxProps.label,
        ...restProps,
        children: children({
            fieldRenderProps: boxProps.field,
            errorId: boxProps.error.id,
            labelId: boxProps.label.id
        })
    });
});

const MobileAutocomplete = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { placeholder, name, emptyState, iconStart, onChange, onFocus, onBlur, onOpenChange, onClear, items, defaultItems, onSubmit, value, defaultValue, shouldFlip, shouldFocusFirstItem, menuTrigger, isFullWidth, autoComplete, isLoading, loadingState, customItems, ...fieldProps } = props;
    const inputRef = useObjectRef();
    const dialogRef = useObjectRef();
    const context = useAutocompleteContext();
    return(// Field is used here instead of FieldBase to prevent moving useAutocomplete upward and
    // having a focus issue seemingly related to selectableListRef when pressing the clear button in the trigger component
    // and also to avoid duplicate usage of ids between the trigger button and the real
    // autocomplete inside the modal, the Field on the trigger will stay standalone
    /*#__PURE__*/ jsx(Field, {
        position: "relative",
        ...fieldProps,
        hasScreenReaderHiddenLabel: typeof fieldProps.label !== 'string' && fieldProps.label.isHidden,
        ref: ref,
        children: ({ fieldRenderProps })=>/*#__PURE__*/ jsx(Modal, {
                ref: dialogRef,
                title: typeof fieldProps.label === 'string' ? fieldProps.label : fieldProps.label.content,
                hasContentPadding: false,
                isOpen: context.isOpen,
                displayMode: "fullscreen",
                isDismissable: true,
                onOpenChange: (isOpen)=>!isOpen ? context.close() : null,
                trigger: ({ onPress, ...triggerProps })=>/*#__PURE__*/ jsx(MobileAutocompleteButton, {
                        ...mergeProps$1(triggerProps, fieldRenderProps),
                        inputRef: inputRef,
                        iconStart: iconStart,
                        placeholder: placeholder,
                        isFullWidth: isFullWidth,
                        isDisabled: fieldProps.isDisabled,
                        onClear: onClear,
                        error: fieldProps.error
                    }),
                children: /*#__PURE__*/ jsx(MobileAutocompleteContent, {
                    props: props,
                    inputRef: inputRef,
                    dialogRef: dialogRef
                })
            })
    }));
});
const MobileAutocompleteButton = /*#__PURE__*/ forwardRef(({ inputRef, isDisabled, onClear, error, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedby, isFullWidth, iconStart: IconStart, placeholder, ...restProps }, ref)=>{
    const valueId = useId$1();
    const tokens = useTokens();
    const context = useAutocompleteContext();
    const t = useAutocompleteTranslation();
    const { boxProps: clearButtonProps, showClearButton } = useAutocompleteClearButton(inputRef, {
        isDisabled,
        onClear
    });
    const { boxProps: buttonProps, isFocused, isHovered } = useButton$1(ref, {
        isDisabled,
        onPress: ()=>context.open(null, 'manual'),
        type: 'button'
    });
    const borderWidth = isFocused ? tokens['unsafe_component.textField.borderWidth.active'] : tokens['unsafe_component.textField.borderWidth.default'];
    const borderColor = useMemo(()=>{
        const hasError = Boolean(error);
        switch(true){
            case isDisabled:
                return `unsafe_component.textField.color.borderDisabled`;
            case hasError && isHovered && !isFocused:
                return `unsafe_component.textField.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.textField.color.borderError`;
            case isFocused:
                return `unsafe_component.textField.color.borderFocus`;
            case isHovered:
                return `unsafe_component.textField.color.borderHover`;
            default:
                return `unsafe_component.textField.color.border`;
        }
    }, [
        error,
        isDisabled,
        isFocused,
        isHovered
    ]);
    const textFieldMinWidth = useMemo(()=>mapTextFieldWidthProps(isFullWidth), [
        isFullWidth
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        position: "relative",
        display: "inline-flex",
        minWidth: textFieldMinWidth,
        children: [
            /*#__PURE__*/ jsxs(Box, {
                ...mergeProps$1(buttonProps, restProps),
                "aria-labelledby": [
                    ariaLabelledBy,
                    valueId
                ].join(' '),
                "aria-describedby": ariaDescribedby,
                ref: ref,
                display: "inline-flex",
                alignItems: "center",
                borderWidth: isFocused ? 'unsafe_component.textField.borderWidth.active' : 'unsafe_component.textField.borderWidth.default',
                borderStyle: "solid",
                borderColor: borderColor,
                borderRadius: "unsafe_component.textField.radius",
                backgroundColor: isDisabled ? `unsafe_component.textField.color.bgDisabled` : `unsafe_component.textField.color.bg`,
                paddingVertical: `calc(${tokens['unsafe_component.textField.spacing.padding.vertical']} - ${borderWidth})`,
                paddingLeft: `calc(${tokens['unsafe_component.textField.spacing.padding.horizontal']} - ${borderWidth})`,
                paddingRight: showClearButton ? `calc(${tokens['unsafe_component.textField.spacing.padding.endButton']} - ${borderWidth} + ${tokens['unsafe_component.textField.spacing.gap']} + ${tokens['unsafe_component.button.sizing.40']})` : `calc(${tokens['unsafe_component.textField.spacing.padding.horizontal']} - ${borderWidth})`,
                outlineWidth: "borderWidth.none",
                height: "unsafe_component.textField.sizing.height",
                color: isDisabled ? `unsafe_component.textField.color.textDisabled` : `unsafe_component.textField.color.text`,
                typography: "unsafe_component.textField.typography",
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                width: "100%",
                children: [
                    IconStart ? /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ jsx(IconStart, {
                            size: "sizing.24",
                            marginRight: "unsafe_component.textField.spacing.gap"
                        })
                    }) : null,
                    /*#__PURE__*/ jsx(Box, {
                        id: valueId,
                        as: "span",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        flexGrow: 1,
                        children: context.inputValue || placeholder
                    })
                ]
            }),
            showClearButton ? /*#__PURE__*/ jsx(Box, {
                display: "inline-flex",
                position: "absolute",
                right: "unsafe_component.textField.spacing.padding.endButton",
                top: "50%",
                transform: "translateY(-50%)",
                children: /*#__PURE__*/ jsx(Button, {
                    ...clearButtonProps,
                    icon: CloseIcon,
                    iconOnly: true,
                    size: "40",
                    variant: "tertiary",
                    type: "button",
                    children: t('autocomplete::clearLabel')
                })
            }) : null
        ]
    });
});
const MobileAutocompleteContent = ({ props, inputRef, dialogRef })=>{
    const { placeholder, name, emptyState, iconStart, onChange, onFocus, onBlur, onOpenChange, onClear, items, defaultItems, onSubmit, value, defaultValue, shouldFlip, shouldFocusFirstItem, menuTrigger, isFullWidth, autoComplete, isLoading, loadingState, customItems, ...fieldProps } = props;
    const selectableListRef = useRef(null);
    const t = useAutocompleteTranslation();
    const context = useAutocompleteContext();
    // TMP: deactivated as we won't use `inert` for now with duplication of code in `usePopover` and `useModalOverlay`
    // Temporary solution to avoid the non-cleaning of aria-hidden on the outside elements when the tray is closed
    // Certainly due to the fact that combobox and modal concurrently want to either hide or inert the outside elements but cleaning is not able to be done properly on both inert/aria-hidden
    // Reality is that we should not be using combobox without popover in a modal normally, so we should change this component code to replace useCombobox in mobile by useAutocomplete (new hook)
    // But there is other issues of doing that (not the same states, ...)
    // https://github.com/adobe/react-spectrum/issues/8934
    // useEffect(() => {
    // 	if (context.isOpen) {
    // 		return ariaHideOutside(
    // 			[inputRef.current, dialogRef.current].filter(
    // 				(element) => element != null,
    // 			),
    // 			{ shouldUseInert: true },
    // 		);
    // 	}
    // 	return () => {};
    // }, [context.isOpen, inputRef, dialogRef]);
    const { boxProps } = useAutocomplete({
        textfield: inputRef,
        selectableList: selectableListRef,
        popover: dialogRef
    }, props);
    const { boxProps: { textfield: finalTextfieldProps, list: listMobileProps } } = useAutocompleteMobile({
        textfield: inputRef,
        popover: dialogRef
    }, {
        ...props,
        textfieldProps: boxProps.input
    });
    const { boxProps: clearButtonProps, showClearButton } = useAutocompleteClearButton(inputRef, {
        isDisabled: fieldProps.isDisabled,
        onClear
    });
    useEffect(()=>{
        if (inputRef.current) {
            focusSafely(inputRef.current);
        }
        // When the tray unmounts, set state.isFocused (i.e. the tray input's focus tracker) to false.
        // This is to prevent state.isFocused from being set to true when the tray closes via tapping on the underlay
        // (FocusScope attempts to restore focus to the tray input when tapping outside the tray due to "contain")
        // Have to do this manually since React doesn't call onBlur when a component is unmounted: https://github.com/facebook/react/issues/12363
        return ()=>{
            context.setFocused(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        padding: "spacing.16",
        paddingBottom: "spacing.none",
        height: "100%",
        children: [
            /*#__PURE__*/ jsx(FieldBase, {
                position: "relative",
                labelProps: boxProps.label,
                helperProps: boxProps.helper,
                errorProps: boxProps.error,
                ...fieldProps,
                children: /*#__PURE__*/ jsx(TextFieldBase, {
                    isDisabled: fieldProps.isDisabled,
                    iconStart: iconStart,
                    iconEnd: showClearButton ? {
                        ...clearButtonProps,
                        icon: CloseIcon,
                        children: t('autocomplete::clearLabel')
                    } : undefined,
                    error: fieldProps.error,
                    inputRef: inputRef,
                    inputProps: mergeProps$1({
                        name,
                        placeholder,
                        autoComplete: 'off'
                    }, finalTextfieldProps),
                    isFullWidth: true
                })
            }),
            /*#__PURE__*/ jsx(SelectableListBase, {
                ...mergeProps$1(boxProps.list, listMobileProps),
                variant: "borderless",
                label: typeof fieldProps.label === 'string' ? fieldProps.label : fieldProps.label.content,
                ref: selectableListRef,
                state: context,
                emptyState: emptyState,
                isLoading: isLoading,
                loadingState: loadingState,
                // change default hover behavior of react-aria list to only apply style on hover
                shouldFocusOnHover: false
            })
        ]
    });
};

const Autocomplete = /*#__PURE__*/ forwardRef(({ menuTrigger, ...props }, ref)=>{
    const isMobile = useBreakpointValue({
        base: true,
        sm: false
    });
    return(// Enforce empty collection on mobile to always display the modal open even when there is no items
    /*#__PURE__*/ jsx(AutocompleteProvider, {
        ...props,
        menuTrigger: isMobile ? 'input' : menuTrigger,
        isMobile: isMobile,
        children: isMobile ? /*#__PURE__*/ jsx(MobileAutocomplete, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ jsx(DesktopAutocomplete, {
            ...props,
            ref: ref
        })
    }));
});
const DesktopAutocomplete = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { placeholder, name, isFullWidth, emptyState, iconStart, onChange, onFocus, onBlur, onOpenChange, onClear, items, defaultItems, onSubmit, value, defaultValue, shouldFlip, shouldFocusFirstItem, menuTrigger, autoComplete, isLoading, loadingState, customItems, placement, ...fieldProps } = props;
    const inputRef = useObjectRef$1(ref);
    const popoverRef = useRef(null);
    const selectableListRef = useRef(null);
    const containerRef = useRef(null);
    const [listWidth, setListWidth] = useState(0);
    const t = useAutocompleteTranslation();
    const context = useAutocompleteContext();
    const onResize = useCallback(()=>{
        if (containerRef.current) {
            const containerWidth = containerRef.current.offsetWidth;
            setListWidth(containerWidth);
        }
    }, [
        setListWidth
    ]);
    useResizeObserver(containerRef, {
        onResize
    });
    useLayoutEffect(onResize, [
        onResize
    ]);
    const { boxProps } = useAutocomplete({
        textfield: inputRef,
        selectableList: selectableListRef,
        popover: popoverRef
    }, {
        ...props,
        placement
    });
    const { boxProps: clearButtonProps, showClearButton } = useAutocompleteClearButton(inputRef, {
        isDisabled: fieldProps.isDisabled,
        onClear
    });
    return /*#__PURE__*/ jsx(FocusableProvider, {
        position: "relative",
        children: /*#__PURE__*/ jsxs(FieldBase, {
            position: "relative",
            labelProps: boxProps.label,
            helperProps: boxProps.helper,
            errorProps: boxProps.error,
            ...fieldProps,
            children: [
                /*#__PURE__*/ jsx(TextFieldBase, {
                    isDisabled: fieldProps.isDisabled,
                    iconStart: iconStart,
                    iconEnd: showClearButton ? {
                        ...clearButtonProps,
                        icon: CloseIcon,
                        children: t('autocomplete::clearLabel')
                    } : undefined,
                    error: fieldProps.error,
                    inputRef: inputRef,
                    inputProps: mergeProps({
                        name,
                        placeholder,
                        autoComplete: 'off'
                    }, boxProps.input),
                    containerRef: containerRef,
                    isFullWidth: isFullWidth
                }),
                /*#__PURE__*/ jsx(Overlay, {
                    isOpen: context.isOpen,
                    children: /*#__PURE__*/ jsx(AutocompleteList, {
                        ...boxProps.list,
                        label: fieldProps.label,
                        triggerRef: containerRef,
                        selectableListRef: selectableListRef,
                        listWidth: listWidth,
                        emptyState: emptyState,
                        shouldFlip: shouldFlip,
                        popoverRef: popoverRef,
                        isLoading: isLoading,
                        loadingState: loadingState,
                        placement: placement
                    })
                })
            ]
        })
    });
});
const AutocompleteList = (props)=>{
    const { label, triggerRef, selectableListRef, listWidth, emptyState, shouldFlip, popoverRef, isLoading, loadingState, placement, ...listProps } = props;
    const tokens = useTokens();
    const rootFontSizeValue = getRootFontSizeValue();
    const context = useAutocompleteContext();
    const { boxProps: popoverProps } = useAutocompleteList({
        trigger: triggerRef,
        popover: popoverRef
    }, {
        isOpen: context.isOpen,
        close: context.close,
        shouldFlip,
        placement,
        offset: parseFloat(tokens['unsafe_component.textField.borderWidth.active'].toString()) * rootFontSizeValue
    });
    return /*#__PURE__*/ jsx(SelectableListBase, {
        ...listProps,
        variant: "contained",
        label: typeof label === 'string' ? label : label.content,
        ref: selectableListRef,
        width: listWidth,
        containerProps: popoverProps,
        containerRef: popoverRef,
        maxHeight: "50vh",
        state: context,
        emptyState: emptyState,
        isLoading: isLoading,
        loadingState: loadingState,
        isNonModal: true,
        // change default hover behavior of react-aria list to only apply style on hover
        shouldFocusOnHover: false
    });
};

const Initials = ({ initials, label, size = '24' })=>{
    const initialToUpperCase = (initials ?? '').toUpperCase().substring(0, 2);
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                color: "unsafe_component.avatar.color.text",
                typography: `unsafe_component.avatar.typography.initials.${size}`,
                "aria-hidden": "true",
                userSelect: "none",
                children: initialToUpperCase
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                srOnly: true,
                children: label
            })
        ]
    });
};

const Image$1 = ({ label, imageUrl, imageFit, type = 'square', maxSize = '120x48', loading })=>{
    const tokens = useTokens();
    const paddingToken = tokens['unsafe_component.avatar.spacing.padding'];
    const typeProps = type === 'rectangle-fluid' ? {
        maxHeight: `calc(${maxSize.split('x')[1]}px - (${paddingToken} * 2))`,
        maxWidth: `calc(${maxSize.split('x')[0]}px - (${paddingToken} * 2))`,
        minWidth: `calc(24px - (${paddingToken} * 2))`,
        minHeight: `calc(24px - (${paddingToken} * 2))`
    } : {};
    return /*#__PURE__*/ jsx(Box, {
        borderRadius: `unsafe_component.avatar.radius.${type}`,
        as: "img",
        src: imageUrl,
        // Known issue : on Safari the alt text is not displayed when it's larger than the image size
        // https://stackoverflow.com/questions/20265415/img-alt-text-is-not-displayed-when-it-is-long
        alt: label,
        loading: loading,
        ...typeProps,
        objectFit: imageFit,
        objectPosition: "center",
        width: type !== 'rectangle-fluid' ? '100%' : undefined,
        height: type !== 'rectangle-fluid' ? '100%' : undefined,
        overflow: [
            'hidden',
            'clip'
        ]
    });
};

const Avatar = (props)=>{
    const { imageUrl, label, size = '24', maxSize = '120x48', type = 'square', icon: Icon, imageFit = 'cover', loading, hasPaddingDisabled = false, hasBorderDisabled = false, initials, ...restProps } = props;
    const tokens = useTokens();
    const borderStyle = useMemo(()=>{
        if (hasBorderDisabled) return {};
        return {
            borderStyle: 'solid',
            borderWidth: 'unsafe_component.avatar.borderWidth',
            borderColor: 'unsafe_component.avatar.color.border'
        };
    }, [
        hasBorderDisabled
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ...mergeProps(restProps, borderStyle),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // To avoid shrink when used within a container with `display="flex"`
        flex: "none",
        width: type === 'rectangle-fluid' ? 'fit-content' : `unsafe_component.avatar.sizing.${size}`,
        height: type === 'rectangle-fluid' ? 'fit-content' : `unsafe_component.avatar.sizing.${size}`,
        padding: !hasPaddingDisabled ? `calc(${tokens['unsafe_component.avatar.spacing.padding']} ${!hasBorderDisabled ? `- ${tokens['unsafe_component.avatar.borderWidth']}` : ''} )` : undefined,
        borderRadius: `unsafe_component.avatar.radius.wrapper.${type}`,
        backgroundColor: imageUrl ? `unsafe_component.avatar.color.background.image` : `unsafe_component.avatar.color.background.default`,
        backgroundClip: "padding-box",
        overflow: [
            'hidden',
            'clip'
        ],
        children: imageUrl ? /*#__PURE__*/ jsx(Image$1, {
            label: label,
            imageUrl: imageUrl,
            type: type,
            imageFit: imageFit,
            maxSize: maxSize,
            loading: loading
        }) : Icon ? /*#__PURE__*/ jsx(Icon, {
            "aria-label": label,
            size: `sizing.${size === '24' ? '16' : '24'}`
        }) : initials ? /*#__PURE__*/ jsx(Initials, {
            initials: initials,
            size: size,
            label: label
        }) : null
    });
};

const CheckboxGroupContext = /*#__PURE__*/ createContext(null);
const useCheckboxButtonGroup = (ref, { isDisabled, label, ...rest })=>{
    const objectRef = useObjectRef$1(ref);
    const propsComputed = {
        ...rest,
        'aria-label': label,
        isDisabled: Boolean(isDisabled)
    };
    const state = useCheckboxGroupState(propsComputed);
    const { groupProps } = useCheckboxGroup(propsComputed, state);
    return {
        boxProps: mergeProps(groupProps, {
            ref: objectRef
        }),
        state
    };
};
const useCheckboxButton = (ref, { isDisabled, label, ...rest })=>{
    const refObject = useObjectRef$1(ref);
    const checkBoxGroupState = useContext(CheckboxGroupContext);
    const propsComputed = {
        ...rest,
        children: label,
        isDisabled: Boolean(isDisabled)
    };
    const { inputProps, labelProps, isSelected, isPressed, isDisabled: isDisabledReactAria } = useCheckboxGroupItem(propsComputed, checkBoxGroupState, refObject);
    return {
        boxProps: {
            input: mergeProps(inputProps, {
                ref: refObject
            }),
            label: labelProps
        },
        isSelected,
        isPressed,
        isDisabled: isDisabledReactAria
    };
};

const IconElement$5 = ({ label, iconPosition, icon: Icon, iconOnly })=>{
    const iconElement = useMemo(()=>{
        if (!Icon) return null;
        if (iconOnly) return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.20"
        });
        return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.20",
            [`margin${iconPosition === 'start' ? 'Right' : 'Left'}`]: 'unsafe_component.buttonGroup.spacing.button.gap'
        });
    }, [
        Icon,
        iconOnly,
        iconPosition
    ]);
    return iconOnly ? iconElement : /*#__PURE__*/ jsxs(Fragment, {
        children: [
            iconPosition === 'start' && iconElement,
            label,
            iconPosition === 'end' && iconElement
        ]
    });
};

const useButtonGroupBase = (ref, { isDisabled })=>{
    const inputRefObject = useObjectRef$1(ref);
    const { boxProps: hoverableProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusableProps, isFocusVisible } = useFocusable(inputRefObject, {
        isDisabled
    });
    return {
        boxProps: {
            label: hoverableProps,
            input: focusableProps
        },
        isHovered,
        isFocused: isFocusVisible
    };
};

const ButtonGroupBase = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { iconOnly, isStartButton, isEndButton, isPressed, isSelected, isDisabled, label, inputProps, labelProps, type, highlightColor, size } = props;
    const { boxProps, isHovered, isFocused } = useButtonGroupBase(ref, {
        isDisabled
    });
    const tokens = useTokens();
    const getPadding = (direction)=>{
        return `calc(${tokens[`unsafe_component.buttonGroup.spacing.button.padding.${direction}`]} - ${tokens['unsafe_component.buttonGroup.borderWidth']})`;
    };
    const stateProps = useMemo(()=>mapButtonStateToBoxProps$3({
            isDisabled,
            isHovered,
            isPressed,
            isSelected
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isSelected
    ]);
    const buttonRoundedRadius = 'unsafe_component.buttonGroup.radius.rounded';
    const buttonDefaultRadius = 'unsafe_component.buttonGroup.radius.none';
    const borderLeftRadius = isStartButton ? buttonRoundedRadius : buttonDefaultRadius;
    const borderRightRadius = isEndButton ? buttonRoundedRadius : buttonDefaultRadius;
    /**
	 * Using backgroundImage with linear gradient because:
	 * - Using border create unwanted rounded border for the first and last item
	 * - Using boxShadow needs high value in spread and compensation with shift down to show a flat border otherwise same issue as border
	 * 	- Example: box-shadow: inset 0px -1000px 0px -996px #000000;
	 * - Using nested element as indicator (nested span) needs usage of `overflow={['hidden', 'clip']}` on parent and create issues when the group actually needs overflow
	 * BackgroundImage + flat gradient is the most suited solution in combination with our existing backgroundColor
	 */ const highlightState = useMemo(()=>{
        const highlightHeight = tokens['unsafe_component.buttonGroup.sizing.highlight.height'];
        return highlightColor ? {
            backgroundImage: `linear-gradient(${tokens[highlightColor]},${tokens[highlightColor]})`,
            // Look at comment below
            backgroundPosition: `bottom -${highlightHeight} center`,
            // 200% to avoid fractions of pixel to show background-color instead of the fake gradient
            // 2 * highlightHeight for the same reason as the 200% but vertically background-position will compensate it
            backgroundSize: `200% calc(${highlightHeight} * 2)`,
            backgroundRepeat: 'no-repeat'
        } : {};
    }, [
        tokens,
        highlightColor
    ]);
    const buttonGroupSize = useMemo(()=>mapButtonGroupSizeProps({
            size
        }), [
        size
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(boxProps.label, labelProps, stateProps, highlightState),
        as: "label",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: getPadding('horizontal'),
        paddingVertical: getPadding('vertical'),
        borderWidth: "unsafe_component.buttonGroup.borderWidth",
        borderStyle: "solid",
        borderTopLeftRadius: borderLeftRadius,
        borderTopRightRadius: borderRightRadius,
        borderBottomLeftRadius: borderLeftRadius,
        borderBottomRightRadius: borderRightRadius,
        borderLeftWidth: "unsafe_component.buttonGroup.borderWidth",
        borderRightWidth: isEndButton ? 'unsafe_component.buttonGroup.borderWidth' : 'borderWidth.none',
        outlineWidth: "borderWidth.2",
        outlineStyle: isFocused ? 'solid' : 'none',
        outlineColor: [
            'Highlight',
            '-webkit-focus-ring-color'
        ],
        outlineOffset: "-borderWidth.2",
        transitionDuration: "unsafe_component.buttonGroup.motionDuration",
        transitionProperty: "background-color",
        transitionTimingFunction: "unsafe_component.buttonGroup.motionEasing",
        typography: "unsafe_component.buttonGroup.typography",
        height: buttonGroupSize,
        whiteSpace: "nowrap",
        "aria-label": iconOnly ? label : undefined,
        flex: 1,
        children: [
            /*#__PURE__*/ jsx(VisuallyHidden, {
                children: /*#__PURE__*/ jsx(Box, {
                    ...mergeProps(inputProps, boxProps.input),
                    as: "input",
                    type: type,
                    ref: ref
                })
            }),
            /*#__PURE__*/ jsx(IconElement$5, {
                ...props
            })
        ]
    });
});
const mapButtonStateToBoxProps$3 = ({ isDisabled, isHovered, isPressed, isSelected })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isSelected && isDisabled:
                return `unsafe_component.buttonGroup.color.bgDisabledSelected`;
            case isSelected && isPressed:
                return `unsafe_component.buttonGroup.color.bgPressedSelected`;
            case isSelected && isHovered:
                return `unsafe_component.buttonGroup.color.bgHoverSelected`;
            case isDisabled:
                return `unsafe_component.buttonGroup.color.bgDisabled`;
            case isPressed:
                return `unsafe_component.buttonGroup.color.bgPressed`;
            case isHovered:
                return `unsafe_component.buttonGroup.color.bgHover`;
            case isSelected:
                return `unsafe_component.buttonGroup.color.bgSelected`;
            default:
                return `unsafe_component.buttonGroup.color.bg`;
        }
    };
    const getBorderColor = ()=>{
        switch(true){
            case isSelected && isDisabled:
                return `unsafe_component.buttonGroup.color.borderDisabled`;
            case isSelected && isPressed:
                return `unsafe_component.buttonGroup.color.borderSelectedPressed`;
            case isSelected && isHovered:
                return `unsafe_component.buttonGroup.color.borderSelectedHover`;
            case isSelected:
                return `unsafe_component.buttonGroup.color.borderSelected`;
            case isDisabled:
                return `unsafe_component.buttonGroup.color.borderDisabled`;
            default:
                return `unsafe_component.buttonGroup.color.border`;
        }
    };
    const getColor = ()=>{
        switch(true){
            case isSelected && isDisabled:
                return `unsafe_component.buttonGroup.color.textDisabledSelected`;
            case isDisabled:
                return `unsafe_component.buttonGroup.color.textDisabled`;
            case isSelected:
                return `unsafe_component.buttonGroup.color.textSelected`;
            default:
                return `unsafe_component.buttonGroup.color.text`;
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        borderColor: getBorderColor(),
        color: getColor(),
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    };
};
const mapButtonGroupSizeProps = ({ size = '40' })=>{
    if (typeof size !== 'object') {
        return `${size}px`;
    }
    return Object.entries(size).reduce((acc, [breakpoint, size])=>{
        return {
            ...acc,
            [breakpoint]: `${size}px`
        };
    }, {});
};

const CheckboxButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { boxProps, isSelected, isPressed, isDisabled } = useCheckboxButton(ref, props);
    return /*#__PURE__*/ jsx(ButtonGroupBase, {
        ...props,
        type: "checkbox",
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        inputProps: boxProps.input,
        labelProps: boxProps.label
    });
});
const CheckboxButtonGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { items, name, iconOnly, iconPosition, size } = props;
    const { boxProps, state } = useCheckboxButtonGroup(ref, props);
    return /*#__PURE__*/ jsx(CheckboxGroupContext.Provider, {
        value: state,
        children: /*#__PURE__*/ jsx(Box, {
            ...boxProps,
            display: "inline-flex",
            flexWrap: "nowrap",
            width: "100%",
            children: items.map((item, idx)=>{
                return /*#__PURE__*/ createElement(CheckboxButton, {
                    ...item,
                    iconOnly: iconOnly,
                    iconPosition: iconPosition,
                    name: name,
                    key: item.value,
                    isStartButton: idx === 0,
                    isEndButton: idx === items.length - 1,
                    size: size
                });
            })
        })
    });
});

const RadioGroupContext$1 = /*#__PURE__*/ createContext(null);
const useRadioButtonGroup = (ref, { isDisabled, label, ...rest })=>{
    const objectRef = useObjectRef$1(ref);
    const propsComputed = {
        ...rest,
        'aria-label': label,
        isDisabled: Boolean(isDisabled)
    };
    const state = useRadioGroupState(propsComputed);
    const { radioGroupProps } = useRadioGroup$1(propsComputed, state);
    return {
        boxProps: mergeProps(radioGroupProps, {
            ref: objectRef
        }),
        state
    };
};
const useRadioButton = (ref, { isDisabled, label, ...rest })=>{
    const refObject = useObjectRef$1(ref);
    const radioGroupState = useContext(RadioGroupContext$1);
    const propsComputed = {
        ...rest,
        children: label,
        isDisabled: Boolean(isDisabled)
    };
    const { inputProps, labelProps, isSelected, isPressed, isDisabled: isDisabledReactAria } = useRadio$1(propsComputed, radioGroupState, refObject);
    return {
        boxProps: {
            input: mergeProps(inputProps, {
                ref: refObject
            }),
            label: labelProps
        },
        isSelected,
        isPressed,
        isDisabled: isDisabledReactAria
    };
};

const RadioButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { boxProps, isSelected, isPressed, isDisabled } = useRadioButton(ref, props);
    return /*#__PURE__*/ jsx(ButtonGroupBase, {
        ...props,
        type: "radio",
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        inputProps: boxProps.input,
        labelProps: boxProps.label
    });
});
const RadioButtonGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { items, name, iconOnly, iconPosition, size } = props;
    const { state, boxProps } = useRadioButtonGroup(ref, props);
    return /*#__PURE__*/ jsx(RadioGroupContext$1.Provider, {
        value: state,
        children: /*#__PURE__*/ jsx(Box, {
            ...boxProps,
            display: "inline-flex",
            flexWrap: "nowrap",
            width: "100%",
            children: items.map((item, idx)=>{
                return /*#__PURE__*/ createElement(RadioButton, {
                    ...item,
                    iconOnly: iconOnly,
                    iconPosition: iconPosition,
                    name: name,
                    key: item.value,
                    isStartButton: idx === 0,
                    isEndButton: idx === items.length - 1,
                    size: size
                });
            })
        })
    });
});

const HelperText = ({ start, end })=>{
    return /*#__PURE__*/ jsxs(Box, {
        as: "span",
        color: "unsafe_component.buttonGroup.color.text",
        marginTop: "unsafe_component.buttonGroup.spacing.helperText.topGap",
        display: "flex",
        justifyContent: "space-between",
        children: [
            start && /*#__PURE__*/ jsx(Box, {
                typography: "typography.body.14.regular",
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "start",
                children: start
            }),
            end && /*#__PURE__*/ jsx(Box, {
                typography: "typography.body.14.regular",
                display: "flex",
                textAlign: "right",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "end",
                children: end
            })
        ]
    });
};

const ButtonGroup = /*#__PURE__*/ forwardRef(function ButtonGroup(props, ref) {
    const { type, helper, isFullWidth, isDisabled, label, items, name, iconOnly, iconPosition, size, value, defaultValue, onChange, onBlur, onFocus, ...rest } = props;
    const buttonGroupWidth = useMemo(()=>mapButtonGroupWidthProps({
            isFullWidth
        }), [
        isFullWidth
    ]);
    // @TODO: Introduce an internal helper/hook to split external props from internal props ?
    const propsForGroup = {
        label,
        isDisabled,
        items,
        name,
        iconOnly,
        iconPosition,
        isFullWidth,
        size,
        ...onBlur ? {
            onBlur
        } : {},
        ...onFocus ? {
            onFocus
        } : {}
    };
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: buttonGroupWidth,
        ...rest,
        children: [
            type === 'checkbox' ? /*#__PURE__*/ jsx(CheckboxButtonGroup, {
                ...propsForGroup,
                ...defaultValue ? {
                    defaultValue
                } : {},
                ...value ? {
                    value
                } : {},
                ...onChange ? {
                    onChange
                } : {},
                ref: ref
            }) : /*#__PURE__*/ jsx(RadioButtonGroup, {
                ...propsForGroup,
                ...defaultValue ? {
                    defaultValue
                } : {},
                ...value ? {
                    value
                } : {},
                ...onChange ? {
                    onChange
                } : {},
                ref: ref
            }),
            helper && /*#__PURE__*/ jsx(HelperText, {
                ...helper
            })
        ]
    });
});
const mapButtonGroupWidthProps = ({ isFullWidth = false })=>{
    if (!isFullWidth) {
        return undefined;
    }
    if (typeof isFullWidth === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidth).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            [breakpoint]: isFullWidth ? '100%' : 'initial'
        };
    }, {});
};

const Card = ({ children, borderRadius = '4', hasPadding = true, backgroundVariant = 'default', ...restProps })=>{
    const tokens = useTokens();
    const borderWidth = backgroundVariant === 'default' ? 'unsafe_component.card.borderWidth' : 'borderWidth.none';
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        borderRadius: `unsafe_component.card.radius.${borderRadius}`,
        borderColor: 'unsafe_component.card.color.border',
        backgroundColor: `unsafe_component.card.color.bgVariant.${backgroundVariant}`,
        borderWidth: borderWidth,
        borderStyle: "solid",
        width: "100%",
        height: "100%",
        padding: hasPadding ? `calc(${tokens['unsafe_component.card.spacing']} - ${tokens[borderWidth]})` : undefined,
        overflow: [
            'hidden',
            'clip'
        ],
        children: children
    });
};

const useCarousel = (ref, props)=>{
    const { items, step, itemsPerView, itemsFixedWidth, onChange, initialStepIndex, stepIndex } = props;
    const tokens = useTokens();
    const rootFontSizeValue = getRootFontSizeValue();
    const pxGap = useMemo(()=>parseFloat(tokens['unsafe_component.carousel.spacing.slides.gap'].toString()) * rootFontSizeValue, [
        tokens,
        rootFontSizeValue
    ]);
    const [containerWidth, setContainerWidth] = useState(null);
    const onResize = useCallback(()=>{
        if (ref.current) {
            const containerWidth = ref.current.offsetWidth;
            setContainerWidth(containerWidth);
        }
    }, [
        ref,
        setContainerWidth
    ]);
    useResizeObserver(ref, {
        onResize
    });
    useLayoutEffect(onResize, [
        onResize
    ]);
    const fixedWidthItemsPerViewNumber = useMemo(()=>itemsFixedWidth !== undefined && containerWidth !== null ? containerWidth / (itemsFixedWidth + (items.length - 1) * pxGap / items.length) : 1, [
        itemsFixedWidth,
        containerWidth,
        items.length,
        pxGap
    ]);
    // Overwrite itemsPerView when content is fixed because we have to calculate the number of showed items per slide
    const computedItemsPerView = itemsFixedWidth !== undefined ? fixedWidthItemsPerViewNumber > items.length ? items.length : Math.floor(fixedWidthItemsPerViewNumber) || 1 : itemsPerView;
    const itemsPerViewNumber = useItemsPerView({
        computedItemsPerView
    });
    // Generates an array with distributed items in each slide (chunk)
    const slides = useMemo(()=>items.reduce((result, item, i)=>{
            // If step is gradual, we put the first items (itemsPerView) in the first slide
            // and then only one item per slide
            // If step is group, we put in each slide the same number of items
            const chunkIndex = Math.floor(step === 'gradual' && i >= itemsPerViewNumber ? i + 1 - itemsPerViewNumber : i / itemsPerViewNumber);
            let slide = result[chunkIndex];
            if (!slide) slide = {
                id: '',
                items: []
            };
            slide.id += slide.id === '' ? item.id : `-${item.id}`;
            slide.items.push(item);
            result[chunkIndex] = slide;
            return result;
        }, []), [
        items,
        itemsPerViewNumber,
        step
    ]);
    const { itemsPosition, scrollWidth } = useMemo(()=>{
        const result = [];
        let itemPosition = {
            percentage: 0,
            pixel: 0
        };
        let scrollWidth = {
            percentage: 0,
            pixel: 0
        };
        for(let i = 0; i < items.length; i++){
            result.push(itemPosition);
            if (itemsFixedWidth !== undefined) {
                itemPosition = {
                    ...itemPosition,
                    pixel: itemPosition.pixel + itemsFixedWidth + pxGap
                };
            } else {
                itemPosition = {
                    percentage: itemPosition.percentage + 100 / itemsPerViewNumber,
                    pixel: itemPosition.pixel - (itemsPerViewNumber - 1) * pxGap / itemsPerViewNumber + pxGap
                };
            }
            scrollWidth = {
                ...itemPosition,
                pixel: itemPosition.pixel - pxGap
            };
        }
        return {
            itemsPosition: result,
            scrollWidth
        };
    }, [
        items.length,
        itemsFixedWidth,
        pxGap,
        itemsPerViewNumber
    ]);
    const computedOnChange = useCallback((newCurrentStep, onChange)=>{
        const visibleItems = items.slice(newCurrentStep, newCurrentStep + itemsPerViewNumber);
        const visibleItemIds = step === 'grouped' ? (newCurrentStep === slides.length - 1 ? items.slice(items.length - itemsPerViewNumber) : slides[newCurrentStep].items).map((visibleSlide)=>visibleSlide.id) : visibleItems.map((visibleItem)=>visibleItem.id);
        onChange?.({
            items,
            visibleItemIds,
            currentStep: newCurrentStep,
            stepsLength: slides.length
        });
    }, [
        items,
        slides,
        itemsPerViewNumber,
        step
    ]);
    const [currentStep, setCurrentStep] = useControlledState(stepIndex, initialStepIndex, (value)=>computedOnChange(value, onChange));
    // When itemsPerView changes on resize, to prevent it from being greater than the maximum number of steps available we block it to the slides length
    const actualCurrentStep = useMemo(()=>currentStep > slides.length - 1 ? slides.length > 0 ? slides.length - 1 : 0 : currentStep, [
        currentStep,
        slides.length
    ]);
    const handlePreviousStep = useCallback(()=>{
        const newCurrentStep = actualCurrentStep === 0 ? actualCurrentStep : actualCurrentStep - 1;
        // Avoid re-trigger when already at this step (when using keyboard arrows)
        if (newCurrentStep === actualCurrentStep) return;
        setCurrentStep(newCurrentStep);
    }, [
        actualCurrentStep,
        setCurrentStep
    ]);
    const handleNextStep = useCallback(()=>{
        const newCurrentStep = actualCurrentStep === slides.length - 1 ? actualCurrentStep : actualCurrentStep + 1;
        // Avoid re-trigger when already at this step (when using keyboard arrows)
        if (newCurrentStep === actualCurrentStep) return;
        setCurrentStep(newCurrentStep);
    }, [
        actualCurrentStep,
        setCurrentStep,
        slides.length
    ]);
    return {
        currentStep: actualCurrentStep,
        handlePreviousStep,
        handleNextStep,
        slides,
        itemsPerViewNumber,
        fixedWidthItemsPerViewNumber,
        itemsPosition,
        scrollWidth,
        containerWidth
    };
};
const useItemsPerView = ({ computedItemsPerView })=>{
    // @todo: Remove breakpoint prefixes when available in future release
    const currentBreakpoint = useBreakpointValue({
        base: 'breakpoint.base',
        lg: 'breakpoint.lg',
        md: 'breakpoint.md',
        sm: 'breakpoint.sm',
        xl: 'breakpoint.xl',
        xs: 'breakpoint.xs',
        xxl: 'breakpoint.xxl',
        xxxl: 'breakpoint.xxxl'
    });
    if (typeof computedItemsPerView === 'number') return computedItemsPerView;
    return computedItemsPerView[currentBreakpoint] ?? 1;
};

const useCarouselTranslation = ()=>useTranslation({
        'en-GB': {
            'aria::label::indicator': 'of',
            'carousel::previous': 'Previous',
            'carousel::next': 'Next'
        },
        'fr-FR': {
            'aria::label::indicator': 'sur',
            'carousel::previous': 'Précédent',
            'carousel::next': 'Suivant'
        },
        'de-DE': {
            'aria::label::indicator': 'von',
            'carousel::previous': 'Zurück',
            'carousel::next': 'Weiter'
        },
        'nl-NL': {
            'aria::label::indicator': 'van de',
            'carousel::previous': 'Terug',
            'carousel::next': 'Verder'
        }
    });

const StepButtons = ({ handlePreviousStep, handleNextStep, currentStep, slidesLength, arrowPosition, carouselId, carouselRef })=>{
    const onKeyDown = (e)=>{
        const slides = carouselRef.current?.children;
        switch(e.key){
            case 'ArrowLeft':
                // To avoid loosing focus on the left step button when it is disabled, we set focus directly on the second slide before handlePreviousStep
                if (currentStep === 1 && slides) {
                    const secondSlide = slides[1];
                    secondSlide.focus();
                }
                handlePreviousStep();
                break;
            case 'ArrowRight':
                // To avoid loosing focus on the right step button when it is disabled, we set focus directly on the penultimate slide before handleNextStep
                if (currentStep === slidesLength - 2 && slides) {
                    const penultimateSlide = slides[slidesLength - 2];
                    penultimateSlide.focus();
                }
                handleNextStep();
                break;
        }
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(StepButton, {
                step: "previous",
                arrowPosition: arrowPosition,
                carouselId: carouselId,
                handleStep: handlePreviousStep,
                onKeyDown: onKeyDown,
                isDisabled: currentStep === 0
            }),
            /*#__PURE__*/ jsx(StepButton, {
                step: "next",
                arrowPosition: arrowPosition,
                carouselId: carouselId,
                handleStep: handleNextStep,
                onKeyDown: onKeyDown,
                isDisabled: currentStep === slidesLength - 1
            })
        ]
    });
};
const StepButton = ({ step, arrowPosition, carouselId, handleStep, onKeyDown, isDisabled })=>{
    const t = useCarouselTranslation();
    const commonButtonStyle = {
        position: arrowPosition === 'outside' ? undefined : 'absolute',
        bottom: arrowPosition === 'outside' ? undefined : '50%',
        zIndex: 'zIndex.1',
        transform: arrowPosition === 'outside' ? undefined : 'translateY(50%)',
        left: step === 'previous' && arrowPosition !== 'outside' ? 'unsafe_component.carousel.spacing.buttons.insideHorizontal' : undefined,
        right: step === 'next' && arrowPosition !== 'outside' ? 'unsafe_component.carousel.spacing.buttons.insideHorizontal' : undefined
    };
    return /*#__PURE__*/ jsx(Box, {
        ...commonButtonStyle,
        children: /*#__PURE__*/ jsx(Button, {
            "aria-controls": carouselId,
            variant: "secondary-floating",
            iconOnly: true,
            icon: step === 'previous' ? ChevronLeftIcon : ChevronRightIcon,
            marginLeft: arrowPosition === 'outside' && step === 'next' ? 'unsafe_component.carousel.spacing.buttons.outsideHorizontal' : undefined,
            onPress: handleStep,
            onKeyDown: onKeyDown,
            isDisabled: isDisabled,
            size: "40",
            type: "button",
            children: t(`carousel::${step}`)
        })
    });
};

const Indicator$1 = ({ currentStep, slides, dotsPosition })=>{
    return /*#__PURE__*/ jsx(Box, {
        position: dotsPosition === 'outside' ? undefined : 'absolute',
        bottom: dotsPosition === 'outside' ? undefined : 'unsafe_component.carousel.spacing.indicator.inside',
        marginTop: dotsPosition === 'outside' ? 'unsafe_component.carousel.spacing.indicator.outside' : undefined,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "unsafe_component.carousel.sizing.indicatorContainer",
        children: slides.map((slide, i)=>/*#__PURE__*/ jsx(Box, {
                width: "unsafe_component.carousel.sizing.indicator",
                height: "unsafe_component.carousel.sizing.indicator",
                marginHorizontal: "unsafe_component.carousel.spacing.indicator.horizontal",
                backgroundColor: currentStep === i ? 'unsafe_component.carousel.color.indicatorCurrent' : 'unsafe_component.carousel.color.indicatorDefault',
                borderRadius: "unsafe_component.carousel.radius.indicator",
                "aria-hidden": "true"
            }, `indicator-${slide.id}`))
    });
};

// Distance in PX that needs to be done with the pointer to allow swiping
const DISTANCE_THRESHOLD = 5;
// To avoid SQRT on runtime, prepare a radius threshold to check distance from origin point (0, 0)
const RADIUS_THRESHOLD = DISTANCE_THRESHOLD * DISTANCE_THRESHOLD;
const useSwipe = ({ onSwipe, onSwipeStart, onSwipeCancelled, isTouchDisabled, isDisabled })=>{
    const [diffX, setDiffX] = useState(0);
    const [diffY, setDiffY] = useState(0);
    const [isScrolling, setIsScrolling] = useState(undefined);
    const { moveProps } = useMove({
        onMoveStart (e) {
            if (onSwipeStart) onSwipeStart(e.pointerType === 'keyboard');
        },
        onMove (e) {
            if (e.pointerType === 'keyboard') {
                // Handle arrow key navigation
                onSwipe(e.deltaX, true);
                return;
            }
            if (isTouchDisabled) return;
            setDiffX((x)=>x + e.deltaX);
            setDiffY((y)=>y + e.deltaY);
            // Adapted from SwiperJS
            // https://github.com/nolimits4web/swiper/blob/74c891f65fa71f221d769a24f12cf7581fb8cbcb/src/core/events/onTouchMove.mjs#L102-L118
            if (isScrolling === undefined && diffY !== 0 && /**
				 * Threshold distance from origin point without SQRT
				 * Formula: `√[(x2 − x1)^2 + (y2 − y1)^2] === distance`
				 * with origin O: `√[(x2)^2 + (y2)^2] === distance from (0,0)`
				 * without sqrt: `(x2)^2 + (y2)^2 === [distance from (0,0)]^2`
				 */ diffX * diffX + diffY * diffY >= RADIUS_THRESHOLD) {
                const touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
                setIsScrolling(touchAngle > 45);
            }
        },
        onMoveEnd (e) {
            if (e.pointerType === 'keyboard' || isTouchDisabled) return;
            if (!isScrolling && Math.abs(diffX) > DISTANCE_THRESHOLD) {
                onSwipe(diffX, false);
            } else if (onSwipeCancelled && Math.abs(diffX) <= DISTANCE_THRESHOLD) onSwipeCancelled();
            setDiffX(0);
            setDiffY(0);
            setIsScrolling(undefined);
        }
    });
    return {
        boxProps: isDisabled ? {} : moveProps,
        isScrolling,
        distanceX: diffX
    };
};

const getSlidesFixedWidth = ({ itemsPerView, itemsFixedWidth = 0, gap })=>`calc(${itemsFixedWidth * itemsPerView}px + ${gap} * ${itemsPerView - 1})`;
const getGradualWidth = ({ itemsPerView, gap })=>`calc((100% - (${itemsPerView - 1} * ${gap}))/ ${itemsPerView})`;
const getSlideOffset = ({ currentPosition, currentStep, step, slidesLength, itemsPerView, itemsPosition, scrollWidth })=>{
    // First slide OR Not filling the container with slides
    // Giving only dragging position
    if (currentStep === 0 || slidesLength === 1) return `${currentPosition}px`;
    // Last slide
    // Giving only dragging position from right
    if (slidesLength > 1 && currentStep === slidesLength - 1) {
        return `calc(${currentPosition}px - (${scrollWidth.percentage}% + ${scrollWidth.pixel}px) + 100%)`;
    }
    if (itemsPosition.length === 0) {
        return `${currentPosition}px`;
    }
    // Gradual steps
    if (step === 'gradual' && itemsPerView > 1) {
        // Remaining slides
        // Giving dragging position + slide position (calc of slide index)
        return `calc(${currentPosition}px - (${itemsPosition[currentStep]?.percentage ?? 0}% + ${itemsPosition[currentStep]?.pixel ?? 0}px))`;
    }
    // Grouped steps after first slide
    // Giving dragging position + slide position
    return `calc(${currentPosition}px - (${itemsPosition[currentStep * itemsPerView]?.percentage ?? 0}% + ${itemsPosition[currentStep * itemsPerView]?.pixel ?? 0}px))`;
};
const getGridTemplate = ({ itemsFixedWidth, step, slides, gap, itemsPerView })=>{
    if (itemsFixedWidth !== undefined) {
        const slidesFixedWidth = getSlidesFixedWidth({
            itemsPerView,
            itemsFixedWidth,
            gap
        });
        if (step === 'grouped') {
            return `repeat(${slides.length}, ${slidesFixedWidth})`;
        }
        return `${slidesFixedWidth}${slides.length - 1 > 0 ? ` repeat(${slides.length - 1}, ${itemsFixedWidth}px)` : ''}`;
    }
    if (step === 'gradual' && itemsPerView > 1) {
        return `100%${slides.length - 1 > 0 ? `  repeat(${slides.length - 1}, ${getGradualWidth({
            itemsPerView,
            gap
        })})` : ''}`;
    }
    return slides[slides.length - 1]?.items.length !== itemsPerView ? `repeat(${slides.length - 1}, 100%) calc(${slides[slides.length - 1]?.items.length ?? itemsPerView} * ((100% - ${gap} * ${itemsPerView - 1}) / ${itemsPerView}) + ${(slides[slides.length - 1]?.items.length ?? 1) - 1} * ${gap})` : `repeat(${slides.length}, 100%)`;
};
const useSlides = (props)=>{
    const { slides, itemsPerView, itemsFixedWidth, currentStep, handlePreviousStep, handleNextStep, step, itemsPosition, scrollWidth } = props;
    const tokens = useTokens();
    const [isBeingSwiped, setIsBeingSwiped] = useState(false);
    const { boxProps, isScrolling, distanceX } = useSwipe({
        isDisabled: slides.length <= 1,
        onSwipeStart: (isKeyboard)=>{
            if (!isKeyboard) {
                setIsBeingSwiped(true);
            }
        },
        onSwipe: (distanceX, isKeyboard)=>{
            if (isKeyboard && 0 < distanceX || !isKeyboard && 0 > distanceX) handleNextStep();
            if (isKeyboard && 0 > distanceX || !isKeyboard && 0 < distanceX) handlePreviousStep();
            setIsBeingSwiped(false);
        },
        onSwipeCancelled: ()=>setIsBeingSwiped(false)
    });
    const currentPosition = !isScrolling ? distanceX : 0;
    return {
        boxProps,
        slidesOffset: getSlideOffset({
            currentPosition,
            currentStep,
            step,
            slidesLength: slides.length,
            itemsPerView,
            itemsPosition,
            scrollWidth
        }),
        slidesGridTemplate: getGridTemplate({
            itemsFixedWidth,
            step,
            slides,
            gap: tokens['unsafe_component.carousel.spacing.slides.gap'],
            itemsPerView
        }),
        isBeingSwiped,
        isSwiping: distanceX !== 0 && !isScrolling
    };
};

const useSlide = (ref, props)=>{
    const { isGradual, slides, isFocusVisible, currentStep, index, itemsPerView, fixedWidthItemsPerView, itemsFixedWidth } = props;
    const { boxProps } = useFocusable(ref);
    const isCurrent = currentStep === index;
    const hasFixedWidthItems = itemsFixedWidth !== undefined;
    useEffect(()=>{
        if (isFocusVisible && isCurrent) ref.current?.focus();
    }, [
        isCurrent,
        isFocusVisible,
        ref
    ]);
    const ceilFixedWidthItemsPerView = Math.ceil(fixedWidthItemsPerView);
    const notInertGradualFixedWidthWithPartialItems = isGradual && hasFixedWidthItems && (index < currentStep && index > currentStep - itemsPerView || // Next/Previous slide partially visible (previous only when on last slide)
    ceilFixedWidthItemsPerView > itemsPerView && (index === currentStep + 1 || currentStep === slides.length - 1 && index === currentStep - itemsPerView));
    const notInertGroupedFixedWidthWithPartialItems = !isGradual && hasFixedWidthItems && ceilFixedWidthItemsPerView > itemsPerView && (index === currentStep + 1 || currentStep === slides.length - 1 && index === currentStep - 1);
    const notInertGroupedPartialLastSlide = !isGradual && itemsPerView !== slides[slides.length - 1]?.items.length && currentStep === slides.length - 1 && index === currentStep - 1;
    const notInertGradual = isGradual && index < currentStep && index > currentStep - itemsPerView;
    const inert = notInertGradualFixedWidthWithPartialItems || notInertGroupedFixedWidthWithPartialItems || notInertGroupedPartialLastSlide || notInertGradual || isCurrent ? undefined : '';
    return {
        boxProps,
        isCurrent,
        inert
    };
};

const Slide = ({ index, slides, isGradual, isSwiping, isFocusVisible, itemsPerView, fixedWidthItemsPerView, slideItems, currentStep, isBeingSwiped, itemsFixedWidth, touchAction, ...moveProps })=>{
    const t = useCarouselTranslation();
    const tokens = useTokens();
    const ref = useRef(null);
    const { boxProps: focusProps, isCurrent, inert } = useSlide(ref, {
        isGradual,
        slides,
        isFocusVisible,
        currentStep,
        index,
        itemsPerView,
        itemsFixedWidth,
        fixedWidthItemsPerView
    });
    return /*#__PURE__*/ jsx(Box, {
        ...mergeProps(moveProps, focusProps),
        ref: ref,
        pointerEvents: isBeingSwiped ? 'none' : undefined,
        inert: inert,
        tabIndex: isCurrent ? 0 : -1,
        "aria-roledescription": "slide",
        "aria-current": isCurrent,
        "aria-hidden": !isCurrent,
        "aria-label": `${index + 1} ${t('aria::label::indicator')} ${slides.length}`,
        role: "group",
        position: "relative",
        display: "grid",
        gridTemplateColumns: `repeat(${slideItems.length}, 1fr)`,
        gap: "unsafe_component.carousel.spacing.slides.gap",
        width: "100%",
        maxWidth: itemsFixedWidth ? `calc(${itemsFixedWidth}px * ${slideItems.length} + ${tokens['unsafe_component.carousel.spacing.slides.gap']} * ${slideItems.length - 1})` : undefined,
        // To allow vertical page scroll but not horizontal and avoid unwanted touchEnd
        touchAction: touchAction,
        children: slideItems.map((content)=>content.item)
    });
};

const Slides = ({ slides, step, itemsPerView, shouldClipContent, currentStep, handlePreviousStep, handleNextStep, carouselId, carouselRef, itemsFixedWidth, fixedWidthItemsPerView, itemsPosition, scrollWidth, containerWidth, touchAction })=>{
    const isGradual = step === 'gradual' && itemsPerView > 1;
    // Only useful when itemsFixedWidth is defined and step is 'grouped' because we don't know the container width server-side.
    const [showAnimation, setShowAnimation] = useState(itemsFixedWidth === undefined && step !== 'grouped');
    const { boxProps: focusProps, isFocusVisible } = useFocusable(carouselRef, {
        within: true
    });
    const { boxProps: moveProps, slidesOffset, slidesGridTemplate, isBeingSwiped, isSwiping } = useSlides({
        step,
        slides,
        itemsPerView,
        itemsFixedWidth,
        currentStep,
        handlePreviousStep,
        handleNextStep,
        itemsPosition,
        scrollWidth
    });
    // Wait for the containerWidth to be calculated before showing the animation on slides.
    // Avoid animation on first render when the containerWidth is not yet calculated (because missing containerWidth).
    // Animation should be shown only when the component is fully mounted
    useEffect(()=>{
        if (containerWidth !== null && !showAnimation) {
            requestAnimationFrame(()=>{
                setShowAnimation(true);
            });
        }
    }, [
        containerWidth,
        showAnimation
    ]);
    return /*#__PURE__*/ jsx(Box, {
        overflow: shouldClipContent ? 'hidden' : undefined,
        children: /*#__PURE__*/ jsx(Box, {
            ...focusProps,
            ref: carouselRef,
            id: carouselId,
            "aria-live": "polite",
            display: "grid",
            gap: "unsafe_component.carousel.spacing.slides.gap",
            gridTemplateColumns: slidesGridTemplate,
            unsafe_style: {
                transform: `translateX(${slidesOffset})`
            },
            transitionDuration: !isSwiping && showAnimation ? 'unsafe_component.carousel.motionDuration' : undefined,
            transitionProperty: "transform",
            transitionTimingFunction: "unsafe_component.carousel.motionEasing",
            children: slides.map((slide, slideIndex)=>/*#__PURE__*/ createElement(Slide, {
                    ...moveProps,
                    key: `slide-${slide.id}`,
                    index: slideIndex,
                    currentStep: currentStep,
                    isBeingSwiped: isBeingSwiped,
                    isFocusVisible: isFocusVisible,
                    slideItems: slide.items,
                    itemsPerView: itemsPerView,
                    fixedWidthItemsPerView: fixedWidthItemsPerView,
                    isGradual: isGradual,
                    isSwiping: isSwiping,
                    slides: slides,
                    itemsFixedWidth: itemsFixedWidth,
                    touchAction: touchAction
                }))
        })
    });
};

const Carousel = (props)=>{
    const { arrowPosition = 'inside', hasDots = false, dotsPosition = hasDots ? 'outside' : undefined, shouldClipContent = false, title, 'aria-labelledby': ariaLabelledBy, items, itemsPerView = 1, step = 'gradual', itemsFixedWidth, onChange, initialStepIndex = 0, stepIndex, touchAction = 'pan-y' } = props;
    const containerRef = useRef(null);
    const carouselRef = useRef(null);
    const { currentStep, handlePreviousStep, handleNextStep, slides, itemsPerViewNumber, fixedWidthItemsPerViewNumber, itemsPosition, scrollWidth, containerWidth } = useCarousel(containerRef, {
        items,
        step,
        itemsPerView,
        itemsFixedWidth,
        onChange,
        initialStepIndex,
        stepIndex
    });
    const labelId = useId();
    const carouselId = useId();
    const hasTitle = Boolean(title);
    return /*#__PURE__*/ jsxs(Box, {
        ref: containerRef,
        "aria-atomic": "false",
        "aria-roledescription": "carousel",
        role: "region",
        "aria-labelledby": ariaLabelledBy ? ariaLabelledBy : hasTitle ? labelId : undefined,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: hasTitle ? 'end' : undefined,
                justifyContent: hasTitle ? undefined : 'end',
                width: "100%",
                typography: "unsafe_component.carousel.typography",
                marginBottom: hasTitle || arrowPosition === 'outside' ? 'unsafe_component.carousel.spacing.margin.bottom' : undefined,
                children: [
                    hasTitle && /*#__PURE__*/ jsx(Box, {
                        id: labelId,
                        display: "flex",
                        width: "100%",
                        marginRight: slides.length > 1 && arrowPosition === 'outside' ? 'unsafe_component.carousel.spacing.buttons.title' : undefined,
                        children: title
                    }),
                    slides.length > 1 && arrowPosition === 'outside' && /*#__PURE__*/ jsx(StepButtons, {
                        currentStep: currentStep,
                        slidesLength: slides.length,
                        arrowPosition: arrowPosition,
                        handleNextStep: handleNextStep,
                        handlePreviousStep: handlePreviousStep,
                        carouselId: carouselId,
                        carouselRef: carouselRef
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(Box, {
                position: "relative",
                width: "100%",
                children: [
                    /*#__PURE__*/ jsx(Slides, {
                        slides: slides,
                        step: step,
                        itemsPerView: itemsPerViewNumber,
                        fixedWidthItemsPerView: fixedWidthItemsPerViewNumber,
                        shouldClipContent: shouldClipContent,
                        currentStep: currentStep,
                        handleNextStep: handleNextStep,
                        handlePreviousStep: handlePreviousStep,
                        carouselId: carouselId,
                        carouselRef: carouselRef,
                        itemsFixedWidth: itemsFixedWidth,
                        scrollWidth: scrollWidth,
                        itemsPosition: itemsPosition,
                        containerWidth: containerWidth,
                        touchAction: touchAction
                    }),
                    slides.length > 1 && arrowPosition === 'inside' && /*#__PURE__*/ jsx(StepButtons, {
                        currentStep: currentStep,
                        slidesLength: slides.length,
                        arrowPosition: arrowPosition,
                        handleNextStep: handleNextStep,
                        handlePreviousStep: handlePreviousStep,
                        carouselId: carouselId,
                        carouselRef: carouselRef
                    })
                ]
            }),
            hasDots && /*#__PURE__*/ jsx(Indicator$1, {
                currentStep: currentStep,
                slides: slides,
                dotsPosition: dotsPosition
            })
        ]
    });
};

const Tag = ({ icon: Icon, children, size = '14', variant = 'primary', iconOnly = false, 'aria-label': ariaLabel, ...restProps })=>{
    const computedChildren = Array.isArray(children) ? children.join('') : children;
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        backgroundColor: `unsafe_component.tag.color.${variant}.bg`,
        color: `unsafe_component.tag.color.${variant}.content`,
        borderRadius: "unsafe_component.tag.radius",
        paddingHorizontal: "unsafe_component.tag.spacing.padding.horizontal",
        paddingVertical: "unsafe_component.tag.spacing.padding.vertical",
        typography: `unsafe_component.tag.typography.${size}`,
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        gap: "unsafe_component.tag.spacing.gap",
        "aria-label": ariaLabel ?? (iconOnly ? computedChildren : undefined),
        children: [
            Icon && /*#__PURE__*/ jsx(Icon, {
                size: "sizing.16"
            }),
            children && !iconOnly && /*#__PURE__*/ jsx(Box, {
                as: "span",
                children: children
            })
        ]
    });
};

/**
 * Custom hook to map `CellContent` props to `Box` ones with all needed interactive and accessible HTML attributes.
 * @param ref CellContent element ref
 * @param props CellContent props
 * @returns Box props
 */ const useCellContent = (ref, props)=>{
    const isCTA = typeof props.onPress === 'function' || typeof props.href === 'string';
    const { boxProps, isHovered, isPressed, isFocused, isLink } = useButton$1(ref, props);
    if (!isCTA) {
        return {
            boxProps: {
                as: 'div',
                ref: boxProps.ref
            },
            isDisabled: false,
            isHovered: false,
            isPressed: false,
            isFocused: false,
            isCTA,
            isLink
        };
    }
    return {
        boxProps: mergeProps(boxProps, isLink ? {
            title: props.linkTitle
        } : {}),
        isDisabled: Boolean(props.isDisabled),
        isHovered,
        isPressed,
        isFocused,
        isCTA,
        isLink
    };
};

/**
 * Helps with ref Element type
 * This will remove the ref from the default forwardRef typing and use the one defined in Props
 */ const createCellContent = (render)=>{
    return /*#__PURE__*/ forwardRef(render);
};
const CellContent = createCellContent((props, ref)=>{
    const { body, description, href, iconEnd: IconEnd, isDisabled: isDisabledProp, isExternal, onPress, padding = '8', placeholderStart: PlaceholderStart, title, linkTitle, linkAttributes, type, badgeProps, tagProps, direction = 'horizontal', ...contentProps } = props;
    const { boxProps, isHovered, isPressed, isFocused, isDisabled, isCTA, isLink } = useCellContent(ref, props);
    const stateProps = useMemo(()=>mapCellContentStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isCTA
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isCTA
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(contentProps, stateProps.wrapper, !isLink ? mergeProps(boxProps, stateProps.cta) : {}),
        paddingHorizontal: `unsafe_component.cellContent.spacing.padding.${padding}`,
        paddingVertical: `unsafe_component.cellContent.spacing.padding.${padding}`,
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderWidth: "borderWidth.none",
        textAlign: "left",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: direction === 'vertical' ? 'flex-start' : 'center',
                flexDirection: direction === 'vertical' ? 'column' : 'row',
                gap: "unsafe_component.cellContent.spacing.gapNew.16",
                children: [
                    typeof PlaceholderStart !== 'object' && PlaceholderStart !== undefined && /*#__PURE__*/ jsx(IconElement$4, {
                        icon: PlaceholderStart,
                        isCTA: isCTA,
                        position: "start",
                        isExternal: false
                    }),
                    typeof PlaceholderStart === 'object' && PlaceholderStart.url !== undefined && /*#__PURE__*/ jsx(Box, {
                        maxWidth: "unsafe_component.cellContent.sizing.image",
                        maxHeight: "unsafe_component.cellContent.sizing.image",
                        borderRadius: "unsafe_component.cellContent.radius",
                        overflow: [
                            'hidden',
                            'clip'
                        ],
                        children: /*#__PURE__*/ jsx(Box, {
                            as: "img",
                            src: PlaceholderStart.url,
                            alt: PlaceholderStart.alt,
                            opacity: isDisabled ? 'opacity.50' : undefined
                        })
                    }),
                    /*#__PURE__*/ jsx(ContentElement, {
                        badgeProps: // Force disabled state for the badge when CellContent is disabled
                        badgeProps ? {
                            ...badgeProps,
                            isDisabled
                        } : undefined,
                        tagProps: tagProps,
                        isLink: isLink,
                        isExternal: isExternal,
                        titleContent: title,
                        bodyContent: body,
                        descriptionContent: description,
                        isDisabled: true,
                        ...isLink ? mergeProps(boxProps, stateProps.cta, linkAttributes) : {}
                    })
                ]
            }),
            /*#__PURE__*/ jsx(IconElement$4, {
                icon: IconEnd,
                isCTA: isCTA,
                isExternal: isExternal,
                position: "end"
            })
        ]
    });
});
const ContentElement = /*#__PURE__*/ forwardRef(({ badgeProps, tagProps, isLink, isExternal, titleContent, bodyContent, descriptionContent, isDisabled, ...rest }, ref)=>{
    const bodyIsLink = isLink && titleContent === undefined;
    const descriptionIsLink = isLink && titleContent === undefined && bodyContent === undefined;
    return /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "grid",
        flexGrow: 1,
        gap: "unsafe_component.cellContent.spacing.gapNew.4",
        children: [
            titleContent !== undefined && /*#__PURE__*/ jsx(LinkElement, {
                forwardedRef: ref,
                badgeProps: badgeProps,
                tagProps: tagProps,
                isLink: isLink,
                isExternal: isExternal,
                ...isLink ? rest : {},
                typography: "unsafe_component.cellContent.typography.title",
                children: titleContent
            }, "titleKey"),
            bodyContent !== undefined && /*#__PURE__*/ jsx(LinkElement, {
                forwardedRef: ref,
                badgeProps: titleContent === undefined ? badgeProps : undefined,
                tagProps: titleContent === undefined ? tagProps : undefined,
                isLink: bodyIsLink,
                isExternal: isExternal,
                ...bodyIsLink ? rest : {},
                typography: "unsafe_component.cellContent.typography.body",
                children: bodyContent
            }, "bodyKey"),
            descriptionContent !== undefined && /*#__PURE__*/ jsx(LinkElement, {
                forwardedRef: ref,
                badgeProps: titleContent === undefined && bodyContent === undefined ? badgeProps : undefined,
                tagProps: titleContent === undefined && bodyContent === undefined ? tagProps : undefined,
                isLink: descriptionIsLink,
                isExternal: isExternal,
                ...descriptionIsLink ? rest : {},
                typography: "unsafe_component.cellContent.typography.description",
                color: !isDisabled ? 'unsafe_component.cellContent.color.content' : undefined,
                children: descriptionContent
            }, "descriptionKey")
        ]
    });
});
const LinkElement = ({ children, badgeProps, tagProps, isLink, isExternal, forwardedRef, ...rest })=>{
    const LinkComponent = useRenderLink({
        isExternal
    });
    return isLink ? badgeProps !== undefined || tagProps !== undefined ? /*#__PURE__*/ jsxs(Box, {
        as: "div",
        display: "flex",
        gap: "spacing.8",
        alignItems: "center",
        children: [
            /*#__PURE__*/ jsxs(LinkComponent, {
                ref: forwardedRef,
                as: "a",
                ...rest,
                color: "inherit",
                outlineStyle: "none",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        display: "inline-flex",
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                    }),
                    children
                ]
            }),
            badgeProps && /*#__PURE__*/ jsx(BadgeElement, {
                ...badgeProps
            }),
            tagProps && /*#__PURE__*/ jsx(TagElement, {
                ...tagProps
            })
        ]
    }) : /*#__PURE__*/ jsxs(LinkComponent, {
        as: "a",
        ref: forwardedRef,
        ...rest,
        color: "inherit",
        outlineStyle: "none",
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                display: "inline-flex",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }),
            children
        ]
    }) : /*#__PURE__*/ jsxs(Box, {
        as: "span",
        ref: forwardedRef,
        ...rest,
        ...badgeProps !== undefined || tagProps !== undefined ? {
            display: 'flex',
            gap: 'spacing.8',
            alignItems: 'center'
        } : {},
        children: [
            children,
            badgeProps && /*#__PURE__*/ jsx(BadgeElement, {
                ...badgeProps
            }),
            tagProps && /*#__PURE__*/ jsx(TagElement, {
                ...tagProps
            })
        ]
    });
};
const BadgeElement = (badgeProps)=>{
    return badgeProps?.label && badgeProps?.children ? /*#__PURE__*/ jsx(Badge, {
        ...badgeProps,
        children: badgeProps.children
    }) : null;
};
const TagElement = (tagProps)=>{
    return tagProps?.children ? /*#__PURE__*/ jsx(Tag, {
        icon: tagProps.icon,
        variant: "secondaryStrong",
        size: "14",
        children: tagProps.children
    }) : null;
};
const IconElement$4 = ({ icon, position, isCTA, isExternal })=>{
    const Icon = (isExternal && position === 'end' ? ExternalLinkIcon : undefined) || icon || (isCTA && position === 'end' ? ChevronRightIcon : undefined);
    if (!Icon) return null;
    return /*#__PURE__*/ jsx(Icon, {
        size: "sizing.24",
        marginLeft: position === 'end' ? 'unsafe_component.cellContent.spacing.icon.end' : undefined
    });
};
const mapCellContentStateToBoxProps = ({ isDisabled, isHovered, isPressed, isCTA })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isPressed:
                return `unsafe_component.cellContent.color.bgPressed`;
            case isHovered:
                return `unsafe_component.cellContent.color.bgHover`;
            default:
                return `unsafe_component.cellContent.color.bg`;
        }
    };
    return {
        wrapper: {
            backgroundColor: getBackgroundColor(),
            color: isDisabled ? 'unsafe_component.cellContent.color.textDisabled' : 'unsafe_component.cellContent.color.text'
        },
        cta: isCTA ? {
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        } : undefined
    };
};

const DEFAULT_VARIANT$1 = 'filter';

const useChipTranslation = ()=>useTranslation({
        'en-GB': {
            'chip::button::remove': 'Remove'
        },
        'fr-FR': {
            'chip::button::remove': 'Supprimer'
        },
        'de-DE': {
            'chip::button::remove': 'Entfernen'
        },
        'nl-NL': {
            'chip::button::remove': 'Verwijderen'
        }
    });

const useChip = (ref, props)=>{
    const refObject = useObjectRef$1(ref);
    const { onPress, onClose, variant = DEFAULT_VARIANT$1 } = props;
    const state = useToggleState(props);
    const { buttonProps, isPressed } = useToggleButton$1({}, state, refObject);
    const { boxProps: actionButtonProps, isPressed: isActionPressed, isHovered: isActionHovered, isFocused: isActionFocused } = useButton$1(refObject, {
        onPress,
        type: 'button'
    });
    const { boxProps: closeButtonProps, isPressed: isClosePressed, isFocused: isCloseFocused } = useButton$1(refObject, {
        onPress: onClose,
        type: 'button'
    });
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocusVisible } = useFocusable(refObject);
    const { boxProps: closeHoverProps, isHovered: isCloseHovered } = useHoverable({});
    let additionalProps;
    switch(variant){
        case 'input':
            additionalProps = {
                as: 'span'
            };
            break;
        case 'action':
            additionalProps = mergeProps(actionButtonProps, {
                as: 'button'
            });
            break;
        case 'filter':
        default:
            additionalProps = mergeProps(hoverProps, focusProps, buttonProps, {
                as: 'button'
            });
    }
    return {
        boxProps: {
            chip: mergeProps(additionalProps, {
                ref: refObject
            }),
            close: mergeProps(closeButtonProps, closeHoverProps, {
                ref: refObject
            })
        },
        isSelected: state.isSelected || false,
        isHovered: (variant === 'action' ? isActionHovered : isHovered) || false,
        isPressed: (variant === 'action' ? isActionPressed : isPressed) || false,
        isFocused: (variant === 'action' ? isActionFocused : isFocusVisible) || false,
        isCloseHovered: isCloseHovered || false,
        isClosePressed: isClosePressed || false,
        isCloseFocused: isCloseFocused || false
    };
};

/**
 * Helps with ref Element type
 * This will remove the ref from the default forwardRef typing and use the one defined in Props
 */ const createChip = (render)=>{
    return /*#__PURE__*/ forwardRef(render);
};
const Chip = createChip((props, ref)=>{
    const { icon: Icon, children, variant = DEFAULT_VARIANT$1, onChange, onPress, onClose, defaultSelected, isSelected: isSelectedProp, ...restProps } = props;
    const tokens = useTokens();
    const { boxProps, isHovered, isPressed, isSelected, isFocused, isClosePressed, isCloseHovered, isCloseFocused } = useChip(ref, props);
    const t = useChipTranslation();
    const stateProps = useMemo(()=>mapChipStateToBoxProps({
            isHovered,
            isPressed,
            isSelected,
            isClosePressed,
            isCloseHovered,
            variant
        }), [
        isHovered,
        isPressed,
        isSelected,
        isClosePressed,
        isCloseHovered,
        variant
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...stateProps.chip,
        ...boxProps.chip,
        ...restProps,
        position: "relative",
        borderRadius: "unsafe_component.chip.tmpNew.radius.chip",
        borderWidth: "unsafe_component.chip.borderWidth",
        borderStyle: "solid",
        height: "unsafe_component.chip.sizing",
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        paddingHorizontal: `calc(${tokens['unsafe_component.chip.spacing.padding.horizontal']} - ${tokens['unsafe_component.chip.borderWidth']})`,
        paddingVertical: "spacing.none",
        typography: "unsafe_component.chip.typography",
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        cursor: variant === 'input' ? 'default' : 'pointer',
        children: [
            /*#__PURE__*/ jsx(Box, {
                position: "absolute",
                top: "50%",
                left: "0",
                right: "0",
                transform: "translateY(-50%)",
                height: "unsafe_component.chip.spacing.touchZone"
            }),
            Icon && /*#__PURE__*/ jsx(Icon, {
                marginRight: "unsafe_component.chip.spacing.margin.gap",
                size: "sizing.16"
            }),
            children,
            variant === 'input' && /*#__PURE__*/ jsx(Box, {
                ...boxProps.close,
                ...stateProps.close,
                borderWidth: "borderWidth.none",
                borderRadius: "unsafe_component.chip.tmpNew.radius.closeButton",
                marginLeft: "unsafe_component.chip.spacing.margin.gap",
                padding: "spacing.none",
                cursor: "pointer",
                display: "inline-flex",
                // Outline only on Keyboard focus (focus-visible)
                outlineStyle: isCloseFocused ? 'auto' : 'none',
                "aria-label": t('chip::button::remove'),
                position: "relative",
                children: /*#__PURE__*/ jsx(CloseIcon, {
                    size: "sizing.20"
                })
            })
        ]
    });
});
const mapChipStateToBoxProps = ({ isHovered, isPressed, isSelected, isClosePressed, isCloseHovered, variant = DEFAULT_VARIANT$1 })=>{
    const getBackgroundColor = ()=>{
        if (isSelected && variant === 'filter') {
            switch(true){
                case isPressed:
                    return `unsafe_component.chip.color.selected.bgPressed`;
                case isHovered:
                    return `unsafe_component.chip.color.selected.bgHover`;
                default:
                    return `unsafe_component.chip.color.selected.bg`;
            }
        } else if (!isSelected && variant != 'input') {
            switch(true){
                case isPressed:
                    return `unsafe_component.chip.color.bgPressed`;
                case isHovered:
                    return `unsafe_component.chip.color.bgHover`;
            }
        } else if (isSelected && variant === 'input') {
            return `unsafe_component.chip.color.selected.bg`;
        }
        return `unsafe_component.chip.color.bg`;
    };
    const getBorderColor = ()=>{
        if (isSelected) {
            switch(true){
                case isPressed:
                    return `unsafe_component.chip.color.selected.borderPressed`;
                case isHovered:
                    return `unsafe_component.chip.color.selected.borderHover`;
                default:
                    return `unsafe_component.chip.color.selected.border`;
            }
        }
        return `unsafe_component.chip.color.border`;
    };
    const getColor = ()=>{
        if (isSelected && variant != 'action') {
            switch(true){
                case isPressed:
                    return `unsafe_component.chip.color.selected.contentPressed`;
                case isHovered:
                    return `unsafe_component.chip.color.selected.contentHover`;
                default:
                    return `unsafe_component.chip.color.selected.content`;
            }
        }
        return `unsafe_component.chip.color.content`;
    };
    const getCloseIconColor = ()=>{
        if (!isSelected) {
            switch(true){
                case isClosePressed:
                    return `unsafe_component.chip.color.closeIcon.bgPressed`;
                case isCloseHovered:
                    return `unsafe_component.chip.color.closeIcon.bgHover`;
                default:
                    return `unsafe_component.chip.color.closeIcon.bg`;
            }
        } else {
            switch(true){
                case isClosePressed:
                    return `unsafe_component.chip.color.closeIcon.selected.bgPressed`;
                case isCloseHovered:
                    return `unsafe_component.chip.color.closeIcon.selected.bgHover`;
                default:
                    return `unsafe_component.chip.color.closeIcon.selected.bg`;
            }
        }
    };
    return {
        chip: {
            borderColor: getBorderColor(),
            backgroundColor: getBackgroundColor(),
            color: getColor()
        },
        close: {
            backgroundColor: getCloseIconColor()
        }
    };
};

const ChipGroup = ({ items, ...groupProps })=>{
    const tokens = useTokens();
    return /*#__PURE__*/ jsx(Box, {
        display: "flex",
        flexWrap: "wrap",
        role: "group",
        margin: `-calc(${tokens['unsafe_component.chipGroup.spacing.gap']} / 2)`,
        ...groupProps,
        children: items.map(({ children, id, ...restProps })=>/*#__PURE__*/ jsx(Chip, {
                ...restProps,
                margin: `calc(${tokens['unsafe_component.chipGroup.spacing.gap']} / 2)`,
                children: children
            }, id))
    });
};

/**
 * Custom hook to map CoachMark props to `Box` ones with all needed interactive and accessible HTML attributes.
 * @param props CoachMark props and triggerRef
 * @returns CoachMark and trigger props, OverlayTrigger state
 */ const useCoachMark = (ref, props)=>{
    // Use useMenuTriggerState instead of useOverlayTriggerState in case a menu is embedded in the dialog.
    // This is needed to handle submenus.
    const state = useMenuTriggerState(props);
    const overlayId = useId$1();
    const { overlayProps } = useOverlay({
        shouldCloseOnBlur: false,
        shouldCloseOnInteractOutside: ()=>false,
        isOpen: state.isOpen,
        onClose: state.close
    }, ref);
    const triggerProps = {
        'aria-haspopup': 'dialog',
        'aria-expanded': state.isOpen,
        ...state.isOpen && {
            'aria-controls': overlayId
        },
        onPress: ()=>{
            if (props.triggerMode === 'manual') return;
            state.toggle();
        }
    };
    return {
        boxProps: {
            coachMark: {
                ...overlayProps,
                id: overlayId
            },
            trigger: triggerProps
        },
        state
    };
};

const useCoachMarkTranslation = ()=>useTranslation({
        'en-GB': {
            'carousel::previous': 'Previous',
            'carousel::next': 'Next'
        },
        'fr-FR': {
            'carousel::previous': 'Précédent',
            'carousel::next': 'Suivant'
        },
        'de-DE': {
            'carousel::previous': 'Zurück',
            'carousel::next': 'Weiter'
        },
        'nl-NL': {
            'carousel::previous': 'Terug',
            'carousel::next': 'Verder'
        }
    });

const tokens = {
    spacing: 'spacing.16',
    backgroundColor: 'color.surface.default.inverted.default',
    border: {
        width: 'borderWidth.1',
        color: 'color.border.transparent.default',
        radius: 'radius.16',
        style: 'solid',
        shadow: 'shadow.4'
    },
    animation: {
        duration: 'motionDuration.150',
        timingFunction: 'motionEasing.ease-in',
        direction: 'reverse'
    },
    title: {
        typography: 'typography.body.16.bold'
    },
    tag: {
        size: '12',
        variant: 'light'
    },
    content: {
        typography: 'typography.body.14.regular',
        color: 'color.content.default.inverted.default'
    },
    footer: {
        steps: {
            color: 'color.content.interactive.inverted.pressed'
        },
        previousButton: {
            variant: 'tertiary-inverted',
            size: '32'
        },
        nextButton: {
            variant: 'primary',
            size: '32'
        }
    }
};
const CoachMark = ({ children, triggerMode, ...props })=>{
    const triggerRef = useRef(null);
    const { boxProps: { coachMark, trigger }, state } = useCoachMark(triggerRef, props);
    // Those props are managed by the hook
    const { defaultOpen, isOpen, onOpenChange, ...popoverProps } = props;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            triggerMode === 'manual' ? children(triggerRef) : /*#__PURE__*/ jsx(PressResponder, {
                ...trigger,
                children: children(triggerRef)
            }),
            /*#__PURE__*/ jsx(Overlay, {
                isOpen: state.isOpen,
                children: /*#__PURE__*/ jsx(CoachMarkPopover, {
                    ...coachMark,
                    ...popoverProps,
                    triggerRef: triggerRef,
                    state: state
                })
            })
        ]
    });
};
const ArrowBox = ({ arrow, placement, arrowDiagonal, arrowSize })=>/*#__PURE__*/ jsx(Box, {
        ...arrow,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: placement === 'left' || placement === 'right' ? arrowDiagonal / 2 : arrowDiagonal,
        height: placement === 'top' || placement === 'bottom' ? arrowDiagonal / 2 : arrowDiagonal,
        overflow: [
            'hidden',
            'clip'
        ],
        transform: placement === 'top' || placement === 'bottom' ? 'translateX(-50%)' : 'translateY(-50%)',
        position: "absolute",
        top: placement === 'top' ? '100%' : undefined,
        bottom: placement === 'bottom' ? '100%' : undefined,
        left: placement === 'left' ? '100%' : undefined,
        right: placement === 'right' ? '100%' : undefined,
        children: /*#__PURE__*/ jsx(Box, {
            width: arrowSize,
            height: arrowSize,
            transform: "rotate(45deg)",
            position: "absolute",
            top: placement === 'top' ? -arrowSize / 2 : undefined,
            bottom: placement === 'bottom' ? -arrowSize / 2 : undefined,
            left: placement === 'left' ? -arrowSize / 2 : undefined,
            right: placement === 'right' ? -arrowSize / 2 : undefined,
            borderWidth: tokens.border.width,
            borderStyle: tokens.border.style,
            borderColor: tokens.border.color,
            backgroundColor: tokens.backgroundColor
        })
    });
const CoachMarkPopover = ({ triggerRef, tagProps, imageSrc, imageRatio, title, content, placement: coachMarkPlacement = 'bottom', alignment: coachMarkAlignment = 'middle', steps, footerPrevButtonProps, footerNextButtonProps, state, ...rest })=>{
    const ref = useRef(null);
    const rootFontSizeValue = getRootFontSizeValue();
    const arrowDiagonal = 18 * rootFontSizeValue / 16;
    const arrowSize = arrowDiagonal / Math.sqrt(2);
    const isHorizontal = coachMarkPlacement === 'left' || coachMarkPlacement === 'right';
    let computedPlacement;
    if (isHorizontal && coachMarkAlignment === 'start') computedPlacement = `${coachMarkPlacement} top`;
    else if (isHorizontal && coachMarkAlignment === 'end') computedPlacement = `${coachMarkPlacement} bottom`;
    else if (!isHorizontal && coachMarkAlignment !== 'middle') computedPlacement = `${coachMarkPlacement} ${coachMarkAlignment}`;
    else computedPlacement = `${coachMarkPlacement}`;
    const { overlayProps, arrowProps, placement } = useOverlayPosition({
        placement: computedPlacement,
        targetRef: triggerRef,
        overlayRef: ref,
        offset: arrowDiagonal / 2,
        isOpen: state.isOpen
    });
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(rest, {
            unsafe_style: overlayProps.style
        }),
        ref: ref,
        display: "flex",
        minWidth: 296,
        maxWidth: 400,
        borderWidth: tokens.border.width,
        borderStyle: tokens.border.style,
        borderColor: tokens.border.color,
        backgroundColor: tokens.backgroundColor,
        boxShadow: tokens.border.shadow,
        borderRadius: tokens.border.radius,
        color: tokens.content.color,
        typography: tokens.content.typography,
        animationDuration: tokens.animation.duration,
        animationTimingFunction: tokens.animation.timingFunction,
        animationDirection: tokens.animation.direction,
        paddingVertical: tokens.spacing,
        height: "auto",
        children: [
            /*#__PURE__*/ jsx(ArrowBox, {
                arrow: mergeProps(arrowProps, {
                    unsafe_style: arrowProps.style
                }),
                placement: !placement || placement === 'center' ? 'bottom' : placement,
                arrowDiagonal: arrowDiagonal,
                arrowSize: arrowSize
            }),
            /*#__PURE__*/ jsx(CoachMarkContent, {
                title: title,
                content: content,
                steps: steps,
                tagProps: tagProps,
                imageSrc: imageSrc,
                imageRatio: imageRatio,
                footerPrevButtonProps: footerPrevButtonProps,
                footerNextButtonProps: footerNextButtonProps,
                state: state
            }),
            /*#__PURE__*/ jsx(DismissButton, {
                onDismiss: state.close
            })
        ]
    });
};
const CoachMarkContent = ({ title, tagProps, imageSrc, imageRatio = '4:3', content, footerPrevButtonProps, footerNextButtonProps, steps, state })=>{
    const t = useTranslation();
    const ratio = imageRatio.split(':').map(Number);
    const imageHeightPercentage = 100 * (ratio[1] / ratio[0]);
    return /*#__PURE__*/ jsxs(Box, {
        typography: tokens.content.typography,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacing,
        children: [
            /*#__PURE__*/ jsxs(Box, {
                as: "header",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                paddingHorizontal: tokens.spacing,
                children: [
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "spacing.8",
                        width: "100%",
                        // Close button width 40px - 8px shift to the right + 8px gap
                        marginRight: "spacing.40",
                        children: [
                            tagProps?.children && /*#__PURE__*/ jsx(Tag, {
                                size: tokens.tag.size,
                                variant: tokens.tag.variant,
                                ...tagProps,
                                children: tagProps?.children
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                typography: tokens.title.typography,
                                flex: "1",
                                color: "color.content.default.inverted.default",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        variant: "tertiary-inverted",
                        iconOnly: true,
                        icon: CloseIcon,
                        size: "40",
                        onPress: state.close,
                        position: "absolute",
                        right: "spacing.8",
                        top: "spacing.8",
                        children: t('core::close')
                    })
                ]
            }),
            content || imageSrc ? /*#__PURE__*/ jsxs(Box, {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: tokens.spacing,
                overflowY: "auto",
                paddingHorizontal: tokens.spacing,
                children: [
                    imageSrc && /*#__PURE__*/ jsx(Box, {
                        borderRadius: "radius.8",
                        paddingTop: `${imageHeightPercentage}%`,
                        position: "relative",
                        overflow: "hidden",
                        width: "100%",
                        children: /*#__PURE__*/ jsx(Box, {
                            as: "img",
                            src: imageSrc,
                            alt: title,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                        })
                    }),
                    content && /*#__PURE__*/ jsx(Box, {
                        typography: tokens.content.typography,
                        color: tokens.content.color,
                        children: content
                    })
                ]
            }) : null,
            steps || footerPrevButtonProps || footerNextButtonProps ? /*#__PURE__*/ jsx(CoachMarkFooter, {
                steps: steps,
                footerNextButtonProps: footerNextButtonProps,
                footerPrevButtonProps: footerPrevButtonProps
            }) : null
        ]
    });
};
const CoachMarkFooter = ({ steps, footerPrevButtonProps, footerNextButtonProps })=>{
    const t = useCoachMarkTranslation();
    return /*#__PURE__*/ jsxs(Box, {
        as: "footer",
        display: "flex",
        alignItems: "center",
        paddingHorizontal: tokens.spacing,
        children: [
            steps && /*#__PURE__*/ jsxs(Box, {
                flex: "1",
                typography: tokens.content.typography,
                color: tokens.footer.steps.color,
                children: [
                    steps[0],
                    "/",
                    steps[1]
                ]
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
                children: [
                    footerPrevButtonProps && /*#__PURE__*/ jsx(Button, {
                        ...footerPrevButtonProps,
                        variant: tokens.footer.previousButton.variant,
                        size: tokens.footer.previousButton.size,
                        children: footerPrevButtonProps?.children || t('carousel::previous')
                    }),
                    footerNextButtonProps && /*#__PURE__*/ jsx(Button, {
                        ...footerNextButtonProps,
                        variant: tokens.footer.nextButton.variant,
                        size: tokens.footer.nextButton.size,
                        marginLeft: "spacing.8",
                        children: footerNextButtonProps?.children || t('carousel::next')
                    })
                ]
            })
        ]
    });
};

// @TODO: Create a global mapping helper for this kind of stuff
// https://avivgroup.atlassian.net/browse/GEMINI-1186
const assignToReactAriaPress$1 = (pressHandler)=>(e)=>pressHandler ? pressHandler({
            ...e,
            target: e.element,
            type: e.eventType
        }) : undefined;
const useCounterField = (ref, { error, isFullWidth, isOptional, isDisabled, label, max = 999, min = 0, unsafe_mappingValues, unsafe_formatOptions, ...rest })=>{
    const locale = useLocale();
    const state = useNumberFieldState({
        isInvalid: Boolean(error),
        isRequired: !isOptional,
        isDisabled: Boolean(isDisabled),
        maxValue: max,
        minValue: min,
        locale,
        ...unsafe_formatOptions ? {
            formatOptions: unsafe_formatOptions
        } : {},
        ...rest
    });
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const { decrementButtonProps, groupProps, incrementButtonProps, inputProps, labelProps, descriptionProps, errorMessageProps } = useNumberField({
        [labelProp]: typeof label === 'string' ? label : label.content,
        isInvalid: Boolean(error),
        isRequired: !isOptional,
        isDisabled: Boolean(isDisabled),
        maxValue: max,
        minValue: min,
        ...unsafe_formatOptions ? {
            formatOptions: unsafe_formatOptions
        } : {},
        onKeyDown: (event)=>{
            const input = event.target;
            /**
				 * We need to check if the user is trying to delete a mapped value using Backspace or Delete
				 * - Check that selectionStart and selectionEnd are not null for typing reasons, it should be null on non-input elements (not the case here)
				 * - If key is Backspace
				 *   - We check that we are not at the beginning of the input with the cursor because we can't delete before 0 with Backspace
				 *   - Or we check that the selectionStart is different from selectionEnd because we can delete a selection of text
				 * - Same for Delete but with cursor after last character
				 * - We check that we have some mapping values
				 */ if (input.selectionStart !== null && input.selectionEnd !== null && (event.key === 'Backspace' && (input.selectionStart > 0 || input.selectionStart !== input.selectionEnd) || event.key === 'Delete' && (input.selectionEnd < input.value.length || input.selectionStart !== input.selectionEnd)) && unsafe_mappingValues && unsafe_mappingValues.length > 0) {
                const mappedTuple = unsafe_mappingValues.find(({ abbreviation })=>input.value.includes(abbreviation));
                // We find one, we clear the input value
                if (mappedTuple) {
                    state.setInputValue('');
                    state.setNumberValue(NaN);
                }
            }
        },
        ...rest
    }, {
        ...state,
        validate: (value)=>{
            // We have some mapping values, we need to check if the value contains any of them
            if (unsafe_mappingValues && unsafe_mappingValues.length > 0) {
                const mappedTuple = unsafe_mappingValues.find(({ abbreviation })=>value.includes(abbreviation));
                // We find one, we need to remove it from the value
                if (mappedTuple) {
                    return state.validate(value.replace(mappedTuple.abbreviation, ''));
                }
            }
            return state.validate(value);
        }
    }, ref);
    const value = unsafe_mappingValues && unsafe_mappingValues.length > 0 ? unsafe_mappingValues.find(({ value })=>value === state.numberValue)?.abbreviation ?? state.inputValue : state.inputValue;
    return {
        boxProps: {
            group: groupProps,
            input: {
                ...inputProps,
                value,
                onChange: (e)=>{
                    // We have some mapping values, we need to check if the input value contains any of them
                    if (unsafe_mappingValues && unsafe_mappingValues.length > 0) {
                        const mappedTuple = unsafe_mappingValues.find(({ abbreviation })=>e.target.value.includes(abbreviation));
                        // We find one, we need to remove it from the input value
                        if (mappedTuple) {
                            inputProps.onChange?.({
                                ...e,
                                target: {
                                    ...e.target,
                                    value: e.target.value.replace(mappedTuple.abbreviation, '')
                                }
                            });
                            return;
                        }
                    }
                    inputProps.onChange?.(e);
                }
            },
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps,
            decrement: {
                ...decrementButtonProps,
                onPress: assignToReactAriaPress$1(decrementButtonProps.onPress),
                onPressStart: assignToReactAriaPress$1(decrementButtonProps.onPressStart),
                onPressEnd: assignToReactAriaPress$1(decrementButtonProps.onPressEnd)
            },
            increment: {
                ...incrementButtonProps,
                onPress: assignToReactAriaPress$1(incrementButtonProps.onPress),
                onPressStart: assignToReactAriaPress$1(incrementButtonProps.onPressStart),
                onPressEnd: assignToReactAriaPress$1(incrementButtonProps.onPressEnd)
            }
        },
        numberValue: state.numberValue
    };
};

const CounterButton = (props)=>{
    const { icon, isDisabled, preventFocusOnPress, excludeFromTabOrder, allowFocusWhenDisabled, onPress, onPressStart, onPressEnd, onFocus, onBlur, ...restProps } = props;
    const ref = useRef(null);
    const { boxProps, isHovered, isPressed } = useButton$1(ref, {
        preventFocusOnPress,
        excludeFromTabOrder,
        allowFocusWhenDisabled,
        onPress,
        onPressStart,
        onPressEnd,
        onFocus,
        onBlur,
        isDisabled: Boolean(isDisabled),
        type: 'button'
    });
    const stateProps = useMemo(()=>mapButtonStateToBoxProps$2({
            isDisabled: Boolean(isDisabled),
            isHovered,
            isPressed
        }), [
        isDisabled,
        isHovered,
        isPressed
    ]);
    const Icon = icon;
    return /*#__PURE__*/ jsx(Box, {
        ...mergeProps(boxProps, stateProps, restProps),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderStyle: "none",
        borderRadius: "unsafe_component.counterField.radius.button",
        height: "unsafe_component.counterField.sizing.button",
        width: "unsafe_component.counterField.sizing.button",
        children: /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            color: stateProps.color
        })
    });
};
const mapButtonStateToBoxProps$2 = ({ isDisabled, isHovered, isPressed })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.counterField.color.bgDisabled`;
            case isPressed:
                return `unsafe_component.counterField.color.bgPressed`;
            case isHovered:
                return `unsafe_component.counterField.color.bgHover`;
            default:
                return `unsafe_component.counterField.color.bgButton`;
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        color: isDisabled ? 'unsafe_component.counterField.color.textDisabled' : 'unsafe_component.counterField.color.text',
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    };
};

const CounterInput = /*#__PURE__*/ forwardRef(({ borderWidth, ...restProps }, ref)=>{
    const tokens = useTokens();
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        ref: ref,
        as: "input",
        borderWidth: "borderWidth.none",
        padding: "spacing.none",
        outlineStyle: "none",
        marginHorizontal: "unsafe_component.counterField.spacing.gap",
        height: `calc(${tokens['unsafe_component.counterField.sizing.input']} - (2 * ${borderWidth}))`,
        flexGrow: 1,
        width: "unsafe_component.counterField.sizing.input",
        minWidth: 0
    });
});

const CounterField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { defaultValue, isFullWidth, min, max, name, onChange, onBlur, onFocus, step, value, unsafe_mappingValues, unsafe_formatOptions, ...fieldProps } = props;
    const refObject = useObjectRef(ref);
    const { boxProps, numberValue } = useCounterField(refObject, props);
    const tokens = useTokens();
    const { boxProps: { input: inputBaseBoxProps, wrapper: wrapperBoxProps }, isFocused, isHovered } = useTextFieldBase({
        inputRef: refObject
    }, props);
    const borderWidth = useMemo(()=>isFocused ? tokens['unsafe_component.counterField.borderWidth.active'] : tokens['unsafe_component.counterField.borderWidth.default'], [
        isFocused,
        tokens
    ]);
    const borderColor = useMemo(()=>{
        const hasError = Boolean(fieldProps.error);
        switch(true){
            case fieldProps.isDisabled:
                return `unsafe_component.counterField.color.borderDisabled`;
            case hasError && isHovered && !isFocused:
                return `unsafe_component.counterField.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.counterField.color.borderError`;
            case isFocused:
                return `unsafe_component.counterField.color.borderFocus`;
            case isHovered:
                return `unsafe_component.counterField.color.borderHover`;
            default:
                return `unsafe_component.counterField.color.border`;
        }
    }, [
        fieldProps.error,
        fieldProps.isDisabled,
        isFocused,
        isHovered
    ]);
    const counterFieldMinWidth = useMemo(()=>mapCounterFieldWidthProps(isFullWidth), [
        isFullWidth
    ]);
    const horizontalPadding = useMemo(()=>`calc(${tokens['unsafe_component.counterField.spacing.padding']} - ${borderWidth})`, [
        borderWidth,
        tokens
    ]);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: /*#__PURE__*/ jsxs(Box, {
            ...mergeProps(wrapperBoxProps, boxProps.group),
            display: "flex",
            alignItems: "center",
            borderWidth: isFocused ? 'unsafe_component.counterField.borderWidth.active' : 'unsafe_component.counterField.borderWidth.default',
            borderStyle: "solid",
            borderColor: borderColor,
            borderRadius: "unsafe_component.counterField.radius.input",
            backgroundColor: fieldProps.isDisabled ? `unsafe_component.counterField.color.bgDisabled` : `unsafe_component.counterField.color.bg`,
            paddingHorizontal: horizontalPadding,
            height: "unsafe_component.counterField.sizing.input",
            color: fieldProps.isDisabled ? `unsafe_component.counterField.color.textDisabled` : `unsafe_component.counterField.color.text`,
            typography: "unsafe_component.counterField.typography",
            cursor: fieldProps.isDisabled ? 'not-allowed' : 'text',
            minWidth: counterFieldMinWidth,
            width: "fit-content",
            children: [
                /*#__PURE__*/ jsx(CounterButton, {
                    ...boxProps.decrement,
                    icon: MinusIcon
                }),
                /*#__PURE__*/ jsx(CounterInput, {
                    ...mergeProps(boxProps.input, inputBaseBoxProps),
                    ref: refObject,
                    textAlign: "center",
                    borderWidth: borderWidth
                }),
                /*#__PURE__*/ jsx(CounterButton, {
                    ...boxProps.increment,
                    icon: PlusIcon
                }),
                name && /*#__PURE__*/ jsx(Box, {
                    as: "input",
                    type: "hidden",
                    name: name,
                    value: Number.isNaN(numberValue) ? '' : numberValue
                })
            ]
        })
    });
});
const mapCounterFieldWidthProps = (isFullWidthWithResponsive)=>{
    // if we don't have full width i.E. undefined / false return min width of the field
    if (!isFullWidthWithResponsive) {
        return 'unsafe_component.counterField.sizing.minWidth';
    }
    // if the prop is not a responsive object return 100% directly
    if (typeof isFullWidthWithResponsive === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidthWithResponsive).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            // apply 100% for full width or default min width of the field
            [breakpoint]: isFullWidth ? '100%' : 'unsafe_component.counterField.sizing.minWidth'
        };
    }, {});
};

const useDateCalendarTranslation = ()=>useTranslation({
        'en-GB': {
            'dateCalendar::button::previous': 'Go to previous month',
            'dateCalendar::button::next': 'Go to next month'
        },
        'fr-FR': {
            'dateCalendar::button::previous': 'Aller au mois précédent',
            'dateCalendar::button::next': 'Aller au mois suivant'
        },
        'de-DE': {
            'dateCalendar::button::previous': 'Gehe zum nächsten Monat',
            'dateCalendar::button::next': 'Gehe zum vorigen Monat'
        },
        'nl-NL': {
            'dateCalendar::button::previous': 'Ga naar vorige maand',
            'dateCalendar::button::next': 'Ga naar volgende maand'
        }
    });

// @TODO: Create a global mapping helper for this kind of stuff
// @deprecated ? Breaking change type <=> eventType, target <=> element ?
// https://avivgroup.atlassian.net/browse/GEMINI-1186
const assignToReactAriaPress = (pressHandler)=>(e)=>pressHandler ? pressHandler({
            ...e,
            target: e.element,
            type: e.eventType
        }) : undefined;
const useDateCalendarBase = (props)=>{
    const locale = useLocale();
    const state = useCalendarState({
        ...props,
        locale,
        createCalendar
    });
    const { calendarProps: calendarBoxProps, prevButtonProps: { 'aria-label': ariaLabelPrev, ...prevButtonProps }, nextButtonProps: { 'aria-label': ariaLabelNext, ...nextButtonProps }, title } = useCalendar(props, state);
    return {
        boxProps: {
            calendar: calendarBoxProps,
            prevButton: {
                ...prevButtonProps,
                onPress: assignToReactAriaPress(prevButtonProps.onPress)
            },
            nextButton: {
                ...nextButtonProps,
                onPress: assignToReactAriaPress(nextButtonProps.onPress)
            }
        },
        state,
        title
    };
};

const useDateCalendarCell = (ref, { date, state })=>{
    const isHighlighted = today(getLocalTimeZone()).compare(date) === 0;
    const { cellProps, buttonProps, isSelected, isOutsideVisibleRange, isDisabled, isUnavailable, isPressed, isFocused, formattedDate } = useCalendarCell({
        date
    }, state, ref);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusProps, isFocusVisible } = useFocusable(ref, {
        isDisabled: Boolean(isDisabled)
    });
    return {
        boxProps: {
            cell: cellProps,
            button: mergeProps(hoverProps, focusProps, buttonProps)
        },
        isSelected,
        isOutsideVisibleRange,
        isDisabled,
        isUnavailable,
        isPressed,
        isHovered,
        isHighlighted,
        // Same as on react-aria calendar component
        // https://github.com/adobe/react-spectrum/blob/e94e36431149b6d3e9ed5900de30b538c0110584/packages/react-aria-components/src/Calendar.tsx#L488
        isFocused: isFocusVisible && isFocused,
        formattedDate
    };
};

const CalendarCell = ({ state, date, hideCurrentDayHighlight })=>{
    const ref = useRef(null);
    const { boxProps: { cell: cellProps, button: buttonProps }, isDisabled, isUnavailable, isHovered, isPressed, isSelected, isHighlighted, isOutsideVisibleRange, isFocused, formattedDate } = useDateCalendarCell(ref, {
        date,
        state
    });
    const stateProps = useMemo(()=>mapButtonStateToBoxProps$1({
            isDisabled,
            isUnavailable,
            isSelected,
            isHovered,
            isPressed,
            isOutsideVisibleRange
        }), [
        isDisabled,
        isUnavailable,
        isHovered,
        isOutsideVisibleRange,
        isPressed,
        isSelected
    ]);
    return /*#__PURE__*/ jsx(Box, {
        as: "td",
        ...cellProps,
        display: "flex",
        justifyContent: "center",
        flex: "1 0 0",
        cursor: isOutsideVisibleRange ? 'default' : 'auto',
        minHeight: "sizing.40",
        minWidth: "sizing.40",
        padding: "spacing.none",
        children: /*#__PURE__*/ jsx(Box, {
            ...buttonProps,
            ...stateProps,
            ref: ref,
            hidden: isOutsideVisibleRange,
            display: isOutsideVisibleRange ? 'none' : 'flex',
            alignItems: "center",
            justifyContent: "center",
            height: "sizing.40",
            width: "sizing.40",
            borderRadius: "radius.rounded",
            borderWidth: isHighlighted && !hideCurrentDayHighlight ? 'borderWidth.2' : 'borderWidth.none',
            borderStyle: "solid",
            borderColor: isDisabled || isUnavailable ? 'color.border.disabled' : 'color.border.interactive.default',
            transitionDuration: "motionDuration.150",
            transitionProperty: "background-color",
            transitionTimingFunction: "motionEasing.linear",
            outlineStyle: !isFocused ? 'none' : undefined,
            outlineWidth: !isFocused ? 'borderWidth.none' : undefined,
            children: formattedDate
        })
    });
};
const mapButtonStateToBoxProps$1 = ({ isDisabled, isUnavailable, isHovered, isPressed, isSelected, isOutsideVisibleRange })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled || isUnavailable:
                return 'color.surface.transparent.default';
            case isSelected:
                return 'color.surface.interactive.selected.default';
            case isPressed:
                return 'color.surface.transparent.pressed';
            case isHovered:
                return 'color.surface.transparent.hover';
            default:
                return 'color.surface.transparent.default';
        }
    };
    const getColor = ()=>{
        switch(true){
            case isDisabled || isUnavailable:
                return 'color.content.disabled';
            case isSelected:
                return 'color.content.default.inverted.default';
            default:
                return 'color.content.default.default';
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        color: getColor(),
        cursor: isOutsideVisibleRange ? 'default' : isDisabled || isUnavailable ? 'not-allowed' : 'pointer'
    };
};

const useDateCalendarGrid = ({ state })=>{
    const { gridProps, headerProps, weekDays } = useCalendarGrid({
        weekdayStyle: 'short'
    }, state);
    return {
        boxProps: {
            grid: gridProps,
            header: headerProps
        },
        weekDays
    };
};

const CalendarGrid = ({ state, hideCurrentDayHighlight })=>{
    const { boxProps: { grid: gridProps, header: headerProps }, weekDays } = useDateCalendarGrid({
        state
    });
    const locale = useLocale();
    // Get the number of weeks in the month so we can render the proper number of rows.
    const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
    return /*#__PURE__*/ jsxs(Box, {
        as: "table",
        ...gridProps,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: "spacing.6",
        children: [
            /*#__PURE__*/ jsx(Box, {
                ...headerProps,
                as: "thead",
                display: "flex",
                width: "100%",
                typography: "typography.body.12.bold",
                color: "color.content.light.default",
                textAlign: "center",
                children: /*#__PURE__*/ jsx(Box, {
                    as: "tr",
                    display: "flex",
                    width: "100%",
                    columnGap: "spacing.2",
                    children: weekDays.map((day, i)=>/*#__PURE__*/ jsx(Box, {
                            as: "th",
                            flex: "1 0 0",
                            padding: "spacing.none",
                            minWidth: "sizing.40",
                            children: day.toUpperCase()
                        }, i))
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "tbody",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                rowGap: "spacing.6",
                children: [
                    ...new Array(weeksInMonth).keys()
                ].map((weekIndex)=>/*#__PURE__*/ jsx(Box, {
                        as: "tr",
                        display: "flex",
                        width: "100%",
                        height: "sizing.40",
                        columnGap: "spacing.2",
                        children: state.getDatesInWeek(weekIndex).map((date, i)=>date ? /*#__PURE__*/ jsx(CalendarCell, {
                                state: state,
                                date: date,
                                hideCurrentDayHighlight: hideCurrentDayHighlight
                            }, i) : /*#__PURE__*/ jsx(Box, {
                                as: "td"
                            }, i))
                    }, weekIndex))
            })
        ]
    });
};

const useDateCalendarMonthDropdownTranslation = ()=>useTranslation({
        'en-GB': {
            'dateCalendar::month::label': 'Month'
        },
        'fr-FR': {
            'dateCalendar::month::label': 'Mois'
        },
        'de-DE': {
            'dateCalendar::month::label': 'Monat'
        },
        'nl-NL': {
            'dateCalendar::month::label': 'Maand'
        }
    });

const CalendarMonthDropdown = ({ state, ...rest })=>{
    const t = useDateCalendarMonthDropdownTranslation();
    const formatter = useDateFormatter({
        month: 'long',
        timeZone: state.timeZone
    });
    const minMonthsConstraint = state.minValue && state.focusedDate.year === state.minValue.year ? state.minValue.month : 1;
    const maxMonthsConstraint = state.maxValue && state.focusedDate.year === state.maxValue.year ? state.maxValue.month : state.focusedDate.calendar.getMonthsInYear(state.focusedDate);
    const months = Array.from({
        length: maxMonthsConstraint - minMonthsConstraint + 1
    }, (_, i)=>{
        const month = minMonthsConstraint + i;
        const date = state.focusedDate.set({
            month
        });
        return {
            value: month,
            formatted: formatter.format(date.toDate(state.timeZone))
        };
    });
    const onChange = (e)=>{
        const value = Number(e.target.value);
        state.setFocusedDate(state.focusedDate.set({
            month: value
        }));
    };
    return /*#__PURE__*/ jsxs(Box, {
        position: "relative",
        ...rest,
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "select",
                "aria-label": t('dateCalendar::month::label'),
                onChange: onChange,
                value: state.focusedDate.month,
                borderWidth: "borderWidth.none",
                padding: "spacing.none",
                paddingRight: "spacing.32",
                outlineOffset: "borderWidth.2",
                unsafe_style: {
                    background: 'none'
                },
                children: months.map((month)=>/*#__PURE__*/ jsx(Box, {
                        as: "option",
                        value: month.value,
                        children: month.formatted
                    }, month.value))
            }),
            /*#__PURE__*/ jsx(Box, {
                display: "inline-flex",
                pointerEvents: "none",
                position: "absolute",
                right: 0,
                children: /*#__PURE__*/ jsx(CaretDownFilledIcon, {})
            })
        ]
    });
};

const useDateCalendarYearDropdownTranslation = ()=>useTranslation({
        'en-GB': {
            'dateCalendar::year::label': 'Year'
        },
        'fr-FR': {
            'dateCalendar::year::label': 'Année'
        },
        'de-DE': {
            'dateCalendar::year::label': 'Jahr'
        },
        'nl-NL': {
            'dateCalendar::year::label': 'Jaar'
        }
    });

const MORE_YEARS = 20;
const CalendarYearDropdown = ({ state, ...rest })=>{
    const t = useDateCalendarYearDropdownTranslation();
    const formatter = useDateFormatter({
        year: 'numeric',
        timeZone: state.timeZone
    });
    const minYearsConstraint = state.minValue ? state.minValue.year : state.focusedDate.add({
        years: -MORE_YEARS
    }).year;
    const maxYearsConstraint = state.maxValue ? state.maxValue.year : state.focusedDate.add({
        years: MORE_YEARS
    }).year;
    const years = Array.from({
        length: maxYearsConstraint - minYearsConstraint + 1
    }, (_, i)=>{
        const year = minYearsConstraint + i;
        const date = state.focusedDate.set({
            year
        });
        return {
            value: date.year,
            formatted: formatter.format(date.toDate(state.timeZone))
        };
    });
    const onChange = (e)=>{
        state.setFocusedDate(state.focusedDate.set({
            year: Number(e.target.value)
        }));
    };
    return /*#__PURE__*/ jsxs(Box, {
        position: "relative",
        ...rest,
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "select",
                "aria-label": t('dateCalendar::year::label'),
                onChange: onChange,
                value: state.focusedDate.year,
                borderWidth: "borderWidth.none",
                padding: "spacing.none",
                paddingRight: "spacing.32",
                outlineOffset: "borderWidth.2",
                unsafe_style: {
                    background: 'none'
                },
                children: years.map((year)=>/*#__PURE__*/ jsx(Box, {
                        as: "option",
                        value: year.value,
                        children: year.formatted
                    }, year.value))
            }),
            /*#__PURE__*/ jsx(Box, {
                display: "inline-flex",
                pointerEvents: "none",
                position: "absolute",
                right: 0,
                children: /*#__PURE__*/ jsx(CaretDownFilledIcon, {})
            })
        ]
    });
};

/**
 * DateCalendarBase used within DateCalendar and DatePicker components.
 * Candidate for shared components later as FieldBase.
 */ const DateCalendarBase = ({ calendarTitleDropdowns = 'full', hideCurrentDayHighlight, ...rest })=>{
    const t = useDateCalendarTranslation();
    const ref = useRef(null);
    const { boxProps: { calendar: calendarBoxProps, prevButton: prevButtonProps, nextButton: nextButtonProps }, state: calendarState, title } = useDateCalendarBase(rest);
    return /*#__PURE__*/ jsxs(Box, {
        ...calendarBoxProps,
        ref: ref,
        backgroundColor: "color.surface.default.default",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "sizing.40",
                marginBottom: "spacing.16",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: calendarTitleDropdowns === 'full' ? 'div' : 'h2',
                        display: "inline-flex",
                        color: "color.content.default.default",
                        typography: "typography.body.16.bold",
                        children: calendarTitleDropdowns === 'full' ? /*#__PURE__*/ jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ jsx(CalendarMonthDropdown, {
                                    state: calendarState
                                }),
                                /*#__PURE__*/ jsx(CalendarYearDropdown, {
                                    state: calendarState,
                                    marginLeft: "spacing.16"
                                })
                            ]
                        }) : title
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        gap: "spacing.8",
                        children: [
                            /*#__PURE__*/ jsx(Button, {
                                ...prevButtonProps,
                                type: "button",
                                variant: "tertiary",
                                icon: ChevronLeftIcon,
                                iconOnly: true,
                                size: "40",
                                children: t('dateCalendar::button::previous')
                            }),
                            /*#__PURE__*/ jsx(Button, {
                                ...nextButtonProps,
                                type: "button",
                                variant: "tertiary",
                                icon: ChevronRightIcon,
                                iconOnly: true,
                                size: "40",
                                children: t('dateCalendar::button::next')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(CalendarGrid, {
                state: calendarState,
                hideCurrentDayHighlight: hideCurrentDayHighlight
            })
        ]
    });
};

const getValue = (value)=>value !== '' ? parseDate(value) : null;
/**
 * @internal This component is made for internal usage only and should not be used outside of Gemini itself.
 */ const DateCalendar = ({ defaultValue, value, onChange, placeholderValue, minValue, maxValue, isDateUnavailable, calendarTitleDropdowns, isDisabled = false, hideCurrentDayHighlight = false, ...rest })=>/*#__PURE__*/ jsx(DateCalendarBase, {
        ...rest,
        ...defaultValue !== undefined ? {
            defaultValue: getValue(defaultValue)
        } : {},
        ...value !== undefined ? {
            value: getValue(value)
        } : {},
        onChange: onChange ? (value)=>onChange(value ? value.toString() : '') : ()=>{},
        ...placeholderValue && value === undefined && defaultValue === undefined ? {
            defaultFocusedValue: parseDate(placeholderValue)
        } : {},
        ...minValue ? {
            minValue: parseDate(minValue)
        } : {},
        ...maxValue ? {
            maxValue: parseDate(maxValue)
        } : {},
        isDateUnavailable: (date)=>isDateUnavailable?.(date.toString()) ?? false,
        calendarTitleDropdowns: calendarTitleDropdowns,
        isDisabled: isDisabled,
        hideCurrentDayHighlight: hideCurrentDayHighlight
    });

const DESKTOP_BREAKPOINT = 'sm';

const useDatePicker = (ref, { value, defaultValue, label, isDisabled, isOptional, name, error, onChange, placeholderValue, minValue, maxValue, isDateUnavailable, ...rest })=>{
    // Default placeholder value is 1st January of the current year to avoid any issues with months having 31 days
    // https://github.com/adobe/react-spectrum/issues/3256#issuecomment-1825942096
    const defaultPlaceholderValue = new CalendarDate(today(getLocalTimeZone()).year, 1, 1);
    const [storedDateValue, setStoredDateValue] = useState('');
    // If there is no placeholder value, use today as the default (already the case inside of react-aria hooks)
    const parsedPlaceholderValue = placeholderValue ? parseDate(placeholderValue) : today(getLocalTimeZone());
    // As we have issues with placeholder value in the DateField, we check if month has 31 days and if not, we set the default placeholder value with 31 days
    const [localPlaceholderValue, setLocalPlaceholderValue] = useState(endOfMonth(parsedPlaceholderValue).day === 31 ? parsedPlaceholderValue : defaultPlaceholderValue);
    const isDesktop = useBreakpointValue({
        base: false,
        [DESKTOP_BREAKPOINT]: true
    });
    const state = useDatePickerState({
        ...defaultValue !== undefined ? {
            defaultValue: defaultValue !== '' ? parseDate(defaultValue) : null
        } : {},
        ...value !== undefined ? {
            value: value !== '' ? parseDate(value) : null
        } : {},
        placeholderValue: localPlaceholderValue,
        onChange: onChange ? (value)=>onChange(value ? value.toString() : '') : ()=>{},
        isDateUnavailable: (date)=>isDateUnavailable?.(date.toString()) ?? false,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        isInvalid: Boolean(error),
        shouldCloseOnSelect: isDesktop,
        onOpenChange: (isOpen)=>{
            // When DatePicker is opened, we put back the placeholder value to show the right placeholder, when it's closed, we put back the default placeholder value with 31 days
            if (endOfMonth(parsedPlaceholderValue).day !== 31) {
                setLocalPlaceholderValue(isOpen ? parsedPlaceholderValue : defaultPlaceholderValue);
            }
            setStoredDateValue(isOpen && state.value ? state.value.toString() : '');
        }
    });
    const onPressCancel = ()=>{
        if (!state.value) state.setValue(null);
        else state.setValue(storedDateValue ? parseDate(storedDateValue) : null);
        state.setOpen(false);
    };
    const onPressRegister = ()=>{
        state.setOpen(false);
    };
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const { groupProps, fieldProps, calendarProps, labelProps, descriptionProps, errorMessageProps } = useDatePicker$1({
        ...rest,
        placeholderValue: localPlaceholderValue,
        ...minValue ? {
            minValue: parseDate(minValue)
        } : {},
        ...maxValue ? {
            maxValue: parseDate(maxValue)
        } : {},
        [labelProp]: typeof label === 'string' ? label : label.content,
        isDateUnavailable: (date)=>isDateUnavailable?.(date.toString()) ?? false,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        name: name,
        isInvalid: Boolean(error)
    }, state, ref);
    return {
        boxProps: {
            field: fieldProps,
            group: groupProps,
            calendar: calendarProps,
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        },
        state,
        isDesktop,
        onPressCancel,
        onPressRegister
    };
};

const useDatePickerSegment = (ref, { state, segment })=>{
    const { segmentProps } = useDateSegment(segment, state, ref);
    const { boxProps: focusProps, isFocused } = useFocusable(ref);
    return {
        boxProps: mergeProps(segmentProps, segment.isEditable ? focusProps : {}),
        isFocused: segment.isEditable ? isFocused : false
    };
};

/**
 * Should stay internal as we use react-aria types
 * @internal
 */ const DatePickerSegment = /*#__PURE__*/ forwardRef(({ segment, state, color }, ref)=>{
    const localRef = useRef(null);
    const { boxProps, isFocused } = useDatePickerSegment(localRef, {
        state,
        segment
    });
    return(// Wrapping each segment in a Box fixes outside clicking focus behavior
    // https://github.com/adobe/react-spectrum/issues/3164
    /*#__PURE__*/ jsx(Box, {
        children: /*#__PURE__*/ jsx(Box, {
            ...boxProps,
            outlineStyle: "none",
            backgroundColor: isFocused ? [
                'Highlight',
                'SelectedItem'
            ] : undefined,
            color: isFocused ? [
                'HighlightText',
                'SelectedItemText'
            ] : color,
            ref: mergeRefs(ref, localRef),
            children: segment.text.toUpperCase()
        })
    }));
});

const useDatePickerTranslation = ()=>useTranslation({
        'en-GB': {
            'datePicker::button::calendar': 'Toggle calendar',
            'datePicker::button::previous': 'Go to previous month',
            'datePicker::button::next': 'Go to next month',
            'datePicker::button::cancel': 'Cancel',
            'datePicker::button::ok': 'OK',
            'datePicker::button::clear': 'Clear date'
        },
        'fr-FR': {
            'datePicker::button::calendar': 'Ouvrir le calendrier',
            'datePicker::button::previous': 'Aller au mois précédent',
            'datePicker::button::next': 'Aller au mois suivant',
            'datePicker::button::cancel': 'Annuler',
            'datePicker::button::ok': 'OK',
            'datePicker::button::clear': 'Effacer la date'
        },
        'de-DE': {
            'datePicker::button::calendar': 'Kalender umschalten',
            'datePicker::button::previous': 'Gehe zum nächsten Monat',
            'datePicker::button::next': 'Gehe zum vorigen Monat',
            'datePicker::button::cancel': 'Abbrechen',
            'datePicker::button::ok': 'OK',
            'datePicker::button::clear': 'Feld leeren'
        },
        'nl-NL': {
            'datePicker::button::calendar': 'Kalender inschakelen',
            'datePicker::button::previous': 'Ga naar vorige maand',
            'datePicker::button::next': 'Ga naar volgende maand',
            'datePicker::button::cancel': 'Annuleer',
            'datePicker::button::ok': 'OK',
            'datePicker::button::clear': 'Clear date'
        }
    });

const useDateField = ({ containerRef, fieldRef }, { fieldProps, isDisabled })=>{
    const locale = useLocale();
    const state = useDateFieldState({
        ...fieldProps,
        locale,
        createCalendar
    });
    const { fieldProps: fieldPropsReactAria, inputProps } = useDateField$1(fieldProps, state, fieldRef);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusProps, isFocused } = useFocusable(containerRef, {
        within: true
    });
    return {
        boxProps: {
            field: mergeProps(hoverProps, focusProps, fieldPropsReactAria),
            input: inputProps
        },
        state,
        isFocused,
        isHovered
    };
};

/**
 * Should stay internal as we use react-aria types
 * @internal
 */ const DateField = (props)=>{
    const { groupProps, inputRef, containerRef, pickerState, isDisabled, error, isFullWidth, onClear, hideClearButton = false } = props;
    const fieldRef = useRef(null);
    const segmentRefs = useRef([]);
    const tokens = useTokens();
    const { boxProps: { field, input }, state, isFocused, isHovered } = useDateField({
        containerRef,
        fieldRef
    }, props);
    const t = useDatePickerTranslation();
    const hasValue = useMemo(()=>state.segments.some((segment)=>segment.type !== 'literal' && !segment.isPlaceholder), [
        state.segments
    ]);
    const clearHandler = ()=>{
        state.setValue(null);
        if (onClear) {
            onClear();
        }
        segmentRefs.current[0]?.focus();
    };
    const borderWidth = pickerState.isOpen || isFocused ? 'unsafe_component.datePicker.borderWidth.active' : 'unsafe_component.datePicker.borderWidth.default';
    const borderColor = useMemo(()=>mapBorderColorProp(Boolean(error), Boolean(isDisabled), pickerState.isOpen || isFocused, isHovered), [
        error,
        isDisabled,
        isFocused,
        isHovered,
        pickerState.isOpen
    ]);
    const datePickerMinWidth = useMemo(()=>mapDatePickerWidthProps(isFullWidth), [
        isFullWidth
    ]);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Box, {
                ...groupProps,
                ref: containerRef,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderWidth: borderWidth,
                borderStyle: "solid",
                borderColor: borderColor,
                borderRadius: "unsafe_component.datePicker.radius.field",
                backgroundColor: isDisabled ? `unsafe_component.datePicker.color.bgDisabled` : `unsafe_component.datePicker.color.bg`,
                paddingLeft: `calc(${tokens['unsafe_component.datePicker.spacing.padding.horizontal']} - ${tokens[borderWidth]})`,
                paddingRight: `calc(${tokens['unsafe_component.datePicker.spacing.padding.endButton']} - ${tokens[borderWidth]})`,
                height: "unsafe_component.datePicker.sizing.height",
                typography: "unsafe_component.datePicker.typography.field",
                cursor: isDisabled ? 'not-allowed' : 'text',
                minWidth: datePickerMinWidth,
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        ...field,
                        ref: fieldRef,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        height: "100%",
                        children: state.segments.map((segment, i)=>{
                            // Returns true when segment is a placeholder
                            // or if segment is a `/` and previous segment is a placeholder
                            const isPlaceholder = segment.isPlaceholder || segment.type === 'literal' && state.segments[i - 1]?.isPlaceholder;
                            return /*#__PURE__*/ jsx(DatePickerSegment, {
                                segment: segment,
                                state: state,
                                ref: (el)=>{
                                    segmentRefs.current[i] = el;
                                },
                                color: isDisabled ? 'unsafe_component.datePicker.color.textDisabled' : isPlaceholder ? 'unsafe_component.datePicker.color.textEmpty' : 'unsafe_component.datePicker.color.text'
                            }, i);
                        })
                    }),
                    !hideClearButton && hasValue && !isDisabled ? /*#__PURE__*/ jsx(Button, {
                        type: "button",
                        icon: CloseIcon,
                        iconOnly: true,
                        size: "40",
                        variant: "tertiary",
                        onPress: clearHandler,
                        marginRight: "spacing.8",
                        children: t('datePicker::button::clear')
                    }) : null,
                    /*#__PURE__*/ jsx(Button, {
                        type: "button",
                        icon: CalendarIcon,
                        iconOnly: true,
                        size: "40",
                        variant: "tertiary",
                        "aria-haspopup": "dialog",
                        "aria-expanded": pickerState.isOpen,
                        isDisabled: isDisabled,
                        onPress: ()=>pickerState.setOpen(true),
                        children: t('datePicker::button::calendar')
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "input",
                ref: inputRef,
                ...input
            })
        ]
    });
};
const mapBorderColorProp = (hasError, isDisabled, isFocused, isHovered)=>{
    switch(true){
        case isDisabled:
            return `unsafe_component.datePicker.color.borderDisabled`;
        case hasError && isHovered && !isFocused:
            return `unsafe_component.datePicker.color.borderErrorHover`;
        case hasError:
            return `unsafe_component.datePicker.color.borderError`;
        case isFocused:
            return `unsafe_component.datePicker.color.borderFocus`;
        case isHovered:
            return `unsafe_component.datePicker.color.borderHover`;
        default:
            return `unsafe_component.datePicker.color.border`;
    }
};
const mapDatePickerWidthProps = (isFullWidthWithResponsive)=>{
    // if we don't have full width i.E. undefined / false return min width of the field
    if (!isFullWidthWithResponsive) {
        return 'unsafe_component.datePicker.sizing.minWidth';
    }
    // if the prop is not an responsive object return 100% directly
    if (typeof isFullWidthWithResponsive === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidthWithResponsive).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            // apply 100% for full width or default min width of the field
            [breakpoint]: isFullWidth ? '100%' : 'unsafe_component.datePicker.sizing.minWidth'
        };
    }, {});
};

const useDatePickerPopover = (refs, { isDesktop, state: datePickerState })=>{
    const { trigger: triggerRef, popover: popoverRef } = refs;
    const tokens = useTokens();
    const rootFontSizeValue = getRootFontSizeValue();
    // Should stay before popover for execution order
    useLayoutEffect(()=>{
        const popover = popoverRef.current;
        if (popover) {
            if (!isDesktop) {
                // Remove styling applied when popover mode
                popover.style.top = '';
                popover.style.bottom = '';
                popover.style.left = '';
                popover.style.right = '';
                popover.style.maxHeight = '';
            } else {
                // Hack to avoid re-scale of the interface when switching responsive
                popover.style.position = 'absolute';
            }
        }
    }, [
        isDesktop,
        popoverRef
    ]);
    const { boxProps: popoverBoxProps } = usePopover({
        popover: popoverRef,
        trigger: triggerRef
    }, {
        isOpen: datePickerState.isOpen,
        close: datePickerState.close,
        placement: 'bottom',
        shouldFlip: true,
        alignment: 'start',
        offset: parseFloat(tokens['unsafe_component.datePicker.borderWidth.active'].toString()) * rootFontSizeValue,
        unsafe_shouldUpdatePosition: isDesktop
    });
    return {
        boxProps: {
            popover: popoverBoxProps.popover,
            underlay: popoverBoxProps.underlay
        }
    };
};

const DatePickerPopover = ({ targetRef, calendarProps, state, isDesktop, onPressCancel, onPressRegister })=>{
    const t = useDatePickerTranslation();
    const tokens = useTokens();
    const ref = useRef(null);
    const { boxProps: { popover: popoverProps, underlay: underlayProps } } = useDatePickerPopover({
        trigger: targetRef,
        popover: ref
    }, {
        isDesktop,
        state
    });
    return /*#__PURE__*/ jsxs(Box, {
        position: {
            'breakpoint.base': 'fixed',
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'initial'
        },
        top: {
            'breakpoint.base': 0,
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'initial'
        },
        left: {
            'breakpoint.base': 0,
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'initial'
        },
        bottom: {
            'breakpoint.base': 0,
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'initial'
        },
        right: {
            'breakpoint.base': 0,
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'initial'
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: {
            'breakpoint.base': '100%',
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'inherit'
        },
        zIndex: {
            'breakpoint.base': 'zIndex.3',
            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'zIndex.1'
        },
        children: [
            !isDesktop ? /*#__PURE__*/ jsx(Backdrop, {
                ...underlayProps
            }) : /*#__PURE__*/ jsx(Box, {
                ...underlayProps,
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }),
            /*#__PURE__*/ jsxs(Box, {
                ...popoverProps,
                ref: ref,
                width: {
                    'breakpoint.base': `calc(100% - 2 * ${tokens['unsafe_component.datePicker.spacing.padding.popover']})`,
                    [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'inherit'
                },
                padding: `calc(${tokens['unsafe_component.datePicker.spacing.padding.popover']} - ${tokens['unsafe_component.datePicker.borderWidth.default']})`,
                borderRadius: "unsafe_component.datePicker.radius.popover",
                borderWidth: "unsafe_component.datePicker.borderWidth.default",
                borderStyle: "solid",
                borderColor: "unsafe_component.datePicker.color.borderPopover",
                boxShadow: "unsafe_component.datePicker.shadow.calendar",
                backgroundColor: "unsafe_component.datePicker.color.bg",
                overflow: "auto",
                children: [
                    /*#__PURE__*/ jsx(DismissButton, {
                        onDismiss: state.close
                    }),
                    /*#__PURE__*/ jsx(DateCalendarBase, {
                        ...calendarProps
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        display: {
                            'breakpoint.base': 'flex',
                            [`breakpoint.${DESKTOP_BREAKPOINT}`]: 'none'
                        },
                        justifyContent: "flex-end",
                        gap: "unsafe_component.datePicker.spacing.gap.calendarButtons",
                        marginTop: "unsafe_component.datePicker.spacing.margin.calendarButtons",
                        children: [
                            /*#__PURE__*/ jsx(Button, {
                                type: "button",
                                variant: "tertiary",
                                size: "40",
                                onPress: onPressCancel,
                                children: t('datePicker::button::cancel')
                            }),
                            /*#__PURE__*/ jsx(Button, {
                                type: "button",
                                variant: "primary",
                                size: "40",
                                onPress: onPressRegister,
                                children: t('datePicker::button::ok')
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsx(DismissButton, {
                        onDismiss: state.close
                    })
                ]
            })
        ]
    });
};

const DatePicker = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { name, onChange, onBlur, onFocus, onClear, value, defaultValue, isFullWidth, placeholderValue, minValue, maxValue, isDateUnavailable, calendarTitleDropdowns, hideCurrentDayHighlight, ...fieldProps } = props;
    const refObject = useObjectRef(ref);
    const containerRefObject = useObjectRef();
    const { boxProps, state, isDesktop, onPressCancel, onPressRegister } = useDatePicker(containerRefObject, props);
    return /*#__PURE__*/ jsxs(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: [
            /*#__PURE__*/ jsx(DateField, {
                ...props,
                inputRef: refObject,
                containerRef: containerRefObject,
                fieldProps: boxProps.field,
                groupProps: boxProps.group,
                pickerState: state,
                onClear: onClear
            }),
            /*#__PURE__*/ jsx(Overlay, {
                isOpen: state.isOpen,
                children: /*#__PURE__*/ jsx(DatePickerPopover, {
                    calendarProps: mergeProps(boxProps.calendar, {
                        calendarTitleDropdowns,
                        hideCurrentDayHighlight
                    }),
                    targetRef: containerRefObject,
                    state: state,
                    isDesktop: isDesktop,
                    onPressCancel: onPressCancel,
                    onPressRegister: onPressRegister
                })
            })
        ]
    });
});

const Divider = ({ 'aria-hidden': ariaHidden = true, ...props })=>{
    /**
	 * If vertical Divider needs to be added, please use `useSeparator` helper from react-aria
	 * https://react-spectrum.adobe.com/react-aria/useSeparator.html
	 */ return /*#__PURE__*/ jsx(Box, {
        margin: "0",
        ...props,
        "aria-hidden": ariaHidden,
        as: "hr",
        // Remove default HR border
        borderWidth: "borderWidth.none",
        borderBottomColor: "unsafe_component.divider.color",
        borderBottomStyle: "solid",
        borderBottomWidth: "unsafe_component.divider.borderWidth",
        width: "100%"
    });
};

const useSelectButton = (ref, { isDisabled, triggerProps })=>{
    const refObject = useObjectRef(ref);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusProps, isFocused } = useFocusable(refObject, {
        unsafe_ignoreProviderProps: true,
        isDisabled: Boolean(isDisabled)
    });
    /** Get props for the button based on the trigger props from useSelect */ const { buttonProps } = useButton(triggerProps, ref);
    return {
        boxProps: mergeProps$1(hoverProps, focusProps, buttonProps),
        isFocused,
        isHovered
    };
};

const SelectButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { isDisabled, error, suffix, iconStart: IconStart, placeholder, triggerProps, state, valueProps, hasSuffix, isFullWidth, shouldShowSelectedItemIconStart } = props;
    const triggerRef = useObjectRef(ref);
    const tokens = useTokens();
    const { boxProps, isFocused, isHovered } = useSelectButton(triggerRef, {
        isDisabled,
        triggerProps
    });
    const borderWidth = state.isOpen || isFocused ? tokens['unsafe_component.dropdown.borderWidth.active'] : tokens['unsafe_component.dropdown.borderWidth.default'];
    const { borderColor } = useMemo(()=>getBorderColor({
            error,
            isDisabled,
            isFocused,
            isHovered,
            isOpen: state.isOpen
        }), [
        error,
        isDisabled,
        isFocused,
        isHovered,
        state.isOpen
    ]);
    const selectButtonMinWidth = useMemo(()=>mapSelectButtonWidthProps(isFullWidth), [
        isFullWidth
    ]);
    const isSelectedItemWithIconStart = shouldShowSelectedItemIconStart && state.selectedItem?.value?.icon && state.selectedItem?.value?.iconPosition === 'start';
    return /*#__PURE__*/ jsxs(Box, {
        ...boxProps,
        as: "button",
        type: "button",
        ref: triggerRef,
        display: "flex",
        alignItems: "center",
        borderWidth: state.isOpen || isFocused ? 'unsafe_component.dropdown.borderWidth.active' : 'unsafe_component.dropdown.borderWidth.default',
        borderStyle: "solid",
        borderColor: borderColor,
        borderRadius: "unsafe_component.dropdown.radius",
        backgroundColor: isDisabled ? `unsafe_component.dropdown.color.bgDisabled` : `unsafe_component.dropdown.color.bg`,
        paddingLeft: `calc(${tokens['unsafe_component.dropdown.spacing.padding.horizontal']} - ${borderWidth})`,
        paddingRight: `calc(${tokens['unsafe_component.dropdown.spacing.padding.horizontal']} - ${borderWidth})`,
        height: "unsafe_component.dropdown.sizing.height",
        color: isDisabled ? `unsafe_component.dropdown.color.textDisabled` : `unsafe_component.dropdown.color.text`,
        typography: "unsafe_component.dropdown.typography",
        cursor: isDisabled ? 'not-allowed' : 'default',
        minWidth: selectButtonMinWidth,
        outlineStyle: isFocused ? 'none' : 'inherit',
        children: [
            (IconStart || isSelectedItemWithIconStart) && /*#__PURE__*/ jsx(IconElement$3, {
                icon: isSelectedItemWithIconStart ? state.selectedItem?.value?.icon : IconStart,
                borderWidth: borderWidth,
                isDisabled: isDisabled
            }),
            /*#__PURE__*/ jsx(SelectedItemElement, {
                error: error,
                valueProps: valueProps,
                borderWidth: borderWidth,
                placeholder: placeholder,
                IconStart: Boolean(IconStart || isSelectedItemWithIconStart),
                suffix: Boolean(suffix),
                state: state,
                isDisabled: isDisabled
            }),
            (suffix ?? (hasSuffix && state.selectedItem?.value?.suffix)) && /*#__PURE__*/ jsx(TextFieldSuffix, {
                suffix: suffix || state.selectedItem?.value?.suffix,
                borderWidth: borderWidth,
                hasEndIcon: true
            }),
            /*#__PURE__*/ jsx(Box, {
                transform: state.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transitionDuration: "unsafe_component.dropdown.motionDuration",
                transitionProperty: "transform",
                transitionTimingFunction: "unsafe_component.dropdown.motionEasing",
                display: "flex",
                alignItems: "center",
                height: `calc(100% - ${borderWidth})`,
                children: /*#__PURE__*/ jsx(IconElement$3, {
                    icon: ChevronDownIcon,
                    borderWidth: borderWidth,
                    isDisabled: isDisabled
                })
            })
        ]
    });
});
const SelectedItemElement = ({ valueProps, borderWidth, IconStart, suffix, state, error, placeholder, isDisabled })=>{
    const tokens = useTokens();
    return /*#__PURE__*/ jsx(Box, {
        ...valueProps,
        borderWidth: "borderWidth.none",
        padding: "spacing.none",
        outlineStyle: "none",
        color: isDisabled ? 'unsafe_component.dropdown.color.textDisabled' : state.selectedItem?.rendered ? 'unsafe_component.dropdown.color.text' : 'unsafe_component.dropdown.color.placeholder',
        paddingVertical: `calc(${tokens['unsafe_component.dropdown.spacing.padding.vertical']} - ${borderWidth})`,
        flexGrow: 1,
        marginLeft: IconStart ? 'unsafe_component.dropdown.spacing.gap' : undefined,
        marginRight: suffix ? 'unsafe_component.dropdown.spacing.endContentGap' : undefined,
        minWidth: 0,
        "aria-invalid": Boolean(error),
        overflow: [
            'hidden',
            'clip'
        ],
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        textAlign: "left",
        children: state.selectedItem ? state.selectedItem.rendered : placeholder
    });
};
const IconElement$3 = ({ icon: Icon, borderWidth, isDisabled })=>{
    const tokens = useTokens();
    if (!Icon) return null;
    return /*#__PURE__*/ jsx(Icon, {
        size: "sizing.24",
        marginVertical: `calc(${tokens['unsafe_component.dropdown.spacing.padding.vertical']} - ${borderWidth})`,
        color: isDisabled ? 'unsafe_component.dropdown.color.textDisabled' : 'unsafe_component.dropdown.color.text'
    });
};
const getBorderColor = ({ error, isDisabled, isFocused, isHovered, isOpen })=>{
    const borderColor = ()=>{
        const hasError = Boolean(error);
        switch(true){
            case hasError && isOpen:
                return `unsafe_component.dropdown.color.borderError`;
            case hasError && isFocused:
                return `unsafe_component.dropdown.color.borderError`;
            case isOpen || isFocused:
                return `unsafe_component.dropdown.color.borderFocus`;
            case isDisabled:
                return `unsafe_component.dropdown.color.borderDisabled`;
            case hasError && isHovered && !isFocused:
                return `unsafe_component.dropdown.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.dropdown.color.borderError`;
            case isHovered:
                return `unsafe_component.dropdown.color.borderHover`;
            default:
                return `unsafe_component.dropdown.color.border`;
        }
    };
    return {
        borderColor: borderColor()
    };
};
const mapSelectButtonWidthProps = (isFullWidthWithResponsive)=>{
    // if we don't have full width i.E. undefined / false return min width of the field
    if (!isFullWidthWithResponsive) {
        return 'unsafe_component.dropdown.sizing.minWidth';
    }
    // if the prop is not an responsive object return 100% directly
    if (typeof isFullWidthWithResponsive === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidthWithResponsive).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            // apply 100% for full width or default min width of the field
            [breakpoint]: isFullWidth ? '100%' : 'unsafe_component.dropdown.sizing.minWidth'
        };
    }, {});
};

const useDropdown = (ref, props)=>{
    const { error, label, items, defaultItems, isDisabled, name, onChange, onFocus, onBlur, value, defaultValue } = props;
    const updatedItems = items?.map((item)=>({
            ...item,
            iconPosition: item.iconPosition || 'start'
        }));
    const updatedDefaultItems = defaultItems?.map((item)=>({
            ...item,
            iconPosition: item.iconPosition || 'start'
        }));
    const state = useSelectState({
        selectedKey: value,
        defaultSelectedKey: defaultValue,
        items: updatedItems || updatedDefaultItems,
        isDisabled: Boolean(isDisabled),
        children: (item)=>/*#__PURE__*/ jsx(Item, {
                children: item.label
            }),
        onSelectionChange: (value)=>{
            if (onChange) {
                // We only allow string as value
                onChange(value);
            }
        },
        // Not sure that the select state use it anyway
        isInvalid: Boolean(error)
    });
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const { menuProps, valueProps, triggerProps, labelProps, descriptionProps, errorMessageProps } = useSelect({
        isDisabled: Boolean(isDisabled),
        // name?:string; doesn't like name?: string | undefined; while it's the same
        name: name,
        [labelProp]: typeof label === 'string' ? label : label.content,
        ...onFocus ? {
            onFocus
        } : {},
        ...onBlur ? {
            onBlur
        } : {}
    }, state, ref);
    return {
        boxProps: {
            menu: menuProps,
            value: valueProps,
            trigger: triggerProps,
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        },
        state
    };
};

const useDropdownList = (ref, props)=>{
    const { trigger: triggerRef, popover: popoverRef } = ref;
    // Prevent virtual click under the dropdown popover
    // https://github.com/adobe/react-spectrum/issues/1513
    // Solution used by Plume https://github.com/plasmicapp/plasmic/commit/19f06e4d4579076d08a60095a6e58089f3518112#diff-2145c77dfcae53f2ffeaba70a8e888e1e21948711432054c13db783fb136ac00
    useEffect(()=>{
        popoverRef.current?.addEventListener('touchend', (e)=>{
            e.preventDefault();
        }, {
            passive: false
        });
    }, [
        popoverRef
    ]);
    const { boxProps: popoverBoxProps } = usePopover({
        popover: popoverRef,
        trigger: triggerRef
    }, {
        ...props,
        placement: 'bottom'
    });
    return {
        boxProps: {
            popover: popoverBoxProps?.popover,
            underlay: popoverBoxProps?.underlay
        }
    };
};

const DropdownList = (props)=>{
    const { label, triggerRef, selectableListRef, listWidth, shouldFlip, state, isLoading, loadingState, ...listProps } = props;
    const popoverRef = useRef(null);
    const tokens = useTokens();
    const rootFontSizeValue = getRootFontSizeValue();
    const { boxProps: { popover: popoverProps, underlay: underlayProps } } = useDropdownList({
        trigger: triggerRef,
        popover: popoverRef
    }, {
        isOpen: state.isOpen,
        close: state.close,
        shouldFlip,
        offset: parseFloat(tokens['unsafe_component.dropdown.borderWidth.active'].toString()) * rootFontSizeValue
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Box, {
                ...underlayProps,
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            }),
            /*#__PURE__*/ jsx(SelectableListBase, {
                ...listProps,
                variant: "contained",
                label: typeof label === 'string' ? label : label.content,
                ref: selectableListRef,
                width: listWidth,
                containerProps: popoverProps,
                containerRef: popoverRef,
                maxHeight: "40vh",
                state: state,
                isLoading: isLoading,
                loadingState: loadingState,
                // change default hover behavior of react-aria list to only apply style on hover
                shouldFocusOnHover: false
            })
        ]
    });
};

const Dropdown = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { name, defaultItems, defaultValue, items, onChange, onBlur, onFocus, value, iconStart, placeholder, shouldFlip, hasSuffix, suffix, isFullWidth, isLoading, loadingState, shouldShowSelectedItemIconStart = false, ...fieldProps } = props;
    const triggerRef = useRef(null);
    const selectableListRef = useRef(null);
    const [listWidth, setListWidth] = useState(0);
    const onResize = useCallback(()=>{
        if (triggerRef.current) {
            const containerWidth = triggerRef.current.offsetWidth;
            setListWidth(containerWidth);
        }
    }, []);
    useResizeObserver(triggerRef, {
        onResize
    });
    useLayoutEffect(onResize, [
        onResize
    ]);
    const { boxProps, state } = useDropdown(triggerRef, props);
    const { menu: { linkBehavior, ...menuProps } } = boxProps;
    const { disallowEmptySelection, ...listBoxProps } = menuProps;
    return /*#__PURE__*/ jsx(FocusableProvider, {
        ref: ref,
        position: "relative",
        children: /*#__PURE__*/ jsxs(FieldBase, {
            position: "relative",
            labelProps: boxProps.label,
            helperProps: boxProps.helper,
            errorProps: boxProps.error,
            ...fieldProps,
            children: [
                /*#__PURE__*/ jsx(HiddenSelect, {
                    state: state,
                    triggerRef: triggerRef,
                    label: typeof fieldProps.label === 'string' ? fieldProps.label : fieldProps.label.content,
                    name: name
                }),
                /*#__PURE__*/ jsx(SelectButton, {
                    ref: triggerRef,
                    triggerProps: boxProps.trigger,
                    placeholder: placeholder,
                    name: name,
                    isDisabled: fieldProps.isDisabled,
                    iconStart: iconStart,
                    error: fieldProps.error,
                    state: state,
                    valueProps: boxProps.value,
                    hasSuffix: hasSuffix,
                    suffix: suffix,
                    isFullWidth: isFullWidth,
                    shouldShowSelectedItemIconStart: shouldShowSelectedItemIconStart
                }),
                /*#__PURE__*/ jsx(Overlay, {
                    isOpen: state.isOpen,
                    children: /*#__PURE__*/ jsx(DropdownList, {
                        ...listBoxProps,
                        label: fieldProps.label,
                        triggerRef: triggerRef,
                        selectableListRef: selectableListRef,
                        listWidth: listWidth,
                        shouldFlip: shouldFlip,
                        state: state,
                        isLoading: isLoading,
                        loadingState: loadingState
                    })
                })
            ]
        })
    });
});

const FeedbackMessage = ({ children, endButtonProps, onClose, startButtonProps, title, variant = 'info', isFloating = false, disableBorderRadius = false, ...restProps })=>{
    const Icon = mapIconToVariant$1(variant);
    const t = useTranslation();
    const feedbackMessageBoxShadow = useMemo(()=>mapFeedbackMessageBoxShadowProps({
            isFloating
        }), [
        isFloating
    ]);
    const feedbackMessageBorderRadius = useMemo(()=>mapFeedbackMessageBorderRadiusProps({
            disableBorderRadius
        }), [
        disableBorderRadius
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        backgroundColor: `unsafe_component.feedbackMessage.color.${variant}.bg`,
        borderRadius: feedbackMessageBorderRadius,
        boxShadow: feedbackMessageBoxShadow,
        padding: "unsafe_component.feedbackMessage.spacing.padding",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignSelf: "stretch",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        display: "inline-flex",
                        color: `unsafe_component.feedbackMessage.color.${variant}.icon`,
                        marginRight: "unsafe_component.feedbackMessage.spacing.margin.button",
                        children: /*#__PURE__*/ jsx(Icon, {
                            size: "sizing.24"
                        })
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        children: [
                            title && /*#__PURE__*/ jsx(Box, {
                                typography: "unsafe_component.feedbackMessage.typography.title",
                                marginBottom: children ? 'unsafe_component.feedbackMessage.spacing.margin.title' : undefined,
                                children: title
                            }),
                            children && /*#__PURE__*/ jsx(Box, {
                                typography: "unsafe_component.feedbackMessage.typography.subtitle",
                                marginTop: "unsafe_component.feedbackMessage.spacing.margin.subtitle",
                                children: children
                            })
                        ]
                    }),
                    onClose && /*#__PURE__*/ jsx(Button, {
                        marginLeft: "unsafe_component.feedbackMessage.spacing.margin.button",
                        marginRight: "-unsafe_component.feedbackMessage.spacing.margin.button",
                        marginTop: "-unsafe_component.feedbackMessage.spacing.margin.button",
                        // If only Title, we need to get rid of the bottom padding too
                        marginBottom: "-unsafe_component.feedbackMessage.spacing.margin.button",
                        variant: "tertiary",
                        size: "40",
                        icon: CloseIcon,
                        iconOnly: true,
                        onPress: onClose,
                        type: "button",
                        children: `${t('core::close')}`
                    })
                ]
            }),
            startButtonProps && /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "start",
                flexDirection: {
                    'breakpoint.base': 'column',
                    'breakpoint.xs': 'row'
                },
                marginTop: "unsafe_component.feedbackMessage.spacing.margin.content",
                marginLeft: "unsafe_component.feedbackMessage.spacing.margin.contentGap",
                children: [
                    /*#__PURE__*/ jsx(Button, {
                        ...startButtonProps,
                        variant: "secondary",
                        size: "40"
                    }),
                    endButtonProps && /*#__PURE__*/ jsx(Button, {
                        ...endButtonProps,
                        variant: "tertiary",
                        size: "40",
                        marginLeft: {
                            'breakpoint.xs': 'unsafe_component.feedbackMessage.spacing.margin.button'
                        },
                        marginTop: {
                            'breakpoint.base': 'unsafe_component.feedbackMessage.spacing.margin.button',
                            'breakpoint.xs': 0
                        }
                    })
                ]
            })
        ]
    });
};
const mapIconToVariant$1 = (variant)=>{
    switch(variant){
        case 'error':
            return CloseFilledCircleIcon;
        case 'success':
            return CheckFilledCircleIcon;
        case 'warning':
            return ExclamationFilledCircleIcon;
        case 'info':
        default:
            return InfoFilledCircleIcon;
    }
};
const mapFeedbackMessageBoxShadowProps = ({ isFloating = false })=>{
    if (!isFloating) {
        return undefined;
    }
    if (typeof isFloating === 'boolean') {
        return 'shadow.8';
    }
    return Object.entries(isFloating).reduce((acc, [breakpoint, isFloating])=>{
        return {
            ...acc,
            [breakpoint]: isFloating ? 'shadow.8' : 'none'
        };
    }, {});
};
const mapFeedbackMessageBorderRadiusProps = ({ disableBorderRadius = false })=>{
    if (!disableBorderRadius) {
        return 'unsafe_component.feedbackMessage.radius';
    }
    if (typeof disableBorderRadius === 'boolean') {
        return undefined;
    }
    return Object.entries(disableBorderRadius).reduce((acc, [breakpoint, disableBorderRadius])=>{
        return {
            ...acc,
            [breakpoint]: disableBorderRadius ? 'radius.none' : 'unsafe_component.feedbackMessage.radius'
        };
    }, {});
};

const FloatingButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, icon: Icon, isDisabled = false, isStartButton, isEndButton, onPress, ...containerProps } = props;
    const { boxProps, isHovered, isPressed, isFocused } = useButton$1(ref, props);
    const stateProps = useMemo(()=>mapFloatingButtonStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed
        }), [
        isDisabled,
        isHovered,
        isPressed
    ]);
    const computedChildren = Array.isArray(children) ? children.join('') : children;
    return /*#__PURE__*/ jsx(Box, {
        ...mergeProps(containerProps, boxProps, stateProps),
        display: "inline-flex",
        borderWidth: "borderWidth.none",
        padding: "unsafe_component.floatingButtonGroup.spacing",
        width: "unsafe_component.floatingButtonGroup.sizing",
        height: "unsafe_component.floatingButtonGroup.sizing",
        "aria-label": computedChildren,
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        borderBottomWidth: !isEndButton ? 'unsafe_component.floatingButtonGroup.borderWidth' : 'borderWidth.none',
        borderColor: "unsafe_component.floatingButtonGroup.color.border",
        transitionProperty: "background-color",
        transitionDuration: "unsafe_component.floatingButtonGroup.motionDuration",
        transitionTimingFunction: "unsafe_component.floatingButtonGroup.motionEasing",
        children: /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24"
        })
    });
});
const mapFloatingButtonStateToBoxProps = ({ isDisabled, isHovered, isPressed })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.floatingButtonGroup.color.bgDisabled`;
            case isPressed:
                return `unsafe_component.floatingButtonGroup.color.bgPressed`;
            case isHovered:
                return `unsafe_component.floatingButtonGroup.color.bgHover`;
            default:
                return `unsafe_component.floatingButtonGroup.color.bg`;
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        color: `unsafe_component.floatingButtonGroup.color.content${isDisabled ? 'Disabled' : ''}`,
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    };
};

const FloatingButtonGroup = ({ items, isDisabled: isGloballyDisabled, ...groupProps })=>{
    return /*#__PURE__*/ jsx(Box, {
        display: "flex",
        flexDirection: "column",
        role: "group",
        boxShadow: "unsafe_component.floatingButtonGroup.shadow",
        borderRadius: "unsafe_component.floatingButtonGroup.radius",
        overflow: [
            'hidden',
            'clip'
        ],
        ...groupProps,
        children: items.map(({ children, id, isDisabled, ...restProps }, index)=>/*#__PURE__*/ jsx(FloatingButton, {
                isStartButton: index === 0,
                isEndButton: index === items.length - 1,
                isDisabled: isGloballyDisabled ?? isDisabled,
                ...restProps,
                children: children
            }, id))
    });
};

const SlideImage = ({ slide, sliderId, lazyLoading, isFirstLoaded, onError, onLoad })=>{
    return slide.shouldShowSlideImage ? /*#__PURE__*/ jsx(Box, {
        as: "img",
        id: `${sliderId}-${slide.id}`,
        alt: slide.alt,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        src: slide.url,
        loading: lazyLoading === 'all' || !isFirstLoaded && lazyLoading === 'first' ? 'lazy' : undefined,
        onError: onError,
        onLoad: onLoad,
        // To avoid different behavior between 1 or more images
        draggable: false
    }) : /*#__PURE__*/ jsx(Box, {
        width: "100%",
        height: "100%"
    });
};

const SlideContainer = ({ index, currentSlide, slide, sliderId, imagesLength, displayNoneSlide, slidePosition, isTransitioning, onTransitionEnd, lazyLoading, isFirstLoaded, isDisabled, onError, onLoad })=>{
    if (isDisabled && index === 0) return /*#__PURE__*/ jsx(SlideImage, {
        slide: slide,
        sliderId: sliderId,
        lazyLoading: lazyLoading,
        isFirstLoaded: isFirstLoaded,
        onLoad: onLoad,
        onError: onError
    });
    if (isDisabled && index !== 0) return null;
    return /*#__PURE__*/ jsx(Box, {
        "aria-label": slide['aria-label'],
        "aria-roledescription": imagesLength > 1 ? 'slide' : undefined,
        "aria-hidden": imagesLength > 1 ? !slide.shouldShowSlideImage || index !== currentSlide : undefined,
        "aria-current": imagesLength > 1 ? index === currentSlide : undefined,
        role: imagesLength > 1 ? 'group' : undefined,
        position: "absolute",
        left: 0,
        top: 0,
        /**
			 * When the display is set to none, the onTransitionEnd is removed before its completion and then the event will not generated.
			 * So we have to manage the display with the opacity.
			 **/ display: "inherit",
        opacity: displayNoneSlide ? 'opacity.none' : 'opacity.full',
        width: "100%",
        height: "100%",
        overflow: [
            'hidden',
            'clip'
        ],
        ...imagesLength > 1 ? {
            transform: `translateX(${slidePosition}%)`,
            transitionDuration: 'unsafe_component.imageSlider.motionDuration.slide',
            transitionProperty: isTransitioning ? 'transform' : 'none',
            transitionTimingFunction: 'unsafe_component.imageSlider.motionEasing',
            onTransitionEnd
        } : {},
        children: /*#__PURE__*/ jsx(SlideImage, {
            slide: slide,
            sliderId: sliderId,
            lazyLoading: lazyLoading,
            isFirstLoaded: isFirstLoaded,
            onLoad: onLoad,
            onError: onError
        })
    });
};

const useImageSliderTranslation = ()=>useTranslation({
        'en-GB': {
            'aria::label::indicator': 'of',
            'aria::label::left': 'go to previous slide',
            'aria::label::right': 'go to next slide'
        },
        'fr-FR': {
            'aria::label::indicator': 'sur',
            'aria::label::left': 'aller à la slide précédente',
            'aria::label::right': 'aller à la slide suivante'
        },
        'de-DE': {
            'aria::label::indicator': 'von',
            'aria::label::left': 'Gehe zur vorherigen Folie',
            'aria::label::right': 'Gehe zur nächsten Folie'
        },
        'nl-NL': {
            'aria::label::indicator': 'van de',
            'aria::label::left': 'ga naar de vorige dia',
            'aria::label::right': 'ga naar de volgende dia'
        }
    });

const SliderButtons = ({ sliderId, shouldDisplayArrows, onNextButtonClick, onPreviousButtonClick, isPreviousDisabled, isNextDisabled })=>{
    const t = useImageSliderTranslation();
    const commonButtonStyle = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: shouldDisplayArrows ? undefined : 'opacity.none',
        pointerEvents: shouldDisplayArrows ? undefined : 'none',
        transitionProperty: 'opacity',
        transitionDuration: 'unsafe_component.imageSlider.motionDuration.buttons',
        transitionTimingFunction: 'unsafe_component.imageSlider.motionEasing',
        zIndex: 'zIndex.1'
    };
    return /*#__PURE__*/ jsxs(Box, {
        children: [
            /*#__PURE__*/ jsx(Button, {
                ...commonButtonStyle,
                left: "unsafe_component.imageSlider.spacing.padding.slider",
                "aria-controls": sliderId,
                variant: "secondary-floating",
                iconOnly: true,
                icon: ChevronLeftIcon,
                onPress: onPreviousButtonClick,
                isDisabled: isPreviousDisabled,
                size: "40",
                type: "button",
                children: t('aria::label::left')
            }),
            /*#__PURE__*/ jsx(Button, {
                ...commonButtonStyle,
                right: "unsafe_component.imageSlider.spacing.padding.slider",
                "aria-controls": sliderId,
                variant: "secondary-floating",
                iconOnly: true,
                icon: ChevronRightIcon,
                onPress: onNextButtonClick,
                isDisabled: isNextDisabled,
                size: "40",
                type: "button",
                children: t('aria::label::right')
            })
        ]
    });
};

const updateSlideDisplay = (slides, currentSlide, previousSlides)=>{
    return slides.map((image, index)=>{
        const isFirstSlideCurrent = currentSlide === 0;
        const isLastSlideCurrent = currentSlide === slides.length - 1;
        // Slides to load
        const loadFirstSlide = index === 0;
        const loadSecondSlide = index === 1;
        const loadLastSlide = index === slides.length - 1;
        const loadPenultimateSlide = index === slides.length - 2;
        const loadPreviousSlide = index === currentSlide - 1;
        const loadNextSlide = index === currentSlide + 1;
        const loadCurrentSlide = currentSlide === index;
        return {
            ...image,
            shouldShowSlideImage: // Already loaded
            image.shouldShowSlideImage || // Was already shown before images update
            previousSlides && previousSlides.find((slide)=>slide.id === image.id)?.shouldShowSlideImage || loadCurrentSlide || isFirstSlideCurrent && (loadSecondSlide || loadLastSlide) || isLastSlideCurrent && (loadFirstSlide || loadPenultimateSlide) || !isFirstSlideCurrent && !isLastSlideCurrent && (loadPreviousSlide || loadNextSlide)
        };
    });
};
const getDisplayNoneSlide = ({ currentSlide, isTransitioning, sliderDirection, slides })=>(slideIndex)=>{
        // If not isTransitioning, we can keep displaying
        if (!isTransitioning) return false;
        const isFirstSlideCurrent = currentSlide === 0;
        const isLastSlideCurrent = currentSlide === slides.length - 1;
        const showFirstSlide = slideIndex === 0;
        const showLastSlide = slideIndex === slides.length - 1;
        const showPreviousSlide = slideIndex === currentSlide - 1;
        const showNextSlide = slideIndex === currentSlide + 1;
        const showCurrentSlide = currentSlide === slideIndex;
        return !(sliderDirection === 'next' && (isFirstSlideCurrent && showLastSlide || showPreviousSlide) || sliderDirection === 'previous' && (isLastSlideCurrent && showFirstSlide || showNextSlide) || showCurrentSlide);
    };
const getSlidePosition = ({ currentSlide, slides })=>(slideIndex)=>{
        // If current slide shown is the last one, prepare the first slide on the right of it
        // Only if more than 2 slide
        if (currentSlide === slides.length - 1 && slides.length > 2 && slideIndex === 0) return (slideIndex + 1) * 100;
        // If current slide shown is the first one, prepare the last slide on the left of it
        // Only if more than 2 slide
        if (currentSlide === 0 && slides.length > 2 && slideIndex === slides.length - 1) return (currentSlide - 1) * 100;
        // Otherwise, we calculate simply the position with computation of index + current slide !
        return (slideIndex - currentSlide) * 100;
    };
/**
 * Returns the value passed to the hook on previous render.
 *
 * Yields `undefined` on first render.
 *
 * @param value Value to yield on next render
 */ function usePrevious(value) {
    const previous = useRef(undefined);
    useEffect(()=>{
        previous.current = value;
    });
    return previous.current;
}
/**
 * Hook to manipulate Image slider
 */ const useImageSlider = (sliderRef, { images, shouldLoop, defaultValue, onChange })=>{
    const imagesLength = images.length;
    const previousImages = usePrevious(images);
    const t = useImageSliderTranslation();
    const getImageIndex = useCallback((id)=>images.findIndex((img)=>img.id === id), [
        images
    ]);
    const [sliderState, setSliderState] = useState(()=>{
        const initialSlideIndex = Math.max(defaultValue ? getImageIndex(defaultValue) : 0, 0);
        const imagesMapped = updateSlideDisplay(images.map((image, index)=>({
                ...image,
                displayNumber: index + 1,
                'aria-label': `${index + 1} ${t('aria::label::indicator')} ${imagesLength}`
            })), initialSlideIndex);
        return {
            currentSlide: initialSlideIndex,
            displayNumber: initialSlideIndex + 1,
            sliderDirection: 'current',
            isTransitioning: false,
            // Double images when there is 2 images to allow transition from left/right
            slides: imagesLength === 2 && shouldLoop !== false ? [
                ...imagesMapped,
                /**
							 * As we have the same image 2 times, add a suffix to the duplicated images
							 */ ...imagesMapped.map((image)=>({
                        ...image,
                        id: image.id + '-geminiSliderClone'
                    }))
            ] : imagesMapped,
            hasAllSlidesLoaded: imagesMapped.every((image)=>image.shouldShowSlideImage)
        };
    });
    const { currentSlide, isTransitioning, slides, sliderDirection } = sliderState;
    // Update slides if images are different
    useEffect(()=>{
        if (images !== previousImages && previousImages !== undefined) {
            setSliderState((prevState)=>{
                // Add initial `displayNumber` and `shouldShowSlideImage` to images
                // Keep existing shouldShowSlideImage value if id stays the same between 2 pools of images
                const imagesMapped = updateSlideDisplay(images.map((image, index)=>({
                        ...image,
                        displayNumber: index + 1
                    })), 0, slides);
                return {
                    ...prevState,
                    slides: imagesLength === 2 && shouldLoop !== false ? [
                        ...imagesMapped,
                        /**
									 * As we have the same image 2 times, add a suffix to the duplicated images
									 */ ...imagesMapped.map((image)=>({
                                ...image,
                                id: image.id + '-geminiSliderClone'
                            }))
                    ] : imagesMapped
                };
            });
        }
    }, [
        images,
        imagesLength,
        previousImages,
        shouldLoop,
        slides
    ]);
    useEffect(()=>{
        /**
		 * The index of the `currentSlide` is calculated to compensate for the cloned images when there are 2 images
		 */ const currentSlideIndex = images.length === 2 ? currentSlide % 2 : currentSlide;
        if (onChange && images[currentSlideIndex]) {
            onChange(images[currentSlideIndex].id);
        }
    }, [
        currentSlide,
        images,
        onChange
    ]);
    const handleNewSlide = useCallback((newCurrentSlide, direction)=>{
        if (isTransitioning) return;
        setSliderState((prevState)=>({
                ...prevState,
                sliderDirection: direction,
                isTransitioning: true,
                currentSlide: newCurrentSlide,
                displayNumber: prevState.slides[newCurrentSlide]?.displayNumber,
                ...!prevState.hasAllSlidesLoaded ? {
                    slides: updateSlideDisplay(prevState.slides, newCurrentSlide),
                    hasAllSlidesLoaded: prevState.slides.every((slide)=>slide.shouldShowSlideImage)
                } : {}
            }));
    }, [
        isTransitioning,
        setSliderState
    ]);
    const handleNextSlide = useCallback(()=>handleNewSlide(currentSlide === slides.length - 1 ? 0 : currentSlide + 1, 'next'), [
        currentSlide,
        slides,
        handleNewSlide
    ]);
    const handlePreviousSlide = useCallback(()=>handleNewSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1, 'previous'), [
        currentSlide,
        slides,
        handleNewSlide
    ]);
    const handleOnEndTransition = useCallback((slideIndex)=>{
        // take only current slide animation
        if (slideIndex === currentSlide) {
            return ()=>{
                setSliderState((prevState)=>({
                        ...prevState,
                        sliderDirection: 'current',
                        isTransitioning: false
                    }));
            };
        }
        return ()=>{};
    }, [
        currentSlide
    ]);
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocusVisible } = useFocusable(sliderRef, {
        within: true
    });
    return {
        boxProps: mergeProps(hoverProps, focusProps),
        state: {
            currentSlide,
            isTransitioning,
            slides,
            displayNumber: sliderState.displayNumber
        },
        handleNextSlide,
        handlePreviousSlide,
        handleOnEndTransition,
        getDisplayNoneSlide: getDisplayNoneSlide({
            currentSlide,
            isTransitioning,
            sliderDirection,
            slides
        }),
        getSlidePosition: getSlidePosition({
            currentSlide,
            slides
        }),
        isHovered,
        isFocused: isFocusVisible
    };
};
const useSliderSwipe = ({ isSwipeable, isDisabled, isNextDisabled, isPreviousDisabled, onNextButtonClick, onPreviousButtonClick })=>{
    const [isBeingSwiped, setIsBeingSwiped] = useState(false);
    const { boxProps } = useSwipe({
        onSwipeStart: (isKeyboard)=>{
            if (!isKeyboard) {
                setIsBeingSwiped(true);
            }
        },
        onSwipe: (distanceX, isKeyboard)=>{
            if ((isKeyboard && 0 < distanceX || !isKeyboard && 0 > distanceX) && !isNextDisabled) onNextButtonClick();
            if ((isKeyboard && 0 > distanceX || !isKeyboard && 0 < distanceX) && !isPreviousDisabled) onPreviousButtonClick();
        },
        isTouchDisabled: !isSwipeable,
        isDisabled: !!isDisabled
    });
    const preventRedirectionOnSwipe = (e)=>{
        if (isBeingSwiped) {
            e.preventDefault();
            setIsBeingSwiped(false);
        }
    };
    const resetIsBeingSwiped = useCallback(()=>{
        if (isBeingSwiped) {
            setIsBeingSwiped(false);
        }
    }, [
        isBeingSwiped
    ]);
    return {
        boxProps,
        preventRedirectionOnSwipe,
        isBeingSwiped,
        resetIsBeingSwiped
    };
};
const useSliderCTA = (props)=>{
    const { onPress, href, isBeingSwiped, resetIsBeingSwiped, preventRedirectionOnSwipe } = props;
    const isLink = typeof href === 'string';
    let additionalProps;
    if (!isLink) {
        additionalProps = {
            type: 'button',
            as: 'button'
        };
    } else {
        additionalProps = {
            tabIndex: 0,
            href,
            as: 'a'
        };
    }
    const { boxProps: pressableProps } = usePressable({
        onPress: !isBeingSwiped ? onPress : undefined,
        onPressEnd: resetIsBeingSwiped,
        preventFocusOnPress: true
    });
    return {
        boxProps: mergeProps(additionalProps, !isLink ? pressableProps : {}, isLink ? {
            // Issue with `preventDefault` not available on press events so we manually handle it
            // https://github.com/adobe/react-spectrum/issues/963
            onClick: preventRedirectionOnSwipe,
            onTouchEnd: preventRedirectionOnSwipe
        } : {})
    };
};

const ImageSlider = (props)=>{
    const { accessibilityLabel, images, isRounded, ratio, shouldLoop = true, shouldAlwaysDisplayArrows, href, onPress, isSwipeable, isDisabled, label, lazyLoading, onImageError, indicatorOffset = '16', iconTags, touchAction = 'pan-y' } = props;
    // Unique identifier for the ImageSlider in order to avoid issues if we have multiple instances with the same images
    const sliderId = useId();
    const imagesLength = images.length;
    const sliderRef = useRef(null);
    // If not loading="lazy", will directly load
    const [isFirstLoaded, setIsFirstLoaded] = useState(lazyLoading === undefined);
    const { boxProps, state: { currentSlide, isTransitioning, slides, displayNumber }, handleNextSlide, handleOnEndTransition, handlePreviousSlide, getDisplayNoneSlide, getSlidePosition, isHovered, isFocused } = useImageSlider(sliderRef, props);
    const hasCTA = typeof onPress === 'function' || typeof href === 'string';
    const isPreviousDisabled = !shouldLoop && currentSlide === 0;
    const isNextDisabled = !shouldLoop && currentSlide === imagesLength - 1;
    const { boxProps: swipeProps, preventRedirectionOnSwipe, isBeingSwiped, resetIsBeingSwiped } = useSliderSwipe({
        isSwipeable,
        isDisabled,
        isNextDisabled,
        isPreviousDisabled,
        onNextButtonClick: handleNextSlide,
        onPreviousButtonClick: handlePreviousSlide
    });
    const mappedRatio = ratio.split('/').reverse().join('/');
    const { boxProps: pressableProps } = useSliderCTA({
        onPress,
        href,
        isBeingSwiped,
        resetIsBeingSwiped,
        preventRedirectionOnSwipe
    });
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps$1(boxProps, swipeProps),
        ref: sliderRef,
        id: sliderId,
        "aria-atomic": !isDisabled && imagesLength > 1 ? false : undefined,
        "aria-label": accessibilityLabel,
        "aria-roledescription": !isDisabled && imagesLength > 1 ? 'carousel' : undefined,
        tabIndex: 0,
        position: "relative",
        display: "flex",
        alignItems: "center",
        height: "auto",
        width: "100%",
        justifyContent: "center",
        paddingBottom: `calc((${mappedRatio}) * 100%)`,
        borderRadius: `unsafe_component.imageSlider.radius.${isRounded ? 'rounded' : 'default'}`,
        overflow: [
            'hidden',
            'clip'
        ],
        whiteSpace: "nowrap",
        // To allow vertical page scroll but not horizontal and avoid unwanted touchEnd
        touchAction: touchAction,
        children: [
            /*#__PURE__*/ jsxs(Box, {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                height: "100%",
                "aria-live": !isDisabled && imagesLength > 1 ? 'polite' : undefined,
                children: [
                    slides.map((slide, index)=>/*#__PURE__*/ jsx(SlideContainer, {
                            index: index,
                            currentSlide: currentSlide,
                            slide: slide,
                            sliderId: sliderId,
                            imagesLength: imagesLength,
                            displayNoneSlide: getDisplayNoneSlide(index),
                            slidePosition: getSlidePosition(index),
                            isTransitioning: isTransitioning,
                            onTransitionEnd: handleOnEndTransition(index),
                            lazyLoading: lazyLoading,
                            isFirstLoaded: isFirstLoaded,
                            isDisabled: isDisabled,
                            onError: onImageError ? (event)=>onImageError(slide.id, event) : undefined,
                            onLoad: index === currentSlide && !isFirstLoaded ? ()=>setIsFirstLoaded(true) : undefined
                        }, `${sliderId}-${slide.id}`)),
                    !isDisabled && hasCTA ? /*#__PURE__*/ jsx(Box, {
                        ...mergeProps$1(swipeProps, pressableProps),
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: "100%",
                        display: "block",
                        padding: "spacing.none",
                        borderWidth: "borderWidth.none",
                        cursor: "pointer",
                        opacity: "opacity.none",
                        "aria-label": label
                    }) : null
                ]
            }),
            !isDisabled && imagesLength > 1 ? /*#__PURE__*/ jsx(SliderButtons, {
                sliderId: sliderId,
                shouldDisplayArrows: shouldAlwaysDisplayArrows || isHovered || isFocused,
                onPreviousButtonClick: handlePreviousSlide,
                onNextButtonClick: handleNextSlide,
                isNextDisabled: isNextDisabled,
                isPreviousDisabled: isPreviousDisabled,
                isBeingSwiped: isBeingSwiped
            }) : null,
            !isDisabled ? /*#__PURE__*/ jsxs(Box, {
                "aria-hidden": "true",
                position: "absolute",
                right: "unsafe_component.imageSlider.spacing.padding.slider",
                bottom: `unsafe_component.imageSlider.spacing.bottom.indicator.${indicatorOffset}`,
                display: "flex",
                gap: "unsafe_component.imageSlider.spacing.padding.indicator",
                pointerEvents: "none",
                children: [
                    (iconTags ?? []).map((icon, i)=>{
                        return /*#__PURE__*/ jsx(Tag, {
                            icon: icon,
                            variant: "darkStrong"
                        }, i);
                    }),
                    /*#__PURE__*/ jsx(Tag, {
                        variant: "darkStrong",
                        children: `${displayNumber} / ${imagesLength}`
                    })
                ]
            }) : undefined
        ]
    });
};

const useLink = (ref, { isExternal, href, onPress, isDisabled })=>{
    const refObject = useObjectRef$1(ref);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusableProps, isFocusVisible } = useFocusable(refObject, {
        isDisabled
    });
    const { boxProps: pressProps, isPressed } = usePressable({
        isDisabled,
        onPress
    });
    const additionalProps = {
        as: 'a',
        tabIndex: 0,
        href: isDisabled ? undefined : href,
        target: isExternal ? '_blank' : undefined,
        /**
		 * `noopener` for security purposes (to prevent the opening page from gaining access to the document opening it)
		 * `noreferrer` has not been added since it can negative consequences on SEO.
		 * @todo Confirm with the SEO team, the `noreferrer`/`nofollow` use cases if any valid ones.
		 */ rel: isExternal ? 'noopener' : undefined,
        'aria-disabled': isDisabled
    };
    return {
        boxProps: mergeProps(hoverProps, focusableProps, pressProps, additionalProps, {
            ref: refObject
        }),
        isPressed,
        isHovered,
        isFocused: isFocusVisible
    };
};

const Link = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { href, icon: Icon, iconPosition = 'start', isExternal, variant = 'standalone', onPress, children, isDisabled, ...restProps } = props;
    const { boxProps, isPressed, isHovered, isFocused } = useLink(ref, props);
    const LinkComponent = useRenderLink({
        isExternal
    });
    const computedVariant = variant.split('-')[0];
    const backgroundBehavior = variant.split('-')[1] || 'default';
    const iconElement = useMemo(()=>{
        if (!Icon) return null;
        if (!isExternal && computedVariant === 'standalone' && Icon === ExternalLinkIcon) {
            console.warn('The `ExternalLinkIcon` is not allowed with non external links');
            return null;
        }
        return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            [`margin${iconPosition === 'start' ? 'Right' : 'Left'}`]: 'unsafe_component.link.spacing.gap'
        });
    }, [
        Icon,
        iconPosition,
        isExternal,
        computedVariant
    ]);
    const stateProps = useMemo(()=>mapLinkStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            backgroundBehavior
        }), [
        backgroundBehavior,
        isDisabled,
        isHovered,
        isPressed
    ]);
    return /*#__PURE__*/ jsxs(LinkComponent, {
        ...mergeProps(restProps, boxProps, stateProps),
        alignItems: "center",
        display: computedVariant === 'standalone' ? 'flex' : 'inline',
        typography: computedVariant === 'standalone' ? 'unsafe_component.link.typography.standalone' : 'unsafe_component.link.typography.default',
        transitionDuration: "unsafe_component.link.motionDuration",
        transitionProperty: "color",
        transitionTimingFunction: "unsafe_component.link.motionEasing",
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        children: [
            iconPosition === 'start' && !isExternal && iconElement,
            children,
            iconPosition === 'end' && !isExternal && iconElement,
            isExternal && /*#__PURE__*/ jsx(ExternalLinkIcon, {
                size: computedVariant === 'standalone' ? 'sizing.24' : 'inherit',
                marginLeft: "unsafe_component.link.spacing.gap"
            })
        ]
    });
});
const mapLinkStateToBoxProps = ({ isDisabled, isHovered, isPressed, backgroundBehavior })=>{
    const getColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.link.color.${backgroundBehavior}.disabled`;
            case isPressed:
                return `unsafe_component.link.color.${backgroundBehavior}.pressed`;
            case isHovered:
                return `unsafe_component.link.color.${backgroundBehavior}.hover`;
            default:
                return `unsafe_component.link.color.${backgroundBehavior}.default`;
        }
    };
    return {
        color: getColor(),
        cursor: isDisabled ? 'default' : 'pointer'
    };
};

const useMediaUploadTranslation = ()=>useTranslation({
        'en-GB': {
            'aria::label::indicator': 'Files',
            'mediaupload::default::desktop': 'Drag and drop files here or click to upload',
            'mediaupload::default::mobile': 'Tap to add files',
            'mediaupload::coverLabel': 'Cover photo',
            'mediaupload::addFile': 'Add files',
            'mediaupload::editFile': 'Edit file ":file_name:"',
            'mediaupload::deleteFile': 'Delete file ":file_name:"',
            'mediaupload::sortFile': 'Drag files to rearrange order',
            'mediaupload::option::cover': 'Choose as cover',
            'mediaupload::option::forward': 'Move forward',
            'mediaupload::option::backward': 'Move backwards',
            'mediaupload::option::caption': 'Edit caption',
            'mediaupload::option::caption::cancel': 'Cancel',
            'mediaupload::option::caption::save': 'Save',
            'mediaupload::option::edit': 'Edit file',
            'mediaupload::option::remove': 'Remove',
            'mediaupload::indicator': 'Files:',
            'mediaupload::error': 'File Error',
            'mediaupload::option::caption::label': 'Caption',
            'mediaupload::filePress': 'File press for ":file_name:"',
            'mediaupload::imageEdit::title': 'Edit image',
            'mediaupload::imageEdit::dropdown::label': 'Image format',
            'mediaupload::imageEdit::dropdown::label::aspect::banner': 'Banner (16:9)',
            'mediaupload::imageEdit::dropdown::label::aspect::portrait': 'Portrait (4:3)',
            'mediaupload::imageEdit::slider::zoom::label': 'Zoom',
            'mediaupload::imageEdit::slider::rotation::label': 'Rotation',
            'mediaupload::imageEdit::button::rotation::label': 'Rotate right',
            'mediaupload::imageEdit::footerStartButton': 'Undo all changes',
            'mediaupload::imageEdit::footerEndButton': 'Apply',
            'mediaupload::imageEdit::discard::modal::title': 'Exit & undo your edits?',
            'mediaupload::imageEdit::discard::modal::text': 'Once you leave the editor, your recent changes will be lost.',
            'mediaupload::imageEdit::discard::modal::discardButton': 'Exit',
            'mediaupload::imageEdit::discard::modal::continueButton': 'Continue editing'
        },
        'fr-FR': {
            'aria::label::indicator': 'Fichiers',
            'mediaupload::default::desktop': 'Glissez et déposez vos fichiers ici ou importez-les',
            'mediaupload::default::mobile': 'Appuyez ici pour ajouter des fichiers',
            'mediaupload::coverLabel': 'Photo de couverture',
            'mediaupload::editFile': 'Modifier le fichier ":file_name:"',
            'mediaupload::deleteFile': 'Supprimer le fichier ":file_name:"',
            'mediaupload::addFile': 'Ajouter des fichiers',
            'mediaupload::sortFile': "Faites glisser les fichiers pour changer l'ordre",
            'mediaupload::option::cover': 'Choisir comme couverture',
            'mediaupload::option::forward': "Déplacer à l'avant",
            'mediaupload::option::backward': "Déplacer à l'arrière",
            'mediaupload::option::caption': 'Modifier la légende',
            'mediaupload::option::caption::cancel': 'Annuler',
            'mediaupload::option::caption::save': 'Sauvegarde',
            'mediaupload::option::edit': 'Éditer le fichier',
            'mediaupload::option::remove': 'Supprimer',
            'mediaupload::indicator': 'Fichiers :',
            'mediaupload::error': 'Erreur de fichier',
            'mediaupload::option::caption::label': 'Légende',
            'mediaupload::filePress': 'Clic sur le fichier ":file_name:"',
            'mediaupload::imageEdit::title': "Modifier l'image",
            'mediaupload::imageEdit::dropdown::label': "Format de l'image",
            'mediaupload::imageEdit::dropdown::label::aspect::banner': 'Bannière (16:9)',
            'mediaupload::imageEdit::dropdown::label::aspect::portrait': 'Portrait (4:3)',
            'mediaupload::imageEdit::slider::zoom::label': 'Zoom',
            'mediaupload::imageEdit::slider::rotation::label': 'Rotation',
            'mediaupload::imageEdit::button::rotation::label': 'Pivoter à droite',
            'mediaupload::imageEdit::footerStartButton': 'Annuler les modifications',
            'mediaupload::imageEdit::footerEndButton': 'Appliquer',
            'mediaupload::imageEdit::discard::modal::title': 'Quitter et annuler vos modifications ?',
            'mediaupload::imageEdit::discard::modal::text': "Vos modifications seront perdues une fois l'éditeur quitté.",
            'mediaupload::imageEdit::discard::modal::discardButton': 'Quitter',
            'mediaupload::imageEdit::discard::modal::continueButton': 'Continuer la modification'
        },
        'de-DE': {
            'aria::label::indicator': 'Dateien',
            'mediaupload::default::desktop': 'Dateien per Drag-and-drop hierherziehen oder zum Hochladen anklicken',
            'mediaupload::default::mobile': 'Antippen, um Dateien hinzuzufügen',
            'mediaupload::coverLabel': 'Titelbild',
            'mediaupload::editFile': 'Datei ":file_name:" bearbeiten',
            'mediaupload::deleteFile': 'Datei ":file_name:" löschen',
            'mediaupload::addFile': 'Dateien hinzufügen',
            'mediaupload::sortFile': 'Ziehen Sie Dateien, um die Reihenfolge zu ändern',
            'mediaupload::option::cover': 'Als Titelbild festlegen',
            'mediaupload::option::forward': 'Nach vorne schieben',
            'mediaupload::option::backward': 'Nach hinten schieben',
            'mediaupload::option::caption': 'Bildunterschrift bearbeiten',
            'mediaupload::option::caption::cancel': 'Abbrechen',
            'mediaupload::option::caption::save': 'Übernehmen',
            'mediaupload::option::edit': 'Datei editieren',
            'mediaupload::option::remove': 'Entfernen',
            'mediaupload::indicator': 'Dateien:',
            'mediaupload::error': 'Datei-Fehler',
            'mediaupload::option::caption::label': 'Bildunterschrift',
            'mediaupload::filePress': 'Klicke auf die Datei ":file_name:"',
            'mediaupload::imageEdit::title': 'Bild bearbeiten',
            'mediaupload::imageEdit::dropdown::label': 'Bildformat',
            'mediaupload::imageEdit::dropdown::label::aspect::banner': 'Banner (16:9)',
            'mediaupload::imageEdit::dropdown::label::aspect::portrait': 'Hochformat (4:3)',
            'mediaupload::imageEdit::slider::zoom::label': 'Zoom',
            'mediaupload::imageEdit::slider::rotation::label': 'Drehung',
            'mediaupload::imageEdit::button::rotation::label': 'Nach rechts drehen',
            'mediaupload::imageEdit::footerStartButton': 'Alle Änderungen rückgängig machen',
            'mediaupload::imageEdit::footerEndButton': 'Anwenden',
            'mediaupload::imageEdit::discard::modal::title': 'Beenden und Änderungen verwerfen?',
            'mediaupload::imageEdit::discard::modal::text': 'Wenn Sie den Editor jetzt schließen, werden die von Ihnen zuletzt angewandten Änderungen nicht übernommen.',
            'mediaupload::imageEdit::discard::modal::discardButton': 'Beenden',
            'mediaupload::imageEdit::discard::modal::continueButton': 'Bearbeitung fortsetzen'
        },
        'nl-NL': {
            'aria::label::indicator': 'Bestanden',
            'mediaupload::default::desktop': 'Sleep de bestanden hierheen of klik om te uploaden',
            'mediaupload::default::mobile': 'Tik om bestanden toe te voegen',
            'mediaupload::coverLabel': 'Omslagfoto',
            'mediaupload::deleteFile': 'Bestand verwijderen ":file_name:"',
            'mediaupload::editFile': 'Bestand bewerken ":file_name:"',
            'mediaupload::addFile': 'Bestanden toevoegen',
            'mediaupload::sortFile': 'Sleep bestanden om volgorde aan te passen',
            'mediaupload::option::cover': 'Kies als omslag',
            'mediaupload::option::forward': 'Breng naar voren',
            'mediaupload::option::backward': 'Breng naar achteren',
            'mediaupload::option::caption': 'Bewerk bijschrift',
            'mediaupload::option::caption::cancel': 'Annuleren',
            'mediaupload::option::caption::save': 'opslaan',
            'mediaupload::option::edit': 'Bestand bewerken',
            'mediaupload::option::remove': 'Verwijder',
            'mediaupload::indicator': 'Bestanden:',
            'mediaupload::error': 'Bestandsfout',
            'mediaupload::option::caption::label': 'Bijschrift',
            'mediaupload::filePress': 'Klik op het bestand ":file_name:"',
            'mediaupload::imageEdit::title': 'Edit image',
            'mediaupload::imageEdit::dropdown::label': 'Image format',
            'mediaupload::imageEdit::dropdown::label::aspect::banner': 'Banner (16:9)',
            'mediaupload::imageEdit::dropdown::label::aspect::portrait': 'Portrait (4:3)',
            'mediaupload::imageEdit::slider::zoom::label': 'Zoom',
            'mediaupload::imageEdit::slider::rotation::label': 'Rotation',
            'mediaupload::imageEdit::button::rotation::label': 'Rotate right',
            'mediaupload::imageEdit::footerStartButton': 'Undo all changes',
            'mediaupload::imageEdit::footerEndButton': 'Apply',
            'mediaupload::imageEdit::discard::modal::title': 'Exit & undo your edits?',
            'mediaupload::imageEdit::discard::modal::text': 'Once you leave the editor, your recent changes will be lost.',
            'mediaupload::imageEdit::discard::modal::discardButton': 'Exit',
            'mediaupload::imageEdit::discard::modal::continueButton': 'Continue editing'
        }
    });

async function createThumbnails(file, maxSize, signal) {
    if (!(file instanceof File) || !file.type.startsWith('image/') || file.size === 0) {
        return undefined;
    }
    try {
        const cancellationPromise = new Promise((_, reject)=>{
            // If the signal is already aborted, reject immediately.
            if (signal?.aborted) {
                return reject(new DOMException('Aborted', 'AbortError'));
            }
            signal?.addEventListener('abort', ()=>{
                reject(new DOMException('Aborted', 'AbortError'));
            });
        });
        const imageBitmap = await Promise.race([
            createImageBitmap(file),
            cancellationPromise
        ]);
        const scale = Math.min(maxSize / imageBitmap.width, maxSize / imageBitmap.height, 1);
        const width = imageBitmap.width * scale;
        const height = imageBitmap.height * scale;
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            return undefined;
        }
        ctx.drawImage(imageBitmap, 0, 0, width, height);
        // Race the blob conversion against the cancellation.
        return await Promise.race([
            new Promise((resolve)=>{
                canvas.toBlob((blob)=>resolve(blob ?? undefined), 'image/jpeg', 0.5);
            }),
            cancellationPromise
        ]);
    } catch  {
        return undefined;
    }
}

const isDragEvent = (ev)=>ev.type === 'drop';
const useFileInput = ({ errors, onChange, defaultValue, value, enableThumbnailGeneration, thumbnailSize = 1280 })=>{
    const [files, setFiles] = useState(value ?? defaultValue ?? []);
    const isControlled = value !== undefined;
    const currentFiles = isControlled ? value : files;
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [onEditFile, setOnEditFile] = useState({
        file: undefined
    });
    const [isEditingFileCaption, setIsEditingFileCaption] = useState(false);
    const [isEditingImage, setIsEditingImage] = useState(false);
    // Generate thumbnails for initial files (defaultValue | value).
    useEffect(()=>{
        if (!enableThumbnailGeneration || !(value ?? defaultValue)?.length) {
            return;
        }
        const processInitialFiles = async ()=>{
            const initialFiles = value ?? defaultValue ?? [];
            let isFileUpdated = false;
            const updatedFilesPromises = initialFiles.map(async (file)=>{
                if (file.file.type.startsWith('image/') && !file.thumbnail) {
                    const thumbnail = await createThumbnails(file.file, thumbnailSize);
                    if (thumbnail) {
                        isFileUpdated = true;
                        return {
                            ...file,
                            thumbnail: URL.createObjectURL(thumbnail)
                        };
                    }
                }
                return file;
            });
            const updatedFiles = await Promise.all(updatedFilesPromises);
            if (isFileUpdated) {
                if (!isControlled) {
                    setFiles(updatedFiles);
                }
                onChange?.(updatedFiles);
            }
        };
        processInitialFiles();
    }, [
        enableThumbnailGeneration,
        thumbnailSize,
        defaultValue,
        value,
        isControlled,
        onChange
    ]);
    // Reactive effect to sequentially process thumbnails for new uploads marked as 'loading'.
    useEffect(()=>{
        if (!enableThumbnailGeneration) return;
        const fileToProcess = currentFiles.find((file)=>file.thumbnail === 'loading');
        if (!fileToProcess) return;
        const controller = new AbortController();
        const generateThumbnail = async ()=>{
            const thumbnailBlob = await createThumbnails(fileToProcess.file, thumbnailSize, controller.signal);
            if (controller.signal.aborted) return;
            const thumbnailUrl = thumbnailBlob ? URL.createObjectURL(thumbnailBlob) : undefined;
            /**
			 * if max files length is exceeded, removes last uploaded files from file list
			 * to remove the displayed error and then adds new uploaded files to file list
			 */ const updatedFiles = currentFiles.map((f)=>f.id === fileToProcess.id ? {
                    ...f,
                    thumbnail: thumbnailUrl
                } : f);
            if (!isControlled) {
                setFiles(updatedFiles);
            }
            onChange?.(updatedFiles);
        };
        generateThumbnail();
        return ()=>{
            controller.abort();
        };
    }, [
        currentFiles,
        enableThumbnailGeneration,
        thumbnailSize,
        isControlled,
        onChange
    ]);
    const handleOnChange = useCallback((e)=>{
        const targetFiles = isDragEvent(e) ? e.dataTransfer.files : e.target.files;
        if (!targetFiles || targetFiles.length <= 0) return;
        const baseFiles = errors?.maxFilesCountExceeded ? currentFiles.filter((f)=>!uploadedFiles.find((uf)=>uf.id === f.id)) : currentFiles;
        const newFileEntries = Array.from(targetFiles).map((file)=>({
                id: v4(),
                file,
                thumbnail: enableThumbnailGeneration && file.type.startsWith('image/') ? 'loading' : undefined
            }));
        const filesWithPlaceholders = [
            ...baseFiles,
            ...newFileEntries
        ];
        if (!isControlled) {
            setFiles(filesWithPlaceholders);
        }
        setUploadedFiles(newFileEntries);
        onChange?.(filesWithPlaceholders);
        if (!isDragEvent(e) && e.target) {
            e.target.value = '';
        }
    }, [
        currentFiles,
        errors?.maxFilesCountExceeded,
        isControlled,
        onChange,
        enableThumbnailGeneration,
        uploadedFiles
    ]);
    const updateFile = useCallback(async (fileId, newFile)=>{
        const fileIndex = currentFiles.findIndex((f)=>f.id === fileId);
        const fileToUpdate = currentFiles[fileIndex];
        if (!fileToUpdate) return;
        if (fileToUpdate.thumbnail?.startsWith('blob:')) {
            URL.revokeObjectURL(fileToUpdate.thumbnail);
        }
        let newThumbnailUrl = fileToUpdate.thumbnail;
        if (enableThumbnailGeneration && newFile.type.startsWith('image/')) {
            const thumbnail = await createThumbnails(newFile, thumbnailSize);
            newThumbnailUrl = thumbnail ? URL.createObjectURL(thumbnail) : undefined;
        }
        const updatedFileEntry = {
            ...fileToUpdate,
            file: newFile,
            thumbnail: newThumbnailUrl
        };
        const newFiles = [
            ...currentFiles
        ];
        newFiles[fileIndex] = updatedFileEntry;
        if (!isControlled) setFiles(newFiles);
        onChange?.(newFiles);
    }, [
        currentFiles,
        isControlled,
        onChange,
        thumbnailSize,
        enableThumbnailGeneration
    ]);
    const setAsCover = useCallback((id)=>{
        const index = currentFiles.findIndex((item)=>item.id === id);
        if (index >= 0) {
            const newFiles = [
                ...currentFiles
            ];
            const [removed] = newFiles.splice(index, 1);
            newFiles.unshift(removed);
            if (!isControlled) setFiles(newFiles);
            onChange?.(newFiles);
        }
    }, [
        currentFiles,
        isControlled,
        onChange
    ]);
    const moveBackward = useCallback((id)=>{
        const index = currentFiles.findIndex((item)=>item.id === id);
        if (index >= 0 && index < currentFiles.length - 1) {
            const newFiles = [
                ...currentFiles
            ];
            const temp = newFiles[index];
            newFiles[index] = newFiles[index + 1];
            newFiles[index + 1] = temp;
            if (!isControlled) setFiles(newFiles);
            onChange?.(newFiles);
        }
    }, [
        currentFiles,
        isControlled,
        onChange
    ]);
    const moveForward = useCallback((id)=>{
        const index = currentFiles.findIndex((item)=>item.id === id);
        if (index > 0) {
            const newFiles = [
                ...currentFiles
            ];
            const temp = newFiles[index];
            newFiles[index] = newFiles[index - 1];
            newFiles[index - 1] = temp;
            if (!isControlled) setFiles(newFiles);
            onChange?.(newFiles);
        }
    }, [
        currentFiles,
        isControlled,
        onChange
    ]);
    const remove = useCallback((id)=>{
        const fileToRemove = currentFiles.find((item)=>item.id === id);
        if (fileToRemove?.thumbnail?.startsWith('blob:')) {
            URL.revokeObjectURL(fileToRemove.thumbnail);
        }
        const newFiles = currentFiles.filter((item)=>item.id !== id);
        if (!isControlled) setFiles(newFiles);
        onChange?.(newFiles);
    }, [
        currentFiles,
        isControlled,
        onChange
    ]);
    const removeUploadedFiles = useCallback(()=>{
        uploadedFiles.forEach((file)=>{
            if (file.thumbnail?.startsWith('blob:')) {
                URL.revokeObjectURL(file.thumbnail);
            }
        });
        const filesToKeep = currentFiles.filter((file)=>!uploadedFiles.find((uf)=>uf.id === file.id));
        if (!isControlled) setFiles(filesToKeep);
        setUploadedFiles([]);
        onChange?.(filesToKeep);
    }, [
        currentFiles,
        isControlled,
        onChange,
        uploadedFiles
    ]);
    const toggleEditFileCaption = useCallback((file)=>{
        setOnEditFile({
            file
        });
        setIsEditingFileCaption((prev)=>!prev);
    }, []);
    const saveNewCaption = useCallback(async (caption)=>{
        const fileToUpdate = onEditFile.file;
        if (!fileToUpdate || fileToUpdate.file.name === caption) {
            setIsEditingFileCaption(false);
            return;
        }
        const renamedFile = new File([
            fileToUpdate.file
        ], caption, {
            type: fileToUpdate.file.type,
            lastModified: fileToUpdate.file.lastModified
        });
        await updateFile(fileToUpdate.id, renamedFile);
        setIsEditingFileCaption(false);
    }, [
        onEditFile.file,
        updateFile
    ]);
    const toggleEditImage = useCallback((file)=>{
        if (!isControlled && files.length === 0 && defaultValue && defaultValue.length > 0) {
            setFiles(defaultValue);
        }
        setOnEditFile({
            file
        });
        setIsEditingImage((prev)=>!prev);
    }, [
        isControlled,
        defaultValue,
        files.length
    ]);
    const saveEditedImage = useCallback(async (editedFile)=>{
        const fileToUpdate = onEditFile.file;
        if (!fileToUpdate) {
            setIsEditingImage(false);
            return;
        }
        await updateFile(fileToUpdate.id, editedFile);
        setIsEditingImage(false);
    }, [
        onEditFile.file,
        updateFile
    ]);
    const rearrangeFilesById = useCallback((sourceId, destinationId)=>{
        const sourceIndex = currentFiles.findIndex((item)=>item.id === sourceId);
        const destinationIndex = currentFiles.findIndex((item)=>item.id === destinationId);
        if (sourceIndex > -1 && destinationIndex > -1) {
            const newFiles = [
                ...currentFiles
            ];
            const [removedFile] = newFiles.splice(sourceIndex, 1);
            newFiles.splice(destinationIndex, 0, removedFile);
            if (!isControlled) setFiles(newFiles);
            onChange?.(newFiles);
        }
    }, [
        currentFiles,
        isControlled,
        onChange
    ]);
    return {
        boxProps: {
            onChange: handleOnChange
        },
        onEditFile: onEditFile.file,
        files: currentFiles,
        uploadedFiles,
        filesLength: currentFiles.length,
        fileMenuProps: {
            toggleEditFileCaptionOpen: toggleEditFileCaption,
            toggleEditImageOpen: toggleEditImage,
            moveForward,
            moveBackward,
            remove,
            setAsCover
        },
        removeUploadedFiles,
        isEditingFileCaptionOpen: isEditingFileCaption,
        isEditingImageOpen: isEditingImage,
        rearrangeFilesById,
        saveNewCaption,
        saveEditedImage
    };
};

const MediaUploadContext = /*#__PURE__*/ createContext(null);
const MediaUploadProvider = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, acceptType, menuItems, maxFileCount, hasMaxFileIndicator, errors, fileErrors, onChange, defaultValue, shouldShowCoverPhotoTag, shouldShowFileNames, value, variant, filePressProps, enableThumbnailGeneration, thumbnailSize, objectFit } = props;
    const addInputRef = useObjectRef(ref);
    const mediaUploadId = useId();
    const dataTransferType = `media-upload-ordering-${mediaUploadId}`;
    const { filesLength, ...fileInputProps } = useFileInput({
        errors,
        onChange,
        defaultValue,
        value,
        enableThumbnailGeneration,
        thumbnailSize
    });
    const shouldAllowMultipleFileUpload = maxFileCount && maxFileCount > 0 ? maxFileCount - filesLength > 1 : true;
    const contextValue = useMemo(()=>({
            htmlId: mediaUploadId,
            addInputRef,
            acceptType,
            menuItems,
            shouldAllowMultipleFileUpload,
            filesLength,
            maxFileCount,
            hasMaxFileIndicator,
            errors,
            fileErrors,
            shouldShowCoverPhotoTag,
            shouldShowFileNames,
            variant,
            dataTransferType,
            filePressProps,
            enableThumbnailGeneration,
            thumbnailSize,
            objectFit,
            ...fileInputProps
        }), [
        mediaUploadId,
        addInputRef,
        acceptType,
        menuItems,
        shouldAllowMultipleFileUpload,
        filesLength,
        maxFileCount,
        hasMaxFileIndicator,
        errors,
        fileErrors,
        shouldShowCoverPhotoTag,
        shouldShowFileNames,
        variant,
        dataTransferType,
        filePressProps,
        enableThumbnailGeneration,
        thumbnailSize,
        objectFit,
        fileInputProps
    ]);
    return /*#__PURE__*/ jsx(MediaUploadContext.Provider, {
        value: contextValue,
        children: children
    });
});
const useMediaUploadContext = ()=>{
    const contextValue = useContext(MediaUploadContext);
    if (!contextValue) {
        throw new Error('The `MediaUploadProvider` has not been instantiated correctly with its corresponding context. Please make sure that it is rendered higher in your app. If the issue persists, report it to Team GEMINI.');
    }
    return contextValue;
};

const Indicator = ()=>{
    const t = useMediaUploadTranslation();
    const { errors, filesLength, maxFileCount, hasMaxFileIndicator } = useMediaUploadContext();
    return /*#__PURE__*/ jsx(Box, {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "unsafe_component.mediaUpload.spacing.margin.indicator",
        width: "100%",
        srOnly: !hasMaxFileIndicator,
        color: errors?.maxFilesCountExceeded ? 'unsafe_component.mediaUpload.color.error' : 'unsafe_component.mediaUpload.color.indicator',
        typography: "unsafe_component.mediaUpload.typography.indicator",
        children: `${t('mediaupload::indicator')} ${filesLength}/${maxFileCount}`
    });
};

const useMediaUpload = (ref, { onChange, dataTransferType, errors, files, uploadedFiles })=>{
    const [shouldEnableDropFromExternalSource, setShouldEnableDropFromExternalSource] = useState(false);
    const handleOnDragLeave = (e)=>{
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setShouldEnableDropFromExternalSource(false);
    };
    const handleOnDragOver = (e)=>{
        e.preventDefault();
        // Testing that the current file being dragged over is a file from the list
        // with the object property of `getItems` in useMediaViewer.ts
        const isFileBeingDraggedInFileList = e.dataTransfer.types.some((type)=>type === dataTransferType);
        if (isFileBeingDraggedInFileList) return;
        if (!shouldEnableDropFromExternalSource) setShouldEnableDropFromExternalSource(true);
    };
    const handleOnDrop = (e)=>{
        e.preventDefault();
        onChange(e);
        setShouldEnableDropFromExternalSource(false);
    };
    // if max files length is exceeded, adds the first new uploaded file
    // to the file list to display the error
    const cardFiles = errors?.maxFilesCountExceeded ? [
        ...files.filter((file)=>!uploadedFiles.find((uploadedFile)=>uploadedFile.id === file.id)),
        uploadedFiles[0]
    ] : files;
    return {
        boxProps: {
            ref,
            onDragLeave: handleOnDragLeave,
            onDragOver: handleOnDragOver,
            onDrop: handleOnDrop
        },
        cardFiles,
        shouldEnableDropFromExternalSource
    };
};

const useTextArea = (ref, { label, isDisabled, isOptional, maxCharacters, error, ...rest })=>{
    const refObject = useObjectRef$1(ref);
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const { inputProps, labelProps, descriptionProps, errorMessageProps } = useTextField$1({
        [labelProp]: typeof label === 'string' ? label : label.content,
        isDisabled: Boolean(isDisabled),
        isRequired: !isOptional,
        isInvalid: Boolean(error),
        inputElementType: 'textarea',
        ...rest
    }, refObject);
    const textLength = inputProps.value?.toString()?.length ?? 0;
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(isDisabled)
    });
    const { boxProps: focusProps, isFocused } = useFocusable(refObject, {
        unsafe_ignoreProviderProps: true
    });
    return {
        boxProps: {
            textArea: mergeProps(hoverProps, focusProps, inputProps),
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        },
        isFocused,
        isHovered,
        isMaxCharacters: maxCharacters !== undefined && textLength > maxCharacters,
        textLength
    };
};

const TextArea = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { placeholder, name, maxCharacters, onChange, onBlur, onFocus, value, defaultValue, rows, isFullWidth, ...fieldProps } = props;
    const tokens = useTokens();
    const { boxProps, isFocused, isHovered, isMaxCharacters, textLength } = useTextArea(ref, props);
    const borderWidth = isFocused ? tokens['unsafe_component.textArea.borderWidth.active'] : tokens['unsafe_component.textArea.borderWidth.default'];
    const borderColor = useMemo(()=>{
        const hasError = Boolean(fieldProps.error);
        switch(true){
            case fieldProps.isDisabled:
                return `unsafe_component.textArea.color.borderDisabled`;
            case hasError && isHovered && !isFocused:
                return `unsafe_component.textArea.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.textArea.color.borderError`;
            case isFocused:
                return `unsafe_component.textArea.color.borderFocus`;
            case isHovered:
                return `unsafe_component.textArea.color.borderHover`;
            default:
                return `unsafe_component.textArea.color.border`;
        }
    }, [
        fieldProps.error,
        fieldProps.isDisabled,
        isFocused,
        isHovered
    ]);
    const textAreaMinWidth = useMemo(()=>mapTextAreaWidthProps(isFullWidth), [
        isFullWidth
    ]);
    return /*#__PURE__*/ jsxs(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: [
            /*#__PURE__*/ jsx(Box, {
                ...boxProps.textArea,
                as: "textarea",
                ref: ref,
                display: "flex",
                alignItems: "center",
                borderWidth: isFocused ? 'unsafe_component.textArea.borderWidth.active' : 'unsafe_component.textArea.borderWidth.default',
                borderStyle: "solid",
                borderColor: borderColor,
                borderRadius: "unsafe_component.textArea.radius",
                backgroundColor: fieldProps.isDisabled ? `unsafe_component.textArea.color.bgDisabled` : `unsafe_component.textArea.color.bg`,
                paddingHorizontal: `calc(${tokens['unsafe_component.textArea.spacing.padding.horizontal']} - ${borderWidth})`,
                minHeight: rows ? undefined : 'unsafe_component.textArea.sizing.height',
                rows: rows,
                maxHeight: "70vh",
                color: fieldProps.isDisabled ? `unsafe_component.textArea.color.textDisabled` : `unsafe_component.textArea.color.text`,
                // Change that for a ref when Tooltip PR is merge and we have rebase on main
                typography: "unsafe_component.textArea.typography.text",
                cursor: fieldProps.isDisabled ? 'not-allowed' : 'text',
                minWidth: textAreaMinWidth,
                outlineStyle: "none",
                placeholderColor: "unsafe_component.textArea.color.placeholder",
                paddingVertical: `calc(${tokens['unsafe_component.textArea.spacing.padding.vertical']} - ${borderWidth})`
            }),
            maxCharacters && /*#__PURE__*/ jsx(Box, {
                as: "span",
                color: isMaxCharacters ? 'unsafe_component.textArea.color.borderError' : 'unsafe_component.textArea.color.counter',
                typography: "unsafe_component.textArea.typography.counter",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "unsafe_component.textArea.spacing.gap",
                children: `${textLength}/${maxCharacters}`
            })
        ]
    });
});
const mapTextAreaWidthProps = (isFullWidthWithResponsive)=>{
    // if we don't have full width i.E. undefined / false return min width of the field
    if (!isFullWidthWithResponsive) {
        return 'unsafe_component.textField.sizing.minWidth';
    }
    // if the prop is not an responsive object return 100% directly
    if (typeof isFullWidthWithResponsive === 'boolean') {
        return '100%';
    }
    return Object.entries(isFullWidthWithResponsive).reduce((acc, [breakpoint, isFullWidth])=>{
        return {
            ...acc,
            // apply 100% for full width or default min width of the field
            [breakpoint]: isFullWidth ? '100%' : 'unsafe_component.textField.sizing.minWidth'
        };
    }, {});
};

const Caption = ({ captionProps })=>{
    const { label, onChange, ...captionRestProps } = captionProps || {};
    const t = useMediaUploadTranslation();
    const [newCaption, setNewCaption] = useState('');
    const captionRef = useRef(null);
    const { onEditFile, fileMenuProps: { toggleEditFileCaptionOpen }, saveNewCaption, isEditingFileCaptionOpen } = useMediaUploadContext();
    const handleOnChange = (value)=>{
        setNewCaption(value);
        if (onChange) onChange(value);
    };
    const saveCaption = useCallback(()=>{
        saveNewCaption(newCaption);
        setNewCaption('');
    }, [
        saveNewCaption,
        newCaption
    ]);
    const FOOTER_START_BUTTON = {
        onPress: ()=>toggleEditFileCaptionOpen(),
        children: t('mediaupload::option::caption::cancel')
    };
    const FOOTER_END_BUTTON = {
        onPress: saveCaption,
        children: t('mediaupload::option::caption::save')
    };
    useEffect(()=>{
        if (!onEditFile || !isEditingFileCaptionOpen) return;
        setNewCaption(onEditFile.file.name);
        /**
		 * @todo move focus handling to TextArea component - GEMINI 1749
		 * setTimeout is used here to block the ios mobile keyboard from opening when the initial focus is set
		 */ setTimeout(()=>captionRef.current?.focus(), 0);
    }, [
        onEditFile,
        onEditFile?.file.name,
        isEditingFileCaptionOpen
    ]);
    return /*#__PURE__*/ jsx(Modal, {
        footerStartButtonProps: FOOTER_START_BUTTON,
        footerEndButtonProps: FOOTER_END_BUTTON,
        // todo: trigger is not needed here, improvements from Modal could be done - GEMINI 1466
        trigger: ()=>null,
        onOpenChange: ()=>toggleEditFileCaptionOpen(),
        isOpen: isEditingFileCaptionOpen,
        children: /*#__PURE__*/ jsx(TextArea, {
            ...captionRestProps,
            label: label ? label : t('mediaupload::option::caption::label'),
            onChange: handleOnChange,
            value: newCaption,
            ref: captionRef
        })
    });
};

const FILE_RATIO = '2/3';
const ACCEPTED_TYPE = 'image/jpeg,image/png';

const useFileReader = (file)=>{
    const [fileState, setFileState] = useState({
        hasError: false,
        hasLoaded: false,
        isLoading: false,
        progress: 0
    });
    const readFile = useCallback((file)=>{
        const reader = new FileReader();
        reader.onloadstart = ()=>{
            setFileState((prevState)=>({
                    ...prevState,
                    isLoading: true
                }));
        };
        reader.onprogress = (event)=>{
            if (event.lengthComputable) {
                const percentage = Math.round(event.loaded / event.total * 100);
                setFileState((prevState)=>({
                        ...prevState,
                        progress: percentage
                    }));
            }
        };
        reader.onerror = ()=>{
            setFileState((prevState)=>({
                    ...prevState,
                    hasError: true,
                    isLoading: false
                }));
        };
        reader.onload = ()=>{
            setFileState((prevState)=>({
                    ...prevState,
                    hasLoaded: true,
                    isLoading: false
                }));
        };
        reader.readAsDataURL(file);
    }, []);
    useEffect(()=>{
        if (file) readFile(file);
    }, [
        file,
        readFile
    ]);
    return {
        ...fileState
    };
};

const useMediaViewer = ({ preview: previewRef, drop: dropRef }, { fileData, files, uploadedFiles, shouldEnableDropFromExternalSource, errors, fileErrors, variant })=>{
    const { rearrangeFilesById, dataTransferType } = useMediaUploadContext();
    const { dropProps } = useDrop({
        ref: dropRef,
        // Receives file id on drop and switch files places in list
        // todo: investigate improvements for different acceptType for item.types - GEMINI-1409
        onDrop: useCallback(async (e)=>{
            const item = e.items?.find((item)=>item.kind === 'text' && item.types.has(dataTransferType));
            if (!item) return;
            const sourceFile = await item.getText(dataTransferType);
            if (sourceFile === fileData.id) return;
            rearrangeFilesById(sourceFile, fileData?.id);
        }, [
            rearrangeFilesById,
            fileData?.id,
            dataTransferType
        ])
    });
    const { dragProps, isDragging } = useDrag({
        // Enforce preview ref for all types of files
        preview: previewRef,
        // Transfers file id to drop handler
        getItems: ()=>{
            return [
                {
                    [dataTransferType]: fileData?.id
                }
            ];
        }
    });
    const { hasError, hasLoaded, isLoading } = useFileReader(fileData.file);
    const isCover = fileData.id === files[0]?.id && variant === 'images';
    const isFirstFromUploadedFiles = fileData.id === uploadedFiles[0]?.id;
    const computedFileType = fileData.file.type.split('/')[0];
    const shouldDisplayError = isFirstFromUploadedFiles && errors?.maxFilesCountExceeded || fileErrors?.[fileData.id] || hasError;
    // When dragging files from an external source, remove onDragOver on
    // drop props to allow dropping on displayed files
    const dndProps = !shouldEnableDropFromExternalSource ? mergeProps(dragProps, {
        ...dropProps,
        onDragOver: undefined
    }) : mergeProps(dragProps, dropProps);
    return {
        boxProps: dndProps,
        isCover,
        isFirstFromUploadedFiles,
        visualFileType: computedFileType,
        shouldDisplayError,
        isLoading,
        hasLoaded,
        isDragging
    };
};

const MediaError = ({ fileData, isCover, isFirstFromUploadedFiles, size })=>{
    const t = useMediaUploadTranslation();
    const deleteFileLabel = t('mediaupload::deleteFile').replace(':file_name:', fileData.file.name);
    const { htmlId, errors, fileErrors, fileMenuProps: { remove }, removeUploadedFiles } = useMediaUploadContext();
    const computedFileErrorId = fileErrors?.[fileData.id] ? `${fileData.id}-${htmlId}` : `error-${htmlId}`;
    const mapErrorToCard = useMemo(()=>{
        switch(true){
            case Boolean(isFirstFromUploadedFiles && errors?.maxFilesCountExceeded):
                return errors?.maxFilesCountExceeded;
            case Boolean(fileErrors?.[fileData.id]):
                return fileErrors?.[fileData.id];
            default:
                return t('mediaupload::error');
        }
    }, [
        errors?.maxFilesCountExceeded,
        fileData.id,
        fileErrors,
        isFirstFromUploadedFiles,
        t
    ]);
    return /*#__PURE__*/ jsx(Box, {
        backgroundColor: "unsafe_component.mediaUpload.color.bgError",
        borderStyle: "none",
        borderColor: "unsafe_component.mediaUpload.color.border",
        borderWidth: "unsafe_component.mediaUpload.borderWidth.default",
        height: "auto",
        paddingBottom: size,
        display: "flex",
        width: "100%",
        borderRadius: "unsafe_component.mediaUpload.radius",
        position: "relative",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        role: "gridcell",
        children: /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            paddingHorizontal: "unsafe_component.mediaUpload.spacing.padding.text",
            children: [
                /*#__PURE__*/ jsx(Box, {
                    typography: {
                        'breakpoint.base': isCover ? 'unsafe_component.mediaUpload.typography.iconDesktop' : 'unsafe_component.mediaUpload.typography.iconMobile',
                        'breakpoint.sm': 'unsafe_component.mediaUpload.typography.iconDesktop'
                    },
                    children: /*#__PURE__*/ jsx(ExclamationTriangleIcon, {
                        size: "inherit"
                    })
                }),
                /*#__PURE__*/ jsx(Box, {
                    id: computedFileErrorId,
                    typography: isCover ? 'unsafe_component.mediaUpload.typography.title' : 'unsafe_component.mediaUpload.typography.fileError',
                    marginTop: "unsafe_component.mediaUpload.spacing.gapMobile",
                    width: "100%",
                    children: mapErrorToCard
                }),
                /*#__PURE__*/ jsx(Box, {
                    position: "absolute",
                    right: {
                        'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                        'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
                    },
                    top: {
                        'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                        'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
                    },
                    children: /*#__PURE__*/ jsx(Button, {
                        "aria-label": deleteFileLabel,
                        variant: "secondary-floating",
                        iconOnly: true,
                        icon: TrashCanIcon,
                        onPress: errors?.maxFilesCountExceeded ? removeUploadedFiles : ()=>remove(fileData.id),
                        size: "40",
                        children: fileData.file.name
                    })
                })
            ]
        })
    });
};

const useMenu = ({ fileData, fileLength })=>{
    const t = useMediaUploadTranslation();
    const { menuItems, fileMenuProps: { toggleEditFileCaptionOpen, toggleEditImageOpen, moveBackward, moveForward, remove, setAsCover }, htmlId, shouldShowFileNames, variant, files } = useMediaUploadContext();
    const fileIndex = files.findIndex((file)=>file.id === fileData.id);
    const defaultMenuItemsIds = useMemo(()=>{
        const items = [];
        if (variant === 'images' && fileIndex !== 0) {
            items.push('cover');
        }
        if (fileIndex !== 0) {
            items.push('forward');
        }
        if (fileIndex !== fileLength - 1) {
            items.push('backward');
        }
        if (shouldShowFileNames) {
            items.push('caption');
        }
        if (variant === 'images' && fileData.file.type.startsWith('image/')) {
            items.push('imageEdit');
        }
        items.push('remove');
        return items;
    }, [
        variant,
        fileIndex,
        fileLength,
        shouldShowFileNames,
        fileData.file.type
    ]);
    const MENU_ITEMS = useMemo(()=>{
        const getDefaultItem = (id)=>{
            switch(id){
                case 'cover':
                    return {
                        id: `${htmlId}-cover`,
                        elementType: 'button',
                        onAction: ()=>setAsCover(fileData.id),
                        children: t('mediaupload::option::cover'),
                        icon: StarIcon
                    };
                case 'forward':
                    return {
                        id: `${htmlId}-forward`,
                        elementType: 'button',
                        onAction: ()=>moveForward(fileData.id),
                        children: t('mediaupload::option::forward'),
                        icon: ArrowUpLeftIcon
                    };
                case 'backward':
                    return {
                        id: `${htmlId}-backward`,
                        elementType: 'button',
                        onAction: ()=>moveBackward(fileData.id),
                        children: t('mediaupload::option::backward'),
                        icon: ArrowDownRightIcon
                    };
                case 'caption':
                    return {
                        id: `${htmlId}-caption`,
                        elementType: 'button',
                        onAction: ()=>toggleEditFileCaptionOpen(fileData),
                        children: t('mediaupload::option::caption'),
                        icon: PenLineIcon
                    };
                case 'imageEdit':
                    return {
                        id: `${htmlId}-imageEdit`,
                        elementType: 'button',
                        onAction: ()=>toggleEditImageOpen(fileData),
                        children: t('mediaupload::imageEdit::title'),
                        icon: ImageIcon
                    };
                case 'remove':
                    return {
                        id: `${htmlId}-remove`,
                        elementType: 'button',
                        onAction: ()=>remove(fileData.id),
                        children: t('mediaupload::option::remove'),
                        icon: TrashCanIcon
                    };
            }
        };
        // Can contain both string IDs and custom objects
        if (Array.isArray(menuItems)) {
            // Check if any item in the array is a MenuItemsId
            const hasMenuItemId = menuItems.some((item)=>typeof item === 'string');
            if (hasMenuItemId) {
                return menuItems.map((item)=>{
                    // If it's a string (default menu ID), get the default item
                    if (typeof item === 'string') {
                        const defaultItem = getDefaultItem(item);
                        if (defaultItem) return defaultItem;
                    } else {
                        return {
                            ...item,
                            onAction: (id)=>item.onAction ? item.onAction(id, {
                                    fileId: fileData.id
                                }) : undefined
                        };
                    }
                    return undefined;
                });
            } else {
                const defaultItems = defaultMenuItemsIds.map((itemId)=>getDefaultItem(itemId));
                const customItems = menuItems.map((item)=>({
                        ...item,
                        onAction: (id)=>item.onAction ? item.onAction(id, {
                                fileId: fileData.id
                            }) : undefined
                    }));
                return [
                    ...defaultItems,
                    ...customItems
                ];
            }
        }
        // Default behavior - show all default items
        return defaultMenuItemsIds.map((itemId)=>getDefaultItem(itemId));
    }, [
        menuItems,
        defaultMenuItemsIds,
        htmlId,
        fileData,
        setAsCover,
        moveForward,
        moveBackward,
        toggleEditFileCaptionOpen,
        toggleEditImageOpen,
        remove,
        t
    ]);
    const filteredMenuItems = MENU_ITEMS.filter((item)=>item !== undefined);
    const shouldDisplayRemoveButton = filteredMenuItems.length === 1 && filteredMenuItems[0]?.id === `${htmlId}-remove`;
    return {
        menuItems: filteredMenuItems,
        shouldDisplayRemoveButton,
        remove
    };
};

const Menu = ({ fileData, fileLength })=>{
    const t = useMediaUploadTranslation();
    const editFileLabel = t('mediaupload::editFile').replace(':file_name:', fileData.file.name);
    const { menuItems: MENU_ITEMS, shouldDisplayRemoveButton, remove } = useMenu({
        fileData,
        fileLength
    });
    // Display remove button if only remove action is available
    if (shouldDisplayRemoveButton) {
        return /*#__PURE__*/ jsx(Button, {
            "aria-label": t('mediaupload::option::remove'),
            variant: "secondary-floating",
            size: "40",
            icon: TrashCanIcon,
            iconOnly: true,
            type: "button",
            position: "absolute",
            right: {
                'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
            },
            top: {
                'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
            },
            zIndex: "zIndex.1",
            onPress: ()=>remove(fileData.id),
            children: fileData.file.name
        });
    }
    return /*#__PURE__*/ jsx(ActionMenu, {
        menuItems: MENU_ITEMS,
        children: (renderProps)=>/*#__PURE__*/ jsx(Button, {
                ...renderProps,
                "aria-label": editFileLabel,
                variant: "secondary-floating",
                size: "40",
                icon: EllipsisVerticalIcon,
                iconOnly: true,
                type: "button",
                position: "absolute",
                right: {
                    'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                    'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
                },
                top: {
                    'breakpoint.base': 'unsafe_component.mediaUpload.spacing.gapMobile',
                    'breakpoint.sm': 'unsafe_component.mediaUpload.spacing.gap'
                },
                zIndex: "zIndex.1",
                children: fileData.file.name
            })
    });
};

const usePreview = (ref, { file, isImage, enableThumbnailGeneration })=>{
    const [shouldDisplayChildren, setShouldDisplayChildren] = useState(false);
    const [imageSource, setImageSource] = useState('');
    const domRef = useRef(null);
    useEffect(()=>{
        if (!isImage || enableThumbnailGeneration) return;
        const reader = new FileReader();
        reader.onload = ()=>{
            setImageSource(reader.result);
        };
        reader.readAsDataURL(file.file);
        return ()=>{
            if (reader.readyState === 1) reader.abort();
        };
    }, [
        file.file,
        isImage,
        enableThumbnailGeneration
    ]);
    useImperativeHandle(ref, ()=>(_, callback)=>{
            // This will be called during the onDragStart event by useDrag. We need to render the
            // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
            if (isImage && enableThumbnailGeneration && file.thumbnail) {
                setImageSource(file.thumbnail);
            }
            flushSync(()=>{
                setShouldDisplayChildren(true);
            });
            if (domRef.current) {
                callback(domRef.current);
            }
            requestAnimationFrame(()=>{
                setShouldDisplayChildren(false);
            });
        }, [
        isImage,
        file,
        enableThumbnailGeneration
    ]);
    return {
        boxProps: {
            ref: domRef
        },
        shouldDisplayChildren,
        imageSource
    };
};

const Preview = /*#__PURE__*/ forwardRef(({ fileData, visualFileType, objectFit = 'cover', enableThumbnailGeneration }, ref)=>{
    const isImage = visualFileType === 'image';
    const { boxProps, shouldDisplayChildren, imageSource } = usePreview(ref, {
        file: fileData,
        isImage,
        enableThumbnailGeneration
    });
    if (!shouldDisplayChildren) {
        return null;
    }
    // adapted from react-aria DragPreview: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/dnd/src/DragPreview.tsx#L47
    return /*#__PURE__*/ jsx(Box, {
        ...boxProps,
        position: "absolute",
        top: 0,
        left: -1e5,
        // Workaround as `zIndex` prop only allows tokens for now
        unsafe_style: {
            zIndex: -1
        },
        width: "100%",
        height: "100%",
        children: isImage ? /*#__PURE__*/ jsx(Box, {
            as: "img",
            display: "block",
            objectFit: objectFit,
            width: "100%",
            height: "100%",
            borderRadius: "unsafe_component.mediaUpload.radius",
            src: imageSource,
            alt: fileData.file.name
        }) : /*#__PURE__*/ jsx(Box, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            borderRadius: "unsafe_component.mediaUpload.radius",
            borderStyle: "solid",
            borderWidth: "unsafe_component.mediaUpload.borderWidth.default",
            children: /*#__PURE__*/ jsx(Box, {
                unsafe_style: {
                    fontSize: '64px'
                },
                children: visualFileType === 'video' ? /*#__PURE__*/ jsx(ClapperboardPlayIcon, {
                    size: "inherit"
                }) : /*#__PURE__*/ jsx(FileLinesIcon, {
                    size: "inherit"
                })
            })
        })
    });
});

/**
 * @param ref - MediaFile Box ref
 * @param filePressProps - File Press props
 * @return boxProps
 */ const useMediaFile = (ref, { 'aria-label': fileAriaLabel, fileData, isDragging, fileLength, onPress })=>{
    const { boxProps: focusableProps, isFocused } = useFocusable(ref);
    const t = useMediaUploadTranslation();
    const { boxProps: pressProps, isPressed } = usePressable({
        onPress: ()=>{
            if (onPress) {
                onPress(fileData.id);
            }
        }
    });
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const outlineStyle = isFocused ? 'auto' : 'none';
    /**
	 * Retrieves a localized label for media upload and replaces a placeholder with the file name.
	 *
	 * @param fileAriaLabel - An optional custom ARIA label for the file. If provided, this label will be used.
	 * @returns The ARIA label for the file. If `fileAriaLabel` is provided, it is returned directly.
	 * Otherwise, a localized label with a placeholder for the file name is returned, with the placeholder replaced by the actual file name.
	 */ const ariaLabel = fileAriaLabel ?? t('mediaupload::filePress');
    const ariaLabelComputed = ariaLabel.replace(':file_name:', fileData.file.name);
    const cursor = (()=>{
        if (onPress) return 'pointer';
        if (fileLength <= 1) return 'default';
        if (isPressed) return 'grabbing';
        if (isDragging) return 'grabbing !important';
        if (isHovered) return 'grab';
        return 'default';
    })();
    return {
        boxProps: {
            ...mergeProps(focusableProps, pressProps, hoverProps),
            outlineStyle,
            outlineOffset: '-borderWidth.1',
            tabIndex: 0,
            ...onPress && {
                'aria-label': ariaLabelComputed
            },
            cursor
        },
        isPressed,
        isHovered
    };
};

const MediaFile = /*#__PURE__*/ forwardRef(({ previewRef, // TODO: GEMINI-1958 Removing dnd `onClick` as the dnd + fileOnPress won't work together
// Without the onClick, it works correctly with mouse but with keyboard, dnd is still broken
dndProps: { onClick, ...dndProps }, fileData, visualFileType, isCover, hasLoaded, shouldShowCoverPhotoTag, shouldShowFileNames, shouldEnableDropFromExternalSource, size, filePressProps, isDragging, enableThumbnailGeneration = false, objectFit = 'cover' }, ref)=>{
    const t = useMediaUploadTranslation();
    const fileRef = useObjectRef$1(ref);
    const { files } = useMediaUploadContext();
    const fileLength = files.length;
    const { boxProps, isPressed, isHovered } = useMediaFile(fileRef, {
        ...filePressProps,
        fileData,
        isDragging,
        fileLength
    });
    const backgroundColor = useMemo(()=>mapStateToBackgroundColor({
            isPressed,
            isHovered
        }), [
        isPressed,
        isHovered
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        position: "relative",
        width: "100%",
        height: "auto",
        overflow: [
            'hidden',
            'clip'
        ],
        borderRadius: "unsafe_component.mediaUpload.radius",
        paddingBottom: size,
        backgroundColor: "unsafe_component.mediaUpload.color.bg",
        borderStyle: visualFileType === 'image' ? 'none' : 'solid',
        borderColor: "unsafe_component.mediaUpload.color.border",
        borderWidth: "unsafe_component.mediaUpload.borderWidth.default",
        children: [
            /*#__PURE__*/ jsx(Menu, {
                fileData: fileData,
                fileLength: fileLength
            }),
            isCover && hasLoaded && shouldShowCoverPhotoTag && /*#__PURE__*/ jsx(Tag, {
                variant: "primaryStrong",
                icon: StarIcon,
                position: "absolute",
                left: "unsafe_component.mediaUpload.spacing.gap",
                top: "unsafe_component.mediaUpload.spacing.gap",
                zIndex: "zIndex.1",
                marginHorizontal: "unsafe_component.mediaUpload.spacing.margin.coverTag",
                children: t('mediaupload::coverLabel')
            }),
            /*#__PURE__*/ jsxs(Box, {
                ...mergeProps(dndProps, boxProps),
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "unsafe_component.mediaUpload.radius",
                pointerEvents: shouldEnableDropFromExternalSource ? 'none' : undefined,
                children: [
                    fileLength > 1 && (isHovered || isPressed) ? /*#__PURE__*/ jsx(Box, {
                        backgroundColor: backgroundColor,
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        typography: "unsafe_component.mediaUpload.typography.overlay",
                        color: "unsafe_component.mediaUpload.color.overlayText",
                        children: /*#__PURE__*/ jsx(Box, {
                            as: "span",
                            width: "unsafe_component.mediaUpload.sizing.108",
                            textAlign: "center",
                            children: t('mediaupload::sortFile')
                        })
                    }) : null,
                    visualFileType === 'image' ? /*#__PURE__*/ jsx(Box, {
                        ref: fileRef,
                        as: "img",
                        objectFit: objectFit,
                        ...objectFit === 'contain' ? {
                            borderWidth: 'unsafe_component.mediaUpload.borderWidth.default',
                            borderStyle: 'solid',
                            borderColor: 'unsafe_component.mediaUpload.color.borderContain',
                            borderRadius: 'unsafe_component.mediaUpload.radius'
                        } : {},
                        src: enableThumbnailGeneration && fileData.thumbnail ? fileData.thumbnail : URL.createObjectURL(fileData.file),
                        alt: fileData.file.name,
                        width: "100%",
                        height: "100%"
                    }) : /*#__PURE__*/ jsxs(Box, {
                        ref: fileRef,
                        "aria-label": fileData.file.name,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                typography: {
                                    'breakpoint.base': isCover ? 'unsafe_component.mediaUpload.typography.iconDesktop' : 'unsafe_component.mediaUpload.typography.iconMobile',
                                    'breakpoint.sm': 'unsafe_component.mediaUpload.typography.iconDesktop'
                                },
                                children: visualFileType === 'video' ? /*#__PURE__*/ jsx(ClapperboardPlayIcon, {
                                    size: "inherit"
                                }) : /*#__PURE__*/ jsx(FileLinesIcon, {
                                    size: "inherit"
                                })
                            }),
                            shouldShowFileNames && /*#__PURE__*/ jsx(Box, {
                                width: "100%",
                                marginTop: "unsafe_component.mediaUpload.spacing.gapMobile",
                                paddingHorizontal: "unsafe_component.mediaUpload.spacing.padding.documentName",
                                textAlign: "center",
                                overflow: [
                                    'hidden',
                                    'clip'
                                ],
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                typography: "unsafe_component.mediaUpload.typography.documentName",
                                children: fileData.file.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Preview, {
                ref: previewRef,
                fileData: fileData,
                visualFileType: visualFileType,
                enableThumbnailGeneration: enableThumbnailGeneration,
                objectFit: objectFit
            })
        ]
    });
});
const mapStateToBackgroundColor = ({ isPressed, isHovered })=>{
    if (isPressed) return 'unsafe_component.mediaUpload.color.overlayPressed';
    if (isHovered) return 'unsafe_component.mediaUpload.color.overlayHover';
    return 'unsafe_component.mediaUpload.color.overlay';
};

const spin = unsafe_keyframes({
    from: {
        transform: 'rotate(0deg)'
    },
    to: {
        transform: 'rotate(360deg)'
    }
});
const MediaLoading = ({ size })=>/*#__PURE__*/ jsx(Box, {
        position: "relative",
        width: "100%",
        height: "auto",
        paddingBottom: size,
        borderRadius: "unsafe_component.mediaUpload.radius",
        borderStyle: "dashed",
        borderColor: "unsafe_component.mediaUpload.color.border",
        borderWidth: "unsafe_component.mediaUpload.borderWidth.default",
        backgroundColor: "unsafe_component.mediaUpload.color.bg",
        unsafe_style: {
            fontSize: '32px'
        },
        children: /*#__PURE__*/ jsx(LoaderIcon, {
            position: "absolute",
            top: "0",
            left: "0",
            bottom: "0",
            right: "0",
            margin: "auto",
            color: "inherit",
            size: "inherit",
            animationDuration: "unsafe_component.mediaUpload.motionDuration.loading",
            animationTimingFunction: "unsafe_component.mediaUpload.motionEasing",
            animationName: spin,
            animationIterationCount: "infinite"
        })
    });

const MediaViewer = ({ fileData, shouldEnableDropFromExternalSource })=>{
    const dropRef = useRef(null);
    const previewRef = useRef(null);
    const tokens = useTokens();
    const { files, uploadedFiles, errors, fileErrors, shouldShowCoverPhotoTag, shouldShowFileNames, variant, filePressProps, enableThumbnailGeneration, objectFit } = useMediaUploadContext();
    const { boxProps: dndProps, visualFileType, isCover, isFirstFromUploadedFiles, shouldDisplayError, hasLoaded, isLoading, isDragging } = useMediaViewer({
        preview: previewRef,
        drop: dropRef
    }, {
        fileData,
        files,
        uploadedFiles,
        shouldEnableDropFromExternalSource,
        errors,
        fileErrors,
        variant
    });
    // Remove borders from ratio size for the input card or non image file card
    // to match file card size
    const size = `calc((${FILE_RATIO} * 100%) ${visualFileType !== 'image' ? `- calc(${tokens['unsafe_component.mediaUpload.borderWidth.default']} * 2)` : ''})`;
    if (shouldDisplayError) return /*#__PURE__*/ jsx(MediaError, {
        fileData: fileData,
        isCover: isCover,
        isFirstFromUploadedFiles: isFirstFromUploadedFiles,
        size: size
    });
    return /*#__PURE__*/ jsxs(Box, {
        role: "gridcell",
        children: [
            isLoading || fileData.thumbnail === 'loading' ? /*#__PURE__*/ jsx(MediaLoading, {
                size: size
            }) : /*#__PURE__*/ jsx(MediaFile, {
                ref: dropRef,
                previewRef: previewRef,
                dndProps: dndProps,
                fileData: fileData,
                hasLoaded: hasLoaded,
                isCover: isCover,
                visualFileType: visualFileType,
                shouldEnableDropFromExternalSource: shouldEnableDropFromExternalSource,
                shouldShowCoverPhotoTag: shouldShowCoverPhotoTag,
                shouldShowFileNames: shouldShowFileNames,
                size: size,
                filePressProps: filePressProps,
                isDragging: isDragging,
                enableThumbnailGeneration: enableThumbnailGeneration,
                objectFit: objectFit
            }),
            shouldShowFileNames && !(isFirstFromUploadedFiles && errors?.maxFilesCountExceeded) && /*#__PURE__*/ jsx(Box, {
                wordBreak: "break-word",
                typography: "unsafe_component.mediaUpload.typography.fileName",
                marginTop: "unsafe_component.mediaUpload.spacing.margin.fileName",
                children: fileData.file.name
            })
        ]
    });
};

const useDropZone = (ref, { htmlId, filesLength, fieldProps, fieldRenderProps, fileErrors, errors })=>{
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: Boolean(fieldProps.isDisabled)
    });
    const { boxProps: focusProps, isFocused } = useFocusable(ref, {
        unsafe_ignoreProviderProps: true
    });
    const isCover = filesLength === 0;
    const shouldInputBeInvalid = Boolean(fieldProps.error) || fileErrors && Object.keys(fileErrors).some((fileErrorKey)=>Boolean(fileErrors[fileErrorKey])) || errors && Object.keys(errors).some((errorsKey)=>Boolean(errors[errorsKey])) || false;
    const computedFileErrorIds = fileErrors ? Object.keys(fileErrors).map((fileErrorKey)=>`${fileErrorKey}-${htmlId}`) : [];
    const computedErrorIds = errors ? [
        `error-${htmlId}`
    ] : [];
    const ariaDescribedByIds = fieldRenderProps?.['aria-describedby'] ? fieldRenderProps['aria-describedby'].split(' ') : [];
    return {
        boxProps: {
            input: {
                ...focusProps,
                ...fieldProps.isDisabled && {
                    disabled: true
                },
                'aria-invalid': shouldInputBeInvalid || undefined,
                'aria-describedby': [
                    ...ariaDescribedByIds,
                    ...computedFileErrorIds,
                    ...computedErrorIds
                ].join(' ')
            },
            wrapper: hoverProps
        },
        isFocused,
        isHovered,
        isCover
    };
};

const DropZone = ({ fieldRenderProps, fieldProps, onChange, addInputRef, shouldEnableDropFromExternalSource })=>{
    const t = useMediaUploadTranslation();
    const tokens = useTokens();
    const ref = useObjectRef$1(addInputRef);
    const { htmlId, acceptType, filesLength, shouldAllowMultipleFileUpload, maxFileCount, fileErrors, errors } = useMediaUploadContext();
    const { boxProps: { input: inputBaseBoxProps, wrapper: wrapperBoxProps }, isFocused, isHovered, isCover } = useDropZone(ref, {
        htmlId,
        filesLength,
        fieldProps,
        fieldRenderProps,
        errors,
        fileErrors
    });
    const isMobile = useBreakpointValue({
        base: true,
        lg: false
    });
    const borderColor = useMemo(()=>{
        switch(true){
            case fieldProps.isDisabled:
                return 'unsafe_component.mediaUpload.color.borderDisabled';
            case shouldEnableDropFromExternalSource || isFocused:
                return 'unsafe_component.mediaUpload.color.borderFocus';
            case fieldProps.error !== undefined:
                return 'unsafe_component.mediaUpload.color.borderError';
            case isHovered:
                return 'unsafe_component.mediaUpload.color.borderHover';
            default:
                return 'unsafe_component.mediaUpload.color.border';
        }
    }, [
        fieldProps.error,
        fieldProps.isDisabled,
        isFocused,
        isHovered,
        shouldEnableDropFromExternalSource
    ]);
    const backgroundColor = useMemo(()=>{
        switch(true){
            case fieldProps.isDisabled:
                return 'unsafe_component.mediaUpload.color.bgDisabled';
            case shouldEnableDropFromExternalSource || isFocused:
                return 'unsafe_component.mediaUpload.color.bgActive';
            case !fieldProps.isDisabled:
            default:
                return 'unsafe_component.mediaUpload.color.bg';
        }
    }, [
        fieldProps.isDisabled,
        isFocused,
        shouldEnableDropFromExternalSource
    ]);
    const borderWidth = shouldEnableDropFromExternalSource || isFocused ? 'unsafe_component.mediaUpload.borderWidth.active' : 'unsafe_component.mediaUpload.borderWidth.default';
    const addFileTitle = isMobile ? `${t('mediaupload::default::mobile')}` : `${t('mediaupload::default::desktop')}`;
    const shouldDisplayDropZone = maxFileCount === null || maxFileCount <= 0 || filesLength < maxFileCount;
    return /*#__PURE__*/ jsx(Box, {
        role: "row",
        gridColumn: isCover ? 'span 2' : 'auto',
        display: shouldDisplayDropZone ? undefined : 'none',
        children: /*#__PURE__*/ jsxs(Box, {
            ...wrapperBoxProps,
            role: "gridcell",
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderStyle: {
                'breakpoint.base': 'solid',
                'breakpoint.lg': 'dashed'
            },
            borderWidth: borderWidth,
            height: "auto",
            // Remove borders from ratio size for the input card or non image file card
            // to match file card size
            paddingBottom: `calc((${FILE_RATIO} * 100%) ${`- calc(${tokens[borderWidth]} * 2)`})`,
            display: "flex",
            width: "100%",
            borderRadius: "unsafe_component.mediaUpload.radius",
            position: "relative",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ jsxs(Box, {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    children: [
                        isCover && /*#__PURE__*/ jsx(Box, {
                            unsafe_style: {
                                fontSize: '64px'
                            },
                            children: /*#__PURE__*/ jsx(FolderOpenIcon, {
                                size: "inherit"
                            })
                        }),
                        !isCover && /*#__PURE__*/ jsx(PlusIcon, {
                            size: "sizing.24"
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            width: "fit-content",
                            textAlign: "center",
                            color: "unsafe_component.mediaUpload.color.text",
                            typography: "unsafe_component.mediaUpload.typography.title",
                            marginTop: "unsafe_component.mediaUpload.spacing.gapMobile",
                            display: "flex",
                            children: [
                                isMobile && isCover && /*#__PURE__*/ jsx(PlusIcon, {
                                    size: "sizing.24",
                                    marginRight: "spacing.4"
                                }),
                                isCover ? addFileTitle : t('mediaupload::addFile')
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ jsx(Box, {
                    ...mergeProps(fieldRenderProps, inputBaseBoxProps, {
                        onChange
                    }),
                    as: "input",
                    title: isCover ? addFileTitle : t('mediaupload::addFile'),
                    type: "file",
                    ref: ref,
                    accept: acceptType,
                    multiple: shouldAllowMultipleFileUpload,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    padding: "spacing.none",
                    // Hides webkit browser wording
                    opacity: "opacity.none",
                    // Prevents rerender of drag over
                    pointerEvents: shouldEnableDropFromExternalSource ? 'none' : undefined
                })
            ]
        })
    });
};

const SliderThumbs = ({ leftThumbProps, rightThumbProps, leftInputRef, rightInputRef, variant, state, minDistance, margin, isDisabledState, isRequired })=>{
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(SliderThumb, {
                thumbProps: leftThumbProps.thumbProps,
                inputProps: leftThumbProps.inputProps,
                inputRef: leftInputRef,
                isDisabledState: isDisabledState,
                variant: variant,
                position: leftThumbProps.position,
                state: state,
                isDragging: leftThumbProps.isDragging,
                isDisabled: leftThumbProps.isDisabled,
                minDistance: minDistance,
                margin: margin,
                isRequired: isRequired
            }),
            variant === 'range' && rightThumbProps !== undefined && rightInputRef !== undefined ? /*#__PURE__*/ jsx(SliderThumb, {
                thumbProps: rightThumbProps.thumbProps,
                inputProps: rightThumbProps.inputProps,
                inputRef: rightInputRef,
                isDisabledState: isDisabledState,
                variant: variant,
                position: rightThumbProps.position,
                state: state,
                isDragging: rightThumbProps.isDragging,
                isDisabled: rightThumbProps.isDisabled,
                minDistance: minDistance,
                margin: margin,
                isRequired: isRequired
            }) : null
        ]
    });
};
const SliderThumb = ({ thumbProps, inputProps, inputRef, isDisabledState, variant, position, state, isDragging, isDisabled, minDistance, margin, isRequired })=>{
    const tokens = useTokens();
    const thumbName = inputProps.name;
    return /*#__PURE__*/ jsxs(Box, {
        ...thumbProps,
        unsafe_style: thumbProps.style,
        top: `calc(${tokens['unsafe_component.slider.spacing.margin']} / 2)`,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "unsafe_component.slider.sizing.44",
        height: "unsafe_component.slider.sizing.46",
        children: [
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                width: "unsafe_component.slider.sizing.6",
                height: "unsafe_component.slider.sizing.6",
                backgroundColor: thumbName === 'rightThumb' && position <= Math.round(state.getThumbPercent(0) * 100) + margin ? 'unsafe_component.slider.color.transparent' : 'unsafe_component.slider.color.vector',
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                children: position <= margin / 2 || thumbName === 'rightThumb' && position <= Math.round(state.getThumbPercent(0) * 100) + margin ? null : /*#__PURE__*/ jsx(Box, {
                    as: "span",
                    width: "unsafe_component.slider.sizing.4",
                    height: "unsafe_component.slider.sizing.6",
                    display: "block",
                    borderTopRightRadius: "unsafe_component.slider.radius.default",
                    borderBottomRightRadius: "unsafe_component.slider.radius.default",
                    backgroundColor: variant !== 'range' && isDisabledState[0] === true || variant === 'range' && (thumbName !== 'rightThumb' || thumbName === 'rightThumb' && isDisabledState[0] === true && isDisabledState[1] === true) ? 'unsafe_component.slider.color.unselected' : 'unsafe_component.slider.color.selected'
                })
            }),
            /*#__PURE__*/ jsx(SliderHandle, {
                isDisabledState: isDisabledState,
                variant: variant,
                thumbName: thumbName,
                isDragging: isDragging,
                isDisabled: isDisabled,
                minDistance: minDistance,
                state: state
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                width: "unsafe_component.slider.sizing.6",
                height: "unsafe_component.slider.sizing.6",
                backgroundColor: "unsafe_component.slider.color.vector",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                children: position >= 100 - margin / 2 || thumbName === 'leftThumb' && position >= Math.round(state.getThumbPercent(1) * 100) - margin ? null : /*#__PURE__*/ jsx(Box, {
                    as: "span",
                    width: "unsafe_component.slider.sizing.4",
                    height: "unsafe_component.slider.sizing.6",
                    display: "block",
                    borderTopLeftRadius: "unsafe_component.slider.radius.default",
                    borderBottomLeftRadius: "unsafe_component.slider.radius.default",
                    backgroundColor: variant === 'range' && thumbName === 'leftThumb' && isDisabledState.includes(false) ? 'unsafe_component.slider.color.selected' : 'unsafe_component.slider.color.unselected'
                })
            }),
            /*#__PURE__*/ jsx(VisuallyHidden, {
                children: /*#__PURE__*/ jsx(Box, {
                    as: "input",
                    ref: inputRef,
                    ...inputProps,
                    "aria-required": isRequired,
                    tabIndex: -1
                })
            })
        ]
    });
};
const SliderHandle = ({ isDisabledState, variant, thumbName, isDragging, isDisabled, state, minDistance })=>{
    const thumbRef = useRef(null);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled: false
    });
    const { boxProps, isFocused } = useFocusable(thumbRef);
    // Manage minimum distance between the thumbs when slider is range
    useLayoutEffect(()=>{
        if (variant === 'range') {
            const leftThumbValue = state.getThumbValue(0);
            const rightThumbValue = state.getThumbValue(1);
            if (leftThumbValue && rightThumbValue || leftThumbValue === state.getThumbMinValue(0)) {
                if (state.focusedThumb === 0 || thumbName === 'leftThumb' && isFocused) {
                    state.setThumbValue(0, Math.min(leftThumbValue, rightThumbValue - minDistance));
                }
                if (state.focusedThumb === 1 || thumbName === 'rightThumb' && isFocused) {
                    state.setThumbValue(1, Math.max(rightThumbValue, leftThumbValue + minDistance));
                }
            }
        }
    }, [
        variant,
        state,
        minDistance,
        thumbName,
        isFocused
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ref: thumbRef,
        ...hoverProps,
        ...boxProps,
        backgroundColor: isDisabled ? `unsafe_component.slider.color.disabled` : isHovered ? isDragging ? `unsafe_component.slider.color.handleDragging` : `unsafe_component.slider.color.handleHovered` : `unsafe_component.slider.color.selected`,
        borderRadius: "unsafe_component.slider.radius.default",
        borderStyle: "none",
        width: "unsafe_component.slider.sizing.12",
        height: "unsafe_component.slider.sizing.32",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        boxShadow: isDragging || isDisabled ? undefined : 'unsafe_component.slider.shadow',
        cursor: isDisabled ? 'not-allowed' : isDragging ? 'grabbing' : 'grab',
        children: [
            isDragging ? /*#__PURE__*/ jsx(Box, {
                position: "absolute",
                width: "unsafe_component.slider.sizing.24",
                height: "unsafe_component.slider.sizing.44",
                backgroundColor: "unsafe_component.slider.color.border",
                borderRadius: "unsafe_component.slider.radius.vector",
                boxShadow: "unsafe_component.slider.shadow"
            }) : null,
            /*#__PURE__*/ jsx(Box, {
                position: "absolute",
                width: "unsafe_component.slider.sizing.2",
                height: "unsafe_component.slider.sizing.18",
                display: "block",
                backgroundColor: variant !== 'range' && isDisabledState[0] !== false || variant === 'range' && (thumbName === 'leftThumb' && isDisabledState[0] === true || thumbName === 'rightThumb' && isDisabledState[1] === true) ? `unsafe_component.slider.color.disabled` : `unsafe_component.slider.color.vector`,
                borderRadius: "unsafe_component.slider.radius.vector"
            })
        ]
    });
};

const SliderMarkers = ({ markers, leftThumbValue, rightThumbValue, variant, isDisabledState, leftThumbPosition, rightThumbPosition })=>{
    const markerPosition = 100 / (markers.length - 1);
    // We used ratio to manage right aligment and display between dot and thumb
    const ratio = leftThumbPosition < 7 || leftThumbPosition > 93 ? 7 : 5;
    return /*#__PURE__*/ jsx(Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        children: markers.map(({ label, value }, index)=>{
            const computedPositionWithRatio = markerPosition * index + ratio;
            const computedPositionWithoutRatio = markerPosition * index - ratio;
            const testLeftThumbPosition = leftThumbPosition > computedPositionWithRatio || leftThumbPosition < computedPositionWithoutRatio;
            const testRightThumbPosition = rightThumbPosition !== undefined && (rightThumbPosition > computedPositionWithRatio || rightThumbPosition < computedPositionWithoutRatio);
            return /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: index === 0 ? 'flex-start' : index === markers.length - 1 ? 'flex-end' : 'center',
                width: index !== 0 && index !== markers.length - 1 ? `calc(100% / ${markers.length - 1})` : `calc((100% / ${markers.length - 1})/2)`,
                children: [
                    testLeftThumbPosition || variant === 'range' && testLeftThumbPosition && testRightThumbPosition ? /*#__PURE__*/ jsx(SliderMarkerDot, {
                        index: index,
                        variant: variant,
                        value: value,
                        leftThumbValue: leftThumbValue,
                        rightThumbValue: rightThumbValue,
                        isDisabledRangeLeftThumb: isDisabledState[0],
                        isDisabledRangeRightThumb: isDisabledState[1]
                    }) : /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        "data-index": index,
                        height: "unsafe_component.slider.sizing.6",
                        width: "unsafe_component.slider.sizing.6",
                        display: "block"
                    }),
                    label !== undefined && label !== '' ? /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        "aria-hidden": "true",
                        color: "unsafe_component.slider.color.text",
                        typography: "unsafe_component.slider.typography.marker",
                        marginTop: "unsafe_component.slider.spacing.markerTop",
                        children: label
                    }) : null
                ]
            }, index);
        })
    });
};
const SliderMarkerDot = ({ variant, value, leftThumbValue, rightThumbValue, isDisabledRangeLeftThumb, isDisabledRangeRightThumb, index })=>{
    const isDisabledOnlyLeftThumb = isDisabledRangeLeftThumb === true && isDisabledRangeRightThumb === false;
    const isDisabledOnlyRightThumb = isDisabledRangeLeftThumb === false && isDisabledRangeRightThumb === true;
    const areDisabledBothThumbs = isDisabledRangeLeftThumb === false && isDisabledRangeRightThumb === false;
    const valuesBiggerThanThumbs = leftThumbValue > value && rightThumbValue > value;
    const valuesSmallerThanThumbs = leftThumbValue < value && rightThumbValue < value;
    const valuesBetweenThumbs = leftThumbValue < value && rightThumbValue > value;
    const isDisabledThumbs = valuesBetweenThumbs && (isDisabledOnlyLeftThumb || isDisabledOnlyRightThumb) || areDisabledBothThumbs && (variant !== 'range' && value < leftThumbValue || valuesBetweenThumbs);
    return /*#__PURE__*/ jsx(Box, {
        as: "span",
        "data-index": index,
        backgroundColor: areDisabledBothThumbs && (variant !== 'range' && leftThumbValue < value || valuesSmallerThanThumbs || valuesBiggerThanThumbs) || isDisabledOnlyLeftThumb && valuesSmallerThanThumbs || isDisabledOnlyRightThumb && valuesBiggerThanThumbs ? 'unsafe_component.slider.color.selected' : isDisabledThumbs ? 'unsafe_component.slider.color.unselected' : 'unsafe_component.slider.color.dot',
        width: "unsafe_component.slider.sizing.6",
        height: "unsafe_component.slider.sizing.6",
        borderRadius: "unsafe_component.slider.radius.rounded",
        // Set border style to avoid to manage margin of 1px
        borderColor: isDisabledThumbs ? 'unsafe_component.slider.color.selected' : 'unsafe_component.slider.color.unselected',
        borderWidth: "borderWidth.1",
        borderStyle: "solid"
    });
};

const SliderTrack = ({ trackRef, leftInputRef, rightInputRef, trackProps, leftThumbProps, rightThumbProps, variant, markers, state, hasTextFields, minDistance, isDisabledState, isRequired })=>{
    const tokens = useTokens();
    const margin = parseFloat(tokens['unsafe_component.slider.sizing.8'].toString()) * getRootFontSizeValue();
    const isDisabled = variant === 'range' && isDisabledState[0] === true && isDisabledState[1] === true || variant !== 'range' && isDisabledState[0] === true;
    const backgroundColorTrackDisabled = tokens['unsafe_component.slider.color.unselected'];
    const backgroundColorTrackRange = isDisabled ? backgroundColorTrackDisabled : variant === 'range' && rightThumbProps !== undefined && rightThumbProps.position - leftThumbProps.position <= margin ? tokens['unsafe_component.slider.color.transparent'] : tokens['unsafe_component.slider.color.selected'];
    const leftThumbPosition = leftThumbProps.position.toString();
    const rightThumbPosition = rightThumbProps?.position.toString();
    const backgroundGradientTrack = variant !== 'range' ? `linear-gradient(90deg, ${backgroundColorTrackRange} 0%, ${backgroundColorTrackRange} ${leftThumbPosition}%, ${backgroundColorTrackDisabled} ${leftThumbPosition}%, ${backgroundColorTrackDisabled} 100%);` : `linear-gradient(90deg, ${backgroundColorTrackDisabled} 0%, ${backgroundColorTrackDisabled} ${leftThumbPosition}%, ${backgroundColorTrackRange} ${leftThumbPosition}%, ${backgroundColorTrackRange} ${rightThumbPosition}%, ${backgroundColorTrackDisabled} ${rightThumbPosition}%, ${backgroundColorTrackDisabled} 100%);`;
    return /*#__PURE__*/ jsx(Box, {
        width: variant !== 'range' && hasTextFields ? `calc(100% - ${tokens['unsafe_component.slider.sizing.64']} - ${tokens['unsafe_component.slider.sizing.8']})` : '100%',
        height: markers ? hasTextFields ? 'unsafe_component.slider.sizing.68' : 'unsafe_component.slider.sizing.60' : 'unsafe_component.slider.sizing.52',
        children: /*#__PURE__*/ jsxs(Box, {
            ref: trackRef,
            position: "relative",
            height: "unsafe_component.slider.sizing.6",
            width: `calc(100% - ${tokens['unsafe_component.slider.sizing.12']})`,
            marginTop: `calc(${tokens['unsafe_component.slider.spacing.top']} + ${tokens['unsafe_component.slider.spacing.margin']})`,
            marginLeft: "unsafe_component.slider.spacing.margin",
            backgroundImage: backgroundGradientTrack,
            borderRadius: "unsafe_component.slider.radius.default",
            ...trackProps,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            children: [
                /*#__PURE__*/ jsx(SliderThumbs, {
                    leftThumbProps: leftThumbProps,
                    rightThumbProps: rightThumbProps,
                    leftInputRef: leftInputRef,
                    rightInputRef: rightInputRef,
                    variant: variant,
                    state: state,
                    minDistance: minDistance,
                    isDisabledState: isDisabledState,
                    margin: margin,
                    isRequired: isRequired
                }),
                markers !== undefined ? /*#__PURE__*/ jsx(SliderMarkers, {
                    markers: markers,
                    leftThumbValue: Number(state.getThumbValueLabel(0)),
                    rightThumbValue: Number(state.getThumbValueLabel(1)),
                    variant: variant,
                    leftThumbPosition: leftThumbProps.position,
                    rightThumbPosition: rightThumbProps?.position,
                    isDisabledState: isDisabledState
                }) : null
            ]
        })
    });
};

const useRangeSlider = (refs, props)=>{
    const { leftInput: leftInputRef, rightInput: rightInputRef, track: trackRef } = refs;
    const { variant, isDisabled, max, min, step, value, defaultValue, label, helper, minDistance, onChange } = props;
    const isLabelDisabled = Array.isArray(isDisabled) ? !isDisabled.includes(false) : !!isDisabled;
    const numberFormatter = useNumberFormatter();
    const state = useSliderState({
        numberFormatter,
        isDisabled: isLabelDisabled,
        minValue: min,
        maxValue: max,
        step,
        value,
        defaultValue,
        onChange: onChange || (()=>{}),
        label
    });
    const { groupProps, trackProps, labelProps, outputProps } = useSlider({
        isDisabled: isLabelDisabled,
        minValue: min,
        maxValue: max,
        step,
        label
    }, state, trackRef);
    const { leftThumbProps, rightThumbProps } = useRangeSliderThumb({
        trackRef,
        'aria-describedby': helper ?? ''
    }, {
        inputRef: leftInputRef,
        isDisabled: Array.isArray(isDisabled) ? isDisabled[0] : isDisabled ?? false
    }, {
        inputRef: rightInputRef,
        isDisabled: Array.isArray(isDisabled) ? isDisabled[1] : isDisabled ?? false
    }, state);
    const outputLabel = variant !== 'range' ? state.getThumbValueLabel(0) : `${state.getThumbValueLabel(0)}-${state.getThumbValueLabel(1)}`;
    const leftThumbPosition = Math.round(state.getThumbPercent(0) * 100);
    const rightThumbPosition = Math.round(state.getThumbPercent(1) * 100);
    return {
        groupProps,
        trackProps,
        labelProps,
        outputProps,
        leftThumbProps: {
            ...leftThumbProps,
            ...{
                position: leftThumbPosition,
                labelledBy: labelProps.id,
                describedBy: helper
            }
        },
        rightThumbProps: {
            ...rightThumbProps,
            ...{
                position: rightThumbPosition,
                labelledBy: labelProps.id,
                describedBy: helper
            }
        },
        outputLabel,
        isLabelDisabled,
        defaultMinDistance: variant === 'range' ? Math.max(state.step, minDistance) : 0,
        isDisabledState: [
            leftThumbProps.isDisabled,
            rightThumbProps?.isDisabled ?? false
        ],
        state
    };
};
const useRangeSliderThumb = (props, leftRangeSliderThumbProps, rightRangeSliderThumbProps, state)=>{
    const { thumbProps: leftThumbProps, inputProps: leftInputProps, isDragging: leftThumbIsDragging, isDisabled: leftThumbIsDisabled } = useSliderThumb({
        ...props,
        ...leftRangeSliderThumbProps,
        ...{
            index: 0,
            name: 'leftThumb'
        }
    }, state);
    const { thumbProps: rightThumbProps, inputProps: rightInputProps, isDragging: rightThumbIsDragging, isDisabled: rightThumbIsDisabled } = useSliderThumb({
        ...props,
        ...rightRangeSliderThumbProps,
        ...{
            index: 1,
            name: 'rightThumb'
        }
    }, state);
    return {
        leftThumbProps: {
            thumbProps: leftThumbProps,
            inputProps: leftInputProps,
            isDragging: leftThumbIsDragging,
            isDisabled: leftThumbIsDisabled
        },
        rightThumbProps: {
            thumbProps: rightThumbProps,
            inputProps: rightInputProps,
            isDragging: rightThumbIsDragging,
            isDisabled: rightThumbIsDisabled
        }
    };
};
const useRangeSliderTextFields = (props, leftTextFieldProps, leftTextFieldRef, rightTextFieldProps, rightTextFieldRef)=>{
    const { inputProps: leftTextFieldInputProps } = useTextField$1({
        ...props,
        ...leftTextFieldProps
    }, leftTextFieldRef);
    const { inputProps: rightTextFieldInputProps } = useTextField$1({
        ...props,
        ...rightTextFieldProps
    }, rightTextFieldRef);
    return {
        leftTextFieldInputProps,
        rightTextFieldInputProps
    };
};

const useSliderTranslation = ()=>useTranslation({
        'en-GB': {
            'aria::label::value': 'value',
            'aria::label::minValue': 'minimum value',
            'aria::label::maxValue': 'maximum value'
        },
        'fr-FR': {
            'aria::label::value': 'valeur',
            'aria::label::minValue': 'valeur minimale',
            'aria::label::maxValue': 'valeur maximale'
        },
        'de-DE': {
            'aria::label::value': 'Wert',
            'aria::label::minValue': 'Mindestwert',
            'aria::label::maxValue': 'Maximalwert'
        },
        'nl-NL': {
            'aria::label::value': 'waarde',
            'aria::label::minValue': 'minimale waarde',
            'aria::label::maxValue': 'maximale waarde'
        }
    });

const Slider = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { variant = 'default', defaultValue, value, onChange, onBlur, onFocus, minDistance = 1, isDisabled, min = 0, max = 100, step = 1, markers, hasTextFields, shouldDisplayCurrentValue = true, error, ...fieldProps } = props;
    // We only pass the ref to the left input because it is always present in the component, for default and range variants.
    // The right input isn't, only for range variant.
    const leftInputRef = useObjectRef(ref);
    const rightInputRef = useRef(null);
    const trackRef = useRef(null);
    const helperId = useId$1();
    const computedHelperId = fieldProps.helper !== undefined ? helperId : undefined;
    const isLabelHidden = typeof fieldProps.label !== 'string' && fieldProps.label.isHidden === true;
    const defaultLabel = typeof fieldProps.label === 'string' ? fieldProps.label : fieldProps.label.content;
    const { groupProps, trackProps, labelProps, outputProps, leftThumbProps, rightThumbProps, outputLabel, isLabelDisabled, defaultMinDistance, isDisabledState, state } = useRangeSlider({
        leftInput: leftInputRef,
        rightInput: rightInputRef,
        track: trackRef
    }, {
        variant,
        isDisabled,
        min,
        max,
        // When markers are set, the value of the texfield must follow the value of markers and the slider doesn't accept a value between two markers
        step: hasTextFields && markers !== undefined && markers.length > 1 && markers[1]?.value !== undefined ? markers[1]?.value : step,
        value: value,
        defaultValue: defaultValue ?? (variant !== 'range' ? min : [
            min,
            max
        ]),
        onChange,
        label: defaultLabel,
        helper: computedHelperId,
        minDistance
    });
    return /*#__PURE__*/ jsxs(Box, {
        width: "100%",
        minWidth: "unsafe_component.slider.sizing.280",
        ...groupProps,
        children: [
            /*#__PURE__*/ jsx(SliderLabel, {
                fieldProps: fieldProps,
                outputProps: outputProps,
                labelProps: labelProps,
                helperId: computedHelperId,
                isDisabled: isLabelDisabled,
                isHidden: isLabelHidden,
                shouldDisplayCurrentValue: shouldDisplayCurrentValue,
                outputLabel: outputLabel
            }),
            /*#__PURE__*/ jsxs(Box, {
                display: "inline-flex",
                flexDirection: variant !== 'range' ? 'row' : 'column',
                flexWrap: "wrap",
                width: "100%",
                alignItems: "flex-start",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ jsx(SliderTrack, {
                        trackRef: trackRef,
                        leftInputRef: leftInputRef,
                        rightInputRef: rightInputRef,
                        trackProps: trackProps,
                        leftThumbProps: leftThumbProps,
                        rightThumbProps: rightThumbProps,
                        variant: variant,
                        markers: markers,
                        state: state,
                        hasTextFields: hasTextFields,
                        minDistance: defaultMinDistance,
                        isDisabledState: isDisabledState,
                        isRequired: !fieldProps.isOptional
                    }),
                    hasTextFields ? /*#__PURE__*/ jsx(SliderTextField, {
                        state: state,
                        label: defaultLabel,
                        helperId: computedHelperId,
                        variant: variant,
                        error: error,
                        isDisabledState: isDisabledState,
                        minDistance: defaultMinDistance
                    }) : null
                ]
            })
        ]
    });
});
const SliderLabel = ({ fieldProps, outputProps, labelProps, helperId, isDisabled, isHidden, shouldDisplayCurrentValue, outputLabel })=>{
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        flexDirection: "row",
        justifyContent: isHidden ? 'flex-end' : 'space-between',
        alignItems: "center",
        gap: shouldDisplayCurrentValue ? 'unsafe_component.slider.spacing.gap' : 'spacing.none',
        children: [
            /*#__PURE__*/ jsx(FieldLabel, {
                labelProps: {
                    id: labelProps.id,
                    htmlFor: labelProps.htmlFor
                },
                helperProps: {
                    id: helperId
                },
                ...fieldProps,
                isDisabled: isDisabled,
                hasScreenReaderHiddenLabel: isHidden
            }),
            shouldDisplayCurrentValue ? /*#__PURE__*/ jsx(Box, {
                as: "output",
                color: isDisabled ? 'unsafe_component.slider.color.textDisabled' : 'unsafe_component.slider.color.text',
                typography: "unsafe_component.slider.typography.output",
                whiteSpace: "nowrap",
                ...outputProps,
                children: outputLabel
            }) : null
        ]
    });
};
const SliderTextField = ({ helperId, state, variant, error, isDisabledState, minDistance, label })=>{
    const [leftValue, setLeftValue] = useState('');
    const [rightValue, setRightValue] = useState('');
    const leftTextFieldRef = useRef(null);
    const rightTextFieldRef = useRef(null);
    const errorId = useId$1();
    const computedErrorId = error !== undefined ? errorId : undefined;
    const t = useSliderTranslation();
    const handleChangeLeftTextField = (value)=>{
        const numberValue = Number(value);
        if (value !== '' && Number.isNaN(numberValue)) return;
        if (variant === 'range') {
            const maxValue = state.getThumbValue(1) - minDistance;
            if (numberValue > maxValue) {
                state.setThumbValue(0, maxValue);
                setLeftValue(maxValue.toString());
                return;
            }
        }
        setLeftValue(value);
        state.setThumbValue(0, Number(value));
    };
    const handleChangeRightTextField = (value)=>{
        const numberValue = Number(value);
        if (value !== '' && Number.isNaN(numberValue)) return;
        const minValue = state.getThumbValue(0) + minDistance;
        if (value === '' || numberValue < minValue) {
            state.setThumbValue(1, minValue);
            setRightValue(value);
            return;
        }
        setRightValue(value);
        state.setThumbValue(1, Number(value));
    };
    useEffect(()=>{
        const leftInput = leftTextFieldRef.current;
        if (leftInput) {
            setLeftValue(state.getThumbValueLabel(0));
        }
        if (variant === 'range') {
            const rightInput = rightTextFieldRef.current;
            if (rightInput) {
                setRightValue(state.getThumbValueLabel(1));
            }
        }
    }, [
        leftTextFieldRef,
        rightTextFieldRef,
        variant,
        state
    ]);
    const { leftTextFieldInputProps, rightTextFieldInputProps } = useRangeSliderTextFields({
        inputMode: 'numeric',
        isRequired: true,
        isInvalid: computedErrorId !== undefined ? true : false,
        'aria-describedby': (computedErrorId ?? '') + (helperId !== undefined && computedErrorId !== undefined ? ' ' : '') + (helperId ?? '')
    }, {
        value: leftValue,
        isDisabled: isDisabledState[0],
        'aria-label': (variant !== 'range' ? t('aria::label::value') : t('aria::label::minValue')) + ' ' + label,
        onKeyDown: (event)=>{
            if (event.key === 'ArrowUp' || event.key === 'PageUp' || event.key === 'ArrowDown' || event.key === 'PageDown') {
                event.preventDefault();
                if ((event.key === 'ArrowUp' || event.key === 'PageUp') && state.getThumbValue(0) < state.getThumbMaxValue(0) - minDistance) {
                    state.incrementThumb(0);
                }
                if (event.key === 'ArrowDown' || event.key === 'PageDown') {
                    state.decrementThumb(0);
                }
                setLeftValue(state.getThumbValueLabel(0));
            }
        },
        onChange: handleChangeLeftTextField,
        onBlur: (event)=>{
            const input = event.target;
            if (input.value === '') {
                setLeftValue(state.getThumbMinValue(0).toString());
            }
        }
    }, leftTextFieldRef, {
        value: rightValue,
        isDisabled: isDisabledState[1],
        'aria-label': t('aria::label::maxValue') + ' ' + label,
        onKeyDown: (event)=>{
            if (event.key === 'ArrowUp' || event.key === 'PageUp' || event.key === 'ArrowDown' || event.key === 'PageDown') {
                event.preventDefault();
                if (event.key === 'ArrowUp' || event.key === 'PageUp') {
                    state.incrementThumb(1);
                }
                if ((event.key === 'ArrowDown' || event.key === 'PageDown') && state.getThumbValue(1) > state.getThumbMinValue(1) + minDistance) {
                    state.decrementThumb(1);
                }
                setRightValue(state.getThumbValueLabel(1));
            }
        },
        onChange: handleChangeRightTextField,
        onBlur: (event)=>{
            const input = event.target;
            const minValue = state.getThumbMinValue(1) + minDistance;
            if (Number(input.value) < minValue) {
                setRightValue(minValue.toString());
            }
            if (Number(input.value) > state.getThumbMaxValue(1)) {
                setRightValue(state.getThumbMaxValue(1).toString());
            }
        }
    }, rightTextFieldRef);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "inline-flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: variant !== 'range' ? 'unsafe_component.slider.sizing.64' : '100%',
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        width: "unsafe_component.slider.sizing.64",
                        children: /*#__PURE__*/ jsx(TextFieldBase, {
                            inputRef: leftTextFieldRef,
                            inputProps: leftTextFieldInputProps,
                            isFullWidth: true,
                            error: error,
                            isDisabled: isDisabledState[0]
                        })
                    }),
                    variant === 'range' ? /*#__PURE__*/ jsx(Box, {
                        width: "unsafe_component.slider.sizing.64",
                        children: /*#__PURE__*/ jsx(TextFieldBase, {
                            inputRef: rightTextFieldRef,
                            inputProps: rightTextFieldInputProps,
                            isFullWidth: true,
                            error: error,
                            isDisabled: isDisabledState[1]
                        })
                    }) : null
                ]
            }),
            error ? /*#__PURE__*/ jsx(StateMessage, {
                id: errorId,
                variant: "error",
                marginTop: "unsafe_component.slider.spacing.margin",
                children: error
            }) : null
        ]
    });
};

/**
 * Converts degrees to radians.
 */ function getRadianAngle(degree) {
    return degree * Math.PI / 180;
}
/**
 * Calculates the bounding box of a rotated rectangle.
 */ function rotateSize(width, height, rotation) {
    const radians = getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(radians) * width) + Math.abs(Math.sin(radians) * height),
        height: Math.abs(Math.sin(radians) * width) + Math.abs(Math.cos(radians) * height)
    };
}
/**
 * Loads an image and returns an HTMLImageElement.
 */ async function loadImage(src) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        image.onload = ()=>resolve(image);
        image.onerror = (err)=>reject(err);
        image.crossOrigin = 'anonymous'; // recommended to avoid CORS issues
        image.src = src;
    });
}
/**
 * Crops, rotates, and optionally flips an image, returning a JPEG Blob.
 */ async function getCroppedImg(imageSrc, crop, rotation = 0, flip = {
    horizontal: false,
    vertical: false
}) {
    const image = await loadImage(imageSrc);
    // Create canvas with rotated image
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    const radians = getRadianAngle(rotation);
    const { width: rotatedWidth, height: rotatedHeight } = rotateSize(image.width, image.height, rotation);
    canvas.width = rotatedWidth;
    canvas.height = rotatedHeight;
    // Move origin to center for rotation and flipping
    ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
    ctx.rotate(radians);
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
    ctx.translate(-image.width / 2, -image.height / 2);
    ctx.drawImage(image, 0, 0);
    // Crop the desired area from the rotated image
    const croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = crop.width;
    croppedCanvas.height = crop.height;
    const croppedCtx = croppedCanvas.getContext('2d');
    if (!croppedCtx) return null;
    croppedCtx.drawImage(canvas, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    // Convert cropped canvas to Blob
    return new Promise((resolve, reject)=>{
        croppedCanvas.toBlob((blob)=>{
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error('Canvas toBlob failed to produce a Blob.'));
            }
        }, 'image/jpeg', 0.95);
    });
}

const normalizeRotation = (angle)=>{
    const normalized = angle % 360;
    return normalized === -360 ? 0 : normalized;
};
const SLIDER_CONFIG = {
    zoom: {
        min: 1,
        max: 3,
        step: 0.1
    },
    rotation: {
        min: 0,
        max: 360,
        step: 1
    }
};
const DEFAULT_ZOOM = 1;
const DEFAULT_ROTATION = 0;
const DEFAULT_CROP = {
    x: 0,
    y: 0
};
const DEFAULT_ASPECT = 16 / 9;
const DEFAULT_IMAGE_EDIT_STATE = {
    zoom: DEFAULT_ZOOM,
    rotation: DEFAULT_ROTATION,
    crop: DEFAULT_CROP,
    aspect: DEFAULT_ASPECT
};
const useImageEdit = ()=>{
    const t = useMediaUploadTranslation();
    const { onEditFile, fileMenuProps: { toggleEditImageOpen }, saveEditedImage, isEditingImageOpen } = useMediaUploadContext();
    const [imageEditState, setImageEditState] = useState(DEFAULT_IMAGE_EDIT_STATE);
    const [showDiscardDialog, setShowDiscardDialog] = useState(false);
    const [pendingClose, setPendingClose] = useState(false);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const imageSrc = useMemo(()=>{
        if (onEditFile?.file) return URL.createObjectURL(onEditFile.file);
        return '';
    }, [
        onEditFile
    ]);
    useEffect(()=>{
        if (isEditingImageOpen) {
            setImageEditState(DEFAULT_IMAGE_EDIT_STATE);
        }
    }, [
        isEditingImageOpen
    ]);
    useEffect(()=>{
        if (!isEditingImageOpen && pendingClose) {
            setShowDiscardDialog(true);
            setPendingClose(false);
        }
    }, [
        isEditingImageOpen,
        pendingClose
    ]);
    const handleReset = ()=>{
        setImageEditState(DEFAULT_IMAGE_EDIT_STATE);
        setPendingClose(false);
        setShowDiscardDialog(false);
    };
    const isModified = useMemo(()=>{
        return imageEditState.zoom !== DEFAULT_ZOOM || imageEditState.rotation !== DEFAULT_ROTATION || imageEditState.crop.x !== DEFAULT_CROP.x || imageEditState.crop.y !== DEFAULT_CROP.y || imageEditState.aspect !== DEFAULT_ASPECT;
    }, [
        imageEditState
    ]);
    const onCropComplete = useCallback((_croppedArea, croppedPixels)=>{
        setCroppedAreaPixels(croppedPixels);
    }, []);
    const footerStartButton = {
        onPress: handleReset,
        isDisabled: !isModified,
        icon: RotateLeftIcon,
        children: t('mediaupload::imageEdit::footerStartButton')
    };
    const footerEndButton = {
        onPress: async ()=>{
            if (!imageSrc || !croppedAreaPixels) return;
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels, imageEditState.rotation);
            if (!croppedImageBlob || !onEditFile?.file?.name) return;
            saveEditedImage(new File([
                croppedImageBlob
            ], onEditFile.file.name, {
                type: onEditFile.file.type
            }));
            setPendingClose(false);
            setShowDiscardDialog(false);
        },
        'aria-label': t('mediaupload::imageEdit::footerEndButton'),
        children: t('mediaupload::imageEdit::footerEndButton')
    };
    const discardContinueButton = {
        onPress: ()=>setShowDiscardDialog(false),
        children: t('mediaupload::imageEdit::discard::modal::continueButton')
    };
    const discardConfirmButton = {
        onPress: ()=>{
            setPendingClose(false);
            setShowDiscardDialog(false);
            toggleEditImageOpen();
        },
        children: t('mediaupload::imageEdit::discard::modal::discardButton')
    };
    return {
        imageEditState,
        imageSrc,
        isEditingImageOpen,
        showDiscardDialog,
        isModified,
        footerStartButton,
        footerEndButton,
        discardContinueButton,
        discardConfirmButton,
        setImageEditState,
        setShowDiscardDialog,
        setPendingClose,
        onCropComplete,
        toggleEditImageOpen
    };
};

const ImageEdit = ()=>{
    const t = useMediaUploadTranslation();
    const isMobile = useBreakpointValue({
        base: true,
        lg: false
    });
    const { imageSrc, imageEditState, setImageEditState, setShowDiscardDialog, setPendingClose, onCropComplete, toggleEditImageOpen, isEditingImageOpen, showDiscardDialog, isModified, footerStartButton, footerEndButton, discardContinueButton, discardConfirmButton } = useImageEdit();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Modal, {
                isOpen: isEditingImageOpen,
                trigger: ()=>null,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) {
                        if (isModified) {
                            setShowDiscardDialog(true);
                            setPendingClose(true);
                        } else {
                            toggleEditImageOpen();
                        }
                    }
                },
                footerStartButtonProps: footerStartButton,
                footerEndButtonProps: footerEndButton,
                predefinedWidth: "1120",
                displayMode: isMobile ? 'fullscreen' : 'default',
                title: t('mediaupload::imageEdit::title'),
                hasContentPadding: false,
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: {
                        'breakpoint.base': 'column',
                        'breakpoint.lg': 'row'
                    },
                    width: "100%",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            position: "relative",
                            width: "100%",
                            height: {
                                'breakpoint.base': 200,
                                'breakpoint.sm': 400
                            },
                            backgroundColor: 'unsafe_component.mediaUpload.color.bgImageEdit',
                            children: imageSrc && /*#__PURE__*/ jsx(Cropper, {
                                image: imageSrc,
                                crop: imageEditState.crop,
                                zoom: imageEditState.zoom,
                                rotation: imageEditState.rotation,
                                aspect: imageEditState.aspect,
                                onZoomChange: (value)=>setImageEditState((prev)=>({
                                            ...prev,
                                            zoom: value
                                        })),
                                onCropChange: (value)=>setImageEditState((prev)=>({
                                            ...prev,
                                            crop: value
                                        })),
                                onRotationChange: (value)=>setImageEditState((prev)=>({
                                            ...prev,
                                            rotation: normalizeRotation(value)
                                        })),
                                onCropComplete: onCropComplete
                            })
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            flexDirection: "column",
                            gap: "spacing.8",
                            paddingTop: 'spacing.16',
                            textAlign: "center",
                            justifySelf: "center",
                            width: {
                                'breakpoint.base': '100%',
                                'breakpoint.lg': '400px'
                            },
                            paddingLeft: {
                                'breakpoint.base': 'spacing.16',
                                'breakpoint.lg': 'spacing.32'
                            },
                            paddingRight: {
                                'breakpoint.base': 'spacing.16',
                                'breakpoint.lg': 'spacing.32'
                            },
                            children: [
                                /*#__PURE__*/ jsx(Dropdown, {
                                    label: t('mediaupload::imageEdit::dropdown::label'),
                                    defaultItems: [
                                        {
                                            label: t('mediaupload::imageEdit::dropdown::label::aspect::banner'),
                                            id: 'banner'
                                        },
                                        {
                                            label: t('mediaupload::imageEdit::dropdown::label::aspect::portrait'),
                                            id: 'portrait'
                                        }
                                    ],
                                    defaultValue: 'banner',
                                    onChange: (selectedId)=>{
                                        setImageEditState((prev)=>({
                                                ...prev,
                                                aspect: selectedId === 'banner' ? 16 / 9 : 4 / 3
                                            }));
                                    }
                                }),
                                /*#__PURE__*/ jsx(Box, {
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "spacing.12",
                                    marginTop: "spacing.16",
                                    children: /*#__PURE__*/ jsx(Slider, {
                                        label: t('mediaupload::imageEdit::slider::zoom::label'),
                                        value: imageEditState.zoom,
                                        onChange: (value)=>{
                                            if (typeof value === 'number') {
                                                setImageEditState((prev)=>({
                                                        ...prev,
                                                        zoom: normalizeRotation(value)
                                                    }));
                                            }
                                        },
                                        ...SLIDER_CONFIG.zoom,
                                        hasTextFields: false,
                                        shouldDisplayCurrentValue: false
                                    })
                                }),
                                /*#__PURE__*/ jsxs(Box, {
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "spacing.12",
                                    children: [
                                        /*#__PURE__*/ jsx(Slider, {
                                            label: t('mediaupload::imageEdit::slider::rotation::label'),
                                            value: imageEditState.rotation,
                                            onChange: (value)=>{
                                                if (typeof value === 'number') {
                                                    setImageEditState((prev)=>({
                                                            ...prev,
                                                            rotation: value
                                                        }));
                                                }
                                            },
                                            ...SLIDER_CONFIG.rotation,
                                            shouldDisplayCurrentValue: false
                                        }),
                                        /*#__PURE__*/ jsx(Button, {
                                            marginTop: "spacing.16",
                                            variant: "secondary",
                                            icon: RotateRightImageIcon,
                                            iconOnly: true,
                                            size: "32",
                                            "aria-label": t('mediaupload::imageEdit::button::rotation::label'),
                                            onPress: ()=>setImageEditState((prev)=>({
                                                        ...prev,
                                                        rotation: normalizeRotation(prev.rotation + 90)
                                                    })),
                                            children: t('mediaupload::imageEdit::button::rotation::label')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showDiscardDialog && /*#__PURE__*/ jsx(Modal, {
                isOpen: showDiscardDialog,
                hasCloseButton: false,
                onOpenChange: (isOpen)=>{
                    if (!isOpen) setShowDiscardDialog(false);
                },
                trigger: ()=>null,
                isDismissable: false,
                footerStartButtonProps: discardContinueButton,
                footerEndButtonProps: discardConfirmButton,
                "aria-label": t('mediaupload::imageEdit::discard::modal::title'),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    height: {
                        'breakpoint.base': 'auto',
                        'breakpoint.lg': '100%'
                    },
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ jsx(InfoQuitSaveHero, {
                            size: "144"
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            typography: "unsafe_component.mediaUpload.typography.discardTitle",
                            marginBottom: "unsafe_component.infoState.spacing.gap.title",
                            children: t('mediaupload::imageEdit::discard::modal::title')
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            typography: "unsafe_component.mediaUpload.typography.discardText",
                            children: t('mediaupload::imageEdit::discard::modal::text')
                        })
                    ]
                })
            })
        ]
    });
};

const MediaUpload = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { acceptType = ACCEPTED_TYPE, menuItems, captionProps, maxFileCount = 1, hasMaxFileIndicator = true, errors, fileErrors, defaultValue, onChange, filePressProps, shouldShowCoverPhotoTag, shouldShowFileNames = true, value, variant = 'images', enableThumbnailGeneration, thumbnailSize, ...fieldProps } = props;
    return /*#__PURE__*/ jsx(Field, {
        ...fieldProps,
        children: ({ fieldRenderProps })=>/*#__PURE__*/ jsx(MediaUploadProvider, {
                ...props,
                ref: ref,
                acceptType: acceptType,
                maxFileCount: maxFileCount,
                hasMaxFileIndicator: hasMaxFileIndicator,
                shouldShowFileNames: shouldShowFileNames,
                variant: variant,
                children: /*#__PURE__*/ jsx(MediaUploadBase, {
                    captionProps: captionProps,
                    errors: errors,
                    fieldProps: fieldProps,
                    ...fieldRenderProps
                })
            })
    });
});
const MediaUploadBase = (props)=>{
    const { captionProps, errors, fieldProps, ...fieldRenderProps } = props;
    const { boxProps, files, uploadedFiles, addInputRef, variant, dataTransferType, maxFileCount } = useMediaUploadContext();
    const dropRef = useRef(null);
    const { boxProps: dropProps, shouldEnableDropFromExternalSource, cardFiles } = useMediaUpload(dropRef, {
        onChange: boxProps.onChange,
        dataTransferType,
        errors,
        files,
        uploadedFiles
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs(Box, {
                ...dropProps,
                role: "grid",
                position: "relative",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "unsafe_component.mediaUpload.spacing.gap",
                children: [
                    cardFiles.map((file, index)=>file && /*#__PURE__*/ jsx(Box, {
                            gridColumn: index === 0 && variant === 'images' ? 'span 2' : 'auto',
                            role: "row",
                            children: /*#__PURE__*/ jsx(MediaViewer, {
                                fileData: file,
                                shouldEnableDropFromExternalSource: shouldEnableDropFromExternalSource
                            })
                        }, file.id)),
                    /*#__PURE__*/ jsx(DropZone, {
                        addInputRef: addInputRef,
                        fieldProps: fieldProps,
                        fieldRenderProps: fieldRenderProps,
                        onChange: boxProps.onChange,
                        shouldEnableDropFromExternalSource: shouldEnableDropFromExternalSource
                    })
                ]
            }),
            maxFileCount && maxFileCount > 0 ? /*#__PURE__*/ jsx(Indicator, {}) : null,
            /*#__PURE__*/ jsx(Caption, {
                captionProps: captionProps
            }),
            /*#__PURE__*/ jsx(ImageEdit, {})
        ]
    });
};

const DEFAULT_NUMBER_FORMAT_OPTIONS = {
    format: 'decimal'
};
const DEFAULT_MASK_FORMAT_OPTIONS = {
    mask: '',
    replacement: ''
};
const useFormattedTextField = (ref, props)=>{
    const { onChange, format: format$2, formatOptions = format$2 === 'number' ? DEFAULT_NUMBER_FORMAT_OPTIONS : DEFAULT_MASK_FORMAT_OPTIONS, value, defaultValue, ...restProps } = props;
    const locale = useLocale();
    const numberInputRef = useNumberFormat({
        locales: locale,
        ...formatOptions
    });
    const refObject = useObjectRef(ref);
    const getNumberFormattingProps = useCallback((opts)=>{
        if (refObject.current) numberInputRef.current = refObject.current;
        return {
            formattedValue: (inputValue)=>format(inputValue, opts),
            unformattedValue: (inputValue)=>unformat(inputValue, opts.locales)
        };
    }, [
        numberInputRef,
        refObject
    ]);
    const maskInputRef = useMask(formatOptions);
    const getMaskFormattingProps = useCallback((opts)=>{
        if (refObject.current) maskInputRef.current = refObject.current;
        return {
            formattedValue: (inputValue)=>format$1(inputValue, opts),
            unformattedValue: (inputValue)=>unformat$1(inputValue, opts)
        };
    }, [
        maskInputRef,
        refObject
    ]);
    const formattingProps = format$2 === 'number' ? getNumberFormattingProps({
        locales: locale,
        ...formatOptions
    }) : getMaskFormattingProps(formatOptions);
    const [computedValue, setComputedValue] = useControlledState(value, defaultValue ?? '', onChange);
    const handleChange = useCallback((inputValue)=>{
        setComputedValue(formattingProps.unformattedValue(inputValue));
    }, [
        formattingProps,
        setComputedValue
    ]);
    const { boxProps } = useTextField(refObject, {
        ...restProps,
        value: computedValue ? formattingProps.formattedValue(computedValue) : '',
        onChange: handleChange,
        type: 'text',
        inputMode: 'text'
    });
    return {
        textField: {
            ...boxProps,
            ref: refObject
        }
    };
};

const FormattedTextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { placeholder, name, onChange, onBlur, onFocus, value, defaultValue, isFullWidth, format, formatOptions, suffix, ...fieldProps } = props;
    const { textField } = useFormattedTextField(ref, props);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: textField.label,
        helperProps: textField.helper,
        errorProps: textField.error,
        ...fieldProps,
        children: /*#__PURE__*/ jsx(TextFieldBase, {
            ...props,
            inputRef: textField.ref,
            inputProps: textField.input,
            suffix: suffix
        })
    });
});

const usePaginationTranslation = ()=>useTranslation({
        'en-GB': {
            'pagination::navigation': 'navigation',
            'pagination::toPage': 'to page',
            'pagination::currentPage': 'current page, page',
            'pagination::previous': 'Previous',
            'pagination::next': 'Next',
            'pagination::previousPage': 'previous page',
            'pagination::nextPage': 'next page'
        },
        'fr-FR': {
            'pagination::navigation': 'navigation',
            'pagination::toPage': 'à la page',
            'pagination::currentPage': 'page actuelle, page',
            'pagination::previous': 'Précédent',
            'pagination::next': 'Suivant',
            'pagination::previousPage': 'page précédente',
            'pagination::nextPage': 'page suivante'
        },
        'de-DE': {
            'pagination::navigation': 'navigation',
            'pagination::toPage': 'zu seite',
            'pagination::currentPage': 'aktuelle seite, seite',
            'pagination::previous': 'Zurück',
            'pagination::next': 'Weiter',
            'pagination::previousPage': 'vorherige seite',
            'pagination::nextPage': 'nächste seite'
        },
        'nl-NL': {
            'pagination::navigation': 'navigatie',
            'pagination::toPage': 'naar pagina',
            'pagination::currentPage': 'huidige pagina, pagina',
            'pagination::previous': 'Vorige',
            'pagination::next': 'Volgende',
            'pagination::previousPage': 'vorige pagina',
            'pagination::nextPage': 'volgende pagina'
        }
    });

const NavigationButton = (props)=>{
    const { itemType, onPress, href, type } = props;
    const t = usePaginationTranslation();
    const getButtonProps = ()=>{
        switch(true){
            case itemType === 'previous':
                return {
                    icon: ChevronLeftIcon,
                    iconOnly: true,
                    children: t('pagination::previousPage'),
                    marginRight: 'unsafe_component.pagination.spacing.margin'
                };
            case itemType === 'next':
                return {
                    icon: ChevronRightIcon,
                    iconOnly: true,
                    children: t('pagination::nextPage'),
                    marginLeft: 'unsafe_component.pagination.spacing.margin'
                };
            default:
                return null;
        }
    };
    const buttonProps = {
        iconOnly: {
            'breakpoint.base': true,
            'breakpoint.md': false
        },
        type: type === 'button' ? 'button' : undefined,
        ...onPress ? {
            onPress
        } : {
            href
        },
        ...getButtonProps()
    };
    return buttonProps && /*#__PURE__*/ jsx(Button, {
        ...buttonProps,
        variant: "tertiary"
    });
};

const PageButton = (props)=>{
    const { page, currentPage, onPress, href } = props;
    const t = usePaginationTranslation();
    const isActive = page === currentPage;
    const { boxProps, isHovered, isPressed, isFocused, isLink } = useButton$1(null, {
        onPress,
        href,
        type: 'button'
    });
    const LinkComponent = useRenderLink({
        isExternal: false
    });
    const Component = isLink ? LinkComponent : Box;
    const stateProps = useMemo(()=>mapStateToBoxProps({
            isHovered,
            isPressed,
            isActive
        }), [
        isHovered,
        isPressed,
        isActive
    ]);
    return /*#__PURE__*/ jsx(Component, {
        ...boxProps,
        ...stateProps,
        color: isActive ? 'unsafe_component.pagination.color.active' : 'unsafe_component.pagination.color.inactive',
        typography: "unsafe_component.pagination.typography",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        height: "unsafe_component.pagination.sizing",
        width: "unsafe_component.pagination.sizing",
        borderRadius: "unsafe_component.pagination.radius",
        borderWidth: "unsafe_component.pagination.borderWidth.none",
        whiteSpace: "nowrap",
        cursor: "pointer",
        "aria-label": isActive ? `${t('pagination::currentPage')} ${page}` : `${t('pagination::toPage')} ${page}`,
        "aria-current": isActive ? 'page' : undefined,
        outlineStyle: isFocused ? 'solid' : 'none',
        outlineWidth: "unsafe_component.pagination.borderWidth.2",
        outlineOffset: "-unsafe_component.pagination.borderWidth.2",
        children: page
    });
};
const mapStateToBoxProps = ({ isHovered, isPressed, isActive })=>{
    const getColor = ()=>{
        switch(true){
            case isPressed && isActive:
                return `unsafe_component.pagination.color.bgPressedSelected`;
            case isHovered && isActive:
                return `unsafe_component.pagination.color.bgHoverSelected`;
            case isActive:
                return 'unsafe_component.pagination.color.bgSelected';
            case isPressed:
                return `unsafe_component.pagination.color.bgPressed`;
            case isHovered:
                return `unsafe_component.pagination.color.bgHover`;
            default:
                return `unsafe_component.pagination.color.bg`;
        }
    };
    return {
        backgroundColor: getColor()
    };
};

// adapted from material ui
// https://github.com/mui/material-ui/blob/1bbb086189fa7786a4ff7387fb78bd74905c0020/packages/mui-material/src/usePagination/usePagination.js
const getPaginationItems = (props)=>{
    const { count, currentPage, type, onChange, pageHref, boundaryCount = 1, siblingCount = 1 } = props;
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    currentPage - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 + 1), // Greater than startPages
    boundaryCount + 1);
    const siblingsEnd = Math.min(Math.max(// Natural end
    currentPage + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2), // Less than endPages
    count - boundaryCount);
    // Basic list of items to render
    // e.g. itemList = ['previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next']
    const itemList = [
        ...currentPage > 1 ? [
            'previous'
        ] : [],
        ...startPages,
        // Start ellipsis
        ...siblingsStart > boundaryCount + 1 ? [
            'ellipsis'
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        ...siblingsEnd < count - boundaryCount ? [
            'ellipsis'
        ] : [],
        ...endPages,
        ...currentPage < count ? [
            'next'
        ] : []
    ];
    const buttonPage = (type)=>{
        switch(type){
            case 'previous':
                return currentPage - 1;
            case 'next':
                return currentPage + 1;
            default:
                return -10;
        }
    };
    return itemList.map((item)=>{
        const baseItem = typeof item === 'number' ? {
            page: item,
            itemType: 'page'
        } : {
            page: buttonPage(item),
            itemType: item
        };
        return {
            currentPage,
            count,
            ...baseItem,
            ...type === 'button' && {
                type: 'button',
                onPress: ()=>onChange(baseItem.page)
            },
            ...type === 'link' && {
                href: pageHref(baseItem.page)
            }
        };
    });
};
const usePagination = (props)=>{
    return useMemo(()=>getPaginationItems(props), [
        props
    ]);
};

const Ellipsis = ()=>/*#__PURE__*/ jsx(Box, {
        height: "unsafe_component.pagination.sizing",
        width: "unsafe_component.pagination.sizing",
        typography: "unsafe_component.pagination.typography",
        display: "flex",
        alignItems: "center",
        userSelect: "none",
        children: /*#__PURE__*/ jsx(Box, {
            flexGrow: "1",
            textAlign: "center",
            children: "..."
        })
    });
const PaginationItem = (props)=>{
    const { itemType } = props;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            itemType === 'ellipsis' && /*#__PURE__*/ jsx(Ellipsis, {}),
            itemType === 'page' && /*#__PURE__*/ jsx(PageButton, {
                ...props
            }),
            (itemType === 'previous' || itemType === 'next') && props.count > 1 && /*#__PURE__*/ jsx(NavigationButton, {
                ...props
            })
        ]
    });
};
const Pagination = (props)=>{
    const { type, page: pageProp, count, sectionName, onChange: onChangeProp, pageHref, defaultPage = 1, ...rest } = props;
    const t = usePaginationTranslation();
    const [currentPage, setCurrentPage] = useState(defaultPage);
    const items = usePagination({
        count,
        currentPage: pageProp !== undefined ? pageProp : currentPage,
        type,
        onChange: (page)=>{
            if (pageProp === undefined) setCurrentPage(page);
            onChangeProp?.(page);
        },
        pageHref
    });
    return /*#__PURE__*/ jsx(Box, {
        as: "nav",
        "aria-label": `${sectionName} ${t('pagination::navigation')}`,
        ...rest,
        children: /*#__PURE__*/ jsx(Box, {
            as: "ul",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: 0,
            children: items.map((item, index)=>/*#__PURE__*/ jsx(Box, {
                    as: "li",
                    children: /*#__PURE__*/ jsx(PaginationItem, {
                        ...item
                    })
                }, index))
        })
    });
};

const ProgressBar = (props)=>{
    const { value = 0, maxValue = 100, type = 'percentage', variant = 'default', size = '8', labelPosition, 'aria-label': ariaLabel, ...externalProps } = props;
    const { progressBarProps } = useProgressBar({
        value,
        maxValue,
        'aria-label': ariaLabel,
        formatOptions: type !== 'stepper' ? {
            style: 'percent'
        } : {
            style: 'decimal'
        }
    });
    // Calculate the width of the progress bar as a percentage
    const percentage = value / maxValue * 100;
    const strPercentage = `${Math.round(percentage)}%`;
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(progressBarProps, externalProps),
        display: "flex",
        flexDirection: labelPosition === 'end' ? 'row-reverse' : undefined,
        alignItems: "center",
        gap: "spacing.8",
        width: "100%",
        children: [
            type !== 'hidden' ? /*#__PURE__*/ jsx(Box, {
                as: "span",
                color: `unsafe_component.progressBar.color.${variant}.text`,
                typography: "unsafe_component.progressBar.typography",
                overflow: [
                    'hidden',
                    'clip'
                ],
                children: type === 'stepper' ? `${value}/${maxValue}` : strPercentage
            }) : null,
            /*#__PURE__*/ jsx(Box, {
                width: "100%",
                height: `unsafe_component.progressBar.sizing.${size}`,
                borderRadius: `unsafe_component.progressBar.radius.${size}`,
                backgroundColor: `unsafe_component.progressBar.color.${variant}.bgBar`,
                children: /*#__PURE__*/ jsx(Box, {
                    width: strPercentage,
                    maxWidth: "100%",
                    height: "100%",
                    borderRadius: "inherit",
                    backgroundColor: `unsafe_component.progressBar.color.${variant}.bgProgress`
                })
            })
        ]
    });
};

const ProgressCircle = (props)=>{
    const { value = 0, maxValue = 100, type = 'percentage', variant = 'default', size = '96', 'aria-label': ariaLabel, ...externalProps } = props;
    const tokens = useTokens();
    const { progressBarProps } = useProgressBar({
        value,
        maxValue,
        'aria-label': ariaLabel,
        formatOptions: type !== 'stepper' ? {
            style: 'percent'
        } : {
            style: 'decimal'
        }
    });
    const intSize = parseInt(size, 10);
    const center = intSize / 2;
    const strokeWidth = size === '64' ? 6 : size === '96' ? 8 : 10;
    const r = intSize / 2 - strokeWidth;
    const c = 2 * r * Math.PI;
    const percentage = value / maxValue;
    const offset = c - percentage * c;
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(progressBarProps, externalProps),
        position: "relative",
        maxWidth: intSize,
        overflow: [
            'hidden',
            'clip'
        ],
        children: [
            /*#__PURE__*/ jsxs(Box, {
                as: "svg",
                width: intSize,
                height: intSize,
                viewBox: `0 0 ${size} ${size}`,
                fill: "none",
                strokeWidth: strokeWidth,
                children: [
                    /*#__PURE__*/ jsx("circle", {
                        role: "presentation",
                        cx: center,
                        cy: center,
                        r: r,
                        stroke: tokens[`unsafe_component.progressCircle.color.${variant}.bgCircle`]
                    }),
                    /*#__PURE__*/ jsx("circle", {
                        role: "presentation",
                        cx: center,
                        cy: center,
                        r: r,
                        stroke: tokens[`unsafe_component.progressCircle.color.${variant}.bgProgress`],
                        strokeDasharray: `${c} ${c}`,
                        strokeDashoffset: offset,
                        strokeLinecap: "round",
                        transform: `rotate(-90 ${intSize / 2} ${intSize / 2})`
                    })
                ]
            }),
            type !== 'hidden' ? /*#__PURE__*/ jsx(Box, {
                as: "span",
                position: "absolute",
                top: "50%",
                left: "50%",
                maxWidth: "80%",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                transform: "translate(-50%, -50%)",
                color: `unsafe_component.progressCircle.color.${variant}.text`,
                typography: `unsafe_component.progressCircle.typography.${size}`,
                overflow: [
                    'hidden',
                    'clip'
                ],
                children: type === 'stepper' ? `${value}/${maxValue}` : `${Math.round(percentage * 100)}%`
            }) : null
        ]
    });
};

const useRadioGroup = (ref, { isDisabled, label, isOptional, error, ...rest })=>{
    const objectRef = useObjectRef$1(ref);
    const labelProp = typeof label !== 'string' && label.isHidden ? 'aria-label' : 'label';
    const propsComputed = {
        ...rest,
        [labelProp]: typeof label === 'string' ? label : label.content,
        isRequired: !isOptional,
        isDisabled: Boolean(isDisabled),
        errorMessage: error,
        isInvalid: Boolean(error)
    };
    const state = useRadioGroupState(propsComputed);
    const { radioGroupProps, labelProps, descriptionProps, errorMessageProps } = useRadioGroup$1(propsComputed, state);
    return {
        boxProps: {
            group: mergeProps(radioGroupProps, {
                ref: objectRef
            }),
            label: labelProps,
            error: errorMessageProps,
            helper: descriptionProps
        },
        state
    };
};

// RadioGroup is the same as in the previous example
const RadioGroupContext = /*#__PURE__*/ createContext(null);
const useRadioGroupProvider = ()=>{
    return useContext(RadioGroupContext);
};

const useRadio = (ref, props)=>{
    const { isDisabled } = props;
    const objectRef = useObjectRef$1(ref);
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocusVisible } = useFocusable(objectRef, {
        unsafe_ignoreProviderProps: true
    });
    const groupContext = useRadioGroupProvider();
    const { inputProps, labelProps, isSelected, isPressed, isDisabled: isDisabledReactAria } = useRadio$1({
        ...props,
        isDisabled: Boolean(isDisabled)
    }, groupContext?.state, objectRef);
    return {
        boxProps: {
            input: mergeProps(focusProps, inputProps),
            radio: mergeProps(hoverProps, labelProps)
        },
        direction: groupContext?.direction,
        isPressed,
        isHovered,
        isFocused: isFocusVisible,
        isSelected,
        isDisabled: isDisabledReactAria
    };
};

/**
 * Internal implementation of Radio (style component)
 */ const Radio = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, hasBorder = false, ...restProps } = props;
    const { boxProps: { radio: radioBoxProps, input: inputBoxProps }, isPressed, isHovered, isFocused, isSelected, isDisabled } = useRadio(ref, props);
    const cardBorderStyle = useMemo(()=>mapCardBorderProp({
            isPressed,
            isHovered,
            isSelected,
            isDisabled,
            hasBorder,
            hasError: restProps.hasError
        }), [
        isPressed,
        isHovered,
        isSelected,
        isDisabled,
        hasBorder,
        restProps.hasError
    ]);
    return /*#__PURE__*/ jsx(Box, {
        display: "inline-flex",
        flexDirection: "column",
        children: /*#__PURE__*/ jsxs(Box, {
            ...mergeProps(radioBoxProps, cardBorderStyle),
            as: "label",
            display: "flex",
            alignItems: "flex-start",
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            typography: "unsafe_component.radio.typography.default",
            color: `unsafe_component.radio.color.label${isDisabled ? 'Disabled' : ''}`,
            paddingVertical: "unsafe_component.radio.spacing.padding.vertical",
            height: "100%",
            children: [
                /*#__PURE__*/ jsx(VisuallyHidden, {
                    elementType: "span",
                    children: /*#__PURE__*/ jsx(Box, {
                        ...inputBoxProps,
                        as: "input",
                        ref: ref
                    })
                }),
                /*#__PURE__*/ jsx(RadioTick, {
                    ...restProps,
                    isDisabled: isDisabled,
                    isPressed: isPressed,
                    isHovered: isHovered,
                    isFocused: isFocused,
                    isSelected: isSelected,
                    marginRight: "unsafe_component.radio.spacing.gap"
                }),
                children
            ]
        })
    });
});
const RadioTick = ({ isHovered, isPressed, isFocused, isSelected, isDisabled, hasError, ...restProps })=>{
    const tokens = useTokens();
    const stateProps = useMemo(()=>mapRadioStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isSelected,
            isInError: hasError
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isSelected,
        hasError
    ]);
    const contentStateProps = useMemo(()=>mapRadioStateToContentBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isInError: hasError
        }), [
        isDisabled,
        isHovered,
        isPressed,
        hasError
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        as: "span",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "unsafe_component.radio.sizing.radioButtonWrapper",
        height: "unsafe_component.radio.sizing.radioButtonWrapper",
        flexShrink: 0,
        children: /*#__PURE__*/ jsx(Box, {
            as: "span",
            ...stateProps,
            width: "unsafe_component.radio.sizing.radioButton",
            height: "unsafe_component.radio.sizing.radioButton",
            backgroundColor: "unsafe_component.radio.color.bg",
            borderStyle: "solid",
            borderRadius: "unsafe_component.radio.radius.tick",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            transitionDuration: "unsafe_component.radio.motionDuration",
            transitionProperty: "background-color",
            transitionTimingFunction: "unsafe_component.radio.motionEasing",
            flexShrink: 0,
            outlineWidth: "borderWidth.2",
            outlineStyle: isFocused ? 'auto' : 'none',
            outlineColor: [
                'Highlight',
                '-webkit-focus-ring-color'
            ],
            padding: `calc(${tokens['unsafe_component.radio.spacing.padding.radioButton']} - ${tokens[stateProps.borderWidth]})`,
            transform: "perspective(1px)",
            children: /*#__PURE__*/ jsx(Box, {
                as: "span",
                ...contentStateProps,
                borderRadius: "unsafe_component.radio.radius.tick",
                height: "99%",
                width: "99%",
                transform: isSelected ? 'scale(1)' : 'scale(0)',
                transitionDuration: "unsafe_component.radio.motionDuration",
                transitionProperty: "transform",
                transitionTimingFunction: "unsafe_component.radio.motionEasing"
            })
        })
    });
};
const mapRadioStateToBoxProps = ({ isSelected, isDisabled, isHovered, isPressed, isInError })=>{
    const getBorderColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.radio.color.borderDisabled`;
            case isInError && isPressed:
                return `unsafe_component.radio.color.borderErrorPressed`;
            case isInError && isHovered:
                return `unsafe_component.radio.color.borderErrorHover`;
            case isPressed:
                return `unsafe_component.radio.color.borderPressed`;
            case isHovered:
                return `unsafe_component.radio.color.borderHover`;
            case isInError:
                return `unsafe_component.radio.color.borderError`;
            case isSelected:
                return `unsafe_component.radio.color.borderSelected`;
            default:
                return `unsafe_component.radio.color.border`;
        }
    };
    return {
        borderColor: getBorderColor(),
        borderWidth: isInError ? 'unsafe_component.radio.borderWidth.error' : 'unsafe_component.radio.borderWidth.default'
    };
};
const mapRadioStateToContentBoxProps = ({ isDisabled, isHovered, isPressed, isInError })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.radio.color.dotDisabled`;
            case isInError && isPressed:
                return `unsafe_component.radio.color.dotErrorPressed`;
            case isInError && isHovered:
                return `unsafe_component.radio.color.dotErrorHover`;
            case isPressed:
                return `unsafe_component.radio.color.dotPressed`;
            case isHovered:
                return `unsafe_component.radio.color.dotHover`;
            case isInError:
                return `unsafe_component.radio.color.dotError`;
            default:
                return `unsafe_component.radio.color.dot`;
        }
    };
    return {
        backgroundColor: getBackgroundColor()
    };
};
const mapCardBorderProp = ({ hasBorder, isSelected, isDisabled, isHovered, isPressed, hasError })=>{
    if (!hasBorder) {
        return undefined;
    }
    const getBorderColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.radio.color.borderDisabled`;
            case hasError && isPressed:
                return `unsafe_component.radio.color.borderErrorPressed`;
            case hasError && isHovered:
                return `unsafe_component.radio.color.borderErrorHover`;
            case isPressed:
                return `unsafe_component.radio.color.borderPressed`;
            case isHovered:
                return `unsafe_component.radio.color.borderHover`;
            case hasError:
                return `unsafe_component.radio.color.borderError`;
            case isSelected:
                return `unsafe_component.radio.color.borderSelected`;
            default:
                return `unsafe_component.radio.color.borderDisabled`;
        }
    };
    return {
        borderColor: getBorderColor(),
        borderRadius: 'unsafe_component.radio.radius.card',
        borderStyle: 'solid',
        borderWidth: 'unsafe_component.radio.borderWidth.default',
        paddingHorizontal: 'unsafe_component.radio.spacing.padding.horizontal'
    };
};

const RadioGroup = /*#__PURE__*/ forwardRef(function RadioGroup(props, ref) {
    const { direction = 'vertical', hasTwoColumns = false, name, onChange, value, defaultValue, items, hasBorder = false, onBlur, onFocus, ...fieldProps } = props;
    const { boxProps, state } = useRadioGroup(ref, props);
    const responsiveFlexDirection = useMemo(()=>mapFlexDirectionProp({
            direction
        }), [
        direction
    ]);
    const responsiveFlexWrap = useMemo(()=>mapFlexWrapProp({
            direction
        }), [
        direction
    ]);
    return /*#__PURE__*/ jsx(FieldBase, {
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        disableMargin: true,
        children: /*#__PURE__*/ jsx(RadioGroupContext.Provider, {
            value: {
                state,
                direction
            },
            children: /*#__PURE__*/ jsx(Box, {
                ...boxProps.group,
                ref: boxProps.group.ref,
                display: hasTwoColumns ? 'grid' : 'flex',
                flexDirection: !hasTwoColumns ? responsiveFlexDirection : 'column',
                flexWrap: !hasTwoColumns ? responsiveFlexWrap : undefined,
                gridTemplateColumns: hasTwoColumns ? 'repeat(2, 1fr)' : undefined,
                // Grid gap
                columnGap: direction !== 'vertical' || hasTwoColumns ? 'unsafe_component.radioGroup.spacing.gap' : undefined,
                rowGap: hasBorder ? 'unsafe_component.radioGroup.spacing.gap' : undefined,
                marginTop: hasBorder ? 'unsafe_component.radioGroup.spacing.margin' : undefined,
                marginBottom: hasBorder && fieldProps.error ? 'unsafe_component.radioGroup.spacing.margin' : undefined,
                children: props.items.map(({ label, value, isDisabled })=>/*#__PURE__*/ jsx(Radio, {
                        name: props.name,
                        value: value,
                        isDisabled: Boolean(fieldProps.isDisabled) || Boolean(isDisabled),
                        hasError: Boolean(fieldProps.error),
                        hasBorder: hasBorder,
                        children: label
                    }, value))
            })
        })
    });
});
const mapFlexDirectionProp = ({ direction })=>{
    if (typeof direction === 'object') {
        return Object.entries(direction).reduce((acc, [breakpoint, direction])=>{
            return {
                ...acc,
                [breakpoint]: direction === 'vertical' ? 'column' : 'row'
            };
        }, {});
    }
    if (direction === 'vertical') {
        return 'column';
    }
    return 'row';
};
const mapFlexWrapProp = ({ direction })=>{
    if (typeof direction === 'object') {
        return Object.entries(direction).reduce((acc, [breakpoint, direction])=>{
            return {
                ...acc,
                [breakpoint]: direction === 'vertical' ? 'nowrap' : 'wrap'
            };
        }, {});
    }
    if (direction === 'vertical') {
        return 'nowrap';
    }
    return 'wrap';
};

const useRatingTranslation = ()=>useTranslation({
        'en-GB': {
            'rating::reviews_zero': 'reviews',
            'rating::reviews_one': 'review',
            'rating::reviews_other': 'reviews',
            'rating::description::rating_zero': 'Rating: 0 out of 5 stars',
            'rating::description::rating_one': 'Rating: :stars: out of 5 stars',
            'rating::description::rating_other': 'Rating: :stars: out of 5 stars',
            'rating::description::reviews_zero': ' from 0 reviews',
            'rating::description::reviews_one': ' from one review',
            'rating::description::reviews_other': ' from :reviews: reviews'
        },
        'fr-FR': {
            'rating::reviews_zero': 'avis',
            'rating::reviews_one': 'avis',
            'rating::reviews_other': 'avis',
            'rating::description::rating_zero': 'Note : 0 étoile sur 5',
            'rating::description::rating_one': 'Note : :stars: étoile sur 5',
            'rating::description::rating_other': 'Note : :stars: étoiles sur 5',
            'rating::description::reviews_zero': ' sur 0 avis',
            'rating::description::reviews_one': ' sur un avis',
            'rating::description::reviews_other': ' sur :reviews: avis'
        },
        'de-DE': {
            'rating::reviews_zero': 'Bewertungen',
            'rating::reviews_one': 'Bewertung',
            'rating::reviews_other': 'Bewertungen',
            'rating::description::rating_zero': 'Bewertung: 0 von 5 Sternen aus 0 Bewertungen',
            'rating::description::rating_one': 'Bewertung: :stars: von 5 Sternen aus einer Bewertung',
            'rating::description::rating_other': 'Bewertung: :stars: von 5 Sternen',
            'rating::description::reviews_zero': ' aus 0 Bewertungen',
            'rating::description::reviews_one': ' aus einer Bewertung',
            'rating::description::reviews_other': ' aus :reviews: Bewertungen'
        },
        'nl-NL': {
            'rating::reviews_zero': 'klantenreviews',
            'rating::reviews_one': 'klantenreview',
            'rating::reviews_other': 'klantenreviews',
            'rating::description::rating_zero': 'Beoordeling: 0 van de 5 sterren',
            'rating::description::rating_one': 'Beoordeling: :stars: van de 5 sterren',
            'rating::description::rating_other': 'Beoordeling: :stars: van de 5 sterren',
            'rating::description::reviews_zero': ' uit 0 beoordelingen',
            'rating::description::reviews_one': ' uit één beoordeling',
            'rating::description::reviews_other': ' uit :reviews: beoordelingen'
        }
    });

const THRESHOLD_TO_INTEGER = 0.2;
const THRESHOLD_TO_FLOAT = 0.3;
const useRating = ({ rating })=>{
    const fullStars = Math.floor(rating + THRESHOLD_TO_INTEGER);
    // substraction on float rating can generate unwanted long float, so I mostly use addition
    const hasHalfStar = rating >= fullStars + THRESHOLD_TO_FLOAT && rating < fullStars + 0.5 + THRESHOLD_TO_FLOAT;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    return {
        fullStars,
        hasHalfStar,
        emptyStars
    };
};

const Rating = ({ reviews, rating = 5, variant = 'default', hasRatingDisplayed = true, hasFullRating = true, size = '24', ...restProps })=>{
    const { fullStars, hasHalfStar, emptyStars } = useRating({
        rating
    });
    const locale = useLocale();
    const ratingFormatter = new Intl.NumberFormat(locale, {
        maximumFractionDigits: 1
    });
    const reviewsFormatter = new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short'
    });
    const pluralFormatter = new Intl.PluralRules(locale);
    const t = useRatingTranslation();
    const pluralReviews = pluralFormatter.select(reviews || 0);
    const pluralRating = pluralFormatter.select(rating);
    const reviewsLabel = new Map([
        [
            'zero',
            t('rating::reviews_zero')
        ],
        [
            'one',
            t('rating::reviews_one')
        ],
        [
            'other',
            t('rating::reviews_other')
        ]
    ]);
    const descriptionRatingLabel = new Map([
        [
            'zero',
            t('rating::description::rating_zero')
        ],
        [
            'one',
            t('rating::description::rating_one')
        ],
        [
            'other',
            t('rating::description::rating_other')
        ]
    ]);
    const descriptionReviewsLabel = new Map([
        [
            'zero',
            t('rating::description::reviews_zero')
        ],
        [
            'one',
            t('rating::description::reviews_one')
        ],
        [
            'other',
            t('rating::description::reviews_other')
        ]
    ]);
    const descriptionLabel = `${(descriptionRatingLabel.get(pluralRating) || descriptionRatingLabel.get('other') || '')?.replace(':stars:', ratingFormatter.format(rating))}${reviews !== undefined ? (descriptionReviewsLabel.get(pluralReviews) || descriptionReviewsLabel.get('other') || '')?.replace(':reviews:', reviews?.toString() || '') : ''}`;
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        color: "unsafe_component.rating.color.starIcon",
        display: "inline-flex",
        alignItems: "center",
        children: [
            variant === 'condensed' ? /*#__PURE__*/ jsx(StarFilledIcon, {
                size: `sizing.${size}`
            }) : /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    [
                        ...Array(fullStars)
                    ].map((_, index)=>/*#__PURE__*/ jsx(StarFilledIcon, {
                            size: `sizing.${size}`
                        }, index)),
                    hasHalfStar ? /*#__PURE__*/ jsx(StarHalfFilledIcon, {
                        size: `sizing.${size}`
                    }) : null,
                    [
                        ...Array(emptyStars)
                    ].map((_, index)=>/*#__PURE__*/ jsx(StarIcon, {
                            size: `sizing.${size}`
                        }, index))
                ]
            }),
            hasRatingDisplayed ? /*#__PURE__*/ jsxs(Box, {
                as: "span",
                typography: `unsafe_component.rating.typography.ratingText.${size}`,
                color: "unsafe_component.rating.color.ratingText",
                paddingHorizontal: "unsafe_component.rating.spacing.padding",
                "aria-hidden": "true",
                children: [
                    ratingFormatter.format(rating),
                    hasRatingDisplayed && hasFullRating && '/5'
                ]
            }) : null,
            reviews !== undefined && /*#__PURE__*/ jsx(Box, {
                as: "span",
                typography: `unsafe_component.rating.typography.reviews.${size}`,
                color: "unsafe_component.rating.color.ratingText",
                "aria-hidden": "true",
                children: `(${reviewsFormatter.format(reviews)} ${reviewsLabel.get(pluralReviews) || reviewsLabel.get('other')})`
            }),
            /*#__PURE__*/ jsx(Box, {
                as: "span",
                srOnly: true,
                children: descriptionLabel
            })
        ]
    });
};

const BUTTON_ARROW_WIDTH$1 = 40;
const ITEM_PADDING = 16;
const CONTAINER_PADDING = 4;
const useSegmentedControl = (ref, props)=>{
    const { items, value, defaultValue = items[0]?.id, onChange, 'aria-label': ariaLabel, name } = props;
    const firstElement = useRef(null);
    const lastElement = useRef(null);
    const selectedElement = useObjectRef$1(null);
    const firstElementLabel = useRef(null);
    const lastElementLabel = useRef(null);
    const selectedElementLabel = useObjectRef$1(null);
    // Track whether the component has been interacted with to prevent initial motion
    const [hasInteracted, setHasInteracted] = useState(false);
    const handleChange = useCallback((selectedValue)=>{
        setHasInteracted(true);
        if (onChange) onChange(selectedValue);
    }, [
        onChange
    ]);
    const radioGroupProps = {
        value: value,
        defaultValue: defaultValue,
        onChange: handleChange,
        name,
        label: {
            content: ariaLabel,
            isHidden: true
        }
    };
    const { boxProps: radioGroupBoxProps, state } = useRadioGroup(ref, radioGroupProps);
    const refObject = useObjectRef$1(ref);
    const { shouldDisplayLeftArrow, shouldDisplayRightArrow, boxProps: indicator } = useHorizontalScroll({
        scrollContainer: refObject,
        selectedElement: selectedElementLabel,
        firstElement: firstElementLabel,
        lastElement: lastElementLabel
    });
    // Scrolls the selected item into view when mounted or on press
    // without scrolling the whole page
    useEffect(()=>{
        if (refObject.current && selectedElementLabel.current) {
            const segmentedControl = refObject.current;
            const selectedItem = selectedElementLabel.current;
            const itemLeft = selectedItem.offsetLeft;
            const itemRight = itemLeft + selectedItem.offsetWidth;
            const scrollLeft = segmentedControl.scrollLeft;
            const scrollRight = scrollLeft + segmentedControl.clientWidth;
            const isVisibleLeft = itemLeft >= scrollLeft + BUTTON_ARROW_WIDTH$1 + CONTAINER_PADDING + ITEM_PADDING;
            const isVisibleRight = itemRight <= scrollRight - BUTTON_ARROW_WIDTH$1 - CONTAINER_PADDING - ITEM_PADDING;
            const isItemFullyVisible = isVisibleLeft && isVisibleRight;
            if (isItemFullyVisible) return;
            if (!isVisibleLeft) {
                requestAnimationFrame(()=>{
                    segmentedControl.scrollTo({
                        left: itemLeft - BUTTON_ARROW_WIDTH$1 - ITEM_PADDING
                    });
                });
            } else if (!isVisibleRight) {
                requestAnimationFrame(()=>{
                    segmentedControl.scrollTo({
                        left: itemLeft + selectedItem.clientWidth - segmentedControl.clientWidth + BUTTON_ARROW_WIDTH$1 + ITEM_PADDING
                    });
                });
            }
        }
    }, [
        state.selectedValue,
        refObject,
        selectedElementLabel
    ]);
    return {
        boxProps: {
            group: mergeProps(radioGroupBoxProps.group, {
                ref: refObject
            }),
            indicator,
            firstItem: {
                ref: firstElement,
                labelRef: firstElementLabel
            },
            lastItem: {
                ref: lastElement,
                labelRef: lastElementLabel
            },
            selectedItem: {
                ref: selectedElement,
                labelRef: selectedElementLabel
            }
        },
        state,
        shouldDisplayLeftArrow,
        shouldDisplayRightArrow,
        scrollContainerRef: refObject,
        hasInteracted
    };
};

const SegmentedControlItem = /*#__PURE__*/ forwardRef(({ item, iconOnly, layoutWidth, name, labelRef }, ref)=>{
    const { boxProps, isPressed, isSelected, isDisabled, isHovered, isFocused } = useRadio(ref, {
        value: item.id,
        children: item.label,
        name,
        isDisabled: item.isDisabled,
        hasError: false
    });
    const Icon = isSelected ? item.iconActive : item.icon;
    const backgroundColor = useMemo(()=>{
        switch(true){
            case isDisabled:
                return 'color.surface.light.default';
            case isSelected:
                return 'color.surface.transparent.default';
            case isPressed:
                return 'color.surface.interactive.pressed';
            case isHovered:
                return 'color.surface.interactive.hover';
            default:
                return 'color.surface.transparent.default';
        }
    }, [
        isDisabled,
        isSelected,
        isPressed,
        isHovered
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...boxProps.radio,
        ref: labelRef,
        "aria-label": iconOnly ? item.label : undefined,
        as: "label",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "spacing.8",
        flex: layoutWidth === 'fill' ? '1 0 auto' : undefined,
        height: 40,
        paddingHorizontal: "spacing.16",
        paddingVertical: "spacing.none",
        borderRadius: "radius.rounded",
        borderStyle: "none",
        outlineWidth: "borderWidth.2",
        outlineStyle: isFocused ? 'solid' : 'none',
        outlineColor: [
            'Highlight',
            '-webkit-focus-ring-color'
        ],
        outlineOffset: "-borderWidth.2",
        typography: "typography.body.14.regular",
        backgroundColor: backgroundColor,
        color: isSelected ? 'color.content.default.inverted.default' : isDisabled ? 'color.content.disabled' : 'color.content.default.default',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        transitionDuration: "motionDuration.150",
        transitionProperty: "background-color, color",
        transitionTimingFunction: "motionEasing.linear",
        children: [
            /*#__PURE__*/ jsx(VisuallyHidden, {
                elementType: "span",
                children: /*#__PURE__*/ jsx(Box, {
                    ...boxProps.input,
                    ref: ref,
                    as: "input"
                })
            }),
            Icon ? /*#__PURE__*/ jsx(Box, {
                as: "span",
                "aria-hidden": "true",
                children: /*#__PURE__*/ jsx(Icon, {
                    size: "sizing.20"
                })
            }) : null,
            !iconOnly ? /*#__PURE__*/ jsx(Box, {
                as: "span",
                children: item.label
            }) : null,
            item.badgeProps?.label && item.badgeProps?.children ? /*#__PURE__*/ jsx(Badge, {
                ...item.badgeProps,
                isDisabled: isDisabled,
                variant: isSelected ? 'primary-inverted' : 'primary',
                size: "16",
                children: item.badgeProps.children
            }) : null
        ]
    });
});

const useSegmentedControlTranslation = ()=>useTranslation({
        'en-GB': {
            'aria::label::scrollLeft': 'Scroll to the left',
            'aria::label::scrollRight': 'Scroll to the right'
        },
        'fr-FR': {
            'aria::label::scrollLeft': 'Faire défiler vers la gauche',
            'aria::label::scrollRight': 'Faire défiler vers la droite'
        },
        'de-DE': {
            'aria::label::scrollLeft': 'Nach links scrollen',
            'aria::label::scrollRight': 'Nach rechts scrollen'
        },
        'nl-NL': {
            'aria::label::scrollLeft': 'Naar links scrollen',
            'aria::label::scrollRight': 'Naar rechts scrollen'
        }
    });

const useScrollButton$1 = ({ buttonRef, scrollContainerRef })=>{
    const horizontalScroll = useCallback((scrollTo)=>{
        const segmentedControlCurrent = scrollContainerRef.current;
        const current = buttonRef.current;
        if (!segmentedControlCurrent || !segmentedControlCurrent.scrollTo || !current) return;
        if (scrollTo === 'left') {
            segmentedControlCurrent.scrollTo({
                left: segmentedControlCurrent.scrollLeft - segmentedControlCurrent.clientWidth / 2,
                behavior: 'smooth'
            });
        } else if (scrollTo === 'right') {
            segmentedControlCurrent.scrollTo({
                left: segmentedControlCurrent.scrollLeft + segmentedControlCurrent.clientWidth / 2,
                behavior: 'smooth'
            });
        }
    }, [
        scrollContainerRef,
        buttonRef
    ]);
    return {
        horizontalScroll
    };
};

const ScrollButton$1 = ({ icon: Icon, direction, shouldDisplay, scrollContainerRef })=>{
    const t = useSegmentedControlTranslation();
    const tokens = useTokens();
    const ref = useRef(null);
    const { horizontalScroll } = useScrollButton$1({
        buttonRef: ref,
        scrollContainerRef
    });
    if (!shouldDisplay) return null;
    return /*#__PURE__*/ jsx(Box, {
        position: "absolute",
        zIndex: "zIndex.1",
        left: direction === 'left' ? 0 : 'auto',
        right: direction === 'right' ? 0 : 'auto',
        height: "100%",
        display: "flex",
        alignItems: "center",
        paddingLeft: direction === 'left' ? `calc(${tokens['spacing.6']} - ${tokens['borderWidth.1']})` : undefined,
        paddingRight: direction === 'right' ? `calc(${tokens['spacing.6']} - ${tokens['borderWidth.1']})` : undefined,
        children: /*#__PURE__*/ jsx(Button, {
            ref: ref,
            variant: "secondary-floating",
            icon: Icon,
            iconOnly: true,
            onPress: ()=>horizontalScroll(direction),
            size: "40",
            children: t(`aria::label::scroll${direction === 'left' ? 'Left' : 'Right'}`)
        })
    });
};

const SegmentedControl = /*#__PURE__*/ forwardRef(function SegmentedControl(props, ref) {
    const { items, value, defaultValue, onChange, layoutWidth = 'fill', iconOnly = false, name, ...restProps } = props;
    const { boxProps, state, shouldDisplayLeftArrow, shouldDisplayRightArrow, scrollContainerRef, hasInteracted } = useSegmentedControl(ref, props);
    return /*#__PURE__*/ jsxs(Box, {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        width: layoutWidth === 'hug' ? 'fit-content' : '100%',
        borderRadius: "radius.rounded",
        borderStyle: "solid",
        borderWidth: "borderWidth.1",
        borderColor: "color.border.subdued.default",
        backgroundColor: "color.surface.default.default",
        children: [
            /*#__PURE__*/ jsx(ScrollButton$1, {
                icon: ChevronLeftIcon,
                shouldDisplay: shouldDisplayLeftArrow,
                direction: "left",
                scrollContainerRef: scrollContainerRef
            }),
            /*#__PURE__*/ jsxs(Box, {
                ...mergeProps(boxProps.group, restProps),
                position: "relative",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "spacing.8",
                width: layoutWidth === 'hug' ? 'fit-content' : '100%',
                maxWidth: "100%",
                padding: "spacing.4",
                borderRadius: "radius.rounded",
                overflow: "auto",
                scrollbarWidth: "none",
                scrollbarDisplay: "none",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        ...boxProps.indicator,
                        role: "presentation",
                        position: "absolute",
                        top: "50%",
                        height: 40,
                        borderRadius: "radius.rounded",
                        backgroundColor: "color.surface.interactive.selected.default",
                        transform: "translateY(-50%)",
                        ...hasInteracted && {
                            transitionDuration: 'motionDuration.300',
                            transitionProperty: 'width, left',
                            transitionTimingFunction: 'motionEasing.ease'
                        }
                    }),
                    /*#__PURE__*/ jsx(RadioGroupContext.Provider, {
                        value: {
                            state,
                            direction: 'horizontal'
                        },
                        children: items.map((item, idx)=>{
                            const { firstItem, lastItem, selectedItem } = boxProps;
                            const isSelected = state.selectedValue === item.id;
                            const itemRefs = {
                                ref: mergeRefs(idx === 0 ? firstItem.ref : null, idx === items.length - 1 ? lastItem.ref : null, isSelected ? selectedItem.ref : null)
                            };
                            const labelRefs = {
                                labelRef: mergeRefs(idx === 0 ? firstItem.labelRef : null, idx === items.length - 1 ? lastItem.labelRef : null, isSelected ? selectedItem.labelRef : null)
                            };
                            return /*#__PURE__*/ createElement(SegmentedControlItem, {
                                ...itemRefs,
                                ...labelRefs,
                                key: item.id,
                                item: item,
                                iconOnly: iconOnly,
                                layoutWidth: layoutWidth,
                                name: name
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx(ScrollButton$1, {
                icon: ChevronRightIcon,
                shouldDisplay: shouldDisplayRightArrow,
                direction: "right",
                scrollContainerRef: scrollContainerRef
            })
        ]
    });
});

const SelectCardBase = /*#__PURE__*/ forwardRef(// eslint-disable-next-line sonarjs/cognitive-complexity
(props, ref)=>{
    const { isSelected, isPressed, isDisabled, isHovered, isFocused, image, label, description, inputProps, labelProps, type, children, error, isFullWidth = false, cardsPerRow, contentDirection = 'vertical' } = props;
    const Icon = image;
    const tokens = useTokens();
    const getPadding = (direction)=>{
        return `calc(${tokens[`unsafe_component.selectCardGroup.spacing.padding.${direction}`]} - ${tokens[`unsafe_component.selectCardGroup.borderWidth.${isSelected ? 'selected' : 'standard'}`]})`;
    };
    const stateProps = useMemo(()=>mapSelectCardStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isSelected,
            hasError: Boolean(error)
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isSelected,
        error
    ]);
    const selectCardWidth = useMemo(()=>mapSelectCardWidthProps({
            isFullWidth,
            cardsPerRow
        }), [
        isFullWidth,
        cardsPerRow
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...mergeProps(labelProps, stateProps),
        as: "label",
        display: "inline-flex",
        flexDirection: contentDirection === 'horizontal' ? 'row' : 'column',
        justifyContent: "flexStart",
        alignItems: "center",
        position: "relative",
        paddingHorizontal: getPadding('horizontal'),
        paddingVertical: getPadding('vertical'),
        borderWidth: `unsafe_component.selectCardGroup.borderWidth.${isSelected ? 'selected' : 'standard'}`,
        borderStyle: "solid",
        borderRadius: "unsafe_component.selectCardGroup.radius.card",
        outlineWidth: "borderWidth.2",
        outlineStyle: isFocused ? 'solid' : 'none',
        outlineColor: [
            'Highlight',
            '-webkit-focus-ring-color'
        ],
        outlineOffset: "-borderWidth.2",
        margin: "unsafe_component.selectCardGroup.spacing.gap.card",
        ...selectCardWidth,
        textAlign: "center",
        children: [
            /*#__PURE__*/ jsx(VisuallyHidden, {
                children: /*#__PURE__*/ jsx(Box, {
                    ...inputProps,
                    as: "input",
                    type: type,
                    ref: ref
                })
            }),
            type === 'checkbox' ? /*#__PURE__*/ jsx(CheckboxTick, {
                isHovered: isHovered,
                isFocused: isFocused,
                isPressed: isPressed,
                isSelected: isSelected,
                isDisabled: Boolean(isDisabled),
                error: error,
                position: "absolute",
                top: contentDirection === 'horizontal' ? 'auto' : 'unsafe_component.selectCardGroup.spacing.gap.tick',
                right: 'unsafe_component.selectCardGroup.spacing.gap.tick',
                marginLeft: contentDirection === 'horizontal' ? 'auto' : '0'
            }) : null,
            children,
            typeof image === 'string' ? /*#__PURE__*/ jsx(Box, {
                as: "img",
                src: image,
                alt: label,
                height: "unsafe_component.selectCardGroup.sizing.image",
                width: "unsafe_component.selectCardGroup.sizing.image",
                marginBottom: contentDirection === 'horizontal' ? '0' : 'unsafe_component.selectCardGroup.spacing.gap.image',
                marginRight: contentDirection === 'horizontal' ? 'unsafe_component.selectCardGroup.spacing.gap.image' : '0',
                objectFit: "cover",
                borderRadius: "unsafe_component.selectCardGroup.radius.image"
            }) : null,
            typeof image !== 'string' && Icon !== undefined ? /*#__PURE__*/ jsx(Icon, {
                size: "sizing.24",
                marginBottom: contentDirection === 'horizontal' ? '0' : 'unsafe_component.selectCardGroup.spacing.gap.image',
                marginRight: contentDirection === 'horizontal' ? 'unsafe_component.selectCardGroup.spacing.gap.image' : '0',
                color: isDisabled ? 'unsafe_component.selectCardGroup.color.disabled' : 'unsafe_component.selectCardGroup.color.icon'
            }) : null,
            /*#__PURE__*/ jsxs(Box, {
                as: "span",
                display: "flex",
                flexDirection: "column",
                alignItems: contentDirection === 'horizontal' ? 'flex-start' : 'center',
                marginRight: contentDirection === 'horizontal' ? 'unsafe_component.selectCardGroup.spacing.padding.vertical' : '0',
                textAlign: contentDirection === 'horizontal' ? 'left' : 'center',
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        typography: "unsafe_component.selectCardGroup.typography.label",
                        color: isDisabled ? 'unsafe_component.selectCardGroup.color.disabled' : 'unsafe_component.selectCardGroup.color.label',
                        children: label
                    }),
                    description ? /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        marginTop: contentDirection === 'horizontal' ? '0' : 'unsafe_component.selectCardGroup.spacing.gap.description',
                        typography: "unsafe_component.selectCardGroup.typography.description",
                        color: isDisabled ? 'unsafe_component.selectCardGroup.color.disabled' : 'unsafe_component.selectCardGroup.color.description',
                        children: description
                    }) : null
                ]
            })
        ]
    });
});
const mapSelectCardWidthProps = ({ isFullWidth, cardsPerRow })=>{
    const getMinWidth = ()=>{
        // if we don't have full width i.E. undefined / false return min width of the container
        if (!isFullWidth) {
            return 'unsafe_component.selectCardGroup.sizing.minWidth';
        }
        // if the prop is not an responsive object return undefined directly
        if (typeof isFullWidth === 'boolean') {
            return undefined;
        }
        return Object.entries(isFullWidth).reduce((acc, [breakpoint, isFullWidth])=>{
            return {
                ...acc,
                // apply undefined for full width or default min width of the container
                [breakpoint]: isFullWidth ? undefined : 'unsafe_component.selectCardGroup.sizing.minWidth'
            };
        }, {});
    };
    const getWidth = ()=>{
        // if we don't have full width i.E. undefined / false return max-content width of the container
        if (!isFullWidth) {
            return 'max-content';
        }
        // if the prop is not an responsive object return 100% directly, or undefined when number of cards is defined per row
        if (typeof isFullWidth === 'boolean') {
            return cardsPerRow !== undefined ? undefined : '100%';
        }
        return Object.entries(isFullWidth).reduce((acc, [breakpoint, isFullWidth])=>{
            return {
                ...acc,
                // apply 100% for full width when number of cards is defined per row, undefined for full width only, or max-content width of the container
                [breakpoint]: isFullWidth ? cardsPerRow !== undefined ? undefined : '100%' : 'max-content'
            };
        }, {});
    };
    return {
        minWidth: getMinWidth(),
        width: getWidth()
    };
};
const mapSelectCardStateToBoxProps = ({ isDisabled, isHovered, isPressed, isSelected, hasError })=>{
    const getBorderColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.selectCardGroup.color.borderDisabled`;
            case isPressed && hasError:
                return `unsafe_component.selectCardGroup.color.borderErrorPressed`;
            case isHovered && hasError:
                return `unsafe_component.selectCardGroup.color.borderErrorHover`;
            case hasError:
                return `unsafe_component.selectCardGroup.color.borderError`;
            case isPressed:
                return `unsafe_component.selectCardGroup.color.borderPressed`;
            case isHovered:
                return `unsafe_component.selectCardGroup.color.borderHover`;
            case isSelected:
                return `unsafe_component.selectCardGroup.color.borderSelected`;
            default:
                return `unsafe_component.selectCardGroup.color.border`;
        }
    };
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled && isSelected:
                return `unsafe_component.selectCardGroup.color.bgSelectedDisabled`;
            case hasError && isSelected && isPressed:
                return `unsafe_component.selectCardGroup.color.bgSelectedErrorPressed`;
            case hasError && isSelected && isHovered:
                return `unsafe_component.selectCardGroup.color.bgSelectedErrorHover`;
            case hasError && isSelected:
                return `unsafe_component.selectCardGroup.color.bgSelectedError`;
            case isPressed && isSelected:
                return `unsafe_component.selectCardGroup.color.bgSelectedPress`;
            case isHovered && isSelected:
                return `unsafe_component.selectCardGroup.color.bgSelectedHover`;
            case isSelected:
                return `unsafe_component.selectCardGroup.color.bgSelected`;
            default:
                return `unsafe_component.selectCardGroup.color.bg`;
        }
    };
    return {
        borderColor: getBorderColor(),
        backgroundColor: getBackgroundColor(),
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    };
};

const CheckboxSelectCard = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { boxProps, isSelected, isPressed, isFocused, isHovered, isDisabled } = useCheckboxInGroup(ref, {
        ...props,
        children: props.label
    });
    return /*#__PURE__*/ jsx(SelectCardBase, {
        ...props,
        type: "checkbox",
        isSelected: isSelected,
        isPressed: isPressed,
        isFocused: isFocused,
        isHovered: isHovered,
        isDisabled: isDisabled,
        inputProps: boxProps.input,
        labelProps: boxProps.checkbox
    });
});
const CheckboxSelectCardGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { items, name, type, defaultValue, value, onChange, cardsPerRow, isFullWidth, contentDirection, ...fieldProps } = props;
    const { boxProps, state } = useCheckboxGroup$1(ref, props);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: /*#__PURE__*/ jsx(CheckboxGroupContext$1.Provider, {
            value: {
                state,
                direction: 'horizontal'
            },
            children: /*#__PURE__*/ jsx(Box, {
                ...boxProps.group,
                display: cardsPerRow !== undefined ? 'grid' : 'flex',
                flexWrap: cardsPerRow !== undefined ? undefined : 'wrap',
                margin: "-unsafe_component.selectCardGroup.spacing.gap.card",
                gridTemplateColumns: cardsPerRow !== undefined ? `repeat(${cardsPerRow}, ${isFullWidth ? `1fr` : `max-content`})` : undefined,
                children: items.map((item)=>{
                    return /*#__PURE__*/ createElement(CheckboxSelectCard, {
                        ...item,
                        error: fieldProps.error,
                        name: name,
                        key: item.value,
                        isFullWidth: isFullWidth,
                        cardsPerRow: cardsPerRow,
                        contentDirection: contentDirection
                    });
                })
            })
        })
    });
});

const RadioSelectCard = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { boxProps, isSelected, isPressed, isFocused, isHovered, isDisabled } = useRadio(ref, {
        ...props,
        children: props.label,
        hasError: Boolean(props.error)
    });
    return /*#__PURE__*/ jsx(SelectCardBase, {
        ...props,
        type: "radio",
        isSelected: isSelected,
        isPressed: isPressed,
        isFocused: isFocused,
        isHovered: isHovered,
        isDisabled: isDisabled,
        inputProps: boxProps.input,
        labelProps: boxProps.radio
    });
});
const RadioSelectCardGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { items, name, type, defaultValue, value, onChange, cardsPerRow, isFullWidth, contentDirection, ...fieldProps } = props;
    const { boxProps, state } = useRadioGroup(ref, props);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: /*#__PURE__*/ jsx(RadioGroupContext.Provider, {
            value: {
                state,
                direction: 'horizontal'
            },
            children: /*#__PURE__*/ jsx(Box, {
                ...boxProps.group,
                display: cardsPerRow !== undefined ? 'grid' : 'flex',
                flexWrap: cardsPerRow !== undefined ? undefined : 'wrap',
                margin: "-unsafe_component.selectCardGroup.spacing.gap.card",
                gridTemplateColumns: cardsPerRow !== undefined ? `repeat(${cardsPerRow}, ${isFullWidth ? `1fr` : `max-content`})` : undefined,
                children: items.map((item)=>{
                    return /*#__PURE__*/ createElement(RadioSelectCard, {
                        ...item,
                        error: fieldProps.error,
                        name: name,
                        key: item.value,
                        isFullWidth: isFullWidth,
                        cardsPerRow: cardsPerRow,
                        contentDirection: contentDirection
                    });
                })
            })
        })
    });
});

const SelectCardGroup = /*#__PURE__*/ forwardRef(function SelectCardGroup(props, ref) {
    const { type } = props;
    if (type === 'checkbox') return /*#__PURE__*/ jsx(CheckboxSelectCardGroup, {
        ...props,
        ref: ref
    });
    else return /*#__PURE__*/ jsx(RadioSelectCardGroup, {
        ...props,
        ref: ref
    });
});

const IS_SERVER = typeof window === 'undefined';
const useMediaQuery = (/** media query string, e.g - '(prefers-reduced-motion: reduce)' */ query, { defaultValue = false, initializeWithValue = true } = {})=>{
    const getMatches = useCallback((query)=>{
        if (IS_SERVER) {
            return defaultValue;
        }
        return window.matchMedia(query).matches;
    }, [
        defaultValue
    ]);
    const [matches, setMatches] = useState(()=>{
        if (initializeWithValue) {
            return getMatches(query);
        }
        return defaultValue;
    });
    useLayoutEffect(()=>{
        const handleChange = ()=>{
            setMatches(getMatches(query));
        };
        const matchMedia = window.matchMedia(query);
        setMatches(getMatches(query));
        matchMedia.addEventListener('change', handleChange);
        return ()=>{
            matchMedia.removeEventListener('change', handleChange);
        };
    }, [
        getMatches,
        query
    ]);
    return matches;
};

const waveKeyframe = unsafe_keyframes({
    '0%': {
        backgroundPosition: '100% 0'
    },
    '100%': {
        backgroundPosition: '-100% 0'
    }
});
const Skeleton = ({ children, height, typography = 'unsafe_component.skeleton.typography', variant = 'rectangle', width, ...restProps })=>{
    const tokens = useTokens();
    const hasMediaQueryReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    const colorLight = tokens['unsafe_component.skeleton.color.bgGradient'];
    const backgroundImage = useMemo(()=>`linear-gradient(90deg, ${colorLight} 15%, ${tokens['unsafe_component.skeleton.color.bg']} 30%, ${colorLight} 45%)`, [
        colorLight,
        tokens
    ]);
    const borderRadius = useMemo(()=>{
        switch(variant){
            case 'circle':
                return 'unsafe_component.skeleton.radius.circle';
            case 'typography':
                return 'unsafe_component.skeleton.radius.typography';
            case 'rectangle':
            default:
                return 'unsafe_component.skeleton.radius.rectangle';
        }
    }, [
        variant
    ]);
    const computeDimension = useMemo(()=>{
        const computeValue = (value, hasChildren)=>{
            switch(true){
                case Boolean(value):
                    return value;
                case Boolean(hasChildren):
                    return 'fit-content';
                default:
                    return 'inherit';
            }
        };
        return [
            computeValue(height, children),
            computeValue(width, children)
        ];
    }, [
        children,
        height,
        width
    ]);
    const [computedHeight, computedWidth] = computeDimension;
    const reducedMotionStyles = useMemo(()=>{
        if (!hasMediaQueryReducedMotion) {
            return {
                animationName: waveKeyframe,
                animationIterationCount: 'infinite',
                animationDuration: 'unsafe_component.skeleton.motionDuration',
                animationTimingFunction: 'unsafe_component.skeleton.motionEasing',
                animationDelay: 'unsafe_component.skeleton.motionDelay',
                backgroundRepeat: 'initial',
                backgroundImage
            };
        }
        return {};
    }, [
        hasMediaQueryReducedMotion,
        backgroundImage
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        ...reducedMotionStyles,
        width: computedWidth,
        height: computedHeight,
        typography: typography,
        borderRadius: borderRadius,
        backgroundColor: colorLight,
        backgroundSize: "200% 100%",
        overflow: [
            'hidden',
            'clip'
        ],
        cursor: "progress",
        position: "relative",
        tabIndex: -1,
        reducedMotion: true,
        children: children && /*#__PURE__*/ jsx(Box, {
            visibility: "hidden",
            /* For most browsers, default line-height is `1.2`
					 * line-height is set to `1` to remove padding from font height
					 */ unsafe_style: {
                lineHeight: 1
            },
            "aria-busy": "true",
            "aria-hidden": "true",
            children: children
        })
    });
};

/**
 * Helps with ref Element type
 * This will remove the ref from the default forwardRef typing and use the one defined in Props
 */ const createTextButton = (render)=>{
    return /*#__PURE__*/ forwardRef(render);
};
const DEFAULT_VARIANT = 'default';
const TextButton = createTextButton((props, ref)=>{
    const { children, isDisabled, variant = DEFAULT_VARIANT, size = '16', href, onPress, isExternal, icon: Icon, iconOnly, iconPosition, ...styleProps } = props;
    const { boxProps, isHovered, isPressed, isFocused, isLink } = useButton$1(ref, props);
    const LinkComponent = useRenderLink({
        isExternal
    });
    const Component = isLink ? LinkComponent : Box;
    const iconElement = useMemo(()=>{
        if (!Icon) return null;
        if (iconOnly) return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24"
        });
        return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            [`margin${iconPosition === 'start' ? 'Right' : 'Left'}`]: `unsafe_component.textButton.spacing.gap`
        });
    }, [
        Icon,
        iconOnly,
        iconPosition
    ]);
    const stateProps = useMemo(()=>mapTextButtonStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            variant
        }), [
        isDisabled,
        isHovered,
        isPressed,
        variant
    ]);
    const computedChildren = Array.isArray(children) ? children.join('') : children;
    return /*#__PURE__*/ jsx(Component, {
        ...styleProps,
        ...boxProps,
        ...stateProps,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        paddingVertical: "unsafe_component.textButton.spacing.padding.vertical",
        paddingHorizontal: "spacing.none",
        borderWidth: "borderWidth.none",
        typography: `unsafe_component.textButton.typography.${size}`,
        transitionDuration: "unsafe_component.textButton.motionDuration",
        transitionProperty: "color",
        transitionTimingFunction: "unsafe_component.textButton.motionEasing",
        height: "unsafe_component.textButton.sizing.40",
        whiteSpace: "nowrap",
        "aria-label": iconOnly ? computedChildren : undefined,
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        children: iconOnly ? iconElement : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                iconPosition === 'start' && iconElement,
                children,
                iconPosition === 'end' && iconElement
            ]
        })
    });
});
const mapTextButtonStateToBoxProps = ({ isDisabled, isHovered, isPressed, variant = DEFAULT_VARIANT })=>{
    const getColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.textButton.color.${variant}.textDisabled`;
            case isPressed:
                return `unsafe_component.textButton.color.${variant}.textPressed`;
            case isHovered:
                return `unsafe_component.textButton.color.${variant}.textHover`;
            default:
                return `unsafe_component.textButton.color.${variant}.text`;
        }
    };
    return {
        color: getColor(),
        cursor: isDisabled ? 'not-allowed' : 'pointer'
    };
};

const SnackbarBase = /*#__PURE__*/ forwardRef(({ description, action, actionType = 'short', variant = 'info', onClose, titleProps, ...restProps }, ref)=>{
    const Icon = mapIconToVariant(variant);
    const t = useTranslation();
    const actionButton = useMemo(()=>{
        if (!action) return null;
        const { children: label, ...actionProps } = action;
        return /*#__PURE__*/ jsx(TextButton, {
            ...actionProps,
            size: "14",
            variant: "inverted",
            marginRight: "unsafe_component.snackbar.spacing.margin.contentGap",
            children: label
        });
    }, [
        action
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        ref: ref,
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
        width: "100%",
        maxWidth: {
            'breakpoint.sm': 'breakpoint.sm'
        },
        zIndex: "zIndex.4",
        // required to get height of snackbar for transitions
        height: "fit-content",
        // Used in combination with pointerEvents="none" on Snackbar to allow click within the gaps of stacked Snackbars
        pointerEvents: "all",
        backgroundColor: "unsafe_component.snackbar.color.bg",
        borderRadius: "unsafe_component.snackbar.radius.default",
        padding: "unsafe_component.snackbar.spacing.padding",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        justifyContent: "start",
                        textAlign: "start",
                        padding: "unsafe_component.snackbar.spacing.padding",
                        typography: "unsafe_component.snackbar.typography.content",
                        color: "unsafe_component.snackbar.color.content",
                        width: "100%",
                        marginRight: "unsafe_component.snackbar.spacing.margin.contentGap",
                        children: [
                            Icon && /*#__PURE__*/ jsx(Icon, {
                                color: "unsafe_component.snackbar.color.content",
                                marginRight: "unsafe_component.snackbar.spacing.margin.contentGap"
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                ...titleProps,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        justifyContent: "end",
                        color: "unsafe_component.snackbar.color.content",
                        alignItems: "start",
                        children: [
                            actionType === 'short' ? actionButton : null,
                            /*#__PURE__*/ jsx(Button, {
                                variant: "tertiary-inverted",
                                size: "40",
                                icon: CloseIcon,
                                iconOnly: true,
                                onPress: onClose,
                                type: "button",
                                children: `${t('core::close')}`
                            })
                        ]
                    })
                ]
            }),
            actionType === 'long' ? actionButton : null
        ]
    });
});
const mapIconToVariant = (variant)=>{
    switch(variant){
        case 'error':
            return ExclamationFilledCircleIcon;
        case 'success':
            return CheckFilledCircleIcon;
        case 'warning':
            return ExclamationFilledTriangleIcon;
        default:
            return null;
    }
};

/**
 * Debounce a callback
 * @param callback Callback that will be debounced
 * @param delay delay that you want to use, default 250
 */ const debounce = (callback, delay = 250)=>{
    let timeoutId;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), delay);
    };
};

/**
 * We manage Snackbar transition on our side, because ToastQueue `hasExitAnimation` rearrange/sort visibleToasts, which distorts the animation behavior.
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/toast/src/useToastState.ts#L171
 */ const useSnackbarTransition = (ref, { onClose })=>{
    // Snackbar show status
    const [isShown, setIsShown] = useState(true);
    const handleClose = ()=>{
        setIsShown(false);
    };
    const handleTransitionEnd = ()=>{
        if (!isShown && onClose) {
            onClose();
        }
    };
    const isEntering = useEnterAnimation(ref);
    const isExiting = useExitAnimation(ref, isShown);
    return {
        isShown,
        isEntering,
        isExiting,
        handleClose,
        handleTransitionEnd
    };
};

const Snackbar = ({ toast, state })=>{
    const { close } = useNotificationGroup();
    const ref = useRef(null);
    const snackBarRef = useRef(null);
    const [snackbarHeight, setSnackbarHeight] = useState(snackBarRef.current?.clientHeight);
    const { boxProps } = useNotification(ref, {
        toast,
        state
    });
    const { isShown, isEntering, isExiting, handleClose, handleTransitionEnd } = useSnackbarTransition(snackBarRef, {
        onClose: ()=>close(toast.key)
    });
    const { toast: toastProps, content: contentProps, title: titleProps } = boxProps;
    const { 'aria-labelledby': ariaLabelledBy, ...restProps } = toastProps;
    const token = useTokens();
    const snackbarBottomMargin = token['unsafe_component.snackbar.spacing.margin.gap'];
    // Will resize when screen size change (with or without scroll)
    const onResize = useCallback(()=>{
        setSnackbarHeight(snackBarRef.current?.clientHeight);
    }, [
        snackBarRef
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onResizeDebounced = useCallback(debounce(onResize), [
        snackBarRef
    ]);
    useResizeObserver(ref, {
        onResize: onResizeDebounced
    });
    // To have the right height when ref is set
    useLayoutEffect(onResize, [
        onResize
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        ref: ref,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        transitionTimingFunction: isShown && !isExiting ? 'unsafe_component.snackbar.motionEasing.entering' : 'unsafe_component.snackbar.motionEasing.exiting',
        transitionProperty: "all",
        transitionDuration: isShown && !isExiting ? 'unsafe_component.snackbar.motionDuration.entering' : 'unsafe_component.snackbar.motionDuration.exiting',
        overflowY: [
            'hidden',
            'clip'
        ],
        onTransitionEnd: handleTransitionEnd,
        height: isShown && !isEntering ? `${snackbarHeight}px` : 0,
        marginBottom: isShown && !isEntering ? `${snackbarBottomMargin}` : undefined,
        marginHorizontal: {
            'breakpoint.base': 'unsafe_component.snackbar.spacing.margin.container.horizontal.base',
            'breakpoint.sm': 'unsafe_component.snackbar.spacing.margin.container.horizontal.sm',
            'breakpoint.lg': 'unsafe_component.snackbar.spacing.margin.container.horizontal.lg'
        },
        borderRadius: "unsafe_component.snackbar.radius.default",
        backgroundColor: "unsafe_component.snackbar.color.bg",
        boxShadow: "unsafe_component.snackbar.shadow",
        // Used in combination with pointerEvents="all" on SnackbarBase to allow click within the gaps of stacked Snackbars
        pointerEvents: "none",
        // https://github.com/adobe/react-spectrum/blob/75417bb15cc7bec44defd2ff71e7d22d56453e85/packages/%40react-aria/toast/src/useToast.ts#L97-L98
        "aria-hidden": isExiting ? 'true' : undefined,
        children: /*#__PURE__*/ jsx(SnackbarBase, {
            ...mergeProps(contentProps, toast.content),
            titleProps: titleProps,
            onClose: handleClose,
            ref: snackBarRef
        })
    });
};

const useSnackbar = ()=>{
    const { add } = useNotificationGroup();
    const addSnackbar = useCallback(function addSnackbar(content, options) {
        return add({
            component: Snackbar,
            ...content
        }, options);
    }, [
        add
    ]);
    const snackbarOption = useCallback((variant)=>(content, options)=>add({
                component: Snackbar,
                variant,
                ...content
            }, options), [
        add
    ]);
    return {
        add: addSnackbar,
        error: snackbarOption('error'),
        info: snackbarOption('info'),
        success: snackbarOption('success'),
        warning: snackbarOption('warning')
    };
};

/**
 * @deprecated Use `Tag` instead of `StatusTag` component.
 * Deprecated in Gemini component library.
 * Scheduled for removal in v3.
 * For more details, refer to the `Tag` component in the Gemini component library documentation.
 */ const StatusTag = ({ icon: Icon, children, variant = 'success', ...restProps })=>{
    const tokens = useTokens();
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        as: "span",
        backgroundColor: `unsafe_component.statusTag.color.${variant}.bg`,
        color: `unsafe_component.statusTag.color.${variant}.content`,
        borderRadius: "unsafe_component.statusTag.radius",
        paddingHorizontal: `calc(${tokens['unsafe_component.statusTag.spacing.padding.horizontal']} - ${tokens['unsafe_component.statusTag.borderWidth']})`,
        paddingVertical: `calc(${tokens['unsafe_component.statusTag.spacing.padding.vertical']} - ${tokens['unsafe_component.statusTag.borderWidth']})`,
        typography: "unsafe_component.statusTag.typography",
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        borderColor: `unsafe_component.statusTag.color.${variant}.content`,
        borderStyle: "solid",
        borderWidth: "unsafe_component.statusTag.borderWidth",
        children: [
            /*#__PURE__*/ jsx(Icon, {
                marginRight: "unsafe_component.statusTag.spacing.gap",
                size: "sizing.16"
            }),
            children
        ]
    });
};

const TabsContext = /*#__PURE__*/ createContext(null);
const TabsProvider = (props)=>{
    const { items, defaultValue = items[0]?.id, onChange, value, children } = props;
    const tabListRef = useRef(null);
    const disabledTabs = items.map((item)=>item.isDisabled ? item.id : undefined).filter(Boolean);
    const state = useTabListState({
        items,
        children: (item)=>/*#__PURE__*/ jsx(Item, {
                children: item.content
            }),
        defaultSelectedKey: defaultValue,
        selectedKey: value,
        disabledKeys: disabledTabs,
        onSelectionChange: (key)=>{
            if (key !== undefined && typeof onChange === 'function') onChange(key);
        }
    });
    return /*#__PURE__*/ jsx(TabsContext.Provider, {
        value: {
            state,
            tabListRef
        },
        children: children
    });
};
const useTabsContext = ()=>{
    const contextValue = useContext(TabsContext);
    if (!contextValue) {
        throw new Error('The `TabsProvider` has not been instantiated correctly with its corresponding context. Please make sure that it is rendered higher in your app. If the issue persists, report it to Team GEMINI.');
    }
    return contextValue;
};

const mapResponsive$1 = (object, [conditionFulfilled, conditionUnfulfilled])=>{
    return Object.entries(object).reduce((acc, [breakpoint, condition])=>{
        return {
            ...acc,
            [breakpoint]: condition ? conditionFulfilled : conditionUnfulfilled
        };
    }, {});
};
const mapTabPanelItemFlexProps = ({ isFullHeight = false })=>{
    if (!isFullHeight) return {};
    if (typeof isFullHeight === 'boolean') return {
        flex: '1 1 auto',
        overflowY: 'auto',
        minHeight: '0px'
    };
    return {
        flex: mapResponsive$1(isFullHeight, [
            '1 1 auto',
            '0 0 auto'
        ]),
        overflowY: mapResponsive$1(isFullHeight, [
            'auto',
            'initial'
        ]),
        minHeight: mapResponsive$1(isFullHeight, [
            '0px',
            'initial'
        ])
    };
};

const TabPanelItem = /*#__PURE__*/ forwardRef(({ isFullHeight = false, ...restProps }, ref)=>{
    const flexValue = useMemo(()=>mapTabPanelItemFlexProps({
            isFullHeight
        }), [
        isFullHeight
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ref: ref,
        ...mergeProps(restProps, flexValue)
    });
});

const useTabPanelsItem = ({ item })=>{
    const panelRef = useObjectRef$1();
    const { state, tabListRef } = useTabsContext();
    const { tabPanelProps } = useTabPanel$1({}, state, panelRef);
    return {
        boxProps: mergeProps(tabPanelProps, {
            ref: panelRef,
            // Override tabPanel id and aria-labelledby as it's made for single tab display usage
            // Here we want to have all panels in the dom so we need to link the ids ourselves
            id: `${tabListRef.current?.id}-tabpanel-${item.key}`,
            'aria-labelledby': `${tabListRef.current?.id}-tab-${item.key}`,
            children: item.props.children,
            display: item.key !== state.selectedKey ? 'none' : undefined
        })
    };
};

const TabPanels = ({ isFullHeight = false })=>{
    const { state } = useTabsContext();
    return /*#__PURE__*/ jsx(Fragment, {
        children: [
            ...state.collection
        ].map((item)=>/*#__PURE__*/ jsx(TabPanelsItem, {
                item: item,
                isFullHeight: isFullHeight
            }, item.key))
    });
};
const TabPanelsItem = ({ item, isFullHeight = false })=>{
    const { boxProps } = useTabPanelsItem({
        item
    });
    return /*#__PURE__*/ jsx(TabPanelItem, {
        ...boxProps,
        isFullHeight: isFullHeight
    });
};

const useScrollButton = (ref, props)=>{
    const { direction } = props;
    const { tabListRef } = useTabsContext();
    const horizontalScroll = useCallback((scrollTo)=>{
        const tabsCurrent = tabListRef.current;
        const current = ref.current;
        if (!tabsCurrent || !tabsCurrent.scrollTo || !current) return;
        if (scrollTo === 'left') {
            tabsCurrent.scrollTo({
                left: tabsCurrent.scrollLeft - (tabsCurrent.clientWidth - current.clientWidth),
                behavior: 'smooth'
            });
        } else if (scrollTo === 'right') {
            tabsCurrent.scrollTo({
                left: tabsCurrent.scrollLeft + (tabsCurrent.clientWidth - current.clientWidth),
                behavior: 'smooth'
            });
        }
    }, [
        tabListRef,
        ref
    ]);
    const { boxProps: scrollPressProps, isPressed: scrollIsPressed } = usePressable({
        onPress: ()=>horizontalScroll(direction)
    });
    const { boxProps: scrollHoverProps, isHovered: scrollIsHovered } = useHoverable();
    return {
        boxProps: mergeProps(scrollPressProps, scrollHoverProps),
        isPressed: scrollIsPressed,
        isHovered: scrollIsHovered
    };
};

const ScrollButton = ({ icon: Icon, direction, shouldDisplay })=>{
    const ref = useRef(null);
    const { boxProps, isPressed, isHovered } = useScrollButton(ref, {
        direction
    });
    return /*#__PURE__*/ jsx(Box, {
        ref: ref,
        ...boxProps,
        as: "button",
        type: "button",
        display: shouldDisplay ? 'flex' : 'none',
        justifyContent: "center",
        alignItems: "center",
        minWidth: "unsafe_component.tabs.sizing.width",
        borderWidth: "borderWidth.none",
        cursor: "pointer",
        backgroundColor: isPressed ? 'unsafe_component.tabs.color.button.bgPressed' : isHovered ? 'unsafe_component.tabs.color.button.bgHover' : 'unsafe_component.tabs.color.button.bg',
        transitionDuration: "unsafe_component.tabs.motionDuration.scrollButton",
        transitionProperty: "background-color",
        transitionTimingFunction: "unsafe_component.tabs.motionEasing.scrollButton",
        tabIndex: -1,
        "aria-hidden": true,
        children: /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24"
        })
    });
};

const useTab = (ref, props)=>{
    const { key } = props;
    const { state } = useTabsContext();
    const refObject = useObjectRef$1(ref);
    const { tabProps, isDisabled, isSelected } = useTab$1({
        key
    }, state, refObject);
    const { boxProps: hoverProps, isHovered } = useHoverable({
        isDisabled
    });
    const { boxProps: focusProps, isFocusVisible } = useFocusable(refObject, {
        isDisabled
    });
    const { boxProps: pressProps, isPressed } = usePressable({
        isDisabled
    });
    return {
        boxProps: mergeProps(hoverProps, pressProps, focusProps, tabProps, {
            ref: refObject
        }),
        isDisabled,
        isSelected,
        isPressed,
        isHovered,
        isFocused: isFocusVisible
    };
};

const IconElement$2 = ({ isSelected, icon: IconElement, iconActive: IconActiveElement, position })=>{
    if (IconElement && IconActiveElement) {
        const Icon = isSelected ? IconActiveElement : IconElement;
        return /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            ...position
        });
    }
    // No icon
    return null;
};
const Tab = /*#__PURE__*/ forwardRef(({ id, label, icon, iconActive, iconPosition, badgeProps, alignment, tabsWidth }, ref)=>{
    const { boxProps, isDisabled, isSelected, isPressed, isHovered, isFocused } = useTab(ref, {
        key: id
    });
    const getIconPosition = useMemo(()=>mapTabIconPositionProps({
            iconPosition
        }), [
        iconPosition
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        ...boxProps,
        ...getIconPosition.tab,
        display: "flex",
        justifyContent: tabsWidth === 'fill' ? alignment : undefined,
        alignItems: "center",
        flex: "1 0 auto",
        overflow: [
            'hidden',
            'clip'
        ],
        paddingHorizontal: "unsafe_component.tabs.spacing.padding.horizontal",
        paddingVertical: "unsafe_component.tabs.spacing.padding.vertical",
        color: isDisabled ? 'unsafe_component.tabs.color.tab.colorDisabled' : isSelected ? 'unsafe_component.tabs.color.tab.colorSelected' : 'unsafe_component.tabs.color.tab.color',
        backgroundColor: isPressed ? 'unsafe_component.tabs.color.tab.bgPressed' : isHovered ? 'unsafe_component.tabs.color.tab.bgHover' : undefined,
        typography: isSelected ? 'unsafe_component.tabs.typography.selected' : 'unsafe_component.tabs.typography.default',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'solid' : 'none',
        outlineOffset: "-borderWidth.2",
        outlineWidth: "borderWidth.2",
        whiteSpace: "nowrap",
        transitionDuration: "unsafe_component.tabs.motionDuration.tab",
        transitionProperty: "background-color",
        transitionTimingFunction: "unsafe_component.tabs.motionEasing.tab",
        children: [
            icon ? /*#__PURE__*/ jsx(Box, {
                as: "span",
                "aria-hidden": "true",
                children: /*#__PURE__*/ jsx(IconElement$2, {
                    icon: icon,
                    iconActive: iconActive,
                    position: getIconPosition.icon,
                    isSelected: isSelected
                })
            }) : null,
            /*#__PURE__*/ jsxs(Box, {
                as: "span",
                display: "inline-flex",
                flexDirection: "column",
                whiteSpace: "nowrap",
                overflow: [
                    'hidden',
                    'clip'
                ],
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        whiteSpace: "nowrap",
                        overflow: [
                            'hidden',
                            'clip'
                        ],
                        textOverflow: "ellipsis",
                        children: label
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        "aria-hidden": "true",
                        height: 0,
                        visibility: "hidden",
                        overflow: [
                            'hidden',
                            'clip'
                        ],
                        textOverflow: "ellipsis",
                        userSelect: "none",
                        pointerEvents: "none",
                        typography: "unsafe_component.tabs.typography.selected",
                        children: label
                    })
                ]
            }),
            badgeProps?.label && badgeProps?.children ? /*#__PURE__*/ jsx(Badge, {
                ...badgeProps,
                isDisabled: isDisabled,
                marginLeft: "unsafe_component.tabs.spacing.rightGap",
                children: badgeProps.children
            }) : null
        ]
    });
});
const iconMargin = (position)=>`unsafe_component.tabs.spacing.${position === 'left' ? 'right' : 'bottom'}Gap`;
const tabDirection = (position)=>position === 'left' ? 'row' : 'column';
const nonResponsivePositionResult = (position)=>({
        icon: {
            [`margin${position === 'left' ? 'Right' : 'Bottom'}`]: iconMargin(position)
        },
        tab: {
            flexDirection: tabDirection(position)
        }
    });
const mapTabIconPositionProps = ({ iconPosition })=>{
    if (!iconPosition) {
        // default
        return nonResponsivePositionResult('left');
    }
    if (typeof iconPosition === 'string') {
        return nonResponsivePositionResult(iconPosition);
    }
    return Object.entries(iconPosition).reduce((acc, [breakpoint, position])=>{
        acc.icon.marginRight = {
            ...acc.icon.marginRight,
            [breakpoint]: position === 'left' ? 'unsafe_component.tabs.spacing.rightGap' : 'spacing.none'
        };
        acc.icon.marginBottom = {
            ...acc.icon.marginBottom,
            [breakpoint]: position === 'top' ? 'unsafe_component.tabs.spacing.bottomGap' : 'spacing.none'
        };
        acc.tab.flexDirection = {
            ...acc.tab.flexDirection,
            [breakpoint]: tabDirection(position)
        };
        return acc;
    }, {
        icon: {
            marginBottom: {},
            marginRight: {}
        },
        tab: {
            flexDirection: {}
        }
    });
};

const BUTTON_ARROW_WIDTH = 48;
const useTabList = ()=>{
    const scrollContainer = useRef(null);
    const firstElement = useRef(null);
    const lastElement = useRef(null);
    const selectedElement = useObjectRef$1(scrollContainer);
    const { state, tabListRef } = useTabsContext();
    const { tabListProps } = useTabList$1({}, state, tabListRef);
    /**
	 * This function ensures that moving through tabs with  `ArrowUp` & `ArrowDown` keys is disabled.
	 * For the available horizontal orientation, navigation should only be possible with `ArrowLeft` & `ArrowRight` keys.
	 * Read more: https://www.w3.org/WAI/ARIA/apg/patterns/tabs/#keyboardinteraction
	 * Reported issue: https://github.com/adobe/react-spectrum/issues/5996
	 */ const handleKeyDown = (e)=>{
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            return;
        }
        tabListProps.onKeyDown?.(e);
    };
    const { shouldDisplayLeftArrow, shouldDisplayRightArrow, boxProps: indicator } = useHorizontalScroll({
        scrollContainer: tabListRef,
        selectedElement,
        firstElement,
        lastElement
    });
    // Scrolls the selected tab into view when mounted or on press
    // without scrolling the whole page
    useEffect(()=>{
        if (tabListRef.current && selectedElement.current) {
            const tabList = tabListRef.current;
            const selectedTab = selectedElement.current;
            const tabLeft = selectedTab.offsetLeft;
            const tabRight = tabLeft + selectedTab.offsetWidth;
            const scrollLeft = tabList.scrollLeft;
            const scrollRight = scrollLeft + tabList.clientWidth;
            const isTabFullyVisible = tabLeft >= scrollLeft && tabRight <= scrollRight;
            // Only scroll if the tab is not fully visible
            if (!isTabFullyVisible) {
                // If tab is to the left of viewport, scroll to show it on the left
                if (tabLeft < scrollLeft) {
                    requestAnimationFrame(()=>{
                        tabList.scrollTo({
                            left: tabLeft
                        });
                    });
                } else if (tabRight > scrollRight) {
                    requestAnimationFrame(()=>{
                        tabList.scrollTo({
                            left: tabRight - tabList.clientWidth + BUTTON_ARROW_WIDTH
                        });
                    });
                }
            }
        }
    }, [
        state.selectedKey,
        tabListRef,
        selectedElement
    ]);
    return {
        boxProps: {
            tabList: {
                ...tabListProps,
                onKeyDown: handleKeyDown
            },
            indicator,
            firstTab: {
                ref: firstElement
            },
            lastTab: {
                ref: lastElement
            },
            selectedTab: {
                ref: selectedElement
            }
        },
        shouldDisplayLeftArrow,
        shouldDisplayRightArrow
    };
};

const TabList = ({ hasDivider, iconPosition = 'left', label, tabsWidth, alignment })=>{
    const { state, tabListRef } = useTabsContext();
    const { boxProps, shouldDisplayLeftArrow, shouldDisplayRightArrow } = useTabList();
    return /*#__PURE__*/ jsxs(Box, {
        display: "flex",
        justifyContent: tabsWidth === 'hug' ? alignment : undefined,
        width: "100%",
        borderBottomColor: hasDivider ? 'unsafe_component.tabs.color.border' : undefined,
        borderBottomWidth: hasDivider ? 'borderWidth.1' : undefined,
        borderBottomStyle: hasDivider ? 'solid' : undefined,
        children: [
            /*#__PURE__*/ jsx(ScrollButton, {
                icon: ChevronLeftIcon,
                shouldDisplay: shouldDisplayLeftArrow,
                direction: "left"
            }),
            /*#__PURE__*/ jsxs(Box, {
                ...boxProps.tabList,
                ref: tabListRef,
                "aria-label": label,
                position: "relative",
                display: "flex",
                width: tabsWidth === 'hug' ? 'auto' : '100%',
                overflow: "auto",
                scrollbarWidth: "none",
                scrollbarDisplay: "none",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        ...boxProps.indicator,
                        position: "absolute",
                        bottom: 0,
                        height: 2,
                        backgroundColor: "unsafe_component.tabs.color.line",
                        transitionDuration: "unsafe_component.tabs.motionDuration.indicator",
                        transitionProperty: "width, left",
                        transitionTimingFunction: "unsafe_component.tabs.motionEasing.indicator",
                        role: "presentation"
                    }),
                    [
                        ...state.collection
                    ].map(({ value }, idx, collection)=>{
                        if (!value) return null;
                        const { firstTab, lastTab, selectedTab } = boxProps;
                        const tabRefs = {
                            ref: mergeRefs(idx === 0 ? firstTab.ref : null, idx === collection.length - 1 ? lastTab.ref : null, state.selectedKey === value.id ? selectedTab.ref : null)
                        };
                        return /*#__PURE__*/ createElement(Tab, {
                            ...tabRefs,
                            ...value,
                            key: value.id,
                            iconPosition: iconPosition,
                            alignment: alignment,
                            tabsWidth: tabsWidth
                        });
                    })
                ]
            }),
            /*#__PURE__*/ jsx(ScrollButton, {
                icon: ChevronRightIcon,
                shouldDisplay: shouldDisplayRightArrow,
                direction: "right"
            })
        ]
    });
};

const useTabPanel = ()=>{
    const ref = useRef(null);
    const { state } = useTabsContext();
    const { tabPanelProps } = useTabPanel$1({}, state, ref);
    return {
        boxProps: mergeProps(tabPanelProps, {
            ref
        })
    };
};

const TabPanel = ({ isFullHeight = false })=>{
    const { state } = useTabsContext();
    const { boxProps } = useTabPanel();
    return /*#__PURE__*/ jsx(TabPanelItem, {
        ...boxProps,
        isFullHeight: isFullHeight,
        children: state.selectedItem && state.selectedItem.props.children
    });
};

const Tabs = /*#__PURE__*/ forwardRef(function Tabs(props, ref) {
    const { items, hasDivider, iconPosition, defaultValue, label, isLazy, isFullHeight = false, onChange, value, tabsWidth = 'fill', alignment = 'center', ...containerProps } = props;
    const heightValue = useMemo(()=>mapTabsHeightProps({
            isFullHeight
        }), [
        isFullHeight
    ]);
    return /*#__PURE__*/ jsx(TabsProvider, {
        ...props,
        children: /*#__PURE__*/ jsxs(Box, {
            ...containerProps,
            height: heightValue,
            ref: ref,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            children: [
                /*#__PURE__*/ jsx(TabList, {
                    hasDivider: hasDivider,
                    iconPosition: iconPosition,
                    label: label,
                    tabsWidth: tabsWidth,
                    alignment: alignment
                }),
                isLazy ? /*#__PURE__*/ jsx(TabPanel, {
                    isFullHeight: isFullHeight
                }) : /*#__PURE__*/ jsx(TabPanels, {
                    isFullHeight: isFullHeight
                })
            ]
        })
    });
});
const mapTabsHeightProps = ({ isFullHeight = false })=>{
    if (!isFullHeight) return undefined;
    if (typeof isFullHeight === 'boolean') return '100%';
    return mapResponsive$1(isFullHeight, [
        '100%',
        'initial'
    ]);
};

const TextField = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { placeholder, suffix, iconStart, iconEnd, type, inputMode, name, min, max, onChange, onBlur, onFocus, value, defaultValue, isFullWidth, autoComplete, containerRef, ...fieldProps } = props;
    const refObject = useObjectRef(ref);
    const { boxProps } = useTextField(refObject, props);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        children: /*#__PURE__*/ jsx(TextFieldBase, {
            ...props,
            inputRef: refObject,
            inputProps: boxProps.input
        })
    });
});

const useToggle = (ref, props)=>{
    const { boxProps, ...rest } = useCheckbox(ref, props);
    return {
        boxProps: mergeProps(boxProps, {
            input: mergeProps(boxProps.input, {
                role: 'switch'
            })
        }),
        ...rest
    };
};
const useToggleInGroup = (ref, props)=>{
    const { boxProps, ...rest } = useCheckboxInGroup(ref, props);
    return {
        boxProps: mergeProps(boxProps, {
            input: mergeProps(boxProps.input, {
                role: 'switch'
            })
        }),
        ...rest
    };
};
const useToggleLoading = ({ isLoading })=>{
    // manage initial isLoading with component instantiation
    const [hasTimer, setHasTimer] = useState(Boolean(isLoading));
    const timeoutRef = useRef(null);
    useEffect(()=>{
        if (isLoading) {
            setHasTimer(true);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                setHasTimer(false);
            }, 600);
        }
    }, [
        isLoading
    ]);
    return {
        hasLoadingSpinner: isLoading || hasTimer
    };
};

const Toggle = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, tooltip, error, isOptional, hasNecessityIndicator = true, isDisabled, isFocused, isSelected, defaultSelected, name, onChange, onBlur, onFocus, isLoading, helper, ...restProps } = props;
    const { direction, ...toggleProps } = useToggle(ref, props);
    return /*#__PURE__*/ jsx(ToggleBase, {
        ...mergeProps(toggleProps, restProps),
        isOptional: isOptional,
        hasNecessityIndicator: hasNecessityIndicator,
        tooltip: tooltip,
        error: error,
        isLoading: isLoading,
        helper: helper,
        children: children
    });
});
/**
 * Internal implementation that use multiple toggle hook (group)
 */ const ToggleInGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, tooltip, error, isLoading } = props;
    const { direction, ...toggleProps } = useToggleInGroup(ref, props);
    return /*#__PURE__*/ jsx(ToggleBase, {
        ...toggleProps,
        tooltip: tooltip,
        error: error,
        isGroup: true,
        isLoading: isLoading,
        children: children
    });
});
const ToggleBase = (props)=>{
    const { children, boxProps, isDisabled, isGroup, tooltip, error, errorId, hasNecessityIndicator, isOptional, isFocused, isHovered, isPressed, isSelected, isLoading, helper, ...restProps } = props;
    const { hasLoadingSpinner } = useToggleLoading({
        isLoading
    });
    return /*#__PURE__*/ jsxs(Box, {
        ...restProps,
        display: "inline-flex",
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ jsx(Box, {
                display: "inline-flex",
                alignItems: "center",
                width: "100%",
                children: /*#__PURE__*/ jsxs(Box, {
                    ...boxProps.checkbox,
                    as: "label",
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    typography: helper ? 'unsafe_component.toggle.typography.bold' : 'unsafe_component.toggle.typography.default',
                    color: `unsafe_component.toggle.color.content${isDisabled ? 'Disabled' : ''}`,
                    paddingVertical: !helper ? 'unsafe_component.toggle.spacing.padding.vertical.root' : undefined,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ jsx(VisuallyHidden, {
                            elementType: "span",
                            children: /*#__PURE__*/ jsx(Box, {
                                ...boxProps.input,
                                as: "input"
                            })
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            as: "span",
                            display: "inline-flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            children: [
                                /*#__PURE__*/ jsxs(Box, {
                                    as: "span",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ jsxs(Box, {
                                            as: "span",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingVertical: "unsafe_component.toggle.spacing.padding.vertical.label",
                                            children: [
                                                children,
                                                !isGroup && hasNecessityIndicator ? /*#__PURE__*/ jsx(FieldNecessityIndicator, {
                                                    isOptional: isOptional,
                                                    marginLeft: "unsafe_component.toggle.spacing.gap",
                                                    color: "unsafe_component.toggle.color.optional",
                                                    typography: "unsafe_component.toggle.typography.optional"
                                                }) : null
                                            ]
                                        }),
                                        !isGroup && tooltip ? /*#__PURE__*/ jsx(Tooltip, {
                                            content: tooltip,
                                            children: /*#__PURE__*/ jsx(FieldTooltipTrigger, {})
                                        }) : null
                                    ]
                                }),
                                helper ? /*#__PURE__*/ jsx(StateMessage, {
                                    children: helper
                                }) : null
                            ]
                        }),
                        hasLoadingSpinner ? /*#__PURE__*/ jsx(Box, {
                            width: "unsafe_component.toggle.sizing.toggleWrapper.width",
                            marginLeft: "unsafe_component.toggle.spacing.gap",
                            children: /*#__PURE__*/ jsx(LoadingState, {})
                        }) : /*#__PURE__*/ jsx(ToggleTick, {
                            isFocused: isFocused,
                            isHovered: isHovered,
                            isPressed: isPressed,
                            isSelected: isSelected,
                            isDisabled: isDisabled,
                            error: error,
                            marginLeft: "unsafe_component.toggle.spacing.gap"
                        })
                    ]
                })
            }),
            error && !isGroup && !isDisabled ? /*#__PURE__*/ jsx(StateMessage, {
                id: errorId,
                variant: "error",
                children: error
            }) : null
        ]
    });
};
const ToggleTick = ({ isHovered, isPressed, isFocused, isSelected, isDisabled, error, ...restProps })=>{
    const tokens = useTokens();
    const stateProps = useMemo(()=>mapToggleStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isSelected
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isSelected
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ...restProps,
        as: "span",
        alignItems: "center",
        display: "inline-flex",
        flexShrink: 0,
        height: "unsafe_component.toggle.sizing.toggleWrapper.height",
        justifyContent: "center",
        marginLeft: "unsafe_component.toggle.spacing.gap",
        width: "unsafe_component.toggle.sizing.toggleWrapper.width",
        children: /*#__PURE__*/ jsx(Box, {
            ...stateProps,
            alignItems: "center",
            as: "span",
            borderRadius: "unsafe_component.toggle.radius",
            borderStyle: "solid",
            borderWidth: "unsafe_component.toggle.borderWidth",
            display: "inline-flex",
            flexShrink: 0,
            height: "unsafe_component.toggle.sizing.toggleWrapper.height",
            justifyContent: "start",
            padding: `calc(${tokens['unsafe_component.toggle.spacing.padding.toggle']} - ${tokens['unsafe_component.toggle.borderWidth']})`,
            width: "unsafe_component.toggle.sizing.toggleWrapper.width",
            outlineWidth: "borderWidth.2",
            outlineStyle: isFocused ? 'solid' : 'none',
            outlineColor: [
                'Highlight',
                '-webkit-focus-ring-color'
            ],
            children: /*#__PURE__*/ jsxs(Box, {
                alignItems: "center",
                as: "span",
                ...stateProps,
                backgroundColor: "unsafe_component.toggle.color.bgKnob",
                borderRadius: "unsafe_component.toggle.radius",
                display: "inline-flex",
                flexShrink: 0,
                height: "unsafe_component.toggle.sizing.knob",
                justifyContent: "center",
                transform: isSelected ? `translateX(calc(${tokens['unsafe_component.toggle.sizing.toggleWrapper.width']} - ${tokens['unsafe_component.toggle.sizing.knob']} - (${tokens['unsafe_component.toggle.sizing.toggleWrapper.height']} - ${tokens['unsafe_component.toggle.sizing.knob']})))` : undefined,
                transitionDuration: "unsafe_component.toggle.motionDuration",
                transitionTimingFunction: "unsafe_component.toggle.motionEasing",
                width: "unsafe_component.toggle.sizing.knob",
                position: "relative",
                children: [
                    /*#__PURE__*/ jsx(CheckIcon, {
                        color: `unsafe_component.toggle.color.content${isDisabled ? 'Disabled' : ''}`,
                        size: "sizing.20",
                        opacity: isSelected ? 'opacity.full' : 'opacity.none',
                        transitionProperty: "opacity",
                        transitionDuration: "unsafe_component.toggle.motionDuration",
                        transitionTimingFunction: "unsafe_component.toggle.motionEasing",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }),
                    /*#__PURE__*/ jsx(CloseIcon, {
                        size: "sizing.24",
                        opacity: isSelected ? 'opacity.none' : 'opacity.full',
                        transitionProperty: "opacity",
                        transitionDuration: "unsafe_component.toggle.motionDuration",
                        transitionTimingFunction: "unsafe_component.toggle.motionEasing",
                        color: `unsafe_component.toggle.color.content${isDisabled ? 'Disabled' : ''}`,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    })
                ]
            })
        })
    });
};
const mapToggleStateToBoxProps = ({ isSelected, isDisabled, isHovered, isPressed })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.toggle.color.bgSelectedDisabled`;
            case isSelected && isPressed:
                return `unsafe_component.toggle.color.bgSelectedPressed`;
            case isSelected && isHovered:
                return `unsafe_component.toggle.color.bgSelectedHover`;
            case isSelected:
                return `unsafe_component.toggle.color.bgSelected`;
            default:
                return `unsafe_component.toggle.color.bgDefault`;
        }
    };
    const getBorderColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.toggle.color.borderDisabled`;
            case isPressed:
                return `unsafe_component.toggle.color.borderPressed`;
            case isHovered:
                return `unsafe_component.toggle.color.borderHover`;
            case isSelected:
                return `unsafe_component.toggle.color.borderSelected`;
            default:
                return `unsafe_component.toggle.color.border`;
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        borderColor: getBorderColor()
    };
};

const ToggleGroup = /*#__PURE__*/ forwardRef(function ToggleGroup(props, ref) {
    const { name, onChange, value, defaultValue, items, hasTwoColumns, hasBorder, onBlur, onFocus, ...fieldProps } = props;
    const { boxProps, state } = useCheckboxGroup$1(ref, props);
    return /*#__PURE__*/ jsx(FieldBase, {
        position: "relative",
        labelProps: boxProps.label,
        helperProps: boxProps.helper,
        errorProps: boxProps.error,
        ...fieldProps,
        disableMargin: true,
        children: /*#__PURE__*/ jsx(CheckboxGroupContext$1.Provider, {
            value: {
                state,
                direction: 'vertical'
            },
            children: /*#__PURE__*/ jsx(Box, {
                ...boxProps.group,
                display: "flex",
                flexDirection: "column",
                children: props.items.map(({ label, value, isDisabled, isLoading })=>/*#__PURE__*/ jsx(ToggleInGroup, {
                        name: props.name,
                        value: value,
                        isDisabled: Boolean(fieldProps.isDisabled || isDisabled),
                        error: fieldProps.error,
                        isLoading: isLoading,
                        children: label
                    }, value))
            })
        })
    });
});

/**
 * Custom hook to map `ToggleButton` props to `Box` ones with all needed interactive and accessible HTML attributes.
 * @param ref ToggleButton element ref
 * @param props ToggleButton props
 * @returns Box props
 */ const useToggleButton = (ref, props)=>{
    const { defaultSelected, isSelected, onChange, ...buttonProps } = props;
    const { isSelected: isToggleSelected, toggle } = useToggleState({
        ...defaultSelected !== undefined ? {
            defaultSelected
        } : {},
        ...isSelected !== undefined ? {
            isSelected
        } : {},
        onChange: onChange || (()=>{})
    });
    const { boxProps, ...rest } = useButton$1(ref, {
        ...buttonProps,
        onPress: chain(toggle, props.onPress)
    });
    return {
        ...rest,
        boxProps: mergeProps(boxProps, {
            'aria-pressed': isToggleSelected
        }),
        isSelected: isToggleSelected
    };
};

const ToggleButton = /*#__PURE__*/ forwardRef(function ToggleButton(props, ref) {
    const { children, isDisabled, onPress, onPressStart, onPressEnd, icon, iconPosition = 'start', badgeProps, isFullWidth = false, 'aria-label': ariaLabel, defaultSelected, isSelected: isSelectedInitially, onChange, alignment = 'center', ...containerProps } = props;
    const { boxProps, isHovered, isPressed, isFocused, isSelected } = useToggleButton(ref, props);
    const tokens = useTokens();
    const stateProps = useMemo(()=>mapButtonStateToBoxProps({
            isDisabled,
            isHovered,
            isPressed,
            isSelected
        }), [
        isDisabled,
        isHovered,
        isPressed,
        isSelected
    ]);
    const buttonStyleProps = {
        width: useMemo(()=>mapButtonWidthProps({
                isFullWidth
            }), [
            isFullWidth
        ]),
        paddingHorizontal: `calc(${tokens['unsafe_component.toggleButton.spacing.padding.horizontal']} - ${tokens['unsafe_component.toggleButton.borderWidth']})`,
        paddingVertical: `calc(${tokens['unsafe_component.toggleButton.spacing.padding.vertical']} - ${tokens['unsafe_component.toggleButton.borderWidth']})`
    };
    const iconProps = {
        icon,
        iconPosition,
        margin: useMemo(()=>mapIconMarginProps({
                iconPosition
            }), [
            iconPosition
        ])
    };
    return /*#__PURE__*/ jsxs(Box, {
        ...containerProps,
        ...boxProps,
        ...stateProps,
        ...buttonStyleProps,
        display: "inline-flex",
        justifyContent: alignment,
        alignItems: "center",
        position: "relative",
        borderWidth: "unsafe_component.toggleButton.borderWidth",
        borderStyle: "solid",
        borderRadius: "unsafe_component.toggleButton.radius",
        transitionDuration: "unsafe_component.toggleButton.motionDuration",
        transitionProperty: "background-color",
        transitionTimingFunction: "unsafe_component.toggleButton.motionEasing",
        height: "unsafe_component.toggleButton.sizing",
        "aria-label": ariaLabel ?? undefined,
        overflow: [
            'hidden',
            'clip'
        ],
        // Outline only on Keyboard focus (focus-visible)
        outlineStyle: isFocused ? 'auto' : 'none',
        children: [
            iconPosition === 'start' ? /*#__PURE__*/ jsx(IconElement$1, {
                ...iconProps
            }) : null,
            /*#__PURE__*/ jsxs(Box, {
                as: "span",
                display: "inline-flex",
                flexDirection: "column",
                whiteSpace: "nowrap",
                overflow: [
                    'hidden',
                    'clip'
                ],
                textAlign: alignment,
                flexGrow: alignment === 'left' ? 1 : undefined,
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        whiteSpace: "nowrap",
                        overflow: [
                            'hidden',
                            'clip'
                        ],
                        textOverflow: "ellipsis",
                        children: children
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        "aria-hidden": "true",
                        height: 0,
                        visibility: "hidden",
                        overflow: [
                            'hidden',
                            'clip'
                        ],
                        textOverflow: "ellipsis",
                        userSelect: "none",
                        pointerEvents: "none",
                        typography: "unsafe_component.toggleButton.typography.selected",
                        children: children
                    })
                ]
            }),
            iconPosition === 'end' ? /*#__PURE__*/ jsx(IconElement$1, {
                ...iconProps
            }) : null,
            /*#__PURE__*/ jsx(ToggleButtonBadge, {
                isDisabled: isDisabled,
                badgeProps: badgeProps
            })
        ]
    });
});
const ToggleButtonBadge = ({ isDisabled, badgeProps })=>{
    return badgeProps?.label && badgeProps?.children ? /*#__PURE__*/ jsx(Badge, {
        ...badgeProps,
        isDisabled: isDisabled,
        variant: "secondary",
        marginLeft: `unsafe_component.toggleButton.spacing.gap`,
        children: badgeProps.children
    }) : null;
};
const mapIconMarginProps = ({ iconPosition })=>{
    const key = `margin${iconPosition === 'start' ? 'Right' : 'Left'}`;
    return {
        [key]: `unsafe_component.toggleButton.spacing.gap`
    };
};
const IconElement$1 = ({ icon: Icon, margin })=>{
    if (!Icon) return null;
    return /*#__PURE__*/ jsx(Box, {
        as: "span",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ jsx(Icon, {
            size: "sizing.24",
            ...margin
        })
    });
};
const mapButtonStateToBoxProps = ({ isDisabled, isHovered, isPressed, isSelected })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.toggleButton.color.bgDisabled`;
            case isPressed:
                return `unsafe_component.toggleButton.color.bgPressed`;
            case isHovered:
                return `unsafe_component.toggleButton.color.bgHover`;
            default:
                return `unsafe_component.toggleButton.color.bg`;
        }
    };
    const getBorderColor = ()=>{
        switch(true){
            case isDisabled:
                return `unsafe_component.toggleButton.color.borderDisabled`;
            case isSelected:
                return `unsafe_component.toggleButton.color.borderSelected`;
            default:
                return `unsafe_component.toggleButton.color.border`;
        }
    };
    return {
        backgroundColor: getBackgroundColor(),
        borderColor: getBorderColor(),
        color: `unsafe_component.toggleButton.color.text${isDisabled ? 'Disabled' : ''}`,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        typography: `unsafe_component.toggleButton.typography.${isSelected ? 'selected' : 'default'}`
    };
};
const mapResponsive = (object, [conditionFulfilled, conditionUnfulfilled])=>{
    return Object.entries(object).reduce((acc, [breakpoint, condition])=>{
        return {
            ...acc,
            [breakpoint]: condition ? conditionFulfilled : conditionUnfulfilled
        };
    }, {});
};
const mapButtonWidthProps = ({ isFullWidth = false })=>{
    // iconOnly has priority for now
    if (!isFullWidth) {
        return undefined;
    }
    if (typeof isFullWidth === 'boolean') {
        return '100%';
    }
    return mapResponsive(isFullWidth, [
        '100%',
        'initial'
    ]);
};

const useWizardTranslation = ()=>useTranslation({
        'en-GB': {
            'wizard::step::completed': 'Step :step_number: completed',
            'wizard::step::current': 'Current step :step_number:',
            'wizard::step::error': 'Step :step_number: incorrect'
        },
        'fr-FR': {
            'wizard::step::completed': 'Étape :step_number: terminée',
            'wizard::step::current': 'Étape :step_number: en cours',
            'wizard::step::error': 'Étape :step_number: erronée'
        },
        'de-DE': {
            'wizard::step::completed': 'Schritt :step_number: abgeschlossen',
            'wizard::step::current': 'Schritt :step_number: aktuell',
            'wizard::step::error': 'Schritt :step_number: Fehler'
        },
        'nl-NL': {
            'wizard::step::completed': 'Stap :step_number: voltooid',
            'wizard::step::current': 'Stap :step_number: bezig',
            'wizard::step::error': 'Stap :step_number: fout'
        }
    });

/**
 * Custom hook to map `WizardStep` props to `Box` ones with all needed interactive and accessible HTML attributes.
 * @param ref
 * @param props WizardStep props
 * @returns Box props
 */ const useWizardStep = (ref, props)=>{
    const isCTA = typeof props.onPress === 'function' || typeof props.href === 'string';
    const { boxProps, isHovered, isFocused, isPressed, isLink } = useButton$1(ref, props);
    if (!isCTA) {
        return {
            boxProps: {
                as: 'div',
                ref: boxProps.ref
            },
            isHovered: false,
            isFocused: false,
            isPressed: false,
            isCTA,
            isLink
        };
    }
    return {
        boxProps: mergeProps(boxProps, isLink ? {
            title: props.linkTitle
        } : {}),
        isHovered,
        isFocused,
        isPressed,
        isCTA,
        isLink
    };
};

const WizardStep = ({ step, index, isCurrent, stepsLength, stepAfterStatus, isNumbered })=>{
    const t = useWizardTranslation();
    const displayNumber = (index + 1).toString();
    const tokens = useTokens();
    const ref = useRef(null);
    const { boxProps, isHovered, isPressed, isLink, isCTA, isFocused } = useWizardStep(ref, step);
    const LinkComponent = useRenderLink({
        isExternal: false
    });
    const Component = isLink ? LinkComponent : Box;
    const labelForLabelStep = isCurrent ? 'current' : step.status;
    const shouldHaveAccessibleLabel = labelForLabelStep === 'current' || labelForLabelStep === 'completed' || labelForLabelStep === 'error';
    const stateProps = useMemo(()=>mapStepStateToBoxProps({
            isHovered,
            isPressed,
            isFocused,
            isDisabled: step.status === 'disabled',
            isCTA,
            isCurrent
        }), [
        isHovered,
        isPressed,
        step.status,
        isCTA,
        isCurrent,
        isFocused
    ]);
    const stepColorIconStyle = useMemo(()=>mapStepStateToIconBoxProps({
            status: step.status
        }), [
        step.status
    ]);
    const stepColorTopLineStyle = useMemo(()=>mapStepStateToLineBoxProps({
            status: step.status,
            stepsLength,
            index,
            position: 'top'
        }), [
        step.status,
        stepsLength,
        index
    ]);
    const stepColorBottomLineStyle = useMemo(()=>mapStepStateToLineBoxProps({
            status: stepAfterStatus,
            stepsLength,
            index,
            position: 'bottom'
        }), [
        stepAfterStatus,
        stepsLength,
        index
    ]);
    const stepIconContent = step.status !== 'disabled' ? 'unsafe_component.wizard.sizing.stepIconContent' : 'unsafe_component.wizard.sizing.stepIconDisabledContent';
    return /*#__PURE__*/ jsxs(Box, {
        as: "li",
        display: "flex",
        flexDirection: "row",
        width: "100%",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                width: "unsafe_component.wizard.sizing.stepIconContainer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        width: "unsafe_component.wizard.borderWidth",
                        height: step.status === 'disabled' ? 'unsafe_component.wizard.sizing.stepDisabledLineHeight' : isCurrent ? 'unsafe_component.wizard.sizing.stepCurrentLineHeight' : 'unsafe_component.wizard.sizing.stepLineHeight',
                        display: "block",
                        ...stepColorTopLineStyle
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        position: "relative",
                        borderRadius: "unsafe_component.wizard.radius.icon",
                        width: stepIconContent,
                        height: stepIconContent,
                        ...isCurrent && step.status !== 'disabled' ? {
                            marginVertical: 'unsafe_component.wizard.spacing.marginCurrentLineHeight',
                            outlineStyle: 'solid',
                            outlineWidth: 'unsafe_component.wizard.borderWidth',
                            outlineOffset: 'unsafe_component.wizard.spacing.margin'
                        } : {
                            marginVertical: 'unsafe_component.wizard.spacing.marginLineHeight',
                            outlineStyle: undefined,
                            outlineWidth: undefined,
                            outlineOffset: undefined
                        },
                        ...stepColorIconStyle,
                        children: /*#__PURE__*/ jsx(IconElement, {
                            status: step.status
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        width: "unsafe_component.wizard.borderWidth",
                        flexGrow: 1,
                        display: "block",
                        ...stepColorBottomLineStyle
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(Component, {
                ...mergeProps(boxProps, stateProps),
                marginLeft: "unsafe_component.wizard.spacing.margin",
                paddingVertical: "unsafe_component.wizard.spacing.padding",
                paddingHorizontal: "spacing.none",
                minHeight: "unsafe_component.wizard.sizing.stepContent",
                width: `calc(100% - ${tokens['unsafe_component.wizard.sizing.stepIconContainer']})`,
                display: "inline-flex",
                flexGrow: 1,
                borderRadius: "unsafe_component.wizard.radius.content",
                typography: "unsafe_component.wizard.typography.title",
                textAlign: "left",
                color: step.status === 'disabled' ? 'unsafe_component.wizard.color.textDisabled' : 'unsafe_component.wizard.color.text',
                borderWidth: "borderWidth.none",
                borderStyle: "none",
                children: [
                    shouldHaveAccessibleLabel && /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        srOnly: true,
                        children: t(`wizard::step::${labelForLabelStep}`).replace(':step_number:', displayNumber)
                    }),
                    isNumbered && /*#__PURE__*/ jsx(Box, {
                        as: "span",
                        width: "unsafe_component.wizard.sizing.stepNumber",
                        paddingLeft: "unsafe_component.wizard.spacing.padding",
                        "aria-hidden": true,
                        children: displayNumber
                    }),
                    /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        width: isNumbered ? step.status !== 'disabled' ? `calc(100% - (${tokens['unsafe_component.wizard.sizing.stepNumber']} * 2))` : `calc(100% - ${tokens['unsafe_component.wizard.sizing.stepNumber']})` : '100%',
                        paddingLeft: !isNumbered ? 'unsafe_component.wizard.spacing.padding' : undefined,
                        children: [
                            /*#__PURE__*/ jsx(Box, {
                                as: "span",
                                children: step.label
                            }),
                            step.description !== undefined && /*#__PURE__*/ jsx(Box, {
                                as: "span",
                                typography: "unsafe_component.wizard.typography.description",
                                children: step.description
                            })
                        ]
                    }),
                    step.status !== 'disabled' && isCTA && /*#__PURE__*/ jsx(Box, {
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        paddingLeft: "unsafe_component.wizard.spacing.padding",
                        children: /*#__PURE__*/ jsx(ChevronRightIcon, {
                            "aria-hidden": true,
                            color: "inherit",
                            size: "sizing.24"
                        })
                    })
                ]
            })
        ]
    });
};
const IconElement = ({ status })=>{
    const Icon = (status === 'completed' ? CheckFilledCircleIcon : undefined) || (status === 'error' ? ExclamationFilledCircleIcon : undefined);
    if (!Icon) return null;
    return /*#__PURE__*/ jsx(Icon, {
        size: "sizing.20",
        "aria-hidden": true,
        color: (status === 'completed' ? 'unsafe_component.wizard.color.icon.bgCompleted' : undefined) || (status === 'error' ? 'unsafe_component.wizard.color.icon.bgError' : undefined),
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    });
};
const mapStepStateToIconBoxProps = ({ status })=>{
    const getBackgroundColor = ()=>{
        switch(status){
            case 'disabled':
                return `unsafe_component.wizard.color.icon.bgDisabled`;
            case 'error':
            case 'completed':
                return `unsafe_component.wizard.color.icon.bg`;
            default:
                return `unsafe_component.wizard.color.icon.bgCurrent`;
        }
    };
    return {
        backgroundColor: getBackgroundColor()
    };
};
const mapStepStateToLineBoxProps = ({ status, stepsLength, index, position })=>{
    if (position === 'top' && index === 0 || position === 'bottom' && index === stepsLength - 1) {
        return undefined;
    }
    const getBackgroundColor = ()=>{
        switch(status){
            case 'disabled':
                return `unsafe_component.wizard.color.icon.bgDisabled`;
            case 'completed':
                return `unsafe_component.wizard.color.icon.bgCompleted`;
            default:
                return `unsafe_component.wizard.color.icon.bgCurrent`;
        }
    };
    return {
        backgroundColor: getBackgroundColor()
    };
};
const mapStepStateToBoxProps = ({ isDisabled, isHovered, isFocused, isPressed, isCurrent, isCTA })=>{
    const getBackgroundColor = ()=>{
        switch(true){
            case isPressed:
                return `unsafe_component.wizard.color.button.bgPressed`;
            case isHovered:
                return `unsafe_component.wizard.color.button.bgHover`;
            case isCurrent:
                return `unsafe_component.wizard.color.button.bgActive`;
            default:
                return `unsafe_component.wizard.color.button.bg`;
        }
    };
    return {
        backgroundColor: isDisabled ? 'unsafe_component.wizard.color.button.bg' : getBackgroundColor(),
        cursor: isDisabled ? 'not-allowed' : isCTA ? 'pointer' : undefined,
        outlineStyle: isFocused ? 'auto' : 'none'
    };
};

const Wizard = ({ isNumbered, steps, currentStepId })=>{
    return /*#__PURE__*/ jsx(Box, {
        as: isNumbered ? 'ol' : 'ul',
        width: "100%",
        children: steps.map((step, index)=>/*#__PURE__*/ jsx(WizardStep, {
                step: step,
                stepsLength: steps.length,
                index: index,
                isCurrent: currentStepId === step.id,
                stepAfterStatus: steps[index + 1] !== undefined ? steps[index + 1]?.status : 'idle',
                isNumbered: isNumbered
            }, step.id))
    });
};

// The content of the metadata object is generated using Google's PhoneNumberMetadata.xml
// https://gitlab.com/catamphetamine/libphonenumber-js#customizing-metadata
// https://github.com/google/libphonenumber/blob/master/resources/PhoneNumberMetadata.xml
const metadata = {
    version: 4,
    country_calling_codes: {
        '32': [
            'BE'
        ],
        '33': [
            'FR'
        ],
        '49': [
            'DE'
        ]
    },
    countries: {
        BE: [
            '32',
            '00',
            '4\\d{8}|[1-9]\\d{7}',
            [
                8,
                9
            ],
            [
                [
                    '(\\d{3})(\\d{2})(\\d{3})',
                    '$1 $2 $3',
                    [
                        '(?:80|9)0'
                    ],
                    '0$1'
                ],
                [
                    '(\\d)(\\d{3})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '[239]|4[23]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '[15-8]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '4'
                    ],
                    '0$1'
                ]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}',
                    [
                        8
                    ]
                ],
                [
                    '4[5-9]\\d{7}',
                    [
                        9
                    ]
                ],
                [
                    '800[1-9]\\d{4}',
                    [
                        8
                    ]
                ],
                [
                    '(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}',
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    '78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}',
                    [
                        8
                    ]
                ],
                0,
                0,
                [
                    '7879\\d{4}',
                    [
                        8
                    ]
                ]
            ]
        ],
        DE: [
            '49',
            '00',
            '[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}',
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    '(\\d{2})(\\d{3,13})',
                    '$1 $2',
                    [
                        '3[02]|40|[68]9'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{3,12})',
                    '$1 $2',
                    [
                        '2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
                        '2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{4})(\\d{2,11})',
                    '$1 $2',
                    [
                        '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]',
                        '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{4})',
                    '$1 $2',
                    [
                        '138'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{5})(\\d{2,10})',
                    '$1 $2',
                    [
                        '3'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{5,11})',
                    '$1 $2',
                    [
                        '181'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d)(\\d{4,10})',
                    '$1 $2 $3',
                    [
                        '1(?:3|80)|9'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{7,8})',
                    '$1 $2',
                    [
                        '1[67]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{7,12})',
                    '$1 $2',
                    [
                        '8'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{5})(\\d{6})',
                    '$1 $2',
                    [
                        '185',
                        '1850',
                        '18500'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{4})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '7'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{4})(\\d{7})',
                    '$1 $2',
                    [
                        '18[68]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{5})(\\d{6})',
                    '$1 $2',
                    [
                        '15[0568]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{4})(\\d{7})',
                    '$1 $2',
                    [
                        '15[1279]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{8})',
                    '$1 $2',
                    [
                        '18'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{2})(\\d{7,8})',
                    '$1 $2 $3',
                    [
                        '1(?:6[023]|7)'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{4})(\\d{2})(\\d{7})',
                    '$1 $2 $3',
                    [
                        '15[279]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{2})(\\d{8})',
                    '$1 $2 $3',
                    [
                        '15'
                    ],
                    '0$1'
                ]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}',
                    [
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15
                    ]
                ],
                [
                    '15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}',
                    [
                        10,
                        11
                    ]
                ],
                [
                    '800\\d{7,12}',
                    [
                        10,
                        11,
                        12,
                        13,
                        14,
                        15
                    ]
                ],
                [
                    '(?:137[7-9]|900(?:[135]|9\\d))\\d{6}',
                    [
                        10,
                        11
                    ]
                ],
                [
                    '700\\d{8}',
                    [
                        11
                    ]
                ],
                0,
                [
                    '18(?:1\\d{5,11}|[2-9]\\d{8})',
                    [
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                [
                    '16(?:4\\d{1,10}|[89]\\d{1,11})',
                    [
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ],
                0,
                [
                    '180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}',
                    [
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14
                    ]
                ]
            ]
        ],
        FR: [
            '33',
            '00',
            '[1-9]\\d{8}',
            [
                9
            ],
            [
                [
                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '8'
                    ],
                    '0 $1'
                ],
                [
                    '(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4 $5',
                    [
                        '[1-79]'
                    ],
                    '0$1'
                ]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}'
                ],
                [
                    '(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}'
                ],
                [
                    '80[0-5]\\d{6}'
                ],
                [
                    '836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}'
                ],
                0,
                0,
                [
                    '80[6-9]\\d{6}'
                ],
                0,
                [
                    '9\\d{8}'
                ],
                [
                    '8(?:1[01]|2[0156]|4[02]|84)\\d{6}'
                ]
            ]
        ]
    },
    nonGeographic: {}
};

/* metadata is a json file containing necessary country phone data used for formatting phone numbers
 * metadata is also used with the `Metadata` constructor to create an instance of `Metadata`
 */ const metadataJson = metadata;

const parseNumberParams = (...parameters)=>{
    parameters.push(metadataJson);
    return parameters;
};

/**
 * @deprecated usePhoneNumberField is deprecated and will be removed in the next major version.
 *
 * Please use the Phone Number pattern instead.
 */ const usePhoneNumberField = ({ defaultCountry, format, onFormat })=>{
    const onBlur = useCallback((event)=>{
        const parseNumberArgs = parseNumberParams(event.target.value, defaultCountry);
        try {
            const phone = parsePhoneNumber(...parseNumberArgs);
            if (phone?.isValid() && format) {
                onFormat(phone?.format(format));
            }
        } catch (error) {
            if (error instanceof ParseError) {
                // error handling to prevent onBlur blocking
                console.error(error.message);
            }
        }
    }, [
        defaultCountry,
        format,
        onFormat
    ]);
    const handleValidation = useCallback((phoneNumber)=>{
        const parseNumberArgs = parseNumberParams(phoneNumber, defaultCountry);
        try {
            const phone = parsePhoneNumber(...parseNumberArgs);
            if (phone?.isValid()) {
                return {
                    isValid: true
                };
            } else {
                return {
                    isValid: false
                };
            }
        } catch (error) {
            if (error instanceof ParseError) {
                return {
                    error: error?.message,
                    isValid: false
                };
            }
        }
        return null;
    }, [
        defaultCountry
    ]);
    return {
        inputProps: {
            onBlur,
            type: 'tel'
        },
        handleValidation
    };
};

export { Accordion, ActionMenu, Autocomplete, Avatar, Backdrop, Badge, Button, ButtonGroup, Card, Carousel, CellContent, Chip, ChipGroup, CoachMark, CounterField, DateCalendar, DatePicker, Divider, Dropdown, FeedbackMessage, Field, FieldLabel, FloatingButtonGroup, FormattedTextField, ImageSlider, InfoState, Link, LoadingState, MediaUpload, Modal, Pagination, ProgressBar, ProgressCircle, RadioGroup, Rating, SegmentedControl, SelectCardGroup, Skeleton, Slider, SnackbarBase, StateMessage, StatusTag, Tabs, Tag, TextArea, TextButton, TextField, Toggle, ToggleButton, ToggleGroup, Tooltip, Wizard, useButton$1 as useButton, usePhoneNumberField, useSnackbar };
//# sourceMappingURL=index.mjs.map
